(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('kendo.draggable.cmn.chunk.js'), require('kendo.file-saver.cmn.chunk.js'), require('kendo.common.cmn.chunk.js'), require('kendo.pdfjs.loader.js')) :
  typeof define === 'function' && define.amd ? define(['exports', 'kendo.draggable.cmn.chunk', 'kendo.file-saver.cmn.chunk', 'kendo.common.cmn.chunk', 'kendo.pdfjs.loader'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global.kendo = global.kendo || {}, global.kendo._globals = global.kendo._globals || {}, global.kendo._globals.PdfviewerCommonCmnChunk = {}), global.kendo._globals.DraggableCmnChunk, global.kendo._globals.FileSaverCmnChunk, global.kendo._globals.CommonCmnChunk, global.kendo._globals.PdfjsLoader));
})(this, (function (exports, kendo_draggable_cmn_chunk_js, kendo_fileSaver_cmn_chunk_js, kendo_common_cmn_chunk_js, kendo_pdfjs_loader_js) {
  const __meta__ = {
      id: "pdfviewer-common.cmn.chunk",
      name: "PdfviewerCommonCmnChunk",
      category: "web",
      description: "A reusable outputed chunk of code",
      depends: ['draggable.cmn.chunk', 'file-saver.cmn.chunk', 'common.cmn.chunk', 'pdfjs.loader'],
      hidden: true,
      chunk: true,
      
  };

  // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
  const extend = (...args) => Object.assign(...args);
  const isObject = (value) => value && typeof (value) === "object" && !Array.isArray(value);
  const isHtmlElement = (element) => element instanceof HTMLElement;
  const isDomElement = (element) => element instanceof Element;
  // @ts-expect-error TS(2304): Cannot find name 'DotNet'.
  const isDotNetObject = (value) => value && window && window.DotNet && window.DotNet.DotNetObject && value instanceof DotNet.DotNetObject;
  const deepExtend = (target, ...sources) => {
      if (!sources.length) {
          return target;
      }
      const source = sources.shift();
      if (isObject(target) && isObject(source)) {
          for (const key in source) {
              // guard against prototype pollution
              // https://github.com/telerik/kendo-charts/pull/478
              if (key === '__proto__' || key === 'constructor') {
                  continue;
              }
              if (source[key] instanceof Component) {
                  target[key] = source[key];
              }
              else if (isHtmlElement(source[key])) {
                  target[key] = source[key];
              }
              else if (key === "dotNetInstance" || isDotNetObject(source[key])) {
                  // avoid cloning a DotNetObject as it might have circular properties
                  // see https://github.com/telerik/blazor/issues/7507
                  // the check for the name of our own option - "dotNetInstance"
                  // is an additional guard against the Blazor API being different in other .NET versions
                  target[key] = source[key];
              }
              else if (source[key] && source[key].buffer && source[key].buffer instanceof ArrayBuffer) {
                  target[key] = source[key];
              }
              else if (isObject(source[key]) && Object.getPrototypeOf(source[key]) !== Object.prototype) {
                  target[key] = source[key];
              }
              else if (isObject(source[key])) {
                  if (!target[key] || !isObject(target[key])) {
                      extend(target, { [key]: {} });
                  }
                  deepExtend(target[key], source[key]);
              }
              else {
                  extend(target, { [key]: source[key] });
              }
          }
      }
      return deepExtend(target, ...sources);
  };
  const isFunction = fn => typeof (fn) === "function";
  const isString = value => typeof (value) === "string";
  const toArray = value => Array.from(value);
  const isDefined = value => typeof (value) !== "undefined";
  const isNotNull = value => value !== null;
  const hasValue = value => isDefined(value) && isNotNull(value);
  const noop = function () { };
  const convertToHtml = (htmlString, ownerDocument) => {
      const template = (ownerDocument || document).createElement('template');
      template.innerHTML = htmlString.trim();
      const content = template.content;
      if (content.childNodes.length > 1) {
          return content.childNodes;
      }
      return content.firstChild;
  };
  const toPixel = value => parseFloat(value) + "px";
  const toClassSelector$1 = (className) => (className === null || className === void 0 ? void 0 : className.startsWith(".")) ? className : `.${className}`;
  const mousewheelDelta = (e) => {
      let delta = 0;
      if (e.wheelDelta) {
          delta = -e.wheelDelta / 120;
      }
      else if (e.detail) {
          delta = e.detail / 3;
      }
      delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
      return delta;
  };
  const createPromise = () => {
      let resolveFn;
      let rejectFn;
      const promise = new Promise(function (resolve, reject) {
          resolveFn = resolve;
          rejectFn = reject;
      });
      // @ts-expect-error TS(2339): Property 'resolve' does not exist on type 'Promise... Remove this comment to see the full error message
      promise.resolve = resolveFn;
      // @ts-expect-error TS(2339): Property 'reject' does not exist on type 'Promise<... Remove this comment to see the full error message
      promise.reject = rejectFn;
      return promise;
  };

  class Component {
      constructor(element, options) {
          this.options = {
              events: {}
          };
          this.element = element;
          this.options = options;
      }
      destroy() {
          this.element = null;
      }
      extendOptions(options) {
          this.options = deepExtend(this.options, options);
      }
      setOptions(options) {
          this.options = options;
      }
      trigger(eventName, args = {}) {
          const eventData = {
              defaultPrevented: false,
              preventDefault: () => {
                  eventData.defaultPrevented = true;
              }
          };
          if (this.options.events && isFunction(this.options.events[eventName])) {
              this.options.events[eventName](extend(eventData, args, {
                  sender: this
              }));
          }
          return eventData.defaultPrevented;
      }
  }

  const throttle = function (func, wait, options = {}) {
      let timeout, context, args, result;
      let previous = 0;
      const later = function () {
          previous = options.leading === false ? 0 : new Date().getTime();
          timeout = undefined;
          result = func.apply(context, args);
          if (!timeout) {
              context = args = null;
          }
      };
      const throttled = function () {
          const now = new Date().getTime();
          if (!previous && options.leading === false) {
              previous = now;
          }
          const remaining = wait - (now - previous);
          context = undefined; // this
          args = arguments;
          if (remaining <= 0 || remaining > wait) {
              if (timeout) {
                  clearTimeout(timeout);
                  timeout = undefined;
              }
              previous = now;
              result = func.apply(context, args);
              if (!timeout) {
                  context = args = null;
              }
          }
          else if (!timeout && options.trailing !== false) {
              timeout = window.setTimeout(later, remaining);
          }
          return result;
      };
      return throttled;
  };
  const preventDefault = (e) => {
      if (e.preventDefault) {
          e.preventDefault();
      }
      if (e.originalEvent) {
          e.originalEvent.preventDefault();
      }
  };
  const matchesElementSelector = (element, selector) => {
      if (!element || !selector) {
          return false;
      }
      return element.closest(selector);
  };
  const FRAMES_PER_SECOND$1 = 1000 / 60;
  const SCROLL$1 = "scroll";
  /**
   * @hidden
   */
  class Scroller extends Component {
      constructor(element, options) {
          super(element, options);
          this.options = {
              events: {
                  [SCROLL$1]: noop
              },
              filter: '',
              // throttle the scroll events to get a more similar experience
              // to the scrolling behavior in Adobe Acrobat Reader
              // as well as allow a way to improve the scrolling performance for large files
              panScrollThrottleDelay: FRAMES_PER_SECOND$1,
              // the drag directions are actually reversed, e.g.
              // dragging to the right actually moves the document to the left
              scrollDirectionModifier: -1,
              scrollThrottleDelay: FRAMES_PER_SECOND$1
          };
          this.onElementScroll = (e) => {
              const element = this.element;
              if (!this.shouldTrackScrollEvents()) {
                  return;
              }
              if (this.state.trackNextElementScroll) {
                  this.scrollTo(element.scrollLeft, element.scrollTop);
              }
              else {
                  // reset the state, so that consecutive scroll events can be handled
                  this.state.trackNextElementScroll = true;
              }
              this.trigger(SCROLL$1, {
                  originalEvent: e
              });
          };
          this.onDragStart = (e) => {
              this.state.dragStarted = false;
              if (!this.shouldTrackPanEvents()) {
                  return;
              }
              const target = e.target || (e.originalEvent || {}).target;
              if (this.options.filter &&
                  !matchesElementSelector(target, this.options.filter)) {
                  return;
              }
              preventDefault(e);
              this.setState({
                  dragStarted: true,
                  location: {
                      pageX: e.pageX,
                      pageY: e.pageY
                  },
                  locationDelta: {
                      x: 0,
                      y: 0
                  }
              });
          };
          this.onDrag = (e) => {
              if (!this.shouldTrackPanEvents() || !this.state.dragStarted) {
                  return;
              }
              this.calculateEventLocationDelta(e);
              this.setState({
                  location: {
                      pageX: e.pageX,
                      pageY: e.pageY
                  }
              });
              const directionModifier = this.options.scrollDirectionModifier;
              const scrollLeft = this.element.scrollLeft +
                  directionModifier * this.state.locationDelta.x;
              const scrollTop = this.element.scrollTop +
                  directionModifier * this.state.locationDelta.y;
              this.scrollTo(scrollLeft, scrollTop);
          };
          this.onDragEnd = () => {
              // if (!this.shouldTrackPanEvents()) { }
          };
          this.extendOptions(options);
          this.resetState();
          this.bindEvents();
      }
      destroy() {
          this.unbindEvents();
      }
      initDraggable() {
          this.destroyDraggable();
          if (this.options.panScrollThrottleDelay > 0) {
              this.throttledOnDrag = throttle(this.onDrag, this.options.panScrollThrottleDelay);
          }
          else {
              this.throttledOnDrag = this.onDrag;
          }
          this.draggable = new kendo_draggable_cmn_chunk_js.D({
              mouseOnly: false,
              press: this.onDragStart,
              drag: this.throttledOnDrag,
              release: this.onDragEnd
          });
          this.draggable.bindTo(this.element);
      }
      destroyDraggable() {
          if (this.draggable && this.draggable.destroy) {
              this.draggable.destroy();
              if (this.throttledOnDrag && this.throttledOnDrag.cancel) {
                  this.throttledOnDrag.cancel();
                  this.throttledOnDrag = null;
              }
          }
      }
      bindEvents() {
          this.bindDraggableEvents();
          this.bindElementScroll();
      }
      bindDraggableEvents() {
          this.initDraggable();
      }
      bindElementScroll() {
          if (this.options.scrollThrottleDelay > 0) {
              this.throttledOnElementScroll = throttle(this.onElementScroll, this.options.scrollThrottleDelay);
          }
          else {
              this.throttledOnElementScroll = this.onElementScroll;
          }
          this.element.addEventListener(SCROLL$1, this.throttledOnElementScroll);
      }
      unbindEvents() {
          this.unbindElementScroll();
          this.unbindDraggableEvents();
      }
      unbindDraggableEvents() {
          this.destroyDraggable();
      }
      unbindElementScroll() {
          if (this.throttledOnElementScroll &&
              this.throttledOnElementScroll.cancel) {
              this.throttledOnElementScroll.cancel();
              this.throttledOnElementScroll = null;
          }
          this.element.removeEventListener(SCROLL$1, this.throttledOnElementScroll);
      }
      setState(newState) {
          this.state = Object.assign({}, this.state || {}, newState);
      }
      resetState() {
          this.setState({
              trackPanEvents: false,
              trackScrollEvents: false,
              trackNextElementScroll: false,
              location: { pageX: 0, pageY: 0 },
              locationDelta: { x: 0, y: 0 }
          });
      }
      enablePanEventsTracking() {
          this.state.trackPanEvents = true;
          this.bindDraggableEvents();
      }
      disablePanEventsTracking() {
          this.unbindDraggableEvents();
          this.state.trackPanEvents = false;
      }
      shouldTrackPanEvents() {
          return this.state.trackPanEvents;
      }
      enableScrollEventsTracking() {
          this.state.trackScrollEvents = true;
          this.unbindElementScroll();
          this.bindElementScroll();
      }
      disableScrollEventsTracking() {
          this.unbindElementScroll();
          this.state.trackScrollEvents = false;
      }
      shouldTrackScrollEvents() {
          return this.state.trackScrollEvents;
      }
      calculateEventLocationDelta(e) {
          this.state.locationDelta = {
              x: e.pageX - this.state.location.pageX,
              y: e.pageY - this.state.location.pageY
          };
      }
      scrollTo(x, y, options = { trackScrollEvent: true }) {
          if (!options.trackScrollEvent) {
              this.state.trackNextElementScroll = false;
          }
          this.element.scrollLeft = x;
          this.element.scrollTop = y;
      }
  }

  const unwrapElement = (element) => {
      const parentElement = element.parentElement;
      if (!element || !parentElement) {
          return;
      }
      parentElement.replaceWith(...Array.from(parentElement.childNodes));
  };
  const unwrapElements = (elements) => {
      if (!elements || !elements.length || elements.length <= 0) {
          return;
      }
      for (let i = 0; i < elements.length; i++) {
          unwrapElement(elements[i]);
      }
  };
  const wrapElement = (element, wrapper) => {
      if (element.parentNode) {
          element.parentNode.insertBefore(wrapper, element);
          wrapper.appendChild(element);
      }
  };
  const wrapInnerElement = (element, wrapper) => {
      if (!element || !element.parentNode || !wrapper) {
          return;
      }
      element.appendChild(wrapper);
      while (element.firstChild && element.firstChild !== wrapper) {
          wrapper.appendChild(element.firstChild);
      }
  };
  const addClass$1 = (className, element) => {
      element.classList.add(className);
  };
  const removeClass$1 = (className, element) => {
      element.classList.remove(className);
  };
  const toClassSelector = (className) => `.${className}`;
  const CHAR_INDEX_DATA_ATTR = 'data-char-index';
  const MATCH_INDEX_DATA_ATTR = 'data-match-index';
  /**
   * @hidden
   */
  class SearchService {
      constructor(options) {
          this.options = {
              highlightClass: 'k-search-highlight',
              highlightMarkClass: 'k-search-highlight-mark',
              charClass: 'k-text-char',
              textContainers: []
          };
          this.extendOptions(options);
          this.resetState();
      }
      destroy() {
          this.clearSearch();
          this.resetState();
      }
      extendOptions(options) {
          this.options = Object.assign({}, this.options, options);
      }
      setState(newState) {
          this.state = Object.assign({}, this.state || {}, newState);
      }
      resetState() {
          this.setState({
              text: '',
              textNodes: [],
              charIndex: 0,
              activeMatchIndex: 0,
              matches: []
          });
      }
      escapeRegExp(text) {
          return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }
      search({ text, matchCase }) {
          const escapedText = this.escapeRegExp(text);
          const searchRegex = new RegExp(escapedText, matchCase ? 'g' : 'ig');
          let match;
          if (this.shouldTransformText()) {
              this.transformTextForSearch();
          }
          this.state.matches = [];
          this.state.activeMatchIndex = 0;
          this.removeIndicators();
          if (escapedText === '') {
              return [];
          }
          match = searchRegex.exec(this.state.text);
          while (match) {
              this.state.matches.push({
                  startOffset: match.index,
                  endOffset: match.index + match[0].length
              });
              match = searchRegex.exec(this.state.text);
          }
          this.highlightAllMatches();
          this.addActiveMatchMark();
          return this.state.matches;
      }
      clearSearch() {
          this.removeIndicators();
          this.restoreOriginalText();
      }
      restoreOriginalText() {
          this.forEachTextContainer((textContainer) => {
              const nodes = Array.from(textContainer.querySelectorAll('span:not(.' + this.options.charClass + ')'));
              nodes.forEach((node) => {
                  node.innerHTML = node.textContent;
              });
          });
      }
      shouldTransformText() {
          return !this.state.text;
      }
      transformTextForSearch() {
          this.state.textNodes = [];
          this.state.charIndex = 0;
          this.state.text = '';
          this.forEachTextContainer((textContainer) => {
              this.extractTextNodes(textContainer);
          });
          this.transformTextNodesForSearch(this.state.textNodes);
      }
      extractTextNodes(node) {
          if (node.nodeType === Node.TEXT_NODE) {
              this.state.textNodes.push(node);
          }
          else {
              for (let i = 0; i < node.childNodes.length; i++) {
                  this.extractTextNodes(node.childNodes[i]);
              }
          }
      }
      transformTextNodesForSearch(textNodes) {
          for (let i = 0; i < textNodes.length; i++) {
              this.transformTextNodeForSearch(textNodes[i]);
          }
      }
      transformTextNodeForSearch(node) {
          const text = node.textContent;
          if (text.length <= 0) {
              return;
          }
          this.state.text = this.state.text + text;
          const span = document.createElement('span');
          wrapElement(node, span);
          const splittedHtml = this.splitTextByChars(text);
          span.innerHTML = splittedHtml;
          unwrapElement(span.childNodes[0]);
      }
      splitTextByChars(text) {
          let splittedTextHtml = '';
          for (let i = 0; i < text.length; i++) {
              splittedTextHtml += `<span class='${this.options.charClass}' ${CHAR_INDEX_DATA_ATTR}=${this.state.charIndex}>${text[i]}</span>`;
              this.state.charIndex++;
          }
          return splittedTextHtml;
      }
      forEachTextContainer(callback) {
          for (let i = 0; i < this.options.textContainers.length; i++) {
              const textContainer = this.options.textContainers[i];
              callback(textContainer, i);
          }
      }
      highlightAllMatches() {
          this.state.matches.forEach((match, matchIndex) => {
              this.addMatchHighlight(match.startOffset, match.endOffset, matchIndex);
          });
      }
      addMatchHighlight(matchStartOffset, matchEndOffset, matchIndex) {
          for (let i = matchStartOffset; i < matchEndOffset; i++) {
              this.forEachTextContainer((textContainer) => {
                  const highlights = Array.from(textContainer.querySelectorAll(toClassSelector(`${this.options.charClass}[${CHAR_INDEX_DATA_ATTR}='${i}']`)));
                  highlights.forEach((highlight) => {
                      addClass$1(this.options.highlightClass, highlight);
                      highlight.setAttribute(MATCH_INDEX_DATA_ATTR, matchIndex);
                  });
              });
          }
      }
      removeMatchHighlights() {
          this.forEachTextContainer((textContainer) => {
              const highlights = Array.from(textContainer.querySelectorAll(toClassSelector(this.options.highlightClass)));
              highlights.forEach((highlight) => {
                  removeClass$1(this.options.highlightClass, highlight);
                  highlight.removeAttribute(MATCH_INDEX_DATA_ATTR);
              });
          });
      }
      addActiveMatchMark() {
          if (!this.state.activeMatchIndex && this.state.activeMatchIndex !== 0) {
              this.state.activeMatchIndex = 0;
          }
          else if (this.state.activeMatchIndex > this.state.matches.length) {
              this.state.activeMatchIndex = this.state.matches.length;
          }
          else {
              this.removeActiveMatchMark();
          }
          const mark = document.createElement('span');
          mark.classList.add(this.options.highlightMarkClass);
          this.forEachTextContainer((textContainer) => {
              const matches = Array.from(textContainer.querySelectorAll(toClassSelector(this.options.charClass +
                  '[' +
                  MATCH_INDEX_DATA_ATTR +
                  '=\'' +
                  this.state.activeMatchIndex +
                  '\']')));
              matches.forEach((match) => {
                  wrapInnerElement(match, mark.cloneNode(true));
              });
          });
      }
      removeActiveMatchMark() {
          this.forEachTextContainer((textContainer) => {
              const marks = Array.from(textContainer.querySelectorAll(toClassSelector(this.options.highlightMarkClass)));
              const childNodes = marks.flatMap((x) => Array.from(x.childNodes));
              unwrapElements(childNodes);
          });
      }
      removeIndicators() {
          this.removeActiveMatchMark();
          this.removeMatchHighlights();
      }
      markNextMatch() {
          this.markNextMatchIndex();
          this.addActiveMatchMark();
      }
      markPreviousMatch() {
          this.markPreviousMatchIndex();
          this.addActiveMatchMark();
      }
      markNextMatchIndex() {
          this.moveActiveMatchIndex(1);
      }
      markPreviousMatchIndex() {
          this.moveActiveMatchIndex(-1);
      }
      moveActiveMatchIndex(delta) {
          this.state.activeMatchIndex += delta;
          if (this.state.activeMatchIndex < 0) {
              this.state.activeMatchIndex = Math.max(this.state.matches.length - 1, 0);
          }
          else if (this.state.activeMatchIndex >
              this.state.matches.length - 1) {
              this.state.activeMatchIndex = 0;
          }
      }
      getActiveMatchElement() {
          let markedMatch;
          this.forEachTextContainer((textContainer) => {
              const mark = textContainer.querySelector(toClassSelector(this.options.highlightMarkClass));
              if (mark) {
                  markedMatch = mark;
              }
          });
          return markedMatch;
      }
  }

  class Annotation {
      constructor(container, viewport, annotation, pdfDoc, zoom, rootElement) {
          this.container = container;
          this.viewport = viewport;
          this.zoom = zoom;
          this.annotation = annotation;
          this.pdfDoc = pdfDoc;
          this.rootElement = rootElement;
      }
      destroy() { }
  }
  class LinkAnnotation extends Annotation {
      constructor(container, viewport, annotation, pdfDoc, zoom, rootElement) {
          super(container, viewport, annotation, pdfDoc, zoom, rootElement);
          this.onLinkClick = (e) => {
              const destination = e.target.getAttribute('href');
              if (destination && destination.indexOf('#') === 0) {
                  this.navigateToDestination(destination);
                  e.preventDefault();
              }
          };
          this.linkElement = null;
          this.renderAnnotation();
          this.bindEvents();
      }
      destroy() {
          this.unbindEvents();
      }
      bindEvents() {
          this.linkElement.addEventListener('click', this.onLinkClick);
      }
      unbindEvents() {
          this.linkElement.removeEventListener('click', this.onLinkClick);
      }
      navigateToDestination(destination) {
          const dest = destination.split('#')[1];
          this.pdfDoc.getDestination(dest).then(r => {
              this.pdfDoc.getPageIndex(r[0]).then(i => this.goToPage(i));
          });
      }
      goToPage(pageNumber) {
          scrollToPage(this.rootElement, pageNumber);
      }
      renderAnnotation() {
          const annotation = this.annotation, viewport = this.viewport, rect = annotation.rect, boundingRect = [
              [rect[0], rect[1]],
              [rect[2], rect[3]]
          ], rawHeight = viewport.rawDims.pageHeight;
          const left = Math.min(boundingRect[0][0], boundingRect[1][0]) * this.zoom, top = (rawHeight - Math.max(boundingRect[0][1], boundingRect[1][1])) * this.zoom, width = (boundingRect[1][0] - boundingRect[0][0]) * this.zoom, height = (boundingRect[1][1] - boundingRect[0][1]) * this.zoom;
          const url = annotation.url || (annotation.dest && `#${encodeURI(annotation.dest)}`);
          const annotationElement = createElement('span', '', {
              position: 'absolute',
              left: left + 'pt',
              top: top + 'pt'
          });
          const linkElement = this.linkElement = createElement('a', '', {
              width: width + 'pt',
              height: height + 'pt',
              display: 'inline-block',
              pointerEvents: 'auto'
          });
          linkElement.setAttribute('href', url);
          annotationElement.append(linkElement);
          this.container.append(annotationElement);
      }
  }

  const MAX_CANVAS_WIDTH_HEIGHT_CHROME = 65535;
  const MAX_CANVAS_AREA_CHROME_SAFARI = 268435456;
  const MAX_CANVAS_WIDTH_HEIGHT_FIREFOX = 32767;
  const MAX_CANVAS_AREA_FIREFOX = 124992400;
  const MAX_CANVAS_WIDTH_SAFARI = 4194303;
  const MAX_CANVAS_HEIGHT_SAFARI = 8388607;
  const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /Macintosh/i.test(navigator.userAgent));
  const isSafari = (userAgent) => {
      return kendo_common_cmn_chunk_js.d(userAgent).safari ||
          (kendo_common_cmn_chunk_js.a(userAgent) && kendo_common_cmn_chunk_js.a(userAgent).browser === 'mobilesafari');
  };
  const isFirefox = (userAgent) => {
      const desktopBrowser = kendo_common_cmn_chunk_js.d(userAgent);
      const mobileOS = kendo_common_cmn_chunk_js.a(userAgent);
      return (desktopBrowser && desktopBrowser.mozilla) || (mobileOS && mobileOS.browser === 'firefox');
  };
  /**
   * @hidden
   */
  const DEFAULT_ZOOM_LEVEL$2 = 1.25;
  const scale = (renderScale = 3) => (isIOS() ? devicePixelRatio : devicePixelRatio * (renderScale || 3));
  const parsePdfFromBase64String = (base64String) => {
      return atob(base64String.replace(/^(data:application\/pdf;base64,)/gi, ''));
  };
  const getDocumentParameters = (options) => {
      let params = {
          verbosity: 0,
          isEvalSupported: false
      };
      if (typeof options.data === 'string') {
          params.data = parsePdfFromBase64String(options.data);
      }
      else if (typeof options.url === 'string') {
          params.url = options.url;
      }
      else if (options.arrayBuffer instanceof ArrayBuffer) {
          params = options.arrayBuffer;
      }
      else if (options.typedArray) {
          params = options.typedArray;
      }
      return params;
  };
  /**
   * @hidden
   */
  const removeChildren = (dom) => {
      while (dom.firstChild) {
          dom.removeChild(dom.firstChild);
      }
  };
  const appendPage = (dom, page, index) => {
      if (index === 0) {
          removeChildren(dom);
      }
      dom.appendChild(page);
  };
  /**
   * @hidden
   */
  const download = (options, fileName = 'Document', saveOptions = {}, onDownload) => {
      if (options.pdf) {
          options.pdf
              .getData()
              .then((data) => new Blob([data], { type: 'application/pdf' }))
              .then((blob) => {
              if (!onDownload(blob, fileName, saveOptions)) {
                  kendo_fileSaver_cmn_chunk_js.s(blob, fileName, saveOptions);
              }
          })
              .catch((reason) => {
              options.error.call(undefined, reason);
          });
      }
  };
  /**
   * @hidden
   */
  const loadPDF = (options) => {
      const params = getDocumentParameters(options);
      const { dom, zoom, done, error, rootElement } = options;
      const loadOnDemandPageSize = options.loadOnDemandPageSize || 2;
      kendo_pdfjs_loader_js.getDocument(params)
          .promise.then((pdfDoc) => {
          const pages = [];
          for (let i = 1; i <= pdfDoc.numPages; i++) {
              pages.push(pdfDoc.getPage(i));
          }
          return { pages, pdfDoc };
      }).then(({ pages, pdfDoc }) => {
          Promise.all(pages)
              .then((all) => all.map((page, i) => {
              const emptyPage = createEmptyPage(page, zoom, pdfDoc, rootElement);
              appendPage(dom, emptyPage.pageElement, i);
              if (options.loadOnDemand) {
                  // If LOD is enabled, render the first two(default) or X pages initially.
                  if (i < loadOnDemandPageSize) {
                      renderPage(page, emptyPage, error);
                  }
              }
              else {
                  renderPage(page, emptyPage, error);
              }
              page._pageInfo.emptyPage = emptyPage;
              return page;
          })).then((pdfPages) => {
              // required by new PDFJS version
              const sheet = new CSSStyleSheet();
              sheet.replaceSync(`.hiddenCanvasElement {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 0;
                        height: 0;
                        display: none;
                    }`);
              options.dom.ownerDocument.adoptedStyleSheets = [sheet];
              done({ pdfPages, pdfDoc, zoom });
          })
              .catch((reason) => {
              options.error(reason);
          });
      })
          .catch((reason) => {
          options.error(reason);
      });
  };
  /**
   * @hidden
   */
  const reloadDocument = (params) => {
      const { pdfDoc, zoom, dom, done, error, loadOnDemand, rootElement } = params;
      const pages = [];
      let currentPageIndex = 0;
      // Save the index of the current page in view before we reload the document.
      if (loadOnDemand && rootElement) {
          currentPageIndex = currentPage(rootElement);
      }
      for (let i = 1; i <= pdfDoc.numPages; i++) {
          pages.push(pdfDoc.getPage(i));
      }
      Promise.all(pages)
          .then((all) => all.map((page, i) => {
          // Set 'rendered' back to false so that the pages can be re-rendered when scrolling.
          page._pageInfo.rendered = false;
          const emptyPage = createEmptyPage(page, zoom, pdfDoc, rootElement);
          appendPage(dom, emptyPage.pageElement, i);
          // If on demand is not enabled, proceed as usual.
          if (!loadOnDemand) {
              renderPage(page, emptyPage, error);
          }
          page._pageInfo.emptyPage = emptyPage;
          return page;
      }))
          .then((pdfPages) => {
          /* If on demand is enabled, render the page that was previously in view.
             Then scroll to that page. */
          if (loadOnDemand) {
              const page = pdfPages[currentPageIndex];
              renderPage(page, page._pageInfo.emptyPage, error);
              scrollToPage(rootElement, currentPageIndex);
          }
          done(pdfPages);
      })
          .catch(error);
  };
  /**
   * @hidden
   */
  const print = (pages, done, error) => {
      const dom = document.createElement('div');
      const allDone = pages.map(() => false);
      const scaleNum = scale();
      pages.forEach((page, index) => {
          const viewport = renderCanvas(page, (el) => {
              dom.appendChild(el);
              allDone[index] = true;
              if (allDone.every(Boolean)) {
                  openPrintDialog(dom, Math.floor(viewport.width / scaleNum), Math.floor(viewport.height / scaleNum), done, error);
              }
          }, error);
      });
  };
  const openPrintDialog = (dom, width, height, done, onError) => {
      const printDialog = window.open('', '', 'innerWidth=' +
          width +
          ',innerHeight=' +
          height +
          'location=no,titlebar=no,toolbar=no');
      if (!printDialog || !printDialog.document) {
          onError();
          return;
      }
      if (printDialog) {
          printDialog.document.body.style.margin = '0';
          printDialog.document.body.appendChild(dom);
          printDialog.focus();
          setTimeout(() => {
              printDialog.print();
              done();
          });
          const onAfterPrint = () => {
              printDialog.removeEventListener('afterprint', onAfterPrint);
              printDialog.close();
          };
          printDialog.addEventListener('afterprint', onAfterPrint);
      }
  };
  const createEmptyPage = (page, zoom, pdfDoc, rootElement) => {
      const { canvasContext, viewport, pageElement, styles } = createCanvas(page, zoom, 'k-page');
      return {
          canvasContext,
          viewport,
          pageElement,
          styles,
          zoom,
          pdfDoc,
          rootElement
      };
  };
  const renderCanvas = (page, done, error) => {
      const { canvasContext, viewport, scaleNum, canvas, pageElement } = createCanvas(page);
      page.render({ canvasContext, viewport })
          .promise.then(() => {
          const printContent = new Image(Math.floor((viewport.width / scaleNum)), Math.floor((viewport.height / scaleNum)));
          printContent.src = canvas.toDataURL();
          const onload = () => {
              printContent.removeEventListener('load', onload);
              done(pageElement);
          };
          printContent.addEventListener('load', onload);
      })
          .catch(error);
      return viewport;
  };
  const createElement = function (name, className, styles) {
      const element = document.createElement(name);
      if (className) {
          element.className = className;
      }
      Object.keys(styles).forEach((key) => (element.style[key] = styles[key]));
      return element;
  };
  const transforms = {
      '0': '',
      '90': 'rotate(90deg) translateY(-100%)',
      '180': 'rotate(180deg) translate(-100%, -100%)',
      '270': 'rotate(270deg) translateX(-100%)'
  };
  const renderPage = (page, emptyPage, error) => {
      const { canvasContext, viewport, pageElement, styles, zoom, pdfDoc, rootElement } = emptyPage;
      page._pageInfo.renderInProgress = true;
      page.render({ canvasContext, viewport })
          .promise.then(() => {
          page.getTextContent().then((textContent) => {
              const textLayer = createElement('div', 'k-text-layer', styles);
              new kendo_pdfjs_loader_js.TextLayer({
                  textContentSource: textContent,
                  container: textLayer,
                  viewport: viewport
              }).render().then(() => {
                  textLayer.style.width = textLayer.style.width.replace(/px/g, 'pt');
                  textLayer.style.height = textLayer.style.height.replace(/px/g, 'pt');
                  const rotation = textLayer.getAttribute('data-main-rotation') || '0';
                  if (transforms[rotation]) {
                      textLayer.style.transform = transforms[rotation];
                      textLayer.style.transformOrigin = 'top left';
                  }
                  textLayer.querySelectorAll('span').forEach((el) => {
                      if (el.style.fontSize) {
                          el.style.fontSize = el.style.fontSize.replace(/px/g, 'pt');
                      }
                  });
                  pageElement.prepend(textLayer); // Use prepend to ensure the element is always inserted before the annotation layer.
              }).catch(error);
          });
          page.getAnnotations({ intent: 'display' }).then((annotations) => {
              const annotationLayer = createElement('div', 'k-annotations-layer', {
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  overflow: 'hidden',
                  height: styles.height,
                  width: styles.width,
                  pointerEvents: 'none'
              });
              pageElement.appendChild(annotationLayer);
              for (const annotation of annotations) {
                  switch (annotation.subtype) {
                      case 'Link':
                          new LinkAnnotation(annotationLayer, viewport, annotation, pdfDoc, zoom, rootElement);
                          break;
                      default:
                          break;
                  }
              }
          });
      })
          .then(() => {
          page._pageInfo.rendered = true;
          page._pageInfo.renderInProgress = false;
      })
          .catch(error);
      return pageElement;
  };
  const searchMatchScrollLeftOffset = 0;
  const searchMatchScrollTopOffset = -64;
  const scrollToSearchMatch = (matchElement, ref) => {
      if (!matchElement) {
          return;
      }
      const closestCharElement = matchElement.closest('.k-text-char');
      const closestTextElement = closestCharElement
          ? closestCharElement.closest('span[role="presentation"]')
          : null;
      if (!closestTextElement) {
          return;
      }
      const closestPageElement = closestTextElement.closest('.k-page');
      if (!closestPageElement) {
          return;
      }
      const scrollLeft = closestPageElement.offsetLeft +
          -1 * ref.scroller.element.offsetLeft +
          closestTextElement.offsetLeft +
          searchMatchScrollLeftOffset;
      const scrollTop = closestPageElement.offsetTop +
          -1 * ref.scroller.element.offsetTop +
          closestTextElement.offsetTop +
          searchMatchScrollTopOffset;
      ref.scroller.scrollTo(scrollLeft, scrollTop, { trackScrollEvent: false });
  };
  /**
   * @hidden
   */
  const goToNextSearchMatch = (ref) => {
      ref.search.markNextMatch();
      const matchElement = ref.search.getActiveMatchElement();
      scrollToSearchMatch(matchElement, ref);
  };
  /**
   * @hidden
   */
  const goToPreviousSearchMatch = (ref) => {
      ref.search.markPreviousMatch();
      const matchElement = ref.search.getActiveMatchElement();
      scrollToSearchMatch(matchElement, ref);
  };
  /**
   * @hidden
   */
  const calculateZoomLevel = (zoomLevel, zoomLevelType, currentZoom, dom) => {
      const documentContainer = dom.closest('.k-pdf-viewer-canvas');
      const page = dom.querySelector('.k-page');
      const pageSize = { width: page.offsetWidth, height: page.offsetHeight };
      let calculatedZoomLevel = zoomLevel;
      if (zoomLevelType === 'ActualWidth') {
          calculatedZoomLevel = 1;
      }
      else if (zoomLevelType === 'FitToWidth') {
          calculatedZoomLevel =
              documentContainer.offsetWidth / (pageSize.width / currentZoom);
      }
      else if (zoomLevelType === 'FitToPage') {
          calculatedZoomLevel =
              documentContainer.offsetHeight / (pageSize.height / currentZoom);
      }
      return calculatedZoomLevel;
  };
  /**
   * Scrolls the PDFViewer document to the passed page number.
   *
   * @param rootElement The root HTML element of the PDFViewer component.
   * @param pageNumber The page number.
   */
  const scrollToPage = (rootElement, pageNumber) => {
      const pages = rootElement.querySelectorAll('.k-page');
      const page = pages[0];
      if (page instanceof HTMLDivElement) {
          const top = (page.offsetHeight + page.offsetTop) *
              Math.max(0, Math.min(pageNumber, pages.length - 1));
          const scrollElement = page.closest('.k-pdf-viewer-canvas');
          if (scrollElement) {
              scrollElement.scrollTo({ top, behavior: 'auto' });
          }
      }
  };
  /**
   * A function which gives you the page number of the document according to the scroll position.
   *
   * @param rootElement The root HTML element of the PDFViewer component.
   * @returns The page number.
   */
  const currentPage = (rootElement) => {
      const scrollElement = rootElement.querySelector('.k-pdf-viewer-canvas');
      const page = rootElement.querySelector('.k-page:not(.k-blank-page)');
      return scrollElement && page
          ? Math.floor(Math.round(scrollElement.scrollTop) /
              Math.max(1, page.offsetHeight + page.offsetTop) +
              0.01)
          : 0;
  };
  /**
   * @hidden
   *
   * related to https://github.com/telerik/kendo-pdfviewer-common/issues/6
   * the bigger the canvas size, the worse the performance;
   * if initial size after scaling is greater than browser limits,
   * we are limiting it to the limits, then halving it for performance.
   */
  const adjustCanvasSize = (targetWidth, targetHeight) => {
      const { maxWidth, maxHeight, maxArea } = isFirefox(navigator.userAgent) ?
          { maxWidth: MAX_CANVAS_WIDTH_HEIGHT_FIREFOX, maxHeight: MAX_CANVAS_WIDTH_HEIGHT_FIREFOX, maxArea: MAX_CANVAS_AREA_FIREFOX } :
          isSafari(navigator.userAgent) ?
              { maxWidth: MAX_CANVAS_WIDTH_SAFARI, maxHeight: MAX_CANVAS_HEIGHT_SAFARI, maxArea: MAX_CANVAS_AREA_CHROME_SAFARI } :
              {
                  maxWidth: MAX_CANVAS_WIDTH_HEIGHT_CHROME,
                  maxHeight: MAX_CANVAS_WIDTH_HEIGHT_CHROME,
                  maxArea: MAX_CANVAS_AREA_CHROME_SAFARI
              };
      let adjustedWidth = targetWidth;
      let adjustedHeight = targetHeight;
      const ratio = targetWidth / targetHeight;
      if (targetWidth > maxWidth) {
          adjustedWidth = maxWidth;
          const deltaWidth = targetWidth - maxWidth;
          const deltaHeight = deltaWidth / ratio;
          adjustedHeight = targetHeight - deltaHeight;
      }
      if (adjustedHeight > maxHeight) {
          const deltaHeight = adjustedHeight - maxHeight;
          const deltaWidth = deltaHeight * ratio;
          adjustedHeight = maxHeight;
          adjustedWidth -= deltaWidth;
      }
      const adjustedArea = adjustedWidth * adjustedHeight;
      if (adjustedArea > maxArea) {
          const areaRatio = Math.sqrt(maxArea / adjustedArea);
          adjustedWidth *= areaRatio;
          adjustedHeight *= areaRatio;
      }
      const adjustRatio = adjustedWidth / targetWidth;
      return {
          adjustedWidth: adjustedWidth !== targetWidth ? Math.floor(adjustedWidth / 2) : targetWidth,
          adjustedHeight: adjustedHeight !== targetHeight ? Math.floor(adjustedHeight / 2) : targetHeight,
          adjustRatio: adjustRatio !== 1 ? adjustRatio / 2 : 1
      };
  };
  const createCanvas = (page, zoom = 1, cssClass = '') => {
      const scaleNum = scale();
      const viewport = page.getViewport({ scale: scaleNum });
      const { adjustedWidth, adjustedHeight, adjustRatio } = adjustCanvasSize(viewport.width, viewport.height);
      const styles = {
          width: Math.floor(viewport.width / scaleNum) * zoom + 'pt',
          height: Math.floor(viewport.height / scaleNum) * zoom + 'pt'
      };
      const pageElement = createElement('div', cssClass, styles);
      const canvas = createElement('canvas', '', {
          width: '100%',
          height: '100%'
      });
      canvas.height = adjustedHeight;
      canvas.width = adjustedWidth;
      const canvasContext = canvas.getContext('2d');
      pageElement.appendChild(canvas);
      const adjustedScale = adjustRatio * scaleNum;
      viewport.width = adjustedWidth;
      viewport.height = adjustedHeight;
      viewport.scale = adjustedScale;
      return {
          canvasContext,
          viewport,
          scaleNum,
          canvas,
          pageElement,
          styles
      };
  };
  const getDevicePixelRatio = () => (window === null || window === void 0 ? void 0 : window.devicePixelRatio) || 1;

  /******************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
  /* global Reflect, Promise, SuppressedError, Symbol, Iterator */

  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
  };

  function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  }

  var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
  };

  function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
  }

  function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
  }

  function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
  }

  function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
  };

  function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
  };

  function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
  };

  function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
  };

  function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
  }

  function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  }

  function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
  }

  var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
  }) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });

  function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
  }

  function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }

  function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
  }

  /** @deprecated */
  function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
  }

  /** @deprecated */
  function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
  }

  function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  }

  function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
  }

  function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
  }

  function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
  }

  function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
  }

  function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
  };

  var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  }) : function(o, v) {
    o["default"] = v;
  };

  var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return ownKeys(o);
  };

  function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  }

  function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
  }

  function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
  }

  function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
  }

  function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
  }

  function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
      if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
      var dispose, inner;
      if (async) {
        if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
        dispose = value[Symbol.asyncDispose];
      }
      if (dispose === void 0) {
        if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
        dispose = value[Symbol.dispose];
        if (async) inner = dispose;
      }
      if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
      if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
      env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
      env.stack.push({ async: true });
    }
    return value;
  }

  var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
  };

  function __disposeResources(env) {
    function fail(e) {
      env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
      env.hasError = true;
    }
    var r, s = 0;
    function next() {
      while (r = env.stack.pop()) {
        try {
          if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
          if (r.dispose) {
            var result = r.dispose.call(r.value);
            if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
          }
          else s |= 1;
        }
        catch (e) {
          fail(e);
        }
      }
      if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
      if (env.hasError) throw env.error;
    }
    return next();
  }

  function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) {
        return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
            return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
        });
    }
    return path;
  }

  var tslib_es6 = {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __esDecorate,
    __runInitializers,
    __propKey,
    __setFunctionName,
    __metadata,
    __awaiter,
    __generator,
    __createBinding,
    __exportStar,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet,
    __classPrivateFieldIn,
    __addDisposableResource,
    __disposeResources,
    __rewriteRelativeImportExtension,
  };

  const addClass = (className, element) => {
      element.classList.add(className);
  };
  const removeClass = (className, element) => {
      element.classList.remove(className);
  };
  const hasClass = (className, element) => {
      if (element instanceof HTMLElement) {
          return element.classList.contains(className);
      }
  };

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  /* Copyright 2012 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  // /* globals process */
  // NW.js / Electron is a browser context, but copies some Node.js objects; see
  // http://docs.nwjs.io/en/latest/For%20Users/Advanced/JavaScript%20Contexts%20in%20NW.js/access-nodejs-and-nwjs-api-in-browser-context
  // https://www.electronjs.org/docs/api/processprocessversionselectron-readonly
  // https://www.electronjs.org/docs/api/processprocesstype-readonly
  // const isNodeJS =
  //     (typeof PDFJSDev === "undefined" || PDFJSDev.test("GENERIC")) &&
  //     typeof process === "object" &&
  //     process + "" === "[object process]" &&
  //     !process.versions.nw &&
  //     !(process.versions.electron && process.type && process.type !== "browser");
  // const IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
  // const FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
  // const MAX_IMAGE_SIZE_TO_CACHE = 10e6; // Ten megabytes.
  // Represent the percentage of the height of a single-line field over
  // the font size. Acrobat seems to use this value.
  const LINE_FACTOR = 1.35;
  const LINE_DESCENT_FACTOR = 0.35;
  const BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
  /**
   * Refer to the `WorkerTransport.getRenderingIntent`-method in the API, to see
   * how these flags are being used:
   *  - ANY, DISPLAY, and PRINT are the normal rendering intents, note the
   *    `PDFPageProxy.{render, getOperatorList, getAnnotations}`-methods.
   *  - SAVE is used, on the worker-thread, when saving modified annotations.
   *  - ANNOTATIONS_FORMS, ANNOTATIONS_STORAGE, ANNOTATIONS_DISABLE control which
   *    annotations are rendered onto the canvas (i.e. by being included in the
   *    operatorList), note the `PDFPageProxy.{render, getOperatorList}`-methods
   *    and their `annotationMode`-option.
   *  - IS_EDITING is used when editing is active in the viewer.
   *  - OPLIST is used with the `PDFPageProxy.getOperatorList`-method, note the
   *    `OperatorList`-constructor (on the worker-thread).
   */
  // const RenderingIntentFlag = {
  //     ANY: 0x01,
  //     DISPLAY: 0x02,
  //     PRINT: 0x04,
  //     SAVE: 0x08,
  //     ANNOTATIONS_FORMS: 0x10,
  //     ANNOTATIONS_STORAGE: 0x20,
  //     ANNOTATIONS_DISABLE: 0x40,
  //     IS_EDITING: 0x80,
  //     OPLIST: 0x100
  // };
  const AnnotationMode = {
      DISABLE: 0,
      ENABLE: 1,
      ENABLE_FORMS: 2,
      ENABLE_STORAGE: 3
  };
  const AnnotationEditorPrefix = "pdfjs_internal_editor_";
  const AnnotationEditorType = {
      DISABLE: -1,
      NONE: 0,
      FREETEXT: 3,
      HIGHLIGHT: 9,
      STAMP: 13,
      INK: 15
  };
  const AnnotationEditorParamsType = {
      RESIZE: 1,
      CREATE: 2,
      FREETEXT_SIZE: 11,
      FREETEXT_COLOR: 12,
      FREETEXT_OPACITY: 13,
      INK_COLOR: 21,
      INK_THICKNESS: 22,
      INK_OPACITY: 23,
      HIGHLIGHT_COLOR: 31,
      HIGHLIGHT_DEFAULT_COLOR: 32,
      HIGHLIGHT_THICKNESS: 33,
      HIGHLIGHT_FREE: 34,
      HIGHLIGHT_SHOW_ALL: 35
  };
  // Permission flags from Table 22, Section 7.6.3.2 of the PDF specification.
  // const PermissionFlag = {
  //     PRINT: 0x04,
  //     MODIFY_CONTENTS: 0x08,
  //     COPY: 0x10,
  //     MODIFY_ANNOTATIONS: 0x20,
  //     FILL_INTERACTIVE_FORMS: 0x100,
  //     COPY_FOR_ACCESSIBILITY: 0x200,
  //     ASSEMBLE: 0x400,
  //     PRINT_HIGH_QUALITY: 0x800
  // };
  // const TextRenderingMode = {
  //     FILL: 0,
  //     STROKE: 1,
  //     FILL_STROKE: 2,
  //     INVISIBLE: 3,
  //     FILL_ADD_TO_PATH: 4,
  //     STROKE_ADD_TO_PATH: 5,
  //     FILL_STROKE_ADD_TO_PATH: 6,
  //     ADD_TO_PATH: 7,
  //     FILL_STROKE_MASK: 3,
  //     ADD_TO_PATH_FLAG: 4
  // };
  // const ImageKind = {
  //     GRAYSCALE_1BPP: 1,
  //     RGB_24BPP: 2,
  //     RGBA_32BPP: 3
  // };
  const AnnotationType = {
      TEXT: 1,
      LINK: 2,
      FREETEXT: 3,
      LINE: 4,
      SQUARE: 5,
      CIRCLE: 6,
      POLYGON: 7,
      POLYLINE: 8,
      HIGHLIGHT: 9,
      UNDERLINE: 10,
      SQUIGGLY: 11,
      STRIKEOUT: 12,
      STAMP: 13,
      CARET: 14,
      INK: 15,
      POPUP: 16,
      FILEATTACHMENT: 17,
      SOUND: 18,
      MOVIE: 19,
      WIDGET: 20,
      SCREEN: 21,
      PRINTERMARK: 22,
      TRAPNET: 23,
      WATERMARK: 24,
      THREED: 25,
      REDACT: 26
  };
  const AnnotationReplyType = {
      GROUP: "Group",
      REPLY: "R"
  };
  const AnnotationFlag = {
      INVISIBLE: 0x01,
      HIDDEN: 0x02,
      PRINT: 0x04,
      NOZOOM: 0x08,
      NOROTATE: 0x10,
      NOVIEW: 0x20,
      READONLY: 0x40,
      LOCKED: 0x80,
      TOGGLENOVIEW: 0x100,
      LOCKEDCONTENTS: 0x200
  };
  const AnnotationFieldFlag = {
      READONLY: 0x0000001,
      REQUIRED: 0x0000002,
      NOEXPORT: 0x0000004,
      MULTILINE: 0x0001000,
      PASSWORD: 0x0002000,
      NOTOGGLETOOFF: 0x0004000,
      RADIO: 0x0008000,
      PUSHBUTTON: 0x0010000,
      COMBO: 0x0020000,
      EDIT: 0x0040000,
      SORT: 0x0080000,
      FILESELECT: 0x0100000,
      MULTISELECT: 0x0200000,
      DONOTSPELLCHECK: 0x0400000,
      DONOTSCROLL: 0x0800000,
      COMB: 0x1000000,
      RICHTEXT: 0x2000000,
      RADIOSINUNISON: 0x2000000,
      COMMITONSELCHANGE: 0x4000000
  };
  const AnnotationBorderStyleType = {
      SOLID: 1,
      DASHED: 2,
      BEVELED: 3,
      INSET: 4,
      UNDERLINE: 5
  };
  const AnnotationActionEventType = {
      E: "Mouse Enter",
      X: "Mouse Exit",
      D: "Mouse Down",
      U: "Mouse Up",
      Fo: "Focus",
      Bl: "Blur",
      PO: "PageOpen",
      PC: "PageClose",
      PV: "PageVisible",
      PI: "PageInvisible",
      K: "Keystroke",
      F: "Format",
      V: "Validate",
      C: "Calculate"
  };
  // const DocumentActionEventType = {
  //     WC: "WillClose",
  //     WS: "WillSave",
  //     DS: "DidSave",
  //     WP: "WillPrint",
  //     DP: "DidPrint"
  // };
  // const PageActionEventType = {
  //     O: "PageOpen",
  //     C: "PageClose"
  // };
  // const VerbosityLevel = {
  //     ERRORS: 0,
  //     WARNINGS: 1,
  //     INFOS: 5
  // };
  // const CMapCompressionType = {
  //     NONE: 0,
  //     BINARY: 1
  // };
  // // All the possible operations for an operator list.
  // const OPS = {
  //     // Intentionally start from 1 so it is easy to spot bad operators that will be
  //     // 0's.
  //     // PLEASE NOTE: We purposely keep any removed operators commented out, since
  //     //              re-numbering the list would risk breaking third-party users.
  //     dependency: 1,
  //     setLineWidth: 2,
  //     setLineCap: 3,
  //     setLineJoin: 4,
  //     setMiterLimit: 5,
  //     setDash: 6,
  //     setRenderingIntent: 7,
  //     setFlatness: 8,
  //     setGState: 9,
  //     save: 10,
  //     restore: 11,
  //     transform: 12,
  //     moveTo: 13,
  //     lineTo: 14,
  //     curveTo: 15,
  //     curveTo2: 16,
  //     curveTo3: 17,
  //     closePath: 18,
  //     rectangle: 19,
  //     stroke: 20,
  //     closeStroke: 21,
  //     fill: 22,
  //     eoFill: 23,
  //     fillStroke: 24,
  //     eoFillStroke: 25,
  //     closeFillStroke: 26,
  //     closeEOFillStroke: 27,
  //     endPath: 28,
  //     clip: 29,
  //     eoClip: 30,
  //     beginText: 31,
  //     endText: 32,
  //     setCharSpacing: 33,
  //     setWordSpacing: 34,
  //     setHScale: 35,
  //     setLeading: 36,
  //     setFont: 37,
  //     setTextRenderingMode: 38,
  //     setTextRise: 39,
  //     moveText: 40,
  //     setLeadingMoveText: 41,
  //     setTextMatrix: 42,
  //     nextLine: 43,
  //     showText: 44,
  //     showSpacedText: 45,
  //     nextLineShowText: 46,
  //     nextLineSetSpacingShowText: 47,
  //     setCharWidth: 48,
  //     setCharWidthAndBounds: 49,
  //     setStrokeColorSpace: 50,
  //     setFillColorSpace: 51,
  //     setStrokeColor: 52,
  //     setStrokeColorN: 53,
  //     setFillColor: 54,
  //     setFillColorN: 55,
  //     setStrokeGray: 56,
  //     setFillGray: 57,
  //     setStrokeRGBColor: 58,
  //     setFillRGBColor: 59,
  //     setStrokeCMYKColor: 60,
  //     setFillCMYKColor: 61,
  //     shadingFill: 62,
  //     beginInlineImage: 63,
  //     beginImageData: 64,
  //     endInlineImage: 65,
  //     paintXObject: 66,
  //     markPoint: 67,
  //     markPointProps: 68,
  //     beginMarkedContent: 69,
  //     beginMarkedContentProps: 70,
  //     endMarkedContent: 71,
  //     beginCompat: 72,
  //     endCompat: 73,
  //     paintFormXObjectBegin: 74,
  //     paintFormXObjectEnd: 75,
  //     beginGroup: 76,
  //     endGroup: 77,
  //     // beginAnnotations: 78,
  //     // endAnnotations: 79,
  //     beginAnnotation: 80,
  //     endAnnotation: 81,
  //     // paintJpegXObject: 82,
  //     paintImageMaskXObject: 83,
  //     paintImageMaskXObjectGroup: 84,
  //     paintImageXObject: 85,
  //     paintInlineImageXObject: 86,
  //     paintInlineImageXObjectGroup: 87,
  //     paintImageXObjectRepeat: 88,
  //     paintImageMaskXObjectRepeat: 89,
  //     paintSolidColorImageMask: 90,
  //     constructPath: 91,
  //     setStrokeTransparent: 92,
  //     setFillTransparent: 93
  // };
  // const PasswordResponses = {
  //     NEED_PASSWORD: 1,
  //     INCORRECT_PASSWORD: 2
  // };
  // let verbosity = VerbosityLevel.WARNINGS;
  // function setVerbosityLevel(level) {
  //     if (Number.isInteger(level)) {
  //         verbosity = level;
  //     }
  // }
  // function getVerbosityLevel() {
  //     return verbosity;
  // }
  // // A notice for devs. These are good for things that are helpful to devs, such
  // // as warning that Workers were disabled, which is important to devs but not
  // // end users.
  // function info(msg) {
  //     if (verbosity >= VerbosityLevel.INFOS) {
  //         console.log(`Info: ${msg}`);
  //     }
  // }
  // // Non-fatal warnings.
  // function warn(msg) {
  //     if (verbosity >= VerbosityLevel.WARNINGS) {
  //         console.log(`Warning: ${msg}`);
  //     }
  // }
  // function unreachable(msg) {
  //     throw new Error(msg);
  // }
  // function assert(cond, msg) {
  //     if (!cond) {
  //         unreachable(msg);
  //     }
  // }
  // // Checks if URLs use one of the allowed protocols, e.g. to avoid XSS.
  // function _isValidProtocol(url) {
  //     if (!url || (url && !url.protocol)) {
  //         return false;
  //     }
  //     switch (url.protocol) {
  //         case "http:":
  //         case "https:":
  //         case "ftp:":
  //         case "mailto:":
  //         case "tel:":
  //             return true;
  //         default:
  //             return false;
  //     }
  // }
  // /**
  //  * Attempts to create a valid absolute URL.
  //  *
  //  * @param {URL|string} url - An absolute, or relative, URL.
  //  * @param {URL|string} [baseUrl] - An absolute URL.
  //  * @param {Object} [options]
  //  * @returns Either a valid {URL}, or `null` otherwise.
  //  */
  // function createValidAbsoluteUrl(url, baseUrl = null, options = null) {
  //     if (!url) {
  //         return null;
  //     }
  //     try {
  //         if (options && typeof url === "string") {
  //             // Let URLs beginning with "www." default to using the "http://" protocol.
  //             if (options.addDefaultProtocol && url.startsWith("www.")) {
  //                 const dots = url.match(/\./g);
  //                 // Avoid accidentally matching a *relative* URL pointing to a file named
  //                 // e.g. "www.pdf" or similar.
  //                 if (dots && dots.length >= 2) {
  //                     url = `http://${url}`;
  //                 }
  //             }
  //             // According to ISO 32000-1:2008, section 12.6.4.7, URIs should be encoded
  //             // in 7-bit ASCII. Some bad PDFs use UTF-8 encoding; see bug 1122280.
  //             if (options.tryConvertEncoding) {
  //                 try {
  //                     url = stringToUTF8String(url);
  //                 } catch (e) { }
  //             }
  //         }
  //         const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
  //         if (_isValidProtocol(absoluteUrl)) {
  //             return absoluteUrl;
  //         }
  //     } catch (e) {
  //         /* `new URL()` will throw on incorrect data. */
  //     }
  //     return null;
  // }
  function shadow(obj, prop, value, nonSerializable = false) {
      // if (typeof PDFJSDev === "undefined" || PDFJSDev.test("TESTING")) {
      //     assert(
      //         prop in obj,
      //         `shadow: Property "${prop && prop.toString()}" not found in object.`
      //     );
      // }
      Object.defineProperty(obj, prop, {
          value,
          enumerable: !nonSerializable,
          configurable: true,
          writable: false
      });
      return value;
  }
  // /**
  //  * @type {any}
  //  */
  // const BaseException = (function BaseExceptionClosure() {
  //     // eslint-disable-next-line no-shadow
  //     function BaseException(message, name) {
  //         if (this.constructor === BaseException) {
  //             unreachable("Cannot initialize BaseException.");
  //         }
  //         this.message = message;
  //         this.name = name;
  //     }
  //     BaseException.prototype = new Error();
  //     BaseException.constructor = BaseException;
  //     return BaseException;
  // })();
  // class PasswordException extends BaseException {
  //     constructor(msg, code) {
  //         super(msg, "PasswordException");
  //         this.code = code;
  //     }
  // }
  // class UnknownErrorException extends BaseException {
  //     constructor(msg, details) {
  //         super(msg, "UnknownErrorException");
  //         this.details = details;
  //     }
  // }
  // class InvalidPDFException extends BaseException {
  //     constructor(msg) {
  //         super(msg, "InvalidPDFException");
  //     }
  // }
  // class MissingPDFException extends BaseException {
  //     constructor(msg) {
  //         super(msg, "MissingPDFException");
  //     }
  // }
  // class UnexpectedResponseException extends BaseException {
  //     constructor(msg, status) {
  //         super(msg, "UnexpectedResponseException");
  //         this.status = status;
  //     }
  // }
  // /**
  //  * Error caused during parsing PDF data.
  //  */
  // class FormatError extends BaseException {
  //     constructor(msg) {
  //         super(msg, "FormatError");
  //     }
  // }
  // /**
  //  * Error used to indicate task cancellation.
  //  */
  // class AbortException extends BaseException {
  //     constructor(msg) {
  //         super(msg, "AbortException");
  //     }
  // }
  function bytesToString(bytes) {
      if (typeof bytes !== "object" || (bytes && bytes.length === undefined)) {
          // unreachable("Invalid argument for bytesToString");
      }
      const length = bytes.length;
      const MAX_ARGUMENT_COUNT = 8192;
      if (length < MAX_ARGUMENT_COUNT) {
          return String.fromCharCode.apply(null, bytes);
      }
      const strBuf = [];
      for (let i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
          const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
          const chunk = bytes.subarray(i, chunkEnd);
          strBuf.push(String.fromCharCode.apply(null, chunk));
      }
      return strBuf.join("");
  }
  // function stringToBytes(str) {
  //     if (typeof str !== "string") {
  //         unreachable("Invalid argument for stringToBytes");
  //     }
  //     const length = str.length;
  //     const bytes = new Uint8Array(length);
  //     for (let i = 0; i < length; ++i) {
  //         bytes[i] = str.charCodeAt(i) & 0xff;
  //     }
  //     return bytes;
  // }
  // function string32(value) {
  //     if (typeof PDFJSDev === "undefined" || PDFJSDev.test("TESTING")) {
  //         assert(
  //             typeof value === "number" && Math.abs(value) < 2 ** 32,
  //             `string32: Unexpected input "${value}".`
  //         );
  //     }
  //     return String.fromCharCode(
  //         (value >> 24) & 0xff,
  //         (value >> 16) & 0xff,
  //         (value >> 8) & 0xff,
  //         value & 0xff
  //     );
  // }
  // function objectSize(obj) {
  //     return Object.keys(obj).length;
  // }
  // // Ensure that the returned Object has a `null` prototype; hence why
  // // `Object.fromEntries(...)` is not used.
  function objectFromMap(map) {
      const obj = Object.create(null);
      for (const [key, value] of map) {
          obj[key] = value;
      }
      return obj;
  }
  // // Checks the endianness of the platform.
  // function isLittleEndian() {
  //     const buffer8 = new Uint8Array(4);
  //     buffer8[0] = 1;
  //     const view32 = new Uint32Array(buffer8.buffer, 0, 1);
  //     return view32[0] === 1;
  // }
  // // Checks if it's possible to eval JS expressions.
  // function isEvalSupported() {
  //     try {
  //         new Function(""); // eslint-disable-line no-new, no-new-func
  //         return true;
  //     } catch (e) {
  //         return false;
  //     }
  // }
  class FeatureTest {
      // static get isLittleEndian() {
      //     return shadow(this, "isLittleEndian", isLittleEndian());
      // }
      // static get isEvalSupported() {
      //     return shadow(this, "isEvalSupported", isEvalSupported());
      // }
      // static get isOffscreenCanvasSupported() {
      //     return shadow(
      //         this,
      //         "isOffscreenCanvasSupported",
      //         typeof OffscreenCanvas !== "undefined"
      //     );
      // }
      // static get platform() {
      //     if (
      //         (typeof PDFJSDev !== "undefined" && PDFJSDev.test("MOZCENTRAL")) ||
      //         (typeof navigator !== "undefined" &&
      //             navigator && typeof navigator.platform === "string")
      //     ) {
      //         return shadow(this, "platform", {
      //             isMac: navigator.platform.includes("Mac"),
      //         });
      //     }
      //     return shadow(this, "platform", { isMac: false });
      // }
      static get isCSSRoundSupported() {
          return shadow(this, "isCSSRoundSupported", globalThis && globalThis.CSS && globalThis.CSS.supports &&
              globalThis.CSS.supports("width: round(1.5px, 1px)"));
      }
  }
  const hexNumbers = Array.from(Array(256).keys(), n => n.toString(16).padStart(2, "0"));
  class Util {
      static makeHexColor(r, g, b) {
          return `${hexNumbers[r]}${hexNumbers[g]}${hexNumbers[b]}`;
      }
      //     // Apply a scaling matrix to some min/max values.
      //     // If a scaling factor is negative then min and max must be
      //     // swapped.
      //     static scaleMinMax(transform, minMax) {
      //         let temp;
      //         if (transform[0]) {
      //             if (transform[0] < 0) {
      //                 temp = minMax[0];
      //                 minMax[0] = minMax[2];
      //                 minMax[2] = temp;
      //             }
      //             minMax[0] *= transform[0];
      //             minMax[2] *= transform[0];
      //             if (transform[3] < 0) {
      //                 temp = minMax[1];
      //                 minMax[1] = minMax[3];
      //                 minMax[3] = temp;
      //             }
      //             minMax[1] *= transform[3];
      //             minMax[3] *= transform[3];
      //         } else {
      //             temp = minMax[0];
      //             minMax[0] = minMax[1];
      //             minMax[1] = temp;
      //             temp = minMax[2];
      //             minMax[2] = minMax[3];
      //             minMax[3] = temp;
      //             if (transform[1] < 0) {
      //                 temp = minMax[1];
      //                 minMax[1] = minMax[3];
      //                 minMax[3] = temp;
      //             }
      //             minMax[1] *= transform[1];
      //             minMax[3] *= transform[1];
      //             if (transform[2] < 0) {
      //                 temp = minMax[0];
      //                 minMax[0] = minMax[2];
      //                 minMax[2] = temp;
      //             }
      //             minMax[0] *= transform[2];
      //             minMax[2] *= transform[2];
      //         }
      //         minMax[0] += transform[4];
      //         minMax[1] += transform[5];
      //         minMax[2] += transform[4];
      //         minMax[3] += transform[5];
      //     }
      //     // Concatenates two transformation matrices together and returns the result.
      //     static transform(m1, m2) {
      //         return [
      //             m1[0] * m2[0] + m1[2] * m2[1],
      //             m1[1] * m2[0] + m1[3] * m2[1],
      //             m1[0] * m2[2] + m1[2] * m2[3],
      //             m1[1] * m2[2] + m1[3] * m2[3],
      //             m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
      //             m1[1] * m2[4] + m1[3] * m2[5] + m1[5],
      //         ];
      //     }
      //     // For 2d affine transforms
      //     static applyTransform(p, m) {
      //         const xt = p[0] * m[0] + p[1] * m[2] + m[4];
      //         const yt = p[0] * m[1] + p[1] * m[3] + m[5];
      //         return [xt, yt];
      //     }
      //     static applyInverseTransform(p, m) {
      //         const d = m[0] * m[3] - m[1] * m[2];
      //         const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
      //         const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
      //         return [xt, yt];
      //     }
      //     // Applies the transform to the rectangle and finds the minimum axially
      //     // aligned bounding box.
      //     static getAxialAlignedBoundingBox(r, m) {
      //         const p1 = this.applyTransform(r, m);
      //         const p2 = this.applyTransform(r.slice(2, 4), m);
      //         const p3 = this.applyTransform([r[0], r[3]], m);
      //         const p4 = this.applyTransform([r[2], r[1]], m);
      //         return [
      //             Math.min(p1[0], p2[0], p3[0], p4[0]),
      //             Math.min(p1[1], p2[1], p3[1], p4[1]),
      //             Math.max(p1[0], p2[0], p3[0], p4[0]),
      //             Math.max(p1[1], p2[1], p3[1], p4[1]),
      //         ];
      //     }
      //     static inverseTransform(m) {
      //         const d = m[0] * m[3] - m[1] * m[2];
      //         return [
      //             m[3] / d,
      //             -m[1] / d,
      //             -m[2] / d,
      //             m[0] / d,
      //             (m[2] * m[5] - m[4] * m[3]) / d,
      //             (m[4] * m[1] - m[5] * m[0]) / d,
      //         ];
      //     }
      //     // This calculation uses Singular Value Decomposition.
      //     // The SVD can be represented with formula A = USV. We are interested in the
      //     // matrix S here because it represents the scale values.
      //     static singularValueDecompose2dScale(m) {
      //         const transpose = [m[0], m[2], m[1], m[3]];
      //         // Multiply matrix m with its transpose.
      //         const a = m[0] * transpose[0] + m[1] * transpose[2];
      //         const b = m[0] * transpose[1] + m[1] * transpose[3];
      //         const c = m[2] * transpose[0] + m[3] * transpose[2];
      //         const d = m[2] * transpose[1] + m[3] * transpose[3];
      //         // Solve the second degree polynomial to get roots.
      //         const first = (a + d) / 2;
      //         const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
      //         const sx = first + second || 1;
      //         const sy = first - second || 1;
      //         // Scale values are the square roots of the eigenvalues.
      //         return [Math.sqrt(sx), Math.sqrt(sy)];
      //     }
      //     // Normalize rectangle rect=[x1, y1, x2, y2] so that (x1,y1) < (x2,y2)
      //     // For coordinate systems whose origin lies in the bottom-left, this
      //     // means normalization to (BL,TR) ordering. For systems with origin in the
      //     // top-left, this means (TL,BR) ordering.
      static normalizeRect(rect) {
          const r = rect.slice(0); // clone rect
          if (rect[0] > rect[2]) {
              r[0] = rect[2];
              r[2] = rect[0];
          }
          if (rect[1] > rect[3]) {
              r[1] = rect[3];
              r[3] = rect[1];
          }
          return r;
      }
  }
  // const PDFStringTranslateTable = [
  //     0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2d8,
  //     0x2c7, 0x2c6, 0x2d9, 0x2dd, 0x2db, 0x2da, 0x2dc, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //     0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //     0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //     0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  //     0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192,
  //     0x2044, 0x2039, 0x203a, 0x2212, 0x2030, 0x201e, 0x201c, 0x201d, 0x2018,
  //     0x2019, 0x201a, 0x2122, 0xfb01, 0xfb02, 0x141, 0x152, 0x160, 0x178, 0x17d,
  //     0x131, 0x142, 0x153, 0x161, 0x17e, 0, 0x20ac,
  // ];
  // function stringToPDFString(str) {
  //     // See section 7.9.2.2 Text String Type.
  //     // The string can contain some language codes bracketed with 0x0b,
  //     // so we must remove them.
  //     if (str[0] >= "\xEF") {
  //         let encoding;
  //         if (str[0] === "\xFE" && str[1] === "\xFF") {
  //             encoding = "utf-16be";
  //             if (str.length % 2 === 1) {
  //                 str = str.slice(0, -1);
  //             }
  //         } else if (str[0] === "\xFF" && str[1] === "\xFE") {
  //             encoding = "utf-16le";
  //             if (str.length % 2 === 1) {
  //                 str = str.slice(0, -1);
  //             }
  //         } else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") {
  //             encoding = "utf-8";
  //         }
  //         if (encoding) {
  //             try {
  //                 const decoder = new TextDecoder(encoding, { fatal: true });
  //                 const buffer = stringToBytes(str);
  //                 const decoded = decoder.decode(buffer);
  //                 if (!decoded.includes("\x1b")) {
  //                     return decoded;
  //                 }
  //                 return decoded.replaceAll(/\x1b[^\x1b]*(?:\x1b|$)/g, "");
  //             } catch (ex) {
  //                 warn(`stringToPDFString: "${ex}".`);
  //             }
  //         }
  //     }
  //     // ISO Latin 1
  //     const strBuf = [];
  //     for (let i = 0, ii = str.length; i < ii; i++) {
  //         const charCode = str.charCodeAt(i);
  //         if (charCode === 0x1b) {
  //             // eslint-disable-next-line no-empty
  //             while (++i < ii && str.charCodeAt(i) !== 0x1b) { }
  //             continue;
  //         }
  //         const code = PDFStringTranslateTable[charCode];
  //         strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
  //     }
  //     return strBuf.join("");
  // }
  // function stringToUTF8String(str) {
  //     return decodeURIComponent(escape(str));
  // }
  // function utf8StringToString(str) {
  //     return unescape(encodeURIComponent(str));
  // }
  // function isArrayEqual(arr1, arr2) {
  //     if (arr1.length !== arr2.length) {
  //         return false;
  //     }
  //     for (let i = 0, ii = arr1.length; i < ii; i++) {
  //         if (arr1[i] !== arr2[i]) {
  //             return false;
  //         }
  //     }
  //     return true;
  // }
  // function getModificationDate(date = new Date()) {
  //     const buffer = [
  //         date.getUTCFullYear().toString(),
  //         (date.getUTCMonth() + 1).toString().padStart(2, "0"),
  //         date.getUTCDate().toString().padStart(2, "0"),
  //         date.getUTCHours().toString().padStart(2, "0"),
  //         date.getUTCMinutes().toString().padStart(2, "0"),
  //         date.getUTCSeconds().toString().padStart(2, "0"),
  //     ];
  //     return buffer.join("");
  // }
  // let NormalizeRegex = null;
  // let NormalizationMap = null;
  // function normalizeUnicode(str) {
  //     if (!NormalizeRegex) {
  //         // In order to generate the following regex:
  //         //  - create a PDF containing all the chars in the range 0000-FFFF with
  //         //    a NFKC which is different of the char.
  //         //  - copy and paste all those chars and get the ones where NFKC is
  //         //    required.
  //         // It appears that most the chars here contain some ligatures.
  //         NormalizeRegex =
  //             /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
  //         NormalizationMap = new Map([["ﬅ", "ſt"]]);
  //     }
  //     return str.replaceAll(NormalizeRegex, (_, p1, p2) =>
  //         p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2)
  //     );
  // }
  function getUuid() {
      if (
      // (typeof PDFJSDev !== "undefined" && PDFJSDev.test("MOZCENTRAL")) ||
      (typeof crypto !== "undefined" && crypto && typeof crypto.randomUUID === "function")) {
          return crypto.randomUUID();
      }
      const buf = new Uint8Array(32);
      if (typeof crypto !== "undefined" &&
          crypto && typeof crypto.getRandomValues === "function") {
          crypto.getRandomValues(buf);
      }
      else {
          for (let i = 0; i < 32; i++) {
              buf[i] = Math.floor(Math.random() * 255);
          }
      }
      return bytesToString(buf);
  }
  const AnnotationPrefix = "pdfjs_internal_id_";

  /* Copyright 2022 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _IdManager_id;
  class IdManager {
      constructor(idPrefix = AnnotationEditorPrefix) {
          _IdManager_id.set(this, 0);
          this.idPrefix = AnnotationEditorPrefix;
          // if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("TESTING")) {
          Object.defineProperty(this, "reset", {
              value: () => (__classPrivateFieldSet(this, _IdManager_id, 0, "f"))
          });
          // }
          this.idPrefix = idPrefix;
      }
      get id() {
          var _a, _b;
          return `${this.idPrefix}${__classPrivateFieldSet(this, _IdManager_id, (_b = __classPrivateFieldGet(this, _IdManager_id, "f"), _a = _b++, _b), "f"), _a}`;
      }
  }
  _IdManager_id = new WeakMap();

  /* Copyright 2022 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _CommandManager_commands, _CommandManager_locked, _CommandManager_maxSize, _CommandManager_position;
  /*
   * Class to handle undo/redo.
   * Commands are just saved in a buffer.
   * If we hit some memory issues we could likely use a circular buffer.
   * It has to be used as a singleton.
   */
  class CommandManager {
      constructor(maxSize = 128) {
          _CommandManager_commands.set(this, []);
          _CommandManager_locked.set(this, false);
          _CommandManager_maxSize.set(this, void 0);
          _CommandManager_position.set(this, -1);
          __classPrivateFieldSet(this, _CommandManager_maxSize, maxSize, "f");
      }
      /**
       * @typedef {Object} addOptions
       * @property {function} cmd
       * @property {function} undo
       * @property {function} [post]
       * @property {boolean} mustExec
       * @property {number} type
       * @property {boolean} overwriteIfSameType
       * @property {boolean} keepUndo
       */
      /*
       * Add a new couple of commands to be used in case of redo/undo.
       * @param {addOptions} options
       */
      add({ cmd, undo, post, mustExec, type = NaN, overwriteIfSameType = false, keepUndo = false }) {
          if (mustExec) {
              cmd();
          }
          if (__classPrivateFieldGet(this, _CommandManager_locked, "f")) {
              return;
          }
          const save = { cmd, undo, post, type };
          if (__classPrivateFieldGet(this, _CommandManager_position, "f") === -1) {
              if (__classPrivateFieldGet(this, _CommandManager_commands, "f").length > 0) {
                  // All the commands have been undone and then a new one is added
                  // hence we clear the queue.
                  __classPrivateFieldGet(this, _CommandManager_commands, "f").length = 0;
              }
              __classPrivateFieldSet(this, _CommandManager_position, 0, "f");
              __classPrivateFieldGet(this, _CommandManager_commands, "f").push(save);
              return;
          }
          if (overwriteIfSameType && __classPrivateFieldGet(this, _CommandManager_commands, "f")[__classPrivateFieldGet(this, _CommandManager_position, "f")].type === type) {
              // For example when we change a color we don't want to
              // be able to undo all the steps, hence we only want to
              // keep the last undoable action in this sequence of actions.
              if (keepUndo) {
                  save.undo = __classPrivateFieldGet(this, _CommandManager_commands, "f")[__classPrivateFieldGet(this, _CommandManager_position, "f")].undo;
              }
              __classPrivateFieldGet(this, _CommandManager_commands, "f")[__classPrivateFieldGet(this, _CommandManager_position, "f")] = save;
              return;
          }
          const next = __classPrivateFieldGet(this, _CommandManager_position, "f") + 1;
          if (next === __classPrivateFieldGet(this, _CommandManager_maxSize, "f")) {
              __classPrivateFieldGet(this, _CommandManager_commands, "f").splice(0, 1);
          }
          else {
              __classPrivateFieldSet(this, _CommandManager_position, next, "f");
              if (next < __classPrivateFieldGet(this, _CommandManager_commands, "f").length) {
                  __classPrivateFieldGet(this, _CommandManager_commands, "f").splice(next);
              }
          }
          __classPrivateFieldGet(this, _CommandManager_commands, "f").push(save);
      }
      /**
       * Undo the last command.
       */
      undo() {
          if (__classPrivateFieldGet(this, _CommandManager_position, "f") === -1) {
              // Nothing to undo.
              return;
          }
          // Avoid to insert something during the undo execution.
          __classPrivateFieldSet(this, _CommandManager_locked, true, "f");
          const { undo, post } = __classPrivateFieldGet(this, _CommandManager_commands, "f")[__classPrivateFieldGet(this, _CommandManager_position, "f")];
          undo();
          post === null || post === void 0 ? void 0 : post();
          __classPrivateFieldSet(this, _CommandManager_locked, false, "f");
          __classPrivateFieldSet(this, _CommandManager_position, __classPrivateFieldGet(this, _CommandManager_position, "f") - 1, "f");
      }
      /**
       * Redo the last command.
       */
      redo() {
          if (__classPrivateFieldGet(this, _CommandManager_position, "f") < __classPrivateFieldGet(this, _CommandManager_commands, "f").length - 1) {
              __classPrivateFieldSet(this, _CommandManager_position, __classPrivateFieldGet(this, _CommandManager_position, "f") + 1, "f");
              // Avoid to insert something during the redo execution.
              __classPrivateFieldSet(this, _CommandManager_locked, true, "f");
              const { cmd, post } = __classPrivateFieldGet(this, _CommandManager_commands, "f")[__classPrivateFieldGet(this, _CommandManager_position, "f")];
              cmd();
              post === null || post === void 0 ? void 0 : post();
              __classPrivateFieldSet(this, _CommandManager_locked, false, "f");
          }
      }
      /**
       * Check if there is something to undo.
       * @returns {boolean}
       */
      hasSomethingToUndo() {
          return __classPrivateFieldGet(this, _CommandManager_position, "f") !== -1;
      }
      /**
       * Check if there is something to redo.
       * @returns {boolean}
       */
      hasSomethingToRedo() {
          return __classPrivateFieldGet(this, _CommandManager_position, "f") < __classPrivateFieldGet(this, _CommandManager_commands, "f").length - 1;
      }
      destroy() {
          __classPrivateFieldSet(this, _CommandManager_commands, null, "f");
      }
  }
  _CommandManager_commands = new WeakMap(), _CommandManager_locked = new WeakMap(), _CommandManager_maxSize = new WeakMap(), _CommandManager_position = new WeakMap();

  /* Copyright 2014 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _AnnotationEditorUIManager_instances, _AnnotationEditorUIManager_abortController, _AnnotationEditorUIManager_activeEditor, _AnnotationEditorUIManager_allEditors, _AnnotationEditorUIManager_allLayers, _AnnotationEditorUIManager_annotationStorage, _AnnotationEditorUIManager_changedExistingAnnotations, _AnnotationEditorUIManager_commandManager, _AnnotationEditorUIManager_currentPageIndex, _AnnotationEditorUIManager_deletedAnnotationsElementIds, _AnnotationEditorUIManager_draggingEditors, _AnnotationEditorUIManager_editorTypes, _AnnotationEditorUIManager_editorsToRescale, _AnnotationEditorUIManager_enableHighlightFloatingButton, _AnnotationEditorUIManager_focusMainContainerTimeoutId, _AnnotationEditorUIManager_focusManagerAC, _AnnotationEditorUIManager_highlightColors, _AnnotationEditorUIManager_highlightWhenShiftUp, _AnnotationEditorUIManager_highlightToolbar, _AnnotationEditorUIManager_idManager, _AnnotationEditorUIManager_isEnabled, _AnnotationEditorUIManager_isWaiting, _AnnotationEditorUIManager_lastActiveElement, _AnnotationEditorUIManager_mode, _AnnotationEditorUIManager_selectedEditors, _AnnotationEditorUIManager_selectedTextNode, _AnnotationEditorUIManager_showAllStates, _AnnotationEditorUIManager_previousStates, _AnnotationEditorUIManager_translation, _AnnotationEditorUIManager_translationTimeoutId, _AnnotationEditorUIManager_container, _AnnotationEditorUIManager_viewer, _AnnotationEditorUIManager_getAnchorElementForSelection, _AnnotationEditorUIManager_getLayerForTextLayer, _AnnotationEditorUIManager_displayHighlightToolbar, _AnnotationEditorUIManager_selectionChange, _AnnotationEditorUIManager_onSelectEnd, _AnnotationEditorUIManager_addSelectionListener, _AnnotationEditorUIManager_addFocusManager, _AnnotationEditorUIManager_removeFocusManager, _AnnotationEditorUIManager_addKeyboardManager, _AnnotationEditorUIManager_removeKeyboardManager, _AnnotationEditorUIManager_addCopyPasteListeners, _AnnotationEditorUIManager_removeCopyPasteListeners, _AnnotationEditorUIManager_addDragAndDropListeners, _AnnotationEditorUIManager_dispatchUpdateStates, _AnnotationEditorUIManager_dispatchUpdateUI, _AnnotationEditorUIManager_enableAll, _AnnotationEditorUIManager_disableAll, _AnnotationEditorUIManager_addEditorToLayer, _AnnotationEditorUIManager_lastSelectedEditor_get, _AnnotationEditorUIManager_isEmpty, _AnnotationEditorUIManager_selectEditors;
  // import { ImageManager } from "./helpers/image-manager";
  class AnnotationEditorUIManager {
      // static get _keyboardManager() {
      //     const proto = AnnotationEditorUIManager.prototype;
      //     /**
      //      * If the focused element is an input, we don't want to handle the arrow.
      //      * For example, sliders can be controlled with the arrow keys.
      //      */
      //     const arrowChecker = self =>
      //         self.#container.contains(document.activeElement) &&
      //         document.activeElement.tagName !== "BUTTON" &&
      //         self.hasSomethingToControl();
      //     const textInputChecker = (_self, { target: el }) => {
      //         if (el instanceof HTMLInputElement) {
      //             const { type } = el;
      //             return type !== "text" && type !== "number";
      //         }
      //         return true;
      //     };
      //     const small = this.TRANSLATE_SMALL;
      //     const big = this.TRANSLATE_BIG;
      //     return shadow(
      //         this,
      //         "_keyboardManager",
      //         new KeyboardManager([
      //             [
      //                 ["ctrl+a", "mac+meta+a"],
      //                 proto.selectAll,
      //                 { checker: textInputChecker },
      //             ],
      //             [["ctrl+z", "mac+meta+z"], proto.undo, { checker: textInputChecker }],
      //             [
      //                 // On mac, depending of the OS version, the event.key is either "z" or
      //                 // "Z" when the user presses "meta+shift+z".
      //                 [
      //                     "ctrl+y",
      //                     "ctrl+shift+z",
      //                     "mac+meta+shift+z",
      //                     "ctrl+shift+Z",
      //                     "mac+meta+shift+Z",
      //                 ],
      //                 proto.redo,
      //                 { checker: textInputChecker },
      //             ],
      //             [
      //                 [
      //                     "Backspace",
      //                     "alt+Backspace",
      //                     "ctrl+Backspace",
      //                     "shift+Backspace",
      //                     "mac+Backspace",
      //                     "mac+alt+Backspace",
      //                     "mac+ctrl+Backspace",
      //                     "Delete",
      //                     "ctrl+Delete",
      //                     "shift+Delete",
      //                     "mac+Delete",
      //                 ],
      //                 proto.delete,
      //                 { checker: textInputChecker },
      //             ],
      //             [
      //                 ["Enter", "mac+Enter"],
      //                 proto.addNewEditorFromKeyboard,
      //                 {
      //                     // Those shortcuts can be used in the toolbar for some other actions
      //                     // like zooming, hence we need to check if the container has the
      //                     // focus.
      //                     checker: (self, { target: el }) =>
      //                         !(el instanceof HTMLButtonElement) &&
      //                         self.#container.contains(el) &&
      //                         !self.isEnterHandled,
      //                 },
      //             ],
      //             [
      //                 [" ", "mac+ "],
      //                 proto.addNewEditorFromKeyboard,
      //                 {
      //                     // Those shortcuts can be used in the toolbar for some other actions
      //                     // like zooming, hence we need to check if the container has the
      //                     // focus.
      //                     checker: (self, { target: el }) =>
      //                         !(el instanceof HTMLButtonElement) &&
      //                         self.#container.contains(document.activeElement),
      //                 },
      //             ],
      //             [["Escape", "mac+Escape"], proto.unselectAll],
      //             [
      //                 ["ArrowLeft", "mac+ArrowLeft"],
      //                 proto.translateSelectedEditors,
      //                 { args: [-small, 0], checker: arrowChecker },
      //             ],
      //             [
      //                 ["ctrl+ArrowLeft", "mac+shift+ArrowLeft"],
      //                 proto.translateSelectedEditors,
      //                 { args: [-big, 0], checker: arrowChecker },
      //             ],
      //             [
      //                 ["ArrowRight", "mac+ArrowRight"],
      //                 proto.translateSelectedEditors,
      //                 { args: [small, 0], checker: arrowChecker },
      //             ],
      //             [
      //                 ["ctrl+ArrowRight", "mac+shift+ArrowRight"],
      //                 proto.translateSelectedEditors,
      //                 { args: [big, 0], checker: arrowChecker },
      //             ],
      //             [
      //                 ["ArrowUp", "mac+ArrowUp"],
      //                 proto.translateSelectedEditors,
      //                 { args: [0, -small], checker: arrowChecker },
      //             ],
      //             [
      //                 ["ctrl+ArrowUp", "mac+shift+ArrowUp"],
      //                 proto.translateSelectedEditors,
      //                 { args: [0, -big], checker: arrowChecker },
      //             ],
      //             [
      //                 ["ArrowDown", "mac+ArrowDown"],
      //                 proto.translateSelectedEditors,
      //                 { args: [0, small], checker: arrowChecker },
      //             ],
      //             [
      //                 ["ctrl+ArrowDown", "mac+shift+ArrowDown"],
      //                 proto.translateSelectedEditors,
      //                 { args: [0, big], checker: arrowChecker },
      //             ],
      //         ])
      //     );
      // }
      constructor({ container = null, viewer, pdfViewer, 
      // altTextManager,
      eventBus, pdfDocument, 
      // pageColors,
      highlightColors = ""
      // enableHighlightFloatingButton,
      // enableUpdatedAddImage,
      // enableNewAltTextWhenAddingImage,
      // mlManager
       }) {
          _AnnotationEditorUIManager_instances.add(this);
          // todo: props
          // todo: extract to pdf viewer
          this.pdfViewer = null;
          this.annotationEditorMode = kendo_pdfjs_loader_js.AnnotationEditorType.NONE;
          this.viewParameters = {};
          this.isShiftKeyDown = false;
          this._eventBus = null;
          // todo: props
          _AnnotationEditorUIManager_abortController.set(this, new AbortController());
          _AnnotationEditorUIManager_activeEditor.set(this, null);
          _AnnotationEditorUIManager_allEditors.set(this, new Map());
          _AnnotationEditorUIManager_allLayers.set(this, new Map());
          // #altTextManager = null;
          _AnnotationEditorUIManager_annotationStorage.set(this, null);
          _AnnotationEditorUIManager_changedExistingAnnotations.set(this, null);
          _AnnotationEditorUIManager_commandManager.set(this, new CommandManager());
          // #copyPasteAC = null;
          _AnnotationEditorUIManager_currentPageIndex.set(this, 0);
          _AnnotationEditorUIManager_deletedAnnotationsElementIds.set(this, new Set());
          _AnnotationEditorUIManager_draggingEditors.set(this, null);
          _AnnotationEditorUIManager_editorTypes.set(this, null);
          _AnnotationEditorUIManager_editorsToRescale.set(this, new Set());
          // todo: change default value
          // #enableHighlightFloatingButton = false;
          _AnnotationEditorUIManager_enableHighlightFloatingButton.set(this, true);
          // #enableUpdatedAddImage = false;
          // #enableNewAltTextWhenAddingImage = false;
          // #filterFactory = null;
          _AnnotationEditorUIManager_focusMainContainerTimeoutId.set(this, null);
          _AnnotationEditorUIManager_focusManagerAC.set(this, null);
          // todo: this is defined in "highlightEditorColors" in pdf.js as
          // value: "yellow=#FFFF98,green=#53FFBC,blue=#80EBFF,pink=#FFCBE6,red=#FF4F5F",
          _AnnotationEditorUIManager_highlightColors.set(this, "");
          _AnnotationEditorUIManager_highlightWhenShiftUp.set(this, false);
          _AnnotationEditorUIManager_highlightToolbar.set(this, null);
          _AnnotationEditorUIManager_idManager.set(this, new IdManager());
          _AnnotationEditorUIManager_isEnabled.set(this, false);
          _AnnotationEditorUIManager_isWaiting.set(this, false);
          // #keyboardManagerAC = null;
          _AnnotationEditorUIManager_lastActiveElement.set(this, null);
          // #mainHighlightColorPicker = null;
          // #mlManager = null;
          _AnnotationEditorUIManager_mode.set(this, kendo_pdfjs_loader_js.AnnotationEditorType.NONE);
          _AnnotationEditorUIManager_selectedEditors.set(this, new Set());
          _AnnotationEditorUIManager_selectedTextNode.set(this, null);
          // #pageColors = null;
          _AnnotationEditorUIManager_showAllStates.set(this, null);
          _AnnotationEditorUIManager_previousStates.set(this, {
              isEditing: false,
              isEmpty: true,
              hasSomethingToUndo: false,
              hasSomethingToRedo: false,
              hasSelectedEditor: false,
              hasSelectedText: false
          });
          _AnnotationEditorUIManager_translation.set(this, [0, 0]);
          _AnnotationEditorUIManager_translationTimeoutId.set(this, null);
          _AnnotationEditorUIManager_container.set(this, null);
          _AnnotationEditorUIManager_viewer.set(this, null);
          // // const signal = (this._signal = this.#abortController.signal);
          const signal = this._signal = __classPrivateFieldGet(this, _AnnotationEditorUIManager_abortController, "f").signal;
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_container, container, "f");
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_viewer, viewer, "f");
          this.pdfViewer = pdfViewer;
          // this.#altTextManager = altTextManager;
          this._eventBus = eventBus;
          this._eventBus._on("editingaction", this.onEditingAction.bind(this), {
              signal
          });
          this._eventBus._on("pagechanging", this.onPageChanging.bind(this), {
              signal
          });
          this._eventBus._on("scalechanging", this.onScaleChanging.bind(this), {
              signal
          });
          this._eventBus._on("rotationchanging", this.onRotationChanging.bind(this), {
              signal
          });
          this._eventBus._on("setpreference", this.onSetPreference.bind(this), {
              signal
          });
          this._eventBus._on("namedaction", this.onNamedAction.bind(this), {
              signal
          });
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addSelectionListener).call(this);
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addDragAndDropListeners).call(this);
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addKeyboardManager).call(this);
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_annotationStorage, pdfDocument.annotationStorage, "f");
          // this.#filterFactory = pdfDocument.filterFactory;
          // this.#pageColors = pageColors;
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_highlightColors, highlightColors || "", "f");
          // this.#enableHighlightFloatingButton = enableHighlightFloatingButton;
          // this.#enableUpdatedAddImage = enableUpdatedAddImage;
          // this.#enableNewAltTextWhenAddingImage = enableNewAltTextWhenAddingImage;
          // this.#mlManager = mlManager || null;
          this.viewParameters = {
              realScale: kendo_pdfjs_loader_js.PixelsPerInch.PDF_TO_CSS_UNITS,
              rotation: 0
          };
          // this.isShiftKeyDown = false;
          // if ( typeof PDFJSDev !== "undefined" && PDFJSDev.test("TESTING")) {
          //     window.uiManager = this;
          //     Object.defineProperty(this, "reset", {
          //         value: () => {
          //             this.selectAll();
          //             this.delete();
          //             this.#idManager.reset();
          //         },
          //     });
          // }
      }
      destroy() {
          var _a;
          (_a = __classPrivateFieldGet(this, _AnnotationEditorUIManager_abortController, "f")) === null || _a === void 0 ? void 0 : _a.abort();
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_abortController, null, "f");
          this._signal = null;
          for (const layer of __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()) {
              layer.destroy();
          }
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").clear();
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").clear();
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_editorsToRescale, "f").clear();
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_activeEditor, null, "f");
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").clear();
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").destroy();
          // this.#altTextManager?.destroy();
          // this.#highlightToolbar?.hide();
          // this.#highlightToolbar = null;
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, "f")) {
              clearTimeout(__classPrivateFieldGet(this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, "f"));
              __classPrivateFieldSet(this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, null, "f");
          }
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_translationTimeoutId, "f")) {
              clearTimeout(__classPrivateFieldGet(this, _AnnotationEditorUIManager_translationTimeoutId, "f"));
              __classPrivateFieldSet(this, _AnnotationEditorUIManager_translationTimeoutId, null, "f");
          }
      }
      // todo: new
      getTextLayerForAnchor(anchorElement) {
          if (!anchorElement) {
              return null;
          }
          return anchorElement.closest(".textLayer") || anchorElement.closest(".k-text-layer");
      }
      combinedSignal(abortSignal) {
          if (AbortSignal && AbortSignal["any"]) {
              return AbortSignal.any([this._signal, abortSignal.signal]);
          }
          else {
              // add this for the unit tests
              // AbortSignal.any is an API since March 2024
              // however, this API is not currently available in
              // the node/jest-related bits version that we are using
              return this._signal || abortSignal.signal;
          }
      }
      // get mlManager() {
      //     return this.#mlManager;
      // }
      // get useNewAltTextFlow() {
      //     return this.#enableUpdatedAddImage;
      // }
      // get useNewAltTextWhenAddingImage() {
      //     return this.#enableNewAltTextWhenAddingImage;
      // }
      // get hcmFilter() {
      //     return shadow(
      //         this,
      //         "hcmFilter",
      //         this.#pageColors
      //             ? this.#filterFactory.addHCMFilter(
      //                 this.#pageColors.foreground,
      //                 this.#pageColors.background
      //             )
      //             : "none"
      //     );
      // }
      get direction() {
          return kendo_pdfjs_loader_js.shadow(this, "direction", getComputedStyle(__classPrivateFieldGet(this, _AnnotationEditorUIManager_container, "f")).direction);
      }
      get highlightColors() {
          return kendo_pdfjs_loader_js.shadow(this, "highlightColors", __classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightColors, "f")
              ? new Map(
              // Array.from(
              //     this.#highlightColors
              //         .split(",")
              //         .map(pair => pair.split("=").map(x => x.trim()))
              // )
              )
              : null);
      }
      get highlightColorNames() {
          return kendo_pdfjs_loader_js.shadow(this, "highlightColorNames", this.highlightColors
              ? new Map(Array.from(this.highlightColors, e => e.reverse()))
              : null);
      }
      // setMainHighlightColorPicker(colorPicker) {
      //     this.#mainHighlightColorPicker = colorPicker;
      // }
      // editAltText(editor, firstTime = false) {
      //     this.#altTextManager?.editAltText(this, editor, firstTime);
      // }
      switchToMode(mode, callback) {
          // Switching to a mode can be asynchronous.
          this._eventBus.on("annotationeditormodechanged", callback, {
              once: true,
              signal: this._signal,
              mode
          });
          this._eventBus.dispatch("showannotationeditorui", {
              source: this,
              mode
          });
      }
      setPreference(name, value) {
          this._eventBus.dispatch("setpreference", {
              source: this,
              name,
              value
          });
      }
      // onSetPreference({ name, value }) {
      onSetPreference({ name }) {
          switch (name) {
              case "enableNewAltTextWhenAddingImage":
                  // this.#enableNewAltTextWhenAddingImage = value;
                  break;
              default: break;
          }
      }
      onNamedAction(event) {
          // Processing a couple of named actions that might be useful, see also
          // `PDFLinkService.executeNamedAction`.
          switch (event.action) {
              case "Print":
                  this.triggerPrinting();
                  break;
              case "SaveAs":
                  this.downloadOrSave();
                  break;
          }
      }
      onPageChanging({ pageNumber }) {
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_currentPageIndex, pageNumber - 1, "f");
      }
      focusMainContainer() {
          var _a;
          (_a = __classPrivateFieldGet(this, _AnnotationEditorUIManager_container, "f")) === null || _a === void 0 ? void 0 : _a.focus();
      }
      findParent(x, y) {
          for (const layer of __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()) {
              const { x: layerX, y: layerY, width, height } = layer.div.getBoundingClientRect();
              if (x >= layerX &&
                  x <= layerX + width &&
                  y >= layerY &&
                  y <= layerY + height) {
                  return layer;
              }
          }
          return null;
      }
      triggerPrinting() {
          var _a;
          (_a = this.pdfViewer) === null || _a === void 0 ? void 0 : _a.printFile();
      }
      downloadOrSave() {
          var _a, _b;
          (_a = this.pdfViewer) === null || _a === void 0 ? void 0 : _a.downloadFile({
              fileName: (_b = this.pdfViewer) === null || _b === void 0 ? void 0 : _b.options.downloadFileName
          });
      }
      disableUserSelect(value = false) {
          var _a;
          (_a = __classPrivateFieldGet(this, _AnnotationEditorUIManager_viewer, "f")) === null || _a === void 0 ? void 0 : _a.classList.toggle("noUserSelect", value);
      }
      addShouldRescale(editor) {
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_editorsToRescale, "f").add(editor);
      }
      removeShouldRescale(editor) {
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_editorsToRescale, "f").delete(editor);
      }
      onScaleChanging({ scale }) {
          this.commitOrRemove();
          this.viewParameters.realScale = scale * kendo_pdfjs_loader_js.PixelsPerInch.PDF_TO_CSS_UNITS;
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_editorsToRescale, "f")) {
              editor.onScaleChanging();
          }
      }
      onRotationChanging({ pagesRotation }) {
          this.commitOrRemove();
          this.viewParameters.rotation = pagesRotation;
      }
      highlightSelection(methodOfCreation = "") {
          const selection = document.getSelection();
          if (!selection || selection.isCollapsed) {
              return;
          }
          const { anchorNode, anchorOffset, focusNode, focusOffset } = selection;
          const text = selection.toString();
          const anchorElement = __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_getAnchorElementForSelection).call(this, selection);
          // const textLayer = anchorElement.closest(".textLayer");
          const textLayer = this.getTextLayerForAnchor(anchorElement);
          const boxes = this.getSelectionBoxes(textLayer);
          if (!boxes) {
              return;
          }
          selection.empty();
          const layer = __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_getLayerForTextLayer).call(this, textLayer);
          const isNoneMode = __classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === kendo_pdfjs_loader_js.AnnotationEditorType.NONE;
          const callback = () => {
              layer === null || layer === void 0 ? void 0 : layer.createAndAddNewEditor({ x: 0, y: 0 }, false, {
                  methodOfCreation,
                  boxes,
                  anchorNode,
                  anchorOffset,
                  focusNode,
                  focusOffset,
                  text
              });
              if (isNoneMode) {
                  // this.showAllEditors("highlight", true, /* updateButton = */ true);
                  this.showAllEditors("highlight", true);
              }
          };
          if (isNoneMode) {
              this.switchToMode(kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT, callback);
              return;
          }
          callback();
      }
      showEditorToolBar(anchor) {
          if (!anchor) {
              return;
          }
          const annotationEditorMode = this.getMode();
          if (annotationEditorMode !== kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT &&
              annotationEditorMode !== kendo_pdfjs_loader_js.AnnotationEditorType.FREETEXT) {
              return;
          }
          this._eventBus.dispatch("kendoAnnotationEditorToolBarShow", {
              source: this,
              anchor: anchor
          });
      }
      hideEditorToolBar() {
          this._eventBus.dispatch("kendoAnnotationEditorToolBarHide", {
              source: this
          });
      }
      /**
       * Add an editor in the annotation storage.
       * @param {AnnotationEditor} editor
       */
      addToAnnotationStorage(editor) {
          if (!editor.isEmpty() &&
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_annotationStorage, "f") &&
              !__classPrivateFieldGet(this, _AnnotationEditorUIManager_annotationStorage, "f").has(editor.id)) {
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_annotationStorage, "f").setValue(editor.id, editor);
          }
      }
      blur() {
          this.isShiftKeyDown = false;
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightWhenShiftUp, "f")) {
              __classPrivateFieldSet(this, _AnnotationEditorUIManager_highlightWhenShiftUp, false, "f");
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_onSelectEnd).call(this, "main_toolbar");
          }
          if (!this.hasSelection) {
              return;
          }
          // When several editors are selected and the window loses focus, we want to
          // keep the last active element in order to be able to focus it again when
          // the window gets the focus back but we don't want to trigger any focus
          // callbacks else only one editor will be selected.
          const { activeElement } = document;
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")) {
              if (editor.div.contains(activeElement)) {
                  __classPrivateFieldSet(this, _AnnotationEditorUIManager_lastActiveElement, [editor, activeElement], "f");
                  editor._focusEventsAllowed = false;
                  break;
              }
          }
      }
      focus() {
          if (!__classPrivateFieldGet(this, _AnnotationEditorUIManager_lastActiveElement, "f")) {
              return;
          }
          const [lastEditor, lastActiveElement] = __classPrivateFieldGet(this, _AnnotationEditorUIManager_lastActiveElement, "f");
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_lastActiveElement, null, "f");
          lastActiveElement.addEventListener("focusin", () => {
              lastEditor._focusEventsAllowed = true;
          }, { once: true, signal: this._signal });
          lastActiveElement.focus();
      }
      addEditListeners() {
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addKeyboardManager).call(this);
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addCopyPasteListeners).call(this);
      }
      removeEditListeners() {
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_removeKeyboardManager).call(this);
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_removeCopyPasteListeners).call(this);
      }
      dragOver(event) {
          for (const { type } of event.dataTransfer.items) {
              for (const editorType of __classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f")) {
                  if (editorType.isHandlingMimeForPasting(type)) {
                      event.dataTransfer.dropEffect = "copy";
                      event.preventDefault();
                      return;
                  }
              }
          }
      }
      /**
       * Drop callback.
       * @param {DragEvent} event
       */
      drop(event) {
          for (const item of event.dataTransfer.items) {
              for (const editorType of __classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f")) {
                  if (editorType.isHandlingMimeForPasting(item.type)) {
                      editorType.paste(item, this.currentLayer);
                      event.preventDefault();
                      return;
                  }
              }
          }
      }
      /**
       * Copy callback.
       * @param {ClipboardEvent} event
       */
      copy(event) {
          var _a;
          event.preventDefault();
          // An editor is being edited so just commit it.
          (_a = __classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f")) === null || _a === void 0 ? void 0 : _a.commitOrRemove();
          if (!this.hasSelection) {
              return;
          }
          const editors = [];
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")) {
              const serialized = editor.serialize(/* isForCopying = */ true);
              if (serialized) {
                  editors.push(serialized);
              }
          }
          if (editors.length === 0) {
              return;
          }
          event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
      }
      /**
       * Cut callback.
       * @param {ClipboardEvent} event
       */
      cut(event) {
          this.copy(event);
          this.delete();
      }
      /**
       * Paste callback.
       * @param {ClipboardEvent} event
       */
      paste(event) {
          event.preventDefault();
          const { clipboardData } = event;
          for (const item of clipboardData.items) {
              for (const editorType of __classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f")) {
                  if (editorType.isHandlingMimeForPasting(item.type)) {
                      editorType.paste(item, this.currentLayer);
                      return;
                  }
              }
          }
          let data = clipboardData.getData("application/pdfjs");
          if (!data) {
              return;
          }
          try {
              data = JSON.parse(data);
          }
          catch (ex) {
              // warn(`paste: "${ex.message}".`);
              return;
          }
          if (!Array.isArray(data)) {
              return;
          }
          this.unselectAll();
          const layer = this.currentLayer;
          try {
              const newEditors = [];
              for (const editor of data) {
                  const deserializedEditor = layer.deserialize(editor);
                  if (!deserializedEditor) {
                      return;
                  }
                  newEditors.push(deserializedEditor);
              }
              const cmd = () => {
                  for (const editor of newEditors) {
                      __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addEditorToLayer).call(this, editor);
                  }
                  __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_selectEditors).call(this, newEditors);
              };
              const undo = () => {
                  for (const editor of newEditors) {
                      editor.remove();
                  }
              };
              this.addCommands({ cmd, undo, mustExec: true });
          }
          catch (ex) {
              // warn(`paste: "${ex.message}".`);
          }
      }
      // /**
      //  * Keydown callback.
      //  * @param {KeyboardEvent} event
      //  */
      // keydown(event) {
      //     if (!this.isShiftKeyDown && event.key === "Shift") {
      //         this.isShiftKeyDown = true;
      //     }
      //     if (
      //         this.#mode !== AnnotationEditorType.NONE &&
      //         !this.isEditorHandlingKeyboard
      //     ) {
      //         AnnotationEditorUIManager._keyboardManager.exec(this, event);
      //     }
      // }
      // /**
      //  * Keyup callback.
      //  * @param {KeyboardEvent} event
      //  */
      // keyup(event) {
      //     if (this.isShiftKeyDown && event.key === "Shift") {
      //         this.isShiftKeyDown = false;
      //         if (this.#highlightWhenShiftUp) {
      //             this.#highlightWhenShiftUp = false;
      //             this.#onSelectEnd("main_toolbar");
      //         }
      //     }
      // }
      /**
       * Execute an action for a given name.
       * For example, the user can click on the "Undo" entry in the context menu
       * and it'll trigger the undo action.
       */
      onEditingAction({ name }) {
          switch (name) {
              case "undo":
              case "redo":
              case "delete":
              case "selectAll":
                  this[name]();
                  break;
              case "highlightSelection":
                  this.highlightSelection("context_menu");
                  break;
              default: break;
          }
      }
      /**
       * Set the editing state.
       * It can be useful to temporarily disable it when the user is editing a
       * FreeText annotation.
       * @param {boolean} isEditing
       */
      setEditingState(isEditing) {
          // setEditingState() {
          if (isEditing) {
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addFocusManager).call(this);
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addCopyPasteListeners).call(this);
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
                  isEditing: __classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") !== kendo_pdfjs_loader_js.AnnotationEditorType.NONE,
                  isEmpty: __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_isEmpty).call(this),
                  hasSomethingToUndo: __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").hasSomethingToUndo(),
                  hasSomethingToRedo: __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").hasSomethingToRedo(),
                  hasSelectedEditor: false
              });
          }
          else {
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_removeFocusManager).call(this);
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_removeCopyPasteListeners).call(this);
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
                  isEditing: false
              });
              this.disableUserSelect(false);
          }
      }
      registerEditorTypes(types) {
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f")) {
              return;
          }
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_editorTypes, types, "f");
          for (const editorType of __classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f")) {
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, editorType.defaultPropertiesToUpdate);
          }
      }
      /**
       * Get an id.
       * @returns {string}
       */
      getId() {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_idManager, "f").id;
      }
      get currentLayer() {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").get(__classPrivateFieldGet(this, _AnnotationEditorUIManager_currentPageIndex, "f"));
      }
      getLayer(pageIndex) {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").get(pageIndex);
      }
      get currentPageIndex() {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_currentPageIndex, "f");
      }
      /**
       * Add a new layer for a page which will contains the editors.
       * @param {AnnotationEditorLayer} layer
       */
      addLayer(layer) {
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").set(layer.pageIndex, layer);
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_isEnabled, "f")) {
              layer.enable();
          }
          else {
              layer.disable();
          }
      }
      /**
       * Remove a layer.
       * @param {AnnotationEditorLayer} layer
       */
      removeLayer(layer) {
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").delete(layer.pageIndex);
      }
      /**
       * Change the editor mode (None, FreeText, Ink, ...)
       * @param {number} mode
       * @param {string|null} editId
       * @param {boolean} [isFromKeyboard] - true if the mode change is due to a
       *   keyboard action.
       */
      updateMode(mode, editId = null, isFromKeyboard = false) {
          // todo: set isFromKeyboard intentionally to allow editor creation
          // updateMode(mode, editId = null, isFromKeyboard = true) {
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === mode) {
              return;
          }
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_mode, mode, "f");
          if (mode === kendo_pdfjs_loader_js.AnnotationEditorType.NONE) {
              this.setEditingState(false);
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_disableAll).call(this);
              return;
          }
          this.setEditingState(true);
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_enableAll).call(this);
          this.unselectAll();
          for (const layer of __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()) {
              layer.updateMode(mode);
          }
          if (!editId && isFromKeyboard) {
              this.addNewEditorFromKeyboard();
              return;
          }
          if (!editId) {
              return;
          }
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values()) {
              if (editor.annotationElementId === editId) {
                  this.setSelected(editor);
                  editor.enterInEditMode();
                  break;
              }
          }
      }
      addNewEditorFromKeyboard() {
          if (this.currentLayer.canCreateNewEmptyEditor()) {
              this.currentLayer.addNewEditor();
          }
      }
      /**
       * Update the toolbar if it's required to reflect the tool currently used.
       * @param {number} mode
       * @returns {undefined}
       */
      updateToolbar(mode) {
          if (mode === __classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f")) {
              return;
          }
          this._eventBus.dispatch("switchannotationeditormode", {
              source: this,
              mode
          });
      }
      /**
       * Update a parameter in the current editor or globally.
       * @param {number} type
       * @param {*} value
       */
      updateParams(type, value) {
          if (!__classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f")) {
              return;
          }
          switch (type) {
              case kendo_pdfjs_loader_js.AnnotationEditorParamsType.CREATE:
                  this.currentLayer.addNewEditor();
                  return;
              case kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR:
                  // this.#mainHighlightColorPicker?.updateColor(value);
                  break;
              case kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL:
                  // this._eventBus.dispatch("reporttelemetry", {
                  //     source: this,
                  //     details: {
                  //         type: "editing",
                  //         data: {
                  //             type: "highlight",
                  //             action: "toggle_visibility",
                  //         },
                  //     },
                  // });
                  (__classPrivateFieldSet(this, _AnnotationEditorUIManager_showAllStates, __classPrivateFieldGet(this, _AnnotationEditorUIManager_showAllStates, "f") || new Map(), "f")).set(type, value);
                  this.showAllEditors("highlight", value);
                  break;
              default: break;
          }
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")) {
              editor.updateParams(type, value);
          }
          for (const editorType of __classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f")) {
              editorType.updateDefaultParams(type, value);
          }
      }
      // showAllEditors(type, visible, updateButton = false) {
      showAllEditors(type, visible) {
          var _a, _b;
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values()) {
              if (editor.editorType === type) {
                  editor.show(visible);
              }
          }
          const state = (_b = (_a = __classPrivateFieldGet(this, _AnnotationEditorUIManager_showAllStates, "f")) === null || _a === void 0 ? void 0 : _a.get(kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL)) !== null && _b !== void 0 ? _b : true;
          if (state !== visible) {
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, [
                  [kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL, visible]
              ]);
          }
      }
      enableWaiting(mustWait = false) {
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_isWaiting, "f") === mustWait) {
              return;
          }
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_isWaiting, mustWait, "f");
          for (const layer of __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()) {
              if (mustWait) {
                  layer.disableClick();
              }
              else {
                  layer.enableClick();
              }
              layer.div.classList.toggle("waiting", mustWait);
          }
      }
      /**
       * Get all the editors belonging to a given page.
       * @param {number} pageIndex
       * @returns {Array<AnnotationEditor>}
       */
      getEditors(pageIndex) {
          const editors = [];
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values()) {
              if (editor.pageIndex === pageIndex) {
                  editors.push(editor);
              }
          }
          return editors;
      }
      /**
       * Get an editor with the given id.
       * @param {string} id
       * @returns {AnnotationEditor}
       */
      getEditor(id) {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").get(id);
      }
      /**
       * Add a new editor.
       * @param {AnnotationEditor} editor
       */
      addEditor(editor) {
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").set(editor.id, editor);
      }
      /**
       * Remove an editor.
       * @param {AnnotationEditor} editor
       */
      removeEditor(editor) {
          var _a;
          if (editor.div.contains(document.activeElement)) {
              if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, "f")) {
                  clearTimeout(__classPrivateFieldGet(this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, "f"));
              }
              __classPrivateFieldSet(this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, setTimeout(() => {
                  // When the div is removed from DOM the focus can move on the
                  // document.body, so we need to move it back to the main container.
                  this.focusMainContainer();
                  __classPrivateFieldSet(this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, null, "f");
              }, 0), "f");
          }
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").delete(editor.id);
          this.unselect(editor);
          if (!editor.annotationElementId ||
              !__classPrivateFieldGet(this, _AnnotationEditorUIManager_deletedAnnotationsElementIds, "f").has(editor.annotationElementId)) {
              (_a = __classPrivateFieldGet(this, _AnnotationEditorUIManager_annotationStorage, "f")) === null || _a === void 0 ? void 0 : _a.remove(editor.id);
          }
      }
      /**
       * The annotation element with the given id has been deleted.
       * @param {AnnotationEditor} editor
       */
      addDeletedAnnotationElement(editor) {
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_deletedAnnotationsElementIds, "f").add(editor.annotationElementId);
          this.addChangedExistingAnnotation(editor);
          editor.deleted = true;
      }
      /**
       * Check if the annotation element with the given id has been deleted.
       * @param {string} annotationElementId
       * @returns {boolean}
       */
      isDeletedAnnotationElement(annotationElementId) {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_deletedAnnotationsElementIds, "f").has(annotationElementId);
      }
      /**
       * The annotation element with the given id have been restored.
       * @param {AnnotationEditor} editor
       */
      removeDeletedAnnotationElement(editor) {
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_deletedAnnotationsElementIds, "f").delete(editor.annotationElementId);
          this.removeChangedExistingAnnotation(editor);
          editor.deleted = false;
      }
      /**
       * Set the given editor as the active one.
       * @param {AnnotationEditor} editor
       */
      setActiveEditor(editor) {
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f") === editor) {
              return;
          }
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_activeEditor, editor, "f");
          if (editor) {
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, editor.propertiesToUpdate);
          }
      }
      /**
       * Update the UI of the active editor.
       * @param {AnnotationEditor} editor
       */
      updateUI(editor) {
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "a", _AnnotationEditorUIManager_lastSelectedEditor_get) === editor) {
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, editor.propertiesToUpdate);
          }
      }
      /**
       * Add or remove an editor the current selection.
       * @param {AnnotationEditor} editor
       */
      toggleSelected(editor) {
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").has(editor)) {
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").delete(editor);
              editor.unselect();
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
                  hasSelectedEditor: this.hasSelection
              });
              return;
          }
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").add(editor);
          editor.select();
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, editor.propertiesToUpdate);
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
              hasSelectedEditor: true
          });
      }
      /**
       * Set the last selected editor.
       * @param {AnnotationEditor} editor
       */
      setSelected(editor) {
          for (const selectedEditor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")) {
              if (selectedEditor !== editor) {
                  selectedEditor.unselect();
              }
          }
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").clear();
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").add(editor);
          editor.select();
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, editor.propertiesToUpdate);
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
              hasSelectedEditor: true
          });
      }
      /**
       * Check if the editor is selected.
       * @param {AnnotationEditor} editor
       */
      isSelected(editor) {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").has(editor);
      }
      get firstSelectedEditor() {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").values().next().value;
      }
      /**
       * Unselect an editor.
       * @param {AnnotationEditor} editor
       */
      unselect(editor) {
          editor.unselect();
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").delete(editor);
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
              hasSelectedEditor: this.hasSelection
          });
      }
      get hasSelection() {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").size !== 0;
      }
      get isEnterHandled() {
          return (__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").size === 1 &&
              this.firstSelectedEditor.isEnterHandled);
      }
      /**
       * Undo the last command.
       */
      undo() {
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").undo();
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
              hasSomethingToUndo: __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").hasSomethingToUndo(),
              hasSomethingToRedo: true,
              isEmpty: __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_isEmpty).call(this)
          });
      }
      /**
       * Redo the last undoed command.
       */
      redo() {
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").redo();
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
              hasSomethingToUndo: true,
              hasSomethingToRedo: __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").hasSomethingToRedo(),
              isEmpty: __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_isEmpty).call(this)
          });
      }
      /**
       * Add a command to execute (cmd) and another one to undo it.
       * @param {Object} params
       */
      addCommands(params) {
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").add(params);
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
              hasSomethingToUndo: true,
              hasSomethingToRedo: false,
              isEmpty: __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_isEmpty).call(this)
          });
      }
      /**
       * Delete the current editor or all.
       */
      delete() {
          this.commitOrRemove();
          if (!this.hasSelection) {
              return;
          }
          const editors = [...__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")];
          const cmd = () => {
              for (const editor of editors) {
                  editor.remove();
              }
          };
          const undo = () => {
              for (const editor of editors) {
                  __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addEditorToLayer).call(this, editor);
              }
          };
          this.addCommands({ cmd, undo, mustExec: true });
      }
      commitOrRemove() {
          var _a;
          // An editor is being edited so just commit it.
          (_a = __classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f")) === null || _a === void 0 ? void 0 : _a.commitOrRemove();
      }
      hasSomethingToControl() {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f") || this.hasSelection;
      }
      /**
       * Select all the editors.
       */
      selectAll() {
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")) {
              editor.commit();
          }
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_selectEditors).call(this, __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values());
      }
      /**
       * Unselect all the selected editors.
       */
      unselectAll() {
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f")) {
              // An editor is being edited so just commit it.
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f").commitOrRemove();
              if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") !== kendo_pdfjs_loader_js.AnnotationEditorType.NONE) {
                  // If the mode is NONE, we want to really unselect the editor, hence we
                  // mustn't return here.
                  return;
              }
          }
          if (!this.hasSelection) {
              return;
          }
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")) {
              editor.unselect();
          }
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").clear();
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
              hasSelectedEditor: false
          });
      }
      translateSelectedEditors(x, y, noCommit = false) {
          if (!noCommit) {
              this.commitOrRemove();
          }
          if (!this.hasSelection) {
              return;
          }
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_translation, "f")[0] += x;
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_translation, "f")[1] += y;
          const [totalX, totalY] = __classPrivateFieldGet(this, _AnnotationEditorUIManager_translation, "f");
          const editors = [...__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")];
          // We don't want to have an undo/redo for each translation so we wait a bit
          // before adding the command to the command manager.
          const TIME_TO_WAIT = 1000;
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_translationTimeoutId, "f")) {
              clearTimeout(__classPrivateFieldGet(this, _AnnotationEditorUIManager_translationTimeoutId, "f"));
          }
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_translationTimeoutId, setTimeout(() => {
              __classPrivateFieldSet(this, _AnnotationEditorUIManager_translationTimeoutId, null, "f");
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_translation, "f")[0] = __classPrivateFieldGet(this, _AnnotationEditorUIManager_translation, "f")[1] = 0;
              this.addCommands({
                  cmd: () => {
                      for (const editor of editors) {
                          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").has(editor.id)) {
                              editor.translateInPage(totalX, totalY);
                          }
                      }
                  },
                  undo: () => {
                      for (const editor of editors) {
                          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").has(editor.id)) {
                              editor.translateInPage(-totalX, -totalY);
                          }
                      }
                  },
                  mustExec: false
              });
          }, TIME_TO_WAIT), "f");
          for (const editor of editors) {
              editor.translateInPage(x, y);
          }
      }
      /**
       * Set up the drag session for moving the selected editors.
       */
      setUpDragSession() {
          // // Note: don't use any references to the editor's parent which can be null
          // // if the editor belongs to a destroyed page.
          if (!this.hasSelection) {
              return;
          }
          // Avoid to have spurious text selection in the text layer when dragging.
          this.disableUserSelect(true);
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_draggingEditors, new Map(), "f");
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")) {
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_draggingEditors, "f").set(editor, {
                  savedX: editor.x,
                  savedY: editor.y,
                  savedPageIndex: editor.pageIndex,
                  newX: 0,
                  newY: 0,
                  newPageIndex: -1
              });
          }
      }
      /**
       * Ends the drag session.
       * @returns {boolean} true if at least one editor has been moved.
       */
      endDragSession() {
          if (!__classPrivateFieldGet(this, _AnnotationEditorUIManager_draggingEditors, "f")) {
              return false;
          }
          this.disableUserSelect(false);
          const map = __classPrivateFieldGet(this, _AnnotationEditorUIManager_draggingEditors, "f");
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_draggingEditors, null, "f");
          let mustBeAddedInUndoStack = false;
          for (const [{ x, y, pageIndex }, value] of map) {
              value.newX = x;
              value.newY = y;
              value.newPageIndex = pageIndex;
              mustBeAddedInUndoStack || (mustBeAddedInUndoStack = x !== value.savedX ||
                  y !== value.savedY ||
                  pageIndex !== value.savedPageIndex);
          }
          if (!mustBeAddedInUndoStack) {
              return false;
          }
          const move = (editor, x, y, pageIndex) => {
              if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").has(editor.id)) {
                  // The editor can be undone/redone on a page which is not visible (and
                  // which potentially has no annotation editor layer), hence we need to
                  // use the pageIndex instead of the parent.
                  const parent = __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").get(pageIndex);
                  if (parent) {
                      editor._setParentAndPosition(parent, x, y);
                  }
                  else {
                      editor.pageIndex = pageIndex;
                      editor.x = x;
                      editor.y = y;
                  }
              }
          };
          this.addCommands({
              cmd: () => {
                  for (const [editor, { newX, newY, newPageIndex }] of map) {
                      move(editor, newX, newY, newPageIndex);
                  }
              },
              undo: () => {
                  for (const [editor, { savedX, savedY, savedPageIndex }] of map) {
                      move(editor, savedX, savedY, savedPageIndex);
                  }
              },
              mustExec: true
          });
          return true;
      }
      /**
       * Drag the set of selected editors.
       * @param {number} tx
       * @param {number} ty
       */
      dragSelectedEditors(tx, ty) {
          if (!__classPrivateFieldGet(this, _AnnotationEditorUIManager_draggingEditors, "f")) {
              return;
          }
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_draggingEditors, "f").keys()) {
              editor.drag(tx, ty);
          }
      }
      /**
       * Rebuild the editor (usually on undo/redo actions) on a potentially
       * non-rendered page.
       * @param {AnnotationEditor} editor
       */
      rebuild(editor) {
          if (editor.parent === null) {
              const parent = this.getLayer(editor.pageIndex);
              if (parent) {
                  parent.changeParent(editor);
                  parent.addOrRebuild(editor);
              }
              else {
                  this.addEditor(editor);
                  this.addToAnnotationStorage(editor);
                  editor.rebuild();
              }
          }
          else {
              editor.parent.addOrRebuild(editor);
          }
      }
      // get isEditorHandlingKeyboard() {
      //     return (
      //         this.getActive()?.shouldGetKeyboardEvents() ||
      //         (this.#selectedEditors.size === 1 &&
      //             this.firstSelectedEditor.shouldGetKeyboardEvents())
      //     );
      // }
      /**
       * Is the current editor the one passed as argument?
       * @param {AnnotationEditor} editor
       * @returns
       */
      isActive(editor) {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f") === editor;
      }
      /**
       * Get the current active editor.
       * @returns {AnnotationEditor|null}
       */
      getActive() {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f");
      }
      getActiveEditor() {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f");
      }
      /**
       * Get the current editor mode.
       * @returns {number}
       */
      getMode() {
          return __classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f");
      }
      // get imageManager() {
      //     return shadow(this, "imageManager", new ImageManager());
      // }
      getSelectionBoxes(textLayer) {
          if (!textLayer) {
              return null;
          }
          const selection = document.getSelection();
          for (let i = 0, ii = selection.rangeCount; i < ii; i++) {
              if (!textLayer.contains(selection.getRangeAt(i).commonAncestorContainer)) {
                  return null;
              }
          }
          const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
          // We must rotate the boxes because we want to have them in the non-rotated
          // page coordinates.
          let rotator;
          switch (textLayer.getAttribute("data-main-rotation")) {
              case "90":
                  rotator = (x, y, w, h) => ({
                      x: (y - layerY) / parentHeight,
                      y: 1 - (x + w - layerX) / parentWidth,
                      width: h / parentHeight,
                      height: w / parentWidth
                  });
                  break;
              case "180":
                  rotator = (x, y, w, h) => ({
                      x: 1 - (x + w - layerX) / parentWidth,
                      y: 1 - (y + h - layerY) / parentHeight,
                      width: w / parentWidth,
                      height: h / parentHeight
                  });
                  break;
              case "270":
                  rotator = (x, y, w, h) => ({
                      x: 1 - (y + h - layerY) / parentHeight,
                      y: (x - layerX) / parentWidth,
                      width: h / parentHeight,
                      height: w / parentWidth
                  });
                  break;
              default:
                  rotator = (x, y, w, h) => ({
                      x: (x - layerX) / parentWidth,
                      y: (y - layerY) / parentHeight,
                      width: w / parentWidth,
                      height: h / parentHeight
                  });
                  break;
          }
          const boxes = [];
          for (let i = 0, ii = selection.rangeCount; i < ii; i++) {
              const range = selection.getRangeAt(i);
              if (range.collapsed) {
                  continue;
              }
              for (const { x, y, width, height } of range.getClientRects()) {
                  if (width === 0 || height === 0) {
                      continue;
                  }
                  boxes.push(rotator(x, y, width, height));
              }
          }
          return boxes.length === 0 ? null : boxes;
      }
      addChangedExistingAnnotation({ annotationElementId, id }) {
          (__classPrivateFieldSet(this, _AnnotationEditorUIManager_changedExistingAnnotations, __classPrivateFieldGet(this, _AnnotationEditorUIManager_changedExistingAnnotations, "f") || new Map(), "f")).set(annotationElementId, id);
      }
      removeChangedExistingAnnotation({ annotationElementId }) {
          var _a;
          (_a = __classPrivateFieldGet(this, _AnnotationEditorUIManager_changedExistingAnnotations, "f")) === null || _a === void 0 ? void 0 : _a.delete(annotationElementId);
      }
      renderAnnotationElement(annotation) {
          var _a;
          const editorId = (_a = __classPrivateFieldGet(this, _AnnotationEditorUIManager_changedExistingAnnotations, "f")) === null || _a === void 0 ? void 0 : _a.get(annotation.data.id);
          if (!editorId) {
              return;
          }
          const editor = __classPrivateFieldGet(this, _AnnotationEditorUIManager_annotationStorage, "f").getRawValue(editorId);
          if (!editor) {
              return;
          }
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === kendo_pdfjs_loader_js.AnnotationEditorType.NONE && !editor.hasBeenModified) {
              return;
          }
          editor.renderAnnotationElement(annotation);
      }
  }
  _AnnotationEditorUIManager_abortController = new WeakMap(), _AnnotationEditorUIManager_activeEditor = new WeakMap(), _AnnotationEditorUIManager_allEditors = new WeakMap(), _AnnotationEditorUIManager_allLayers = new WeakMap(), _AnnotationEditorUIManager_annotationStorage = new WeakMap(), _AnnotationEditorUIManager_changedExistingAnnotations = new WeakMap(), _AnnotationEditorUIManager_commandManager = new WeakMap(), _AnnotationEditorUIManager_currentPageIndex = new WeakMap(), _AnnotationEditorUIManager_deletedAnnotationsElementIds = new WeakMap(), _AnnotationEditorUIManager_draggingEditors = new WeakMap(), _AnnotationEditorUIManager_editorTypes = new WeakMap(), _AnnotationEditorUIManager_editorsToRescale = new WeakMap(), _AnnotationEditorUIManager_enableHighlightFloatingButton = new WeakMap(), _AnnotationEditorUIManager_focusMainContainerTimeoutId = new WeakMap(), _AnnotationEditorUIManager_focusManagerAC = new WeakMap(), _AnnotationEditorUIManager_highlightColors = new WeakMap(), _AnnotationEditorUIManager_highlightWhenShiftUp = new WeakMap(), _AnnotationEditorUIManager_highlightToolbar = new WeakMap(), _AnnotationEditorUIManager_idManager = new WeakMap(), _AnnotationEditorUIManager_isEnabled = new WeakMap(), _AnnotationEditorUIManager_isWaiting = new WeakMap(), _AnnotationEditorUIManager_lastActiveElement = new WeakMap(), _AnnotationEditorUIManager_mode = new WeakMap(), _AnnotationEditorUIManager_selectedEditors = new WeakMap(), _AnnotationEditorUIManager_selectedTextNode = new WeakMap(), _AnnotationEditorUIManager_showAllStates = new WeakMap(), _AnnotationEditorUIManager_previousStates = new WeakMap(), _AnnotationEditorUIManager_translation = new WeakMap(), _AnnotationEditorUIManager_translationTimeoutId = new WeakMap(), _AnnotationEditorUIManager_container = new WeakMap(), _AnnotationEditorUIManager_viewer = new WeakMap(), _AnnotationEditorUIManager_instances = new WeakSet(), _AnnotationEditorUIManager_getAnchorElementForSelection = function _AnnotationEditorUIManager_getAnchorElementForSelection({ anchorNode }) {
      return anchorNode.nodeType === Node.TEXT_NODE
          ? anchorNode.parentElement
          : anchorNode;
  }, _AnnotationEditorUIManager_getLayerForTextLayer = function _AnnotationEditorUIManager_getLayerForTextLayer(textLayer) {
      const { currentLayer } = this;
      if (currentLayer.hasTextLayer(textLayer)) {
          return currentLayer;
      }
      for (const layer of __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()) {
          if (layer.hasTextLayer(textLayer)) {
              return layer;
          }
      }
      return null;
  }, _AnnotationEditorUIManager_displayHighlightToolbar = function _AnnotationEditorUIManager_displayHighlightToolbar() {
      const selection = document.getSelection();
      if (!selection || selection.isCollapsed) {
          return;
      }
      const anchorElement = __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_getAnchorElementForSelection).call(this, selection);
      const textLayer = this.getTextLayerForAnchor(anchorElement);
      const boxes = this.getSelectionBoxes(textLayer);
      if (!boxes) {
          return;
      }
      this.showEditorToolBar(anchorElement);
      // this._eventBus.dispatch("showannotationeditorui", {
      //     source: this,
      //     details: Object.assign(this.#previousStates, details),
      // });
      // this.#highlightToolbar ||= new HighlightToolbar(this);
      // this.#highlightToolbar.show(textLayer, boxes, this.direction === "ltr");
  }, _AnnotationEditorUIManager_selectionChange = function _AnnotationEditorUIManager_selectionChange() {
      var _a, _b;
      const selection = document.getSelection();
      if (!selection || selection.isCollapsed) {
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedTextNode, "f")) {
              // this.#highlightToolbar?.hide();
              __classPrivateFieldSet(this, _AnnotationEditorUIManager_selectedTextNode, null, "f");
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
                  hasSelectedText: false
              });
          }
          return;
      }
      const { anchorNode } = selection;
      if (anchorNode === __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedTextNode, "f")) {
          return;
      }
      const anchorElement = __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_getAnchorElementForSelection).call(this, selection);
      // const textLayer = anchorElement.closest(".textLayer");
      const textLayer = this.getTextLayerForAnchor(anchorElement);
      if (!textLayer) {
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedTextNode, "f")) {
              (_a = __classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightToolbar, "f")) === null || _a === void 0 ? void 0 : _a.hide();
              __classPrivateFieldSet(this, _AnnotationEditorUIManager_selectedTextNode, null, "f");
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
                  hasSelectedText: false
              });
          }
          return;
      }
      (_b = __classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightToolbar, "f")) === null || _b === void 0 ? void 0 : _b.hide();
      __classPrivateFieldSet(this, _AnnotationEditorUIManager_selectedTextNode, anchorNode, "f");
      __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
          hasSelectedText: true
      });
      if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") !== kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT && __classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") !== kendo_pdfjs_loader_js.AnnotationEditorType.NONE) {
          return;
      }
      if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT) {
          // this.showAllEditors("highlight", true, /* updateButton = */ true);
          this.showAllEditors("highlight", true);
      }
      // this.#highlightWhenShiftUp = this.isShiftKeyDown;
      if (!this.isShiftKeyDown) {
          const activeLayer = __classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT
              ? __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_getLayerForTextLayer).call(this, textLayer)
              : null;
          activeLayer === null || activeLayer === void 0 ? void 0 : activeLayer.toggleDrawing();
          const abortController = new AbortController();
          const signal = this.combinedSignal(abortController);
          const pointerup = e => {
              if (e.type === "pointerup" && e.button !== 0) {
                  // Do nothing on right click.
                  return;
              }
              abortController.abort();
              activeLayer === null || activeLayer === void 0 ? void 0 : activeLayer.toggleDrawing(true);
              if (e.type === "pointerup") {
                  __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_onSelectEnd).call(this, "main_toolbar");
              }
          };
          window.removeEventListener("pointerup", pointerup);
          window.addEventListener("pointerup", pointerup, { signal });
          window.removeEventListener("blur", pointerup);
          window.addEventListener("blur", pointerup, { signal });
      }
  }, _AnnotationEditorUIManager_onSelectEnd = function _AnnotationEditorUIManager_onSelectEnd(methodOfCreation = "") {
      if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT) {
          this.highlightSelection(methodOfCreation);
      }
      else if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_enableHighlightFloatingButton, "f")) {
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_displayHighlightToolbar).call(this);
      }
  }, _AnnotationEditorUIManager_addSelectionListener = function _AnnotationEditorUIManager_addSelectionListener() {
      document.addEventListener("selectionchange", __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_selectionChange).bind(this), { signal: this._signal });
  }, _AnnotationEditorUIManager_addFocusManager = function _AnnotationEditorUIManager_addFocusManager() {
      if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_focusManagerAC, "f")) {
          return;
      }
      __classPrivateFieldSet(this, _AnnotationEditorUIManager_focusManagerAC, new AbortController(), "f");
      const signal = this.combinedSignal(__classPrivateFieldGet(this, _AnnotationEditorUIManager_focusManagerAC, "f"));
      window.addEventListener("focus", this.focus.bind(this), { signal });
      window.addEventListener("blur", this.blur.bind(this), { signal });
  }, _AnnotationEditorUIManager_removeFocusManager = function _AnnotationEditorUIManager_removeFocusManager() {
      var _a;
      (_a = __classPrivateFieldGet(this, _AnnotationEditorUIManager_focusManagerAC, "f")) === null || _a === void 0 ? void 0 : _a.abort();
      __classPrivateFieldSet(this, _AnnotationEditorUIManager_focusManagerAC, null, "f");
  }, _AnnotationEditorUIManager_addKeyboardManager = function _AnnotationEditorUIManager_addKeyboardManager() {
      //     if (this.#keyboardManagerAC) {
      //         return;
      //     }
      //     this.#keyboardManagerAC = new AbortController();
      //     const signal = this.combinedSignal(this.#keyboardManagerAC);
      //     // The keyboard events are caught at the container level in order to be able
      //     // to execute some callbacks even if the current page doesn't have focus.
      //     window.addEventListener("keydown", this.keydown.bind(this), { signal });
      //     window.addEventListener("keyup", this.keyup.bind(this), { signal });
  }, _AnnotationEditorUIManager_removeKeyboardManager = function _AnnotationEditorUIManager_removeKeyboardManager() {
      //     this.#keyboardManagerAC?.abort();
      //     this.#keyboardManagerAC = null;
  }, _AnnotationEditorUIManager_addCopyPasteListeners = function _AnnotationEditorUIManager_addCopyPasteListeners() {
      //     if (this.#copyPasteAC) {
      //         return;
      //     }
      //     this.#copyPasteAC = new AbortController();
      //     const signal = this.combinedSignal(this.#copyPasteAC);
      //     document.addEventListener("copy", this.copy.bind(this), { signal });
      //     document.addEventListener("cut", this.cut.bind(this), { signal });
      //     document.addEventListener("paste", this.paste.bind(this), { signal });
  }, _AnnotationEditorUIManager_removeCopyPasteListeners = function _AnnotationEditorUIManager_removeCopyPasteListeners() {
      //     this.#copyPasteAC?.abort();
      //     this.#copyPasteAC = null;
  }, _AnnotationEditorUIManager_addDragAndDropListeners = function _AnnotationEditorUIManager_addDragAndDropListeners() {
      const signal = this._signal;
      document.addEventListener("dragover", this.dragOver.bind(this), { signal });
      document.addEventListener("drop", this.drop.bind(this), { signal });
  }, _AnnotationEditorUIManager_dispatchUpdateStates = function _AnnotationEditorUIManager_dispatchUpdateStates(details) {
      if (!details) {
          return;
      }
      const hasChanged = Object.entries(details).some(([key, value]) => __classPrivateFieldGet(this, _AnnotationEditorUIManager_previousStates, "f")[key] !== value);
      if (hasChanged) {
          this._eventBus.dispatch("annotationeditorstateschanged", {
              source: this,
              details: Object.assign(__classPrivateFieldGet(this, _AnnotationEditorUIManager_previousStates, "f"), details)
          });
          // We could listen on our own event but it sounds like a bit weird and
          // it's a way to simpler to handle that stuff here instead of having to
          // add something in every place where an editor can be unselected.
          if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT &&
              details.hasSelectedEditor === false) {
              __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, [
                  [kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_FREE, true]
              ]);
          }
      }
  }, _AnnotationEditorUIManager_dispatchUpdateUI = function _AnnotationEditorUIManager_dispatchUpdateUI(details) {
      this._eventBus.dispatch("annotationeditorparamschanged", {
          source: this,
          details
      });
  }, _AnnotationEditorUIManager_enableAll = function _AnnotationEditorUIManager_enableAll() {
      if (!__classPrivateFieldGet(this, _AnnotationEditorUIManager_isEnabled, "f")) {
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_isEnabled, true, "f");
          for (const layer of __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()) {
              layer.enable();
          }
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values()) {
              editor.enable();
          }
      }
  }, _AnnotationEditorUIManager_disableAll = function _AnnotationEditorUIManager_disableAll() {
      this.unselectAll();
      if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_isEnabled, "f")) {
          __classPrivateFieldSet(this, _AnnotationEditorUIManager_isEnabled, false, "f");
          for (const layer of __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()) {
              layer.disable();
          }
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values()) {
              editor.disable();
          }
      }
  }, _AnnotationEditorUIManager_addEditorToLayer = function _AnnotationEditorUIManager_addEditorToLayer(editor) {
      const layer = __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").get(editor.pageIndex);
      if (layer) {
          layer.addOrRebuild(editor);
      }
      else {
          this.addEditor(editor);
          this.addToAnnotationStorage(editor);
      }
  }, _AnnotationEditorUIManager_lastSelectedEditor_get = function _AnnotationEditorUIManager_lastSelectedEditor_get() {
      let ed = null;
      for (ed of __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")) {
          // Iterate to get the last element.
      }
      return ed;
  }, _AnnotationEditorUIManager_isEmpty = function _AnnotationEditorUIManager_isEmpty() {
      if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").size === 0) {
          return true;
      }
      if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").size === 1) {
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values()) {
              return editor.isEmpty();
          }
      }
      return false;
  }, _AnnotationEditorUIManager_selectEditors = function _AnnotationEditorUIManager_selectEditors(editors) {
      for (const editor of __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")) {
          editor.unselect();
      }
      __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").clear();
      for (const editor of editors) {
          if (editor.isEmpty()) {
              continue;
          }
          __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").add(editor);
          editor.select();
      }
      __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, { hasSelectedEditor: this.hasSelection });
  };
  AnnotationEditorUIManager.TRANSLATE_SMALL = 1; // page units.
  AnnotationEditorUIManager.TRANSLATE_BIG = 10; // page units.

  /* Copyright 2012 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  // const WaitOnType = {
  //     EVENT: "event",
  //     TIMEOUT: "timeout",
  // };
  var _EventBus_listeners;
  // /**
  //  * @typedef {Object} WaitOnEventOrTimeoutParameters
  //  * @property {Object} target - The event target, can for example be:
  //  *   `window`, `document`, a DOM element, or an {EventBus} instance.
  //  * @property {string} name - The name of the event.
  //  * @property {number} delay - The delay, in milliseconds, after which the
  //  *   timeout occurs (if the event wasn't already dispatched).
  //  */
  // /**
  //  * Allows waiting for an event or a timeout, whichever occurs first.
  //  * Can be used to ensure that an action always occurs, even when an event
  //  * arrives late or not at all.
  //  *
  //  * @param {WaitOnEventOrTimeoutParameters}
  //  * @returns {Promise} A promise that is resolved with a {WaitOnType} value.
  //  */
  // async function waitOnEventOrTimeout({ target, name, delay = 0 }) {
  //     if (
  //         typeof target !== "object" ||
  //         !(name && typeof name === "string") ||
  //         !(Number.isInteger(delay) && delay >= 0)
  //     ) {
  //         throw new Error("waitOnEventOrTimeout - invalid parameters.");
  //     }
  //     const { promise, resolve } = Promise.withResolvers();
  //     const ac = new AbortController();
  //     function handler(type) {
  //         ac.abort(); // Remove event listener.
  //         clearTimeout(timeout);
  //         resolve(type);
  //     }
  //     const evtMethod = target instanceof EventBus ? "_on" : "addEventListener";
  //     target[evtMethod](name, handler.bind(null, WaitOnType.EVENT), {
  //         signal: ac.signal,
  //     });
  //     const timeout = setTimeout(handler.bind(null, WaitOnType.TIMEOUT), delay);
  //     return promise;
  // }
  /**
   * Simple event bus for an application. Listeners are attached using the `on`
   * and `off` methods. To raise an event, the `dispatch` method shall be used.
   */
  class EventBus {
      constructor() {
          _EventBus_listeners.set(this, Object.create(null));
      }
      /**
       * Returs the current event listeners - used purely for debugging purposes.
       */
      getListeners() {
          return __classPrivateFieldGet(this, _EventBus_listeners, "f");
      }
      /**
       * @param {string} eventName
       * @param {function} listener
       * @param {Object} [options]
       */
      on(eventName, listener, options = null) {
          this._on(eventName, listener, {
              external: true,
              once: options === null || options === void 0 ? void 0 : options.once,
              signal: options === null || options === void 0 ? void 0 : options.signal
          });
      }
      /**
       * @param {string} eventName
       * @param {function} listener
       * @param {Object} [options]
       */
      off(eventName, listener) {
          this._off(eventName, listener);
      }
      /**
       * @param {string} eventName
       * @param {Object} data
       */
      dispatch(eventName, data) {
          const eventListeners = __classPrivateFieldGet(this, _EventBus_listeners, "f")[eventName];
          if (!eventListeners || eventListeners.length === 0) {
              return;
          }
          let externalListeners;
          // Making copy of the listeners array in case if it will be modified
          // during dispatch.
          for (const { listener, external, once } of eventListeners.slice(0)) {
              if (once) {
                  this._off(eventName, listener);
              }
              if (external) {
                  (externalListeners || (externalListeners = [])).push(listener);
                  continue;
              }
              listener(data);
          }
          // Dispatch any "external" listeners *after* the internal ones, to give the
          // viewer components time to handle events and update their state first.
          if (externalListeners) {
              for (const listener of externalListeners) {
                  listener(data);
              }
              externalListeners = null;
          }
      }
      /**
       * @ignore
       */
      _on(eventName, listener, options = null) {
          var _a;
          let rmAbort = null;
          if ((options === null || options === void 0 ? void 0 : options.signal) instanceof AbortSignal) {
              const { signal } = options;
              if (signal.aborted) {
                  // console.error("Cannot use an `aborted` signal.");
                  return;
              }
              const onAbort = () => this._off(eventName, listener);
              rmAbort = () => signal.removeEventListener("abort", onAbort);
              signal.addEventListener("abort", onAbort);
          }
          const eventListeners = ((_a = __classPrivateFieldGet(this, _EventBus_listeners, "f"))[eventName] || (_a[eventName] = []));
          eventListeners.push({
              listener,
              external: (options === null || options === void 0 ? void 0 : options.external) === true,
              once: (options === null || options === void 0 ? void 0 : options.once) === true,
              rmAbort
          });
      }
      /**
       * @ignore
       */
      _off(eventName, listener) {
          var _a;
          const eventListeners = __classPrivateFieldGet(this, _EventBus_listeners, "f")[eventName];
          if (!eventListeners) {
              return;
          }
          for (let i = 0, ii = eventListeners.length; i < ii; i++) {
              const evt = eventListeners[i];
              if (evt.listener === listener) {
                  (_a = evt.rmAbort) === null || _a === void 0 ? void 0 : _a.call(evt); // Ensure that the `AbortSignal` listener is removed.
                  eventListeners.splice(i, 1);
                  return;
              }
          }
      }
  }
  _EventBus_listeners = new WeakMap();

  /* Copyright 2012 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  // const DEFAULT_SCALE_VALUE = "auto";
  const DEFAULT_SCALE = 1.0;
  // const DEFAULT_SCALE_DELTA = 1.1;
  // const MIN_SCALE = 0.1;
  // const MAX_SCALE = 10.0;
  // const UNKNOWN_SCALE = 0;
  // const MAX_AUTO_SCALE = 1.25;
  // const SCROLLBAR_PADDING = 40;
  // const VERTICAL_PADDING = 5;
  const RenderingStates = {
      INITIAL: 0,
      RUNNING: 1,
      PAUSED: 2,
      FINISHED: 3
  };
  const PresentationModeState = {
      UNKNOWN: 0,
      NORMAL: 1,
      CHANGING: 2,
      FULLSCREEN: 3
  };
  // const SidebarView = {
  //   UNKNOWN: -1,
  //   NONE: 0,
  //   THUMBS: 1, // Default value.
  //   OUTLINE: 2,
  //   ATTACHMENTS: 3,
  //   LAYERS: 4,
  // };
  const TextLayerMode = {
      DISABLE: 0,
      ENABLE: 1,
      ENABLE_PERMISSIONS: 2
  };
  const ScrollMode = {
      UNKNOWN: -1,
      VERTICAL: 0, // Default value.
      HORIZONTAL: 1,
      WRAPPED: 2,
      PAGE: 3
  };
  // const SpreadMode = {
  //   UNKNOWN: -1,
  //   NONE: 0, // Default value.
  //   ODD: 1,
  //   EVEN: 2,
  // };
  // const CursorTool = {
  //   SELECT: 0, // The default value.
  //   HAND: 1,
  //   ZOOM: 2,
  // };
  // // Used by `PDFViewerApplication`, and by the API unit-tests.
  // const AutoPrintRegExp = /\bprint\s*\(/;
  // /**
  //  * Scale factors for the canvas, necessary with HiDPI displays.
  //  */
  // class OutputScale {
  //   constructor() {
  //     const pixelRatio = window.devicePixelRatio || 1;
  //     /**
  //      * @type {number} Horizontal scale.
  //      */
  //     this.sx = pixelRatio;
  //     /**
  //      * @type {number} Vertical scale.
  //      */
  //     this.sy = pixelRatio;
  //   }
  //   /**
  //    * @type {boolean} Returns `true` when scaling is required, `false` otherwise.
  //    */
  //   get scaled() {
  //     return this.sx !== 1 || this.sy !== 1;
  //   }
  // }
  /**
   * Scrolls specified element into view of its parent.
   * @param {HTMLElement} element - The element to be visible.
   * @param {Object} [spot] - An object with optional top and left properties,
   *   specifying the offset from the top left edge.
   * @param {number} [spot.left]
   * @param {number} [spot.top]
   * @param {boolean} [scrollMatches] - When scrolling search results into view,
   *   ignore elements that either: Contains marked content identifiers,
   *   or have the CSS-rule `overflow: hidden;` set. The default value is `false`.
   */
  function scrollIntoView(element, spot, scrollMatches = false) {
      // Assuming offsetParent is available (it's not available when viewer is in
      // hidden iframe or object). We have to scroll: if the offsetParent is not set
      // producing the error. See also animationStarted.
      let parent = element.offsetParent;
      if (!parent) {
          // eslint-disable-next-line no-console
          console.error("offsetParent is not set -- cannot scroll");
          return;
      }
      let offsetY = element.offsetTop + element.clientTop;
      let offsetX = element.offsetLeft + element.clientLeft;
      while ((parent.clientHeight === parent.scrollHeight &&
          parent.clientWidth === parent.scrollWidth) ||
          (scrollMatches &&
              (parent.classList.contains("markedContent") || parent.classList.contains("k-marked-content") ||
                  getComputedStyle(parent).overflow === "hidden"))) {
          offsetY += parent.offsetTop;
          offsetX += parent.offsetLeft;
          parent = parent.offsetParent;
          if (!parent) {
              return; // no need to scroll
          }
      }
      if (spot) {
          if (spot.top !== undefined) {
              offsetY += spot.top;
          }
          if (spot.left !== undefined) {
              offsetX += spot.left;
              parent.scrollLeft = offsetX;
          }
      }
      parent.scrollTop = offsetY;
  }
  // /**
  //  * Helper function to start monitoring the scroll event and converting them into
  //  * PDF.js friendly one: with scroll debounce and scroll direction.
  //  */
  // function watchScroll(viewAreaElement, callback, abortSignal = undefined) {
  //   const debounceScroll = function (evt) {
  //     if (rAF) {
  //       return;
  //     }
  //     // schedule an invocation of scroll for next animation frame.
  //     rAF = window.requestAnimationFrame(function viewAreaElementScrolled() {
  //       rAF = null;
  //       const currentX = viewAreaElement.scrollLeft;
  //       const lastX = state.lastX;
  //       if (currentX !== lastX) {
  //         state.right = currentX > lastX;
  //       }
  //       state.lastX = currentX;
  //       const currentY = viewAreaElement.scrollTop;
  //       const lastY = state.lastY;
  //       if (currentY !== lastY) {
  //         state.down = currentY > lastY;
  //       }
  //       state.lastY = currentY;
  //       callback(state);
  //     });
  //   };
  //   const state = {
  //     right: true,
  //     down: true,
  //     lastX: viewAreaElement.scrollLeft,
  //     lastY: viewAreaElement.scrollTop,
  //     _eventHandler: debounceScroll,
  //   };
  //   let rAF = null;
  //   viewAreaElement.addEventListener("scroll", debounceScroll, {
  //     useCapture: true,
  //     signal: abortSignal,
  //   });
  //   abortSignal?.addEventListener(
  //     "abort",
  //     () => window.cancelAnimationFrame(rAF),
  //     { once: true }
  //   );
  //   return state;
  // }
  /**
   * Helper function to parse query string (e.g. ?param1=value&param2=...).
   * @param {string} query
   * @returns {Map}
   */
  function parseQueryString(query) {
      const params = new Map();
      const urlSearchParams = new URLSearchParams(query);
      for (const [key, value] of urlSearchParams) {
          // for (const [key, value] of new URLSearchParams(query)) {
          params.set(key.toLowerCase(), value);
      }
      return params;
  }
  // const InvisibleCharsRegExp = /[\x00-\x1F]/g;
  // /**
  //  * @param {string} str
  //  * @param {boolean} [replaceInvisible]
  //  */
  // function removeNullCharacters(str, replaceInvisible = false) {
  //   if (!InvisibleCharsRegExp.test(str)) {
  //     return str;
  //   }
  //   if (replaceInvisible) {
  //     return str.replaceAll(InvisibleCharsRegExp, m => (m === "\x00" ? "" : " "));
  //   }
  //   return str.replaceAll("\x00", "");
  // }
  /**
   * Use binary search to find the index of the first item in a given array which
   * passes a given condition. The items are expected to be sorted in the sense
   * that if the condition is true for one item in the array, then it is also true
   * for all following items.
   *
   * @returns {number} Index of the first array element to pass the test,
   *                   or |items.length| if no such element exists.
   */
  function binarySearchFirstItem(items, condition, start = 0) {
      let minIndex = start;
      let maxIndex = items.length - 1;
      if (maxIndex < 0 || !condition(items[maxIndex])) {
          return items.length;
      }
      if (condition(items[minIndex])) {
          return minIndex;
      }
      while (minIndex < maxIndex) {
          const currentIndex = (minIndex + maxIndex) >> 1;
          const currentItem = items[currentIndex];
          if (condition(currentItem)) {
              maxIndex = currentIndex;
          }
          else {
              minIndex = currentIndex + 1;
          }
      }
      return minIndex; /* === maxIndex */
  }

  /* Copyright 2022 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _TextAccessibilityManager_instances, _a$8, _TextAccessibilityManager_enabled, _TextAccessibilityManager_textChildren, _TextAccessibilityManager_textNodes, _TextAccessibilityManager_waitingElements, _TextAccessibilityManager_compareElementPositions, _TextAccessibilityManager_addIdToAriaOwns;
  /**
   * This class aims to provide some methods:
   *  - to reorder elements in the DOM with respect to the visual order;
   *  - to create a link, using aria-owns, between spans in the textLayer and
   *    annotations in the annotationLayer. The goal is to help to know
   *    where the annotations are in the text flow.
   */
  class TextAccessibilityManager {
      constructor() {
          _TextAccessibilityManager_instances.add(this);
          _TextAccessibilityManager_enabled.set(this, false);
          _TextAccessibilityManager_textChildren.set(this, null);
          _TextAccessibilityManager_textNodes.set(this, new Map());
          _TextAccessibilityManager_waitingElements.set(this, new Map());
      }
      setTextMapping(textDivs) {
          __classPrivateFieldSet(this, _TextAccessibilityManager_textChildren, textDivs, "f");
      }
      /**
       * Function called when the text layer has finished rendering.
       */
      enable() {
          if (__classPrivateFieldGet(this, _TextAccessibilityManager_enabled, "f")) {
              // throw new Error("TextAccessibilityManager is already enabled.");
          }
          if (!__classPrivateFieldGet(this, _TextAccessibilityManager_textChildren, "f")) {
              throw new Error("Text divs and strings have not been set.");
          }
          __classPrivateFieldSet(this, _TextAccessibilityManager_enabled, true, "f");
          __classPrivateFieldSet(this, _TextAccessibilityManager_textChildren, __classPrivateFieldGet(this, _TextAccessibilityManager_textChildren, "f").slice(), "f");
          __classPrivateFieldGet(this, _TextAccessibilityManager_textChildren, "f").sort(__classPrivateFieldGet(_a$8, _a$8, "m", _TextAccessibilityManager_compareElementPositions));
          if (__classPrivateFieldGet(this, _TextAccessibilityManager_textNodes, "f").size > 0) {
              // Some links have been made before this manager has been disabled, hence
              // we restore them.
              const textChildren = __classPrivateFieldGet(this, _TextAccessibilityManager_textChildren, "f");
              for (const [id, nodeIndex] of __classPrivateFieldGet(this, _TextAccessibilityManager_textNodes, "f")) {
                  const element = document.getElementById(id);
                  if (!element) {
                      // If the page was *fully* reset the element no longer exists, and it
                      // will be re-inserted later (i.e. when the annotationLayer renders).
                      __classPrivateFieldGet(this, _TextAccessibilityManager_textNodes, "f").delete(id);
                      continue;
                  }
                  __classPrivateFieldGet(this, _TextAccessibilityManager_instances, "m", _TextAccessibilityManager_addIdToAriaOwns).call(this, id, textChildren[nodeIndex]);
              }
          }
          for (const [element, isRemovable] of __classPrivateFieldGet(this, _TextAccessibilityManager_waitingElements, "f")) {
              this.addPointerInTextLayer(element, isRemovable);
          }
          __classPrivateFieldGet(this, _TextAccessibilityManager_waitingElements, "f").clear();
      }
      disable() {
          if (!__classPrivateFieldGet(this, _TextAccessibilityManager_enabled, "f")) {
              return;
          }
          // Don't clear this.#textNodes which is used to rebuild the aria-owns
          // in case it's re-enabled at some point.
          __classPrivateFieldGet(this, _TextAccessibilityManager_waitingElements, "f").clear();
          __classPrivateFieldSet(this, _TextAccessibilityManager_textChildren, null, "f");
          __classPrivateFieldSet(this, _TextAccessibilityManager_enabled, false, "f");
      }
      /**
       * Remove an aria-owns id from a node in the text layer.
       * @param {HTMLElement} element
       */
      removePointerInTextLayer(element) {
          if (!__classPrivateFieldGet(this, _TextAccessibilityManager_enabled, "f")) {
              __classPrivateFieldGet(this, _TextAccessibilityManager_waitingElements, "f").delete(element);
              return;
          }
          const children = __classPrivateFieldGet(this, _TextAccessibilityManager_textChildren, "f");
          if (!children || children.length === 0) {
              return;
          }
          const { id } = element;
          const nodeIndex = __classPrivateFieldGet(this, _TextAccessibilityManager_textNodes, "f").get(id);
          if (nodeIndex === undefined) {
              return;
          }
          const node = children[nodeIndex];
          __classPrivateFieldGet(this, _TextAccessibilityManager_textNodes, "f").delete(id);
          let owns = node.getAttribute("aria-owns");
          if (owns === null || owns === void 0 ? void 0 : owns.includes(id)) {
              owns = owns
                  .split(" ")
                  .filter(x => x !== id)
                  .join(" ");
              if (owns) {
                  node.setAttribute("aria-owns", owns);
              }
              else {
                  node.removeAttribute("aria-owns");
                  node.setAttribute("role", "presentation");
              }
          }
      }
      /**
       * Find the text node which is the nearest and add an aria-owns attribute
       * in order to correctly position this editor in the text flow.
       * @param {HTMLElement} element
       * @param {boolean} isRemovable
       * @returns {string|null} The id in the struct tree if any.
       */
      addPointerInTextLayer(element, isRemovable) {
          // todo: mocked highlight editor is null here
          if (!element) {
              // eslint-disable-next-line no-console
              console.warn("no element");
              return;
          }
          const { id } = element;
          if (!id) {
              return null;
          }
          if (!__classPrivateFieldGet(this, _TextAccessibilityManager_enabled, "f")) {
              // The text layer needs to be there, so we postpone the association.
              __classPrivateFieldGet(this, _TextAccessibilityManager_waitingElements, "f").set(element, isRemovable);
              return null;
          }
          if (isRemovable) {
              this.removePointerInTextLayer(element);
          }
          const children = __classPrivateFieldGet(this, _TextAccessibilityManager_textChildren, "f");
          if (!children || children.length === 0) {
              return null;
          }
          const index = binarySearchFirstItem(children, node => __classPrivateFieldGet(_a$8, _a$8, "m", _TextAccessibilityManager_compareElementPositions).call(_a$8, element, node) < 0);
          const nodeIndex = Math.max(0, index - 1);
          const child = children[nodeIndex];
          __classPrivateFieldGet(this, _TextAccessibilityManager_instances, "m", _TextAccessibilityManager_addIdToAriaOwns).call(this, id, child);
          __classPrivateFieldGet(this, _TextAccessibilityManager_textNodes, "f").set(id, nodeIndex);
          const parent = child.parentNode;
          // return parent?.classList.contains("markedContent") ? parent.id : null;
          return (parent === null || parent === void 0 ? void 0 : parent.classList.contains("markedContent")) ||
              (parent === null || parent === void 0 ? void 0 : parent.classList.contains("k-marked-content")) ? parent.id : null;
      }
      /**
       * Move a div in the DOM in order to respect the visual order.
       * @param {HTMLDivElement} element
       * @returns {string|null} The id in the struct tree if any.
       */
      moveElementInDOM(container, element, contentElement, isRemovable) {
          const id = this.addPointerInTextLayer(contentElement, isRemovable);
          if (!container.hasChildNodes()) {
              container.append(element);
              return id;
          }
          // todo: use children to skip text nodes
          // const children = Array.from(container.childNodes).filter(
          const children = Array.from(container.children).filter(node => node !== element);
          if (children.length === 0) {
              return id;
          }
          const elementToCompare = contentElement || element;
          const index = binarySearchFirstItem(children, node => __classPrivateFieldGet(_a$8, _a$8, "m", _TextAccessibilityManager_compareElementPositions).call(_a$8, elementToCompare, node) < 0);
          if (index === 0) {
              children[0].before(element);
          }
          else {
              children[index - 1].after(element);
          }
          return id;
      }
      destroy() {
          __classPrivateFieldSet(this, _TextAccessibilityManager_textNodes, new Map(), "f");
          __classPrivateFieldSet(this, _TextAccessibilityManager_waitingElements, new Map(), "f");
          __classPrivateFieldSet(this, _TextAccessibilityManager_textChildren, null, "f");
      }
  }
  _a$8 = TextAccessibilityManager, _TextAccessibilityManager_enabled = new WeakMap(), _TextAccessibilityManager_textChildren = new WeakMap(), _TextAccessibilityManager_textNodes = new WeakMap(), _TextAccessibilityManager_waitingElements = new WeakMap(), _TextAccessibilityManager_instances = new WeakSet(), _TextAccessibilityManager_compareElementPositions = function _TextAccessibilityManager_compareElementPositions(e1, e2) {
      const rect1 = e1.getBoundingClientRect();
      const rect2 = e2.getBoundingClientRect();
      if (rect1.width === 0 && rect1.height === 0) {
          return +1;
      }
      if (rect2.width === 0 && rect2.height === 0) {
          return -1;
      }
      const top1 = rect1.y;
      const bot1 = rect1.y + rect1.height;
      const mid1 = rect1.y + rect1.height / 2;
      const top2 = rect2.y;
      const bot2 = rect2.y + rect2.height;
      const mid2 = rect2.y + rect2.height / 2;
      if (mid1 <= top2 && mid2 >= bot1) {
          return -1;
      }
      if (mid2 <= top1 && mid1 >= bot2) {
          return +1;
      }
      const centerX1 = rect1.x + rect1.width / 2;
      const centerX2 = rect2.x + rect2.width / 2;
      return centerX1 - centerX2;
  }, _TextAccessibilityManager_addIdToAriaOwns = function _TextAccessibilityManager_addIdToAriaOwns(id, node) {
      const owns = node.getAttribute("aria-owns");
      if (!(owns === null || owns === void 0 ? void 0 : owns.includes(id))) {
          node.setAttribute("aria-owns", owns ? `${owns} ${id}` : id);
      }
      node.removeAttribute("role");
  };

  /* Copyright 2012 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _TextLayerBuilder_instances, _a$7, _TextLayerBuilder_onAppend, _TextLayerBuilder_textLayer, _TextLayerBuilder_textLayers, _TextLayerBuilder_selectionChangeAbortController, _TextLayerBuilder_bindMouse, _TextLayerBuilder_removeGlobalSelectionListener, _TextLayerBuilder_enableGlobalSelectionListener;
  /**
   * The text layer builder provides text selection functionality for the PDF.
   * It does this by creating overlay divs over the PDF's text. These divs
   * contain text that matches the PDF text they are overlaying.
   */
  class TextLayerBuilder {
      constructor({ pdfPage, 
      // highlighter = null,
      accessibilityManager, 
      // enablePermissions = false,
      // todo: fix styles
      styles, onAppend = null }) {
          _TextLayerBuilder_instances.add(this);
          // todo: props
          this.pdfPage = null;
          // highlighter = null;
          this.div = null;
          this.accessibilityManager = null;
          // todo: props
          // #enablePermissions = false;
          _TextLayerBuilder_onAppend.set(this, null);
          // #renderingDone = false;
          _TextLayerBuilder_textLayer.set(this, null);
          this.pdfPage = pdfPage;
          // this.highlighter = highlighter;
          this.accessibilityManager = accessibilityManager;
          // this.#enablePermissions = enablePermissions === true;
          __classPrivateFieldSet(this, _TextLayerBuilder_onAppend, onAppend, "f");
          this.div = document.createElement("div");
          this.div.tabIndex = 0;
          // this.div.className = "textLayer";
          // todo: fix classes
          this.div.classList.add("k-text-layer");
          // todo: fix styles
          Object.keys(styles).forEach((key) => (this.div.style[key] = styles[key]));
      }
      /**
       * Renders the text layer.
       * @param {PageViewport} viewport
       * @param {Object} [textContentParams]
       */
      render(viewport_1) {
          return __awaiter(this, arguments, void 0, function* (viewport, textContentParams = null) {
              var _b, _c, _d;
              // if (this.#renderingDone && this.#textLayer) {
              if (__classPrivateFieldGet(this, _TextLayerBuilder_textLayer, "f")) {
                  __classPrivateFieldGet(this, _TextLayerBuilder_textLayer, "f").update({
                      viewport,
                      onBefore: this.hide.bind(this)
                  });
                  this.show();
                  return;
              }
              this.cancel();
              __classPrivateFieldSet(this, _TextLayerBuilder_textLayer, new kendo_pdfjs_loader_js.TextLayer({
                  textContentSource: this.pdfPage.streamTextContent(textContentParams || {
                      // includeMarkedContent: true,
                      // setting this to false requires removing "await"
                      // in page.ts when calling this.#renderTextLayer()
                      includeMarkedContent: false,
                      disableNormalization: true
                  }),
                  container: this.div,
                  viewport
              }), "f");
              // const { textDivs, textContentItemsStr } = this.#textLayer;
              const { textDivs } = __classPrivateFieldGet(this, _TextLayerBuilder_textLayer, "f");
              // this.highlighter?.setTextMapping(textDivs, textContentItemsStr);
              (_b = this.accessibilityManager) === null || _b === void 0 ? void 0 : _b.setTextMapping(textDivs);
              yield __classPrivateFieldGet(this, _TextLayerBuilder_textLayer, "f").render();
              // this.#renderingDone = true;
              // todo: manually add "k-marked-content" class
              // as pdf.js text layer cannot render it
              const markedContentElements = Array.from(this.div.querySelectorAll(".markedContent") || []) || [];
              markedContentElements.forEach(x => addClass("k-marked-content", x));
              if (markedContentElements && markedContentElements.length > 0) {
                  const endOfContent = document.createElement("div");
                  endOfContent.className = "endOfContent";
                  this.div.append(endOfContent);
                  __classPrivateFieldGet(this, _TextLayerBuilder_instances, "m", _TextLayerBuilder_bindMouse).call(this, endOfContent);
              }
              // Ensure that the textLayer is appended to the DOM *before* handling
              // e.g. a pending search operation.
              (_c = __classPrivateFieldGet(this, _TextLayerBuilder_onAppend, "f")) === null || _c === void 0 ? void 0 : _c.call(this, this.div);
              // this.highlighter?.enable();
              (_d = this.accessibilityManager) === null || _d === void 0 ? void 0 : _d.enable();
          });
      }
      hide() {
          // if (!this.div.hidden && this.#renderingDone) {
          if (!this.div.hidden) {
              // We turn off the highlighter in order to avoid to scroll into view an
              // element of the text layer which could be hidden.
              // this.highlighter?.disable();
              this.div.hidden = true;
          }
      }
      show() {
          // if (this.div.hidden && this.#renderingDone) {
          if (this.div.hidden) {
              this.div.hidden = false;
              // this.highlighter?.enable();
          }
      }
      /**
       * Cancel rendering of the text layer.
       */
      cancel() {
          var _b, _c, _d;
          (_b = __classPrivateFieldGet(this, _TextLayerBuilder_textLayer, "f")) === null || _b === void 0 ? void 0 : _b.cancel();
          __classPrivateFieldSet(this, _TextLayerBuilder_textLayer, null, "f");
          // this.highlighter?.disable();
          (_c = this.accessibilityManager) === null || _c === void 0 ? void 0 : _c.disable();
          (_d = this.accessibilityManager) === null || _d === void 0 ? void 0 : _d.destroy();
          __classPrivateFieldGet(_a$7, _a$7, "m", _TextLayerBuilder_removeGlobalSelectionListener).call(_a$7, this.div);
      }
      destroy() {
          var _b, _c;
          kendo_pdfjs_loader_js.TextLayer.cleanup();
          this.cancel();
          this.pdfPage = null;
          // this.highlighter = null;
          (_b = this.accessibilityManager) === null || _b === void 0 ? void 0 : _b.destroy();
          this.accessibilityManager = null;
          (_c = this.div) === null || _c === void 0 ? void 0 : _c.remove();
          this.div = null;
      }
  }
  _a$7 = TextLayerBuilder, _TextLayerBuilder_onAppend = new WeakMap(), _TextLayerBuilder_textLayer = new WeakMap(), _TextLayerBuilder_instances = new WeakSet(), _TextLayerBuilder_bindMouse = function _TextLayerBuilder_bindMouse(end) {
      const { div } = this;
      // div.addEventListener("mousedown", () => {
      //     div.classList.add("selecting");
      // });
      // div.addEventListener("copy", event => {
      //     if (!this.#enablePermissions) {
      //         const selection = document.getSelection();
      //         event.clipboardData.setData(
      //             "text/plain",
      //             removeNullCharacters(normalizeUnicode(selection.toString()))
      //         );
      //     }
      //     event.preventDefault();
      //     event.stopPropagation();
      // });
      __classPrivateFieldGet(_a$7, _a$7, "f", _TextLayerBuilder_textLayers).set(div, end);
      __classPrivateFieldGet(_a$7, _a$7, "m", _TextLayerBuilder_enableGlobalSelectionListener).call(_a$7);
  }, _TextLayerBuilder_removeGlobalSelectionListener = function _TextLayerBuilder_removeGlobalSelectionListener(textLayerDiv) {
      var _b;
      __classPrivateFieldGet(this, _a$7, "f", _TextLayerBuilder_textLayers).delete(textLayerDiv);
      if (__classPrivateFieldGet(this, _a$7, "f", _TextLayerBuilder_textLayers).size === 0) {
          (_b = __classPrivateFieldGet(this, _a$7, "f", _TextLayerBuilder_selectionChangeAbortController)) === null || _b === void 0 ? void 0 : _b.abort();
          __classPrivateFieldSet(this, _a$7, null, "f", _TextLayerBuilder_selectionChangeAbortController);
      }
  }, _TextLayerBuilder_enableGlobalSelectionListener = function _TextLayerBuilder_enableGlobalSelectionListener() {
      // if (this.#selectionChangeAbortController) {
      //     // document-level event listeners already installed
      //     return;
      // }
      // this.#selectionChangeAbortController = new AbortController();
      // const { signal } = this.#selectionChangeAbortController;
      // const reset = (end, textLayer) => {
      //     if (typeof PDFJSDev === "undefined" || !PDFJSDev.test("MOZCENTRAL")) {
      //         textLayer.append(end);
      //         end.style.width = "";
      //         end.style.height = "";
      //     }
      //     textLayer.classList.remove("selecting");
      // };
      // let isPointerDown = false;
      // document.addEventListener(
      //     "pointerdown",
      //     () => {
      //         isPointerDown = true;
      //     },
      //     { signal }
      // );
      // document.addEventListener(
      //     "pointerup",
      //     () => {
      //         isPointerDown = false;
      //         this.#textLayers.forEach(reset);
      //     },
      //     { signal }
      // );
      // window.addEventListener(
      //     "blur",
      //     () => {
      //         isPointerDown = false;
      //         this.#textLayers.forEach(reset);
      //     },
      //     { signal }
      // );
      // document.addEventListener(
      //     "keyup",
      //     () => {
      //         if (!isPointerDown) {
      //             this.#textLayers.forEach(reset);
      //         }
      //     },
      //     { signal }
      // );
      // if (typeof PDFJSDev === "undefined" || !PDFJSDev.test("MOZCENTRAL")) {
      //     // eslint-disable-next-line no-var
      //     var isFirefox, prevRange;
      // }
      // document.addEventListener(
      //     "selectionchange",
      //     () => {
      //         const selection = document.getSelection();
      //         if (selection.rangeCount === 0) {
      //             this.#textLayers.forEach(reset);
      //             return;
      //         }
      //         // Even though the spec says that .rangeCount should be 0 or 1, Firefox
      //         // creates multiple ranges when selecting across multiple pages.
      //         // Make sure to collect all the .textLayer elements where the selection
      //         // is happening.
      //         const activeTextLayers = new Set();
      //         for (let i = 0; i < selection.rangeCount; i++) {
      //             const range = selection.getRangeAt(i);
      //             for (const textLayerDiv of this.#textLayers.keys()) {
      //                 if (
      //                     !activeTextLayers.has(textLayerDiv) &&
      //                     range.intersectsNode(textLayerDiv)
      //                 ) {
      //                     activeTextLayers.add(textLayerDiv);
      //                 }
      //             }
      //         }
      //         for (const [textLayerDiv, endDiv] of this.#textLayers) {
      //             if (activeTextLayers.has(textLayerDiv)) {
      //                 textLayerDiv.classList.add("selecting");
      //             } else {
      //                 reset(endDiv, textLayerDiv);
      //             }
      //         }
      //         if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("MOZCENTRAL")) {
      //             return;
      //         }
      //         if (typeof PDFJSDev === "undefined" || !PDFJSDev.test("CHROME")) {
      //             isFirefox ??=
      //                 getComputedStyle(
      //                     this.#textLayers.values().next().value
      //                 ).getPropertyValue("-moz-user-select") === "none";
      //             if (isFirefox) {
      //                 return;
      //             }
      //         }
      //         // In non-Firefox browsers, when hovering over an empty space (thus,
      //         // on .endOfContent), the selection will expand to cover all the
      //         // text between the current selection and .endOfContent. By moving
      //         // .endOfContent to right after (or before, depending on which side
      //         // of the selection the user is moving), we limit the selection jump
      //         // to at most cover the enteirety of the <span> where the selection
      //         // is being modified.
      //         const range = selection.getRangeAt(0);
      //         const modifyStart =
      //             prevRange &&
      //             (range.compareBoundaryPoints(Range.END_TO_END, prevRange) === 0 ||
      //                 range.compareBoundaryPoints(Range.START_TO_END, prevRange) === 0);
      //         let anchor = modifyStart ? range.startContainer : range.endContainer;
      //         if (anchor.nodeType === Node.TEXT_NODE) {
      //             anchor = anchor.parentNode;
      //         }
      //         const parentTextLayer = anchor.parentElement.closest(".textLayer");
      //         const endDiv = this.#textLayers.get(parentTextLayer);
      //         if (endDiv) {
      //             endDiv.style.width = parentTextLayer.style.width;
      //             endDiv.style.height = parentTextLayer.style.height;
      //             anchor.parentElement.insertBefore(
      //                 endDiv,
      //                 modifyStart ? anchor : anchor.nextSibling
      //             );
      //         }
      //         prevRange = range.cloneRange();
      //     },
      //     { signal }
      // );
  };
  _TextLayerBuilder_textLayers = { value: new Map() };
  _TextLayerBuilder_selectionChangeAbortController = { value: null };

  /* Copyright 2020 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  /**
   * PLEASE NOTE: This file is currently imported in both the `../display/` and
   *              `../scripting_api/` folders, hence be EXTREMELY careful about
   *              introducing any dependencies here since that can lead to an
   *              unexpected/unnecessary size increase of the *built* files.
   */
  function makeColorComp(n) {
      return Math.floor(Math.max(0, Math.min(1, n)) * 255)
          .toString(16)
          .padStart(2, "0");
  }
  function scaleAndClamp(x) {
      return Math.max(0, Math.min(255, 255 * x));
  }
  // PDF specifications section 10.3
  class ColorConverters {
      static CMYK_G([c, y, m, k]) {
          return ["G", 1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)];
      }
      static G_CMYK([g]) {
          return ["CMYK", 0, 0, 0, 1 - g];
      }
      static G_RGB([g]) {
          return ["RGB", g, g, g];
      }
      static G_rgb([g]) {
          g = scaleAndClamp(g);
          return [g, g, g];
      }
      static G_HTML([g]) {
          const G = makeColorComp(g);
          return `#${G}${G}${G}`;
      }
      static RGB_G([r, g, b]) {
          return ["G", 0.3 * r + 0.59 * g + 0.11 * b];
      }
      static RGB_rgb(color) {
          return color.map(scaleAndClamp);
      }
      static RGB_HTML(color) {
          return `#${color.map(makeColorComp).join("")}`;
      }
      static T_HTML() {
          return "#00000000";
      }
      static T_rgb() {
          return [null];
      }
      static CMYK_RGB([c, y, m, k]) {
          return [
              "RGB",
              1 - Math.min(1, c + k),
              1 - Math.min(1, m + k),
              1 - Math.min(1, y + k)
          ];
      }
      static CMYK_rgb([c, y, m, k]) {
          return [
              scaleAndClamp(1 - Math.min(1, c + k)),
              scaleAndClamp(1 - Math.min(1, m + k)),
              scaleAndClamp(1 - Math.min(1, y + k))
          ];
      }
      static CMYK_HTML(components) {
          const rgb = this.CMYK_RGB(components).slice(1);
          return this.RGB_HTML(rgb);
      }
      static RGB_CMYK([r, g, b]) {
          const c = 1 - r;
          const m = 1 - g;
          const y = 1 - b;
          const k = Math.min(c, m, y);
          return ["CMYK", c, m, y, k];
      }
  }

  /* Copyright 2015 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  // import {
  //     BaseCanvasFactory,
  //     BaseCMapReaderFactory,
  //     BaseFilterFactory,
  //     BaseStandardFontDataFactory,
  //     BaseSVGFactory,
  // } from "./base_factory.js";
  // import {
  //     BaseException,
  //     FeatureTest,
  //     shadow,
  //     stringToBytes,
  //     Util,
  //     warn,
  // } from "../shared/util.js";
  // const SVG_NS = "http://www.w3.org/2000/svg";
  // class PixelsPerInch {
  //     static CSS = 96.0;
  //     static PDF = 72.0;
  //     static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
  // }
  // /**
  //  * FilterFactory aims to create some SVG filters we can use when drawing an
  //  * image (or whatever) on a canvas.
  //  * Filters aren't applied with ctx.putImageData because it just overwrites the
  //  * underlying pixels.
  //  * With these filters, it's possible for example to apply some transfer maps on
  //  * an image without the need to apply them on the pixel arrays: the renderer
  //  * does the magic for us.
  //  */
  // class DOMFilterFactory extends BaseFilterFactory {
  //     #baseUrl;
  //     #_cache;
  //     #_defs;
  //     #docId;
  //     #document;
  //     #_hcmCache;
  //     #id = 0;
  //     constructor({ docId, ownerDocument = globalThis.document } = {}) {
  //         super();
  //         this.#docId = docId;
  //         this.#document = ownerDocument;
  //     }
  //     get #cache() {
  //         return (this.#_cache ||= new Map());
  //     }
  //     get #hcmCache() {
  //         return (this.#_hcmCache ||= new Map());
  //     }
  //     get #defs() {
  //         if (!this.#_defs) {
  //             const div = this.#document.createElement("div");
  //             const { style } = div;
  //             style.visibility = "hidden";
  //             style.contain = "strict";
  //             style.width = style.height = 0;
  //             style.position = "absolute";
  //             style.top = style.left = 0;
  //             style.zIndex = -1;
  //             const svg = this.#document.createElementNS(SVG_NS, "svg");
  //             svg.setAttribute("width", 0);
  //             svg.setAttribute("height", 0);
  //             this.#_defs = this.#document.createElementNS(SVG_NS, "defs");
  //             div.append(svg);
  //             svg.append(this.#_defs);
  //             this.#document.body.append(div);
  //         }
  //         return this.#_defs;
  //     }
  //     #createTables(maps) {
  //         if (maps.length === 1) {
  //             const mapR = maps[0];
  //             const buffer = new Array(256);
  //             for (let i = 0; i < 256; i++) {
  //                 buffer[i] = mapR[i] / 255;
  //             }
  //             const table = buffer.join(",");
  //             return [table, table, table];
  //         }
  //         const [mapR, mapG, mapB] = maps;
  //         const bufferR = new Array(256);
  //         const bufferG = new Array(256);
  //         const bufferB = new Array(256);
  //         for (let i = 0; i < 256; i++) {
  //             bufferR[i] = mapR[i] / 255;
  //             bufferG[i] = mapG[i] / 255;
  //             bufferB[i] = mapB[i] / 255;
  //         }
  //         return [bufferR.join(","), bufferG.join(","), bufferB.join(",")];
  //     }
  //     #createUrl(id) {
  //         if (this.#baseUrl === undefined) {
  //             // Unless a `<base>`-element is present a relative URL should work.
  //             this.#baseUrl = "";
  //             const url = this.#document.URL;
  //             if (url !== this.#document.baseURI) {
  //                 if (isDataScheme(url)) {
  //                     warn('#createUrl: ignore "data:"-URL for performance reasons.');
  //                 } else {
  //                     this.#baseUrl = url.split("#", 1)[0];
  //                 }
  //             }
  //         }
  //         return `url(${this.#baseUrl}#${id})`;
  //     }
  //     addFilter(maps) {
  //         if (!maps) {
  //             return "none";
  //         }
  //         // When a page is zoomed the page is re-drawn but the maps are likely
  //         // the same.
  //         let value = this.#cache.get(maps);
  //         if (value) {
  //             return value;
  //         }
  //         const [tableR, tableG, tableB] = this.#createTables(maps);
  //         const key = maps.length === 1 ? tableR : `${tableR}${tableG}${tableB}`;
  //         value = this.#cache.get(key);
  //         if (value) {
  //             this.#cache.set(maps, value);
  //             return value;
  //         }
  //         // We create a SVG filter: feComponentTransferElement
  //         //  https://www.w3.org/TR/SVG11/filters.html#feComponentTransferElement
  //         const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
  //         const url = this.#createUrl(id);
  //         this.#cache.set(maps, url);
  //         this.#cache.set(key, url);
  //         const filter = this.#createFilter(id);
  //         this.#addTransferMapConversion(tableR, tableG, tableB, filter);
  //         return url;
  //     }
  //     addHCMFilter(fgColor, bgColor) {
  //         const key = `${fgColor}-${bgColor}`;
  //         const filterName = "base";
  //         let info = this.#hcmCache.get(filterName);
  //         if (info?.key === key) {
  //             return info.url;
  //         }
  //         if (info) {
  //             info.filter?.remove();
  //             info.key = key;
  //             info.url = "none";
  //             info.filter = null;
  //         } else {
  //             info = {
  //                 key,
  //                 url: "none",
  //                 filter: null,
  //             };
  //             this.#hcmCache.set(filterName, info);
  //         }
  //         if (!fgColor || !bgColor) {
  //             return info.url;
  //         }
  //         const fgRGB = this.#getRGB(fgColor);
  //         fgColor = Util.makeHexColor(...fgRGB);
  //         const bgRGB = this.#getRGB(bgColor);
  //         bgColor = Util.makeHexColor(...bgRGB);
  //         this.#defs.style.color = "";
  //         if (
  //             (fgColor === "#000000" && bgColor === "#ffffff") ||
  //             fgColor === bgColor
  //         ) {
  //             return info.url;
  //         }
  //         // https://developer.mozilla.org/en-US/docs/Web/Accessibility/Understanding_Colors_and_Luminance
  //         //
  //         // Relative luminance:
  //         // https://www.w3.org/TR/WCAG20/#relativeluminancedef
  //         //
  //         // We compute the rounded luminance of the default background color.
  //         // Then for every color in the pdf, if its rounded luminance is the
  //         // same as the background one then it's replaced by the new
  //         // background color else by the foreground one.
  //         const map = new Array(256);
  //         for (let i = 0; i <= 255; i++) {
  //             const x = i / 255;
  //             map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
  //         }
  //         const table = map.join(",");
  //         const id = `g_${this.#docId}_hcm_filter`;
  //         const filter = (info.filter = this.#createFilter(id));
  //         this.#addTransferMapConversion(table, table, table, filter);
  //         this.#addGrayConversion(filter);
  //         const getSteps = (c, n) => {
  //             const start = fgRGB[c] / 255;
  //             const end = bgRGB[c] / 255;
  //             const arr = new Array(n + 1);
  //             for (let i = 0; i <= n; i++) {
  //                 arr[i] = start + (i / n) * (end - start);
  //             }
  //             return arr.join(",");
  //         };
  //         this.#addTransferMapConversion(
  //             getSteps(0, 5),
  //             getSteps(1, 5),
  //             getSteps(2, 5),
  //             filter
  //         );
  //         info.url = this.#createUrl(id);
  //         return info.url;
  //     }
  //     addAlphaFilter(map) {
  //         // When a page is zoomed the page is re-drawn but the maps are likely
  //         // the same.
  //         let value = this.#cache.get(map);
  //         if (value) {
  //             return value;
  //         }
  //         const [tableA] = this.#createTables([map]);
  //         const key = `alpha_${tableA}`;
  //         value = this.#cache.get(key);
  //         if (value) {
  //             this.#cache.set(map, value);
  //             return value;
  //         }
  //         const id = `g_${this.#docId}_alpha_map_${this.#id++}`;
  //         const url = this.#createUrl(id);
  //         this.#cache.set(map, url);
  //         this.#cache.set(key, url);
  //         const filter = this.#createFilter(id);
  //         this.#addTransferMapAlphaConversion(tableA, filter);
  //         return url;
  //     }
  //     addLuminosityFilter(map) {
  //         // When a page is zoomed the page is re-drawn but the maps are likely
  //         // the same.
  //         let value = this.#cache.get(map || "luminosity");
  //         if (value) {
  //             return value;
  //         }
  //         let tableA, key;
  //         if (map) {
  //             [tableA] = this.#createTables([map]);
  //             key = `luminosity_${tableA}`;
  //         } else {
  //             key = "luminosity";
  //         }
  //         value = this.#cache.get(key);
  //         if (value) {
  //             this.#cache.set(map, value);
  //             return value;
  //         }
  //         const id = `g_${this.#docId}_luminosity_map_${this.#id++}`;
  //         const url = this.#createUrl(id);
  //         this.#cache.set(map, url);
  //         this.#cache.set(key, url);
  //         const filter = this.#createFilter(id);
  //         this.#addLuminosityConversion(filter);
  //         if (map) {
  //             this.#addTransferMapAlphaConversion(tableA, filter);
  //         }
  //         return url;
  //     }
  //     addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
  //         const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
  //         let info = this.#hcmCache.get(filterName);
  //         if (info?.key === key) {
  //             return info.url;
  //         }
  //         if (info) {
  //             info.filter?.remove();
  //             info.key = key;
  //             info.url = "none";
  //             info.filter = null;
  //         } else {
  //             info = {
  //                 key,
  //                 url: "none",
  //                 filter: null,
  //             };
  //             this.#hcmCache.set(filterName, info);
  //         }
  //         if (!fgColor || !bgColor) {
  //             return info.url;
  //         }
  //         const [fgRGB, bgRGB] = [fgColor, bgColor].map(this.#getRGB.bind(this));
  //         let fgGray = Math.round(
  //             0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]
  //         );
  //         let bgGray = Math.round(
  //             0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]
  //         );
  //         let [newFgRGB, newBgRGB] = [newFgColor, newBgColor].map(
  //             this.#getRGB.bind(this)
  //         );
  //         if (bgGray < fgGray) {
  //             [fgGray, bgGray, newFgRGB, newBgRGB] = [
  //                 bgGray,
  //                 fgGray,
  //                 newBgRGB,
  //                 newFgRGB,
  //             ];
  //         }
  //         this.#defs.style.color = "";
  //         // Now we can create the filters to highlight some canvas parts.
  //         // The colors in the pdf will almost be Canvas and CanvasText, hence we
  //         // want to filter them to finally get Highlight and HighlightText.
  //         // Since we're in HCM the background color and the foreground color should
  //         // be really different when converted to grayscale (if they're not then it
  //         // means that we've a poor contrast). Once the canvas colors are converted
  //         // to grayscale we can easily map them on their new colors.
  //         // The grayscale step is important because if we've something like:
  //         //   fgColor = #FF....
  //         //   bgColor = #FF....
  //         //   then we are enable to map the red component on the new red components
  //         //   which can be different.
  //         const getSteps = (fg, bg, n) => {
  //             const arr = new Array(256);
  //             const step = (bgGray - fgGray) / n;
  //             const newStart = fg / 255;
  //             const newStep = (bg - fg) / (255 * n);
  //             let prev = 0;
  //             for (let i = 0; i <= n; i++) {
  //                 const k = Math.round(fgGray + i * step);
  //                 const value = newStart + i * newStep;
  //                 for (let j = prev; j <= k; j++) {
  //                     arr[j] = value;
  //                 }
  //                 prev = k + 1;
  //             }
  //             for (let i = prev; i < 256; i++) {
  //                 arr[i] = arr[prev - 1];
  //             }
  //             return arr.join(",");
  //         };
  //         const id = `g_${this.#docId}_hcm_${filterName}_filter`;
  //         const filter = (info.filter = this.#createFilter(id));
  //         this.#addGrayConversion(filter);
  //         this.#addTransferMapConversion(
  //             getSteps(newFgRGB[0], newBgRGB[0], 5),
  //             getSteps(newFgRGB[1], newBgRGB[1], 5),
  //             getSteps(newFgRGB[2], newBgRGB[2], 5),
  //             filter
  //         );
  //         info.url = this.#createUrl(id);
  //         return info.url;
  //     }
  //     destroy(keepHCM = false) {
  //         if (keepHCM && this.#hcmCache.size !== 0) {
  //             return;
  //         }
  //         if (this.#_defs) {
  //             this.#_defs.parentNode.parentNode.remove();
  //             this.#_defs = null;
  //         }
  //         if (this.#_cache) {
  //             this.#_cache.clear();
  //             this.#_cache = null;
  //         }
  //         this.#id = 0;
  //     }
  //     #addLuminosityConversion(filter) {
  //         const feColorMatrix = this.#document.createElementNS(
  //             SVG_NS,
  //             "feColorMatrix"
  //         );
  //         feColorMatrix.setAttribute("type", "matrix");
  //         feColorMatrix.setAttribute(
  //             "values",
  //             "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0"
  //         );
  //         filter.append(feColorMatrix);
  //     }
  //     #addGrayConversion(filter) {
  //         const feColorMatrix = this.#document.createElementNS(
  //             SVG_NS,
  //             "feColorMatrix"
  //         );
  //         feColorMatrix.setAttribute("type", "matrix");
  //         feColorMatrix.setAttribute(
  //             "values",
  //             "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
  //         );
  //         filter.append(feColorMatrix);
  //     }
  //     #createFilter(id) {
  //         const filter = this.#document.createElementNS(SVG_NS, "filter");
  //         filter.setAttribute("color-interpolation-filters", "sRGB");
  //         filter.setAttribute("id", id);
  //         this.#defs.append(filter);
  //         return filter;
  //     }
  //     #appendFeFunc(feComponentTransfer, func, table) {
  //         const feFunc = this.#document.createElementNS(SVG_NS, func);
  //         feFunc.setAttribute("type", "discrete");
  //         feFunc.setAttribute("tableValues", table);
  //         feComponentTransfer.append(feFunc);
  //     }
  //     #addTransferMapConversion(rTable, gTable, bTable, filter) {
  //         const feComponentTransfer = this.#document.createElementNS(
  //             SVG_NS,
  //             "feComponentTransfer"
  //         );
  //         filter.append(feComponentTransfer);
  //         this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
  //         this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
  //         this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
  //     }
  //     #addTransferMapAlphaConversion(aTable, filter) {
  //         const feComponentTransfer = this.#document.createElementNS(
  //             SVG_NS,
  //             "feComponentTransfer"
  //         );
  //         filter.append(feComponentTransfer);
  //         this.#appendFeFunc(feComponentTransfer, "feFuncA", aTable);
  //     }
  //     #getRGB(color) {
  //         this.#defs.style.color = color;
  //         return getRGB(getComputedStyle(this.#defs).getPropertyValue("color"));
  //     }
  // }
  // class DOMCanvasFactory extends BaseCanvasFactory {
  //     constructor({ ownerDocument = globalThis.document, enableHWA = false } = {}) {
  //         super({ enableHWA });
  //         this._document = ownerDocument;
  //     }
  //     /**
  //      * @ignore
  //      */
  //     _createCanvas(width, height) {
  //         const canvas = this._document.createElement("canvas");
  //         canvas.width = width;
  //         canvas.height = height;
  //         return canvas;
  //     }
  // }
  // async function fetchData(url, type = "text") {
  //     if (
  //         (typeof PDFJSDev !== "undefined" && PDFJSDev.test("MOZCENTRAL")) ||
  //         isValidFetchUrl(url, document.baseURI)
  //     ) {
  //         const response = await fetch(url);
  //         if (!response.ok) {
  //             throw new Error(response.statusText);
  //         }
  //         switch (type) {
  //             case "arraybuffer":
  //                 return response.arrayBuffer();
  //             case "blob":
  //                 return response.blob();
  //             case "json":
  //                 return response.json();
  //         }
  //         return response.text();
  //     }
  //     // The Fetch API is not supported.
  //     return new Promise((resolve, reject) => {
  //         const request = new XMLHttpRequest();
  //         request.open("GET", url, /* async = */ true);
  //         request.responseType = type;
  //         request.onreadystatechange = () => {
  //             if (request.readyState !== XMLHttpRequest.DONE) {
  //                 return;
  //             }
  //             if (request.status === 200 || request.status === 0) {
  //                 switch (type) {
  //                     case "arraybuffer":
  //                     case "blob":
  //                     case "json":
  //                         resolve(request.response);
  //                         return;
  //                 }
  //                 resolve(request.responseText);
  //                 return;
  //             }
  //             reject(new Error(request.statusText));
  //         };
  //         request.send(null);
  //     });
  // }
  // class DOMCMapReaderFactory extends BaseCMapReaderFactory {
  //     /**
  //      * @ignore
  //      */
  //     _fetchData(url, compressionType) {
  //         return fetchData(
  //             url,
  //         /* type = */ this.isCompressed ? "arraybuffer" : "text"
  //         ).then(data => ({
  //             cMapData:
  //                 data instanceof ArrayBuffer
  //                     ? new Uint8Array(data)
  //                     : stringToBytes(data),
  //             compressionType,
  //         }));
  //     }
  // }
  // class DOMStandardFontDataFactory extends BaseStandardFontDataFactory {
  //     /**
  //      * @ignore
  //      */
  //     _fetchData(url) {
  //         return fetchData(url, /* type = */ "arraybuffer").then(
  //             data => new Uint8Array(data)
  //         );
  //     }
  // }
  // class DOMSVGFactory extends BaseSVGFactory {
  //     /**
  //      * @ignore
  //      */
  //     _createSVG(type) {
  //         return document.createElementNS(SVG_NS, type);
  //     }
  // }
  // /**
  //  * @typedef {Object} PageViewportParameters
  //  * @property {Array<number>} viewBox - The xMin, yMin, xMax and
  //  *   yMax coordinates.
  //  * @property {number} scale - The scale of the viewport.
  //  * @property {number} rotation - The rotation, in degrees, of the viewport.
  //  * @property {number} [offsetX] - The horizontal, i.e. x-axis, offset. The
  //  *   default value is `0`.
  //  * @property {number} [offsetY] - The vertical, i.e. y-axis, offset. The
  //  *   default value is `0`.
  //  * @property {boolean} [dontFlip] - If true, the y-axis will not be flipped.
  //  *   The default value is `false`.
  //  */
  // /**
  //  * @typedef {Object} PageViewportCloneParameters
  //  * @property {number} [scale] - The scale, overriding the one in the cloned
  //  *   viewport. The default value is `this.scale`.
  //  * @property {number} [rotation] - The rotation, in degrees, overriding the one
  //  *   in the cloned viewport. The default value is `this.rotation`.
  //  * @property {number} [offsetX] - The horizontal, i.e. x-axis, offset.
  //  *   The default value is `this.offsetX`.
  //  * @property {number} [offsetY] - The vertical, i.e. y-axis, offset.
  //  *   The default value is `this.offsetY`.
  //  * @property {boolean} [dontFlip] - If true, the x-axis will not be flipped.
  //  *   The default value is `false`.
  //  */
  // /**
  //  * PDF page viewport created based on scale, rotation and offset.
  //  */
  // class PageViewport {
  //     /**
  //      * @param {PageViewportParameters}
  //      */
  //     constructor({
  //         viewBox,
  //         scale,
  //         rotation,
  //         offsetX = 0,
  //         offsetY = 0,
  //         dontFlip = false,
  //     }) {
  //         this.viewBox = viewBox;
  //         this.scale = scale;
  //         this.rotation = rotation;
  //         this.offsetX = offsetX;
  //         this.offsetY = offsetY;
  //         // creating transform to convert pdf coordinate system to the normal
  //         // canvas like coordinates taking in account scale and rotation
  //         const centerX = (viewBox[2] + viewBox[0]) / 2;
  //         const centerY = (viewBox[3] + viewBox[1]) / 2;
  //         let rotateA, rotateB, rotateC, rotateD;
  //         // Normalize the rotation, by clamping it to the [0, 360) range.
  //         rotation %= 360;
  //         if (rotation < 0) {
  //             rotation += 360;
  //         }
  //         switch (rotation) {
  //             case 180:
  //                 rotateA = -1;
  //                 rotateB = 0;
  //                 rotateC = 0;
  //                 rotateD = 1;
  //                 break;
  //             case 90:
  //                 rotateA = 0;
  //                 rotateB = 1;
  //                 rotateC = 1;
  //                 rotateD = 0;
  //                 break;
  //             case 270:
  //                 rotateA = 0;
  //                 rotateB = -1;
  //                 rotateC = -1;
  //                 rotateD = 0;
  //                 break;
  //             case 0:
  //                 rotateA = 1;
  //                 rotateB = 0;
  //                 rotateC = 0;
  //                 rotateD = -1;
  //                 break;
  //             default:
  //                 throw new Error(
  //                     "PageViewport: Invalid rotation, must be a multiple of 90 degrees."
  //                 );
  //         }
  //         if (dontFlip) {
  //             rotateC = -rotateC;
  //             rotateD = -rotateD;
  //         }
  //         let offsetCanvasX, offsetCanvasY;
  //         let width, height;
  //         if (rotateA === 0) {
  //             offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
  //             offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
  //             width = (viewBox[3] - viewBox[1]) * scale;
  //             height = (viewBox[2] - viewBox[0]) * scale;
  //         } else {
  //             offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
  //             offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
  //             width = (viewBox[2] - viewBox[0]) * scale;
  //             height = (viewBox[3] - viewBox[1]) * scale;
  //         }
  //         // creating transform for the following operations:
  //         // translate(-centerX, -centerY), rotate and flip vertically,
  //         // scale, and translate(offsetCanvasX, offsetCanvasY)
  //         this.transform = [
  //             rotateA * scale,
  //             rotateB * scale,
  //             rotateC * scale,
  //             rotateD * scale,
  //             offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
  //             offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY,
  //         ];
  //         this.width = width;
  //         this.height = height;
  //     }
  //     /**
  //      * The original, un-scaled, viewport dimensions.
  //      * @type {Object}
  //      */
  //     get rawDims() {
  //         const { viewBox } = this;
  //         return shadow(this, "rawDims", {
  //             pageWidth: viewBox[2] - viewBox[0],
  //             pageHeight: viewBox[3] - viewBox[1],
  //             pageX: viewBox[0],
  //             pageY: viewBox[1],
  //         });
  //     }
  //     /**
  //      * Clones viewport, with optional additional properties.
  //      * @param {PageViewportCloneParameters} [params]
  //      * @returns {PageViewport} Cloned viewport.
  //      */
  //     clone({
  //         scale = this.scale,
  //         rotation = this.rotation,
  //         offsetX = this.offsetX,
  //         offsetY = this.offsetY,
  //         dontFlip = false,
  //     } = {}) {
  //         return new PageViewport({
  //             viewBox: this.viewBox.slice(),
  //             scale,
  //             rotation,
  //             offsetX,
  //             offsetY,
  //             dontFlip,
  //         });
  //     }
  //     /**
  //      * Converts PDF point to the viewport coordinates. For examples, useful for
  //      * converting PDF location into canvas pixel coordinates.
  //      * @param {number} x - The x-coordinate.
  //      * @param {number} y - The y-coordinate.
  //      * @returns {Array} Array containing `x`- and `y`-coordinates of the
  //      *   point in the viewport coordinate space.
  //      * @see {@link convertToPdfPoint}
  //      * @see {@link convertToViewportRectangle}
  //      */
  //     convertToViewportPoint(x, y) {
  //         return Util.applyTransform([x, y], this.transform);
  //     }
  //     /**
  //      * Converts PDF rectangle to the viewport coordinates.
  //      * @param {Array} rect - The xMin, yMin, xMax and yMax coordinates.
  //      * @returns {Array} Array containing corresponding coordinates of the
  //      *   rectangle in the viewport coordinate space.
  //      * @see {@link convertToViewportPoint}
  //      */
  //     convertToViewportRectangle(rect) {
  //         const topLeft = Util.applyTransform([rect[0], rect[1]], this.transform);
  //         const bottomRight = Util.applyTransform([rect[2], rect[3]], this.transform);
  //         return [topLeft[0], topLeft[1], bottomRight[0], bottomRight[1]];
  //     }
  //     /**
  //      * Converts viewport coordinates to the PDF location. For examples, useful
  //      * for converting canvas pixel location into PDF one.
  //      * @param {number} x - The x-coordinate.
  //      * @param {number} y - The y-coordinate.
  //      * @returns {Array} Array containing `x`- and `y`-coordinates of the
  //      *   point in the PDF coordinate space.
  //      * @see {@link convertToViewportPoint}
  //      */
  //     convertToPdfPoint(x, y) {
  //         return Util.applyInverseTransform([x, y], this.transform);
  //     }
  // }
  // class RenderingCancelledException extends BaseException {
  //     constructor(msg, extraDelay = 0) {
  //         super(msg, "RenderingCancelledException");
  //         this.extraDelay = extraDelay;
  //     }
  // }
  // function isDataScheme(url) {
  //     const ii = url.length;
  //     let i = 0;
  //     while (i < ii && url[i].trim() === "") {
  //         i++;
  //     }
  //     return url.substring(i, i + 5).toLowerCase() === "data:";
  // }
  // function isPdfFile(filename) {
  //     return typeof filename === "string" && /\.pdf$/i.test(filename);
  // }
  // /**
  //  * Gets the filename from a given URL.
  //  * @param {string} url
  //  * @returns {string}
  //  */
  // function getFilenameFromUrl(url) {
  //     [url] = url.split(/[#?]/, 1);
  //     return url.substring(url.lastIndexOf("/") + 1);
  // }
  // /**
  //  * Returns the filename or guessed filename from the url (see issue 3455).
  //  * @param {string} url - The original PDF location.
  //  * @param {string} defaultFilename - The value returned if the filename is
  //  *   unknown, or the protocol is unsupported.
  //  * @returns {string} Guessed PDF filename.
  //  */
  // function getPdfFilenameFromUrl(url, defaultFilename = "document.pdf") {
  //     if (typeof url !== "string") {
  //         return defaultFilename;
  //     }
  //     if (isDataScheme(url)) {
  //         warn('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
  //         return defaultFilename;
  //     }
  //     const reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
  //     //              SCHEME        HOST        1.PATH  2.QUERY   3.REF
  //     // Pattern to get last matching NAME.pdf
  //     const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
  //     const splitURI = reURI.exec(url);
  //     let suggestedFilename =
  //         reFilename.exec(splitURI[1]) ||
  //         reFilename.exec(splitURI[2]) ||
  //         reFilename.exec(splitURI[3]);
  //     if (suggestedFilename) {
  //         suggestedFilename = suggestedFilename[0];
  //         if (suggestedFilename.includes("%")) {
  //             // URL-encoded %2Fpath%2Fto%2Ffile.pdf should be file.pdf
  //             try {
  //                 suggestedFilename = reFilename.exec(
  //                     decodeURIComponent(suggestedFilename)
  //                 )[0];
  //             } catch {
  //                 // Possible (extremely rare) errors:
  //                 // URIError "Malformed URI", e.g. for "%AA.pdf"
  //                 // TypeError "null has no properties", e.g. for "%2F.pdf"
  //             }
  //         }
  //     }
  //     return suggestedFilename || defaultFilename;
  // }
  // class StatTimer {
  //     started = Object.create(null);
  //     times = [];
  //     time(name) {
  //         if (name in this.started) {
  //             warn(`Timer is already running for ${name}`);
  //         }
  //         this.started[name] = Date.now();
  //     }
  //     timeEnd(name) {
  //         if (!(name in this.started)) {
  //             warn(`Timer has not been started for ${name}`);
  //         }
  //         this.times.push({
  //             name,
  //             start: this.started[name],
  //             end: Date.now(),
  //         });
  //         // Remove timer from started so it can be called again.
  //         delete this.started[name];
  //     }
  //     toString() {
  //         // Find the longest name for padding purposes.
  //         const outBuf = [];
  //         let longest = 0;
  //         for (const { name } of this.times) {
  //             longest = Math.max(name.length, longest);
  //         }
  //         for (const { name, start, end } of this.times) {
  //             outBuf.push(`${name.padEnd(longest)} ${end - start}ms\n`);
  //         }
  //         return outBuf.join("");
  //     }
  // }
  // function isValidFetchUrl(url, baseUrl) {
  //     if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("MOZCENTRAL")) {
  //         throw new Error("Not implemented: isValidFetchUrl");
  //     }
  //     try {
  //         const { protocol } = baseUrl ? new URL(url, baseUrl) : new URL(url);
  //         // The Fetch API only supports the http/https protocols, and not file/ftp.
  //         return protocol === "http:" || protocol === "https:";
  //     } catch {
  //         return false; // `new URL()` will throw on incorrect data.
  //     }
  // }
  /**
   * Event handler to suppress context menu.
   */
  function noContextMenu(e) {
      e.preventDefault();
  }
  // // Deprecated API function -- display regardless of the `verbosity` setting.
  // function deprecated(details) {
  //     console.log("Deprecated API usage: " + details);
  // }
  // let pdfDateStringRegex;
  // class PDFDateString {
  //     /**
  //      * Convert a PDF date string to a JavaScript `Date` object.
  //      *
  //      * The PDF date string format is described in section 7.9.4 of the official
  //      * PDF 32000-1:2008 specification. However, in the PDF 1.7 reference (sixth
  //      * edition) Adobe describes the same format including a trailing apostrophe.
  //      * This syntax in incorrect, but Adobe Acrobat creates PDF files that contain
  //      * them. We ignore all apostrophes as they are not necessary for date parsing.
  //      *
  //      * Moreover, Adobe Acrobat doesn't handle changing the date to universal time
  //      * and doesn't use the user's time zone (effectively ignoring the HH' and mm'
  //      * parts of the date string).
  //      *
  //      * @param {string} input
  //      * @returns {Date|null}
  //      */
  //     static toDateObject(input) {
  //         if (!input || typeof input !== "string") {
  //             return null;
  //         }
  //         // Lazily initialize the regular expression.
  //         pdfDateStringRegex ||= new RegExp(
  //             "^D:" + // Prefix (required)
  //             "(\\d{4})" + // Year (required)
  //             "(\\d{2})?" + // Month (optional)
  //             "(\\d{2})?" + // Day (optional)
  //             "(\\d{2})?" + // Hour (optional)
  //             "(\\d{2})?" + // Minute (optional)
  //             "(\\d{2})?" + // Second (optional)
  //             "([Z|+|-])?" + // Universal time relation (optional)
  //             "(\\d{2})?" + // Offset hour (optional)
  //             "'?" + // Splitting apostrophe (optional)
  //             "(\\d{2})?" + // Offset minute (optional)
  //             "'?" // Trailing apostrophe (optional)
  //         );
  //         // Optional fields that don't satisfy the requirements from the regular
  //         // expression (such as incorrect digit counts or numbers that are out of
  //         // range) will fall back the defaults from the specification.
  //         const matches = pdfDateStringRegex.exec(input);
  //         if (!matches) {
  //             return null;
  //         }
  //         // JavaScript's `Date` object expects the month to be between 0 and 11
  //         // instead of 1 and 12, so we have to correct for that.
  //         const year = parseInt(matches[1], 10);
  //         let month = parseInt(matches[2], 10);
  //         month = month >= 1 && month <= 12 ? month - 1 : 0;
  //         let day = parseInt(matches[3], 10);
  //         day = day >= 1 && day <= 31 ? day : 1;
  //         let hour = parseInt(matches[4], 10);
  //         hour = hour >= 0 && hour <= 23 ? hour : 0;
  //         let minute = parseInt(matches[5], 10);
  //         minute = minute >= 0 && minute <= 59 ? minute : 0;
  //         let second = parseInt(matches[6], 10);
  //         second = second >= 0 && second <= 59 ? second : 0;
  //         const universalTimeRelation = matches[7] || "Z";
  //         let offsetHour = parseInt(matches[8], 10);
  //         offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
  //         let offsetMinute = parseInt(matches[9], 10) || 0;
  //         offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
  //         // Universal time relation 'Z' means that the local time is equal to the
  //         // universal time, whereas the relations '+'/'-' indicate that the local
  //         // time is later respectively earlier than the universal time. Every date
  //         // is normalized to universal time.
  //         if (universalTimeRelation === "-") {
  //             hour += offsetHour;
  //             minute += offsetMinute;
  //         } else if (universalTimeRelation === "+") {
  //             hour -= offsetHour;
  //             minute -= offsetMinute;
  //         }
  //         return new Date(Date.UTC(year, month, day, hour, minute, second));
  //     }
  // }
  // /**
  //  * NOTE: This is (mostly) intended to support printing of XFA forms.
  //  */
  // function getXfaPageViewport(xfaPage, { scale = 1, rotation = 0 }) {
  //     const { width, height } = xfaPage.attributes.style;
  //     const viewBox = [0, 0, parseInt(width), parseInt(height)];
  //     return new PageViewport({
  //         viewBox,
  //         scale,
  //         rotation,
  //     });
  // }
  function getRGB(color) {
      if (color.startsWith("#")) {
          const colorRGB = parseInt(color.slice(1), 16);
          return [
              (colorRGB & 0xff0000) >> 16,
              (colorRGB & 0x00ff00) >> 8,
              colorRGB & 0x0000ff
          ];
      }
      if (color.startsWith("rgb(")) {
          // getComputedStyle(...).color returns a `rgb(R, G, B)` color.
          return color
              .slice(/* "rgb(".length */ 4, -1) // Strip out "rgb(" and ")".
              .split(",")
              .map(x => parseInt(x, 10));
      }
      if (color.startsWith("rgba(")) {
          return color
              .slice(/* "rgba(".length */ 5, -1) // Strip out "rgba(" and ")".
              .split(",")
              .map(x => parseInt(x, 10))
              .slice(0, 3);
      }
      // warn(`Not a valid color format: "${color}"`);
      return [0, 0, 0];
  }
  function getColorValues(colors) {
      const span = document.createElement("span");
      span.style.visibility = "hidden";
      document.body.append(span);
      for (const name of colors.keys()) {
          span.style.color = name;
          const computedColor = window.getComputedStyle(span).color;
          colors.set(name, getRGB(computedColor));
      }
      span.remove();
  }
  // function getCurrentTransform(ctx) {
  //     const { a, b, c, d, e, f } = ctx.getTransform();
  //     return [a, b, c, d, e, f];
  // }
  // function getCurrentTransformInverse(ctx) {
  //     const { a, b, c, d, e, f } = ctx.getTransform().invertSelf();
  //     return [a, b, c, d, e, f];
  // }
  // /**
  //  * @param {HTMLDivElement} div
  //  * @param {PageViewport} viewport
  //  * @param {boolean} mustFlip
  //  * @param {boolean} mustRotate
  //  */
  // function setLayerDimensions(
  //     div,
  //     viewport,
  //     mustFlip = false,
  //     mustRotate = true
  // ) {
  //     if (viewport instanceof PageViewport) {
  //         const { pageWidth, pageHeight } = viewport.rawDims;
  //         const { style } = div;
  //         const useRound = FeatureTest.isCSSRoundSupported;
  //         const w = `var(--scale-factor) * ${pageWidth}px`,
  //             h = `var(--scale-factor) * ${pageHeight}px`;
  //         const widthStr = useRound ? `round(${w}, 1px)` : `calc(${w})`,
  //             heightStr = useRound ? `round(${h}, 1px)` : `calc(${h})`;
  //         if (!mustFlip || viewport.rotation % 180 === 0) {
  //             style.width = widthStr;
  //             style.height = heightStr;
  //         } else {
  //             style.width = heightStr;
  //             style.height = widthStr;
  //         }
  //     }
  //     if (mustRotate) {
  //         div.setAttribute("data-main-rotation", viewport.rotation);
  //     }
  // }
  // export {
  //     // deprecated,
  //     // DOMCanvasFactory,
  //     // DOMCMapReaderFactory,
  //     // DOMFilterFactory,
  //     // DOMStandardFontDataFactory,
  //     // DOMSVGFactory,
  //     // fetchData,
  //     // getColorValues,
  //     // getCurrentTransform,
  //     // getCurrentTransformInverse,
  //     // getFilenameFromUrl,
  //     // getPdfFilenameFromUrl,
  //     // getRGB,
  //     // getXfaPageViewport,
  //     // isDataScheme,
  //     // isPdfFile,
  //     // isValidFetchUrl,
  //     // noContextMenu,
  //     // PageViewport,
  //     // PDFDateString,
  //     // PixelsPerInch,
  //     // RenderingCancelledException,
  //     setLayerDimensions,
  //     // StatTimer,
  // };

  /* Copyright 2022 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  class ColorManager {
      get _colors() {
          if (
          // typeof PDFJSDev !== "undefined" &&
          // PDFJSDev.test("LIB") &&
          typeof document === "undefined") {
              return shadow(this, "_colors", ColorManager._colorsMapping);
          }
          const colors = new Map([
              ["CanvasText", null],
              ["Canvas", null]
          ]);
          getColorValues(colors);
          return shadow(this, "_colors", colors);
      }
      /*
       * In High Contrast Mode, the color on the screen is not always the
       * real color used in the pdf.
       * For example in some cases white can appear to be black but when saving
       * we want to have white.
       * @param {string} color
       * @returns {Array<number>}
       */
      convert(color) {
          const rgb = getRGB(color);
          if (!window.matchMedia("(forced-colors: active)").matches) {
              return rgb;
          }
          for (const [name, RGB] of this._colors) {
              if (RGB.every((x, i) => x === rgb[i])) {
                  return ColorManager._colorsMapping.get(name);
              }
          }
          return rgb;
      }
      /*
       * An input element must have its color value as a hex string
       * and not as color name.
       * So this function converts a name into an hex string.
       * @param {string} name
       * @returns {string}
       */
      getHexCode(name) {
          const rgb = this._colors.get(name);
          if (!rgb) {
              return name;
          }
          // @ts-expect-error TS(2556):
          return Util.makeHexColor(...rgb);
      }
  }
  ColorManager._colorsMapping = new Map([
      ["CanvasText", [0, 0, 0]],
      ["Canvas", [255, 255, 255]]
  ]);

  /* Copyright 2022 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  function bindEvents(obj, element, names) {
      for (const name of names) {
          element.addEventListener(name, obj[name].bind(obj));
      }
  }

  /* Copyright 2022 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _AnnotationEditor_instances, _a$6, _AnnotationEditor_x, _AnnotationEditor_y, _AnnotationEditor_disabled, _AnnotationEditor_keepAspectRatio, _AnnotationEditor_focusAC, _AnnotationEditor_hasBeenClicked, _AnnotationEditor_initialPosition, _AnnotationEditor_isEditing, _AnnotationEditor_isInEditMode, _AnnotationEditor_moveInDOMTimeout, _AnnotationEditor_prevDragX, _AnnotationEditor_prevDragY, _AnnotationEditor_isDraggable, _AnnotationEditor_zIndex, _AnnotationEditor_translate, _AnnotationEditor_rotatePoint, _AnnotationEditor_selectOnPointerEvent, _AnnotationEditor_setUpDragSession, _AnnotationEditor_addFocusListeners, _AnnotationEditor_stopResizing;
  class AnnotationEditor {
      constructor(parameters) {
          // if (this.constructor === AnnotationEditor) {
          //     unreachable("Cannot initialize AnnotationEditor.");
          // }
          _AnnotationEditor_instances.add(this);
          // todo: properties
          this.parent = null;
          this.id = null;
          this.width = null;
          this.height = null;
          this.pageIndex = 0;
          this.name = "";
          this.div = null;
          this.annotationElementId = null;
          this._willKeepAspectRatio = false;
          // _initialOptions = {};
          this._structTreeParentId = null;
          this.rotation = 0;
          this.pageRotation = 0;
          this.pageDimensions = [];
          this.pageTranslation = [];
          // x = 0;
          // y = 0;
          _AnnotationEditor_x.set(this, 0);
          _AnnotationEditor_y.set(this, 0);
          this.isAttachedToDOM = false;
          this.deleted = false;
          // todo: end
          // #accessibilityData = null;
          // #allResizerDivs = null;
          // #altText = null;
          _AnnotationEditor_disabled.set(this, false);
          _AnnotationEditor_keepAspectRatio.set(this, false);
          // #resizersDiv = null;
          // #savedDimensions = null;
          _AnnotationEditor_focusAC.set(this, null);
          // #focusedResizerName = "";
          _AnnotationEditor_hasBeenClicked.set(this, false);
          _AnnotationEditor_initialPosition.set(this, null);
          _AnnotationEditor_isEditing.set(this, false);
          _AnnotationEditor_isInEditMode.set(this, false);
          // #isResizerEnabledForKeyboard = false;
          _AnnotationEditor_moveInDOMTimeout.set(this, null);
          _AnnotationEditor_prevDragX.set(this, 0);
          _AnnotationEditor_prevDragY.set(this, 0);
          // #telemetryTimeouts = null;
          this._editToolbar = null;
          this._initialOptions = Object.create(null);
          this._isVisible = true;
          this._uiManager = null;
          this._focusEventsAllowed = true;
          this._l10nPromise = null;
          _AnnotationEditor_isDraggable.set(this, false);
          _AnnotationEditor_zIndex.set(this, _a$6._zIndex++);
          this.parent = parameters.parent;
          this.id = parameters.id || _a$6.idManager.id;
          this.width = this.height = null;
          this.pageIndex = parameters.parent.pageIndex;
          this.name = parameters.name;
          this.div = null;
          this._uiManager = parameters.uiManager;
          this.annotationElementId = null;
          this._willKeepAspectRatio = false;
          this._initialOptions.isCentered = parameters.isCentered;
          this._structTreeParentId = null;
          const { rotation, rawDims: { pageWidth, pageHeight, pageX, pageY } } = this.parent.viewport;
          this.rotation = rotation;
          this.pageRotation =
              (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
          this.pageDimensions = [pageWidth, pageHeight];
          this.pageTranslation = [pageX, pageY];
          const [width, height] = this.parentDimensions;
          this.x = parameters.x / width;
          this.y = parameters.y / height;
          this.isAttachedToDOM = false;
          this.deleted = false;
      }
      get x() {
          return __classPrivateFieldGet(this, _AnnotationEditor_x, "f");
      }
      set x(value) {
          __classPrivateFieldSet(this, _AnnotationEditor_x, value, "f");
      }
      get y() {
          return __classPrivateFieldGet(this, _AnnotationEditor_y, "f");
      }
      set y(value) {
          __classPrivateFieldSet(this, _AnnotationEditor_y, value, "f");
      }
      get editorType() {
          return Object.getPrototypeOf(this).constructor._type;
      }
      static get _defaultLineColor() {
          return kendo_pdfjs_loader_js.shadow(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
      }
      static deleteAnnotationElement(editor) {
          const fakeEditor = new FakeEditor({
              id: editor.parent.getNextId(),
              parent: editor.parent,
              uiManager: editor._uiManager
          });
          fakeEditor.annotationElementId = editor.annotationElementId;
          fakeEditor.deleted = true;
          fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
      }
      static initialize(l10n, uiManager, options) {
          if (!l10n || !uiManager || !options) {
              /* no-empty */
          }
          // static initialize() {
          // AnnotationEditor._l10nPromise ||= new Map(
          //     [
          //         "pdfjs-editor-alt-text-button-label",
          //         "pdfjs-editor-alt-text-edit-button-label",
          //         "pdfjs-editor-alt-text-decorative-tooltip",
          //         "pdfjs-editor-new-alt-text-added-button-label",
          //         "pdfjs-editor-new-alt-text-missing-button-label",
          //         "pdfjs-editor-new-alt-text-to-review-button-label",
          //         "pdfjs-editor-resizer-label-topLeft",
          //         "pdfjs-editor-resizer-label-topMiddle",
          //         "pdfjs-editor-resizer-label-topRight",
          //         "pdfjs-editor-resizer-label-middleRight",
          //         "pdfjs-editor-resizer-label-bottomRight",
          //         "pdfjs-editor-resizer-label-bottomMiddle",
          //         "pdfjs-editor-resizer-label-bottomLeft",
          //         "pdfjs-editor-resizer-label-middleLeft",
          //     ].map(str => [
          //         str,
          //         l10n.get(str.replaceAll(/([A-Z])/g, c => `-${c.toLowerCase()}`)),
          //     ])
          // );
          // // The string isn't in the above list because the string has a parameter
          // // (i.e. the guessed text) and we must pass it to the l10n function to get
          // // the correct translation.
          // AnnotationEditor._l10nPromise.set(
          //     "pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer",
          //     l10n.get.bind(
          //         l10n,
          //         "pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer"
          //     )
          // );
          // if (options?.strings) {
          //     for (const str of options.strings) {
          //         AnnotationEditor._l10nPromise.set(str, l10n.get(str));
          //     }
          // }
          // if (AnnotationEditor._borderLineWidth !== -1) {
          //     return;
          // }
          // const style = getComputedStyle(document.documentElement);
          // AnnotationEditor._borderLineWidth =
          //     parseFloat(style.getPropertyValue("--outline-width")) || 0;
      }
      /**
       * Update the default parameters for this type of editor.
       * @param {number} _type
       * @param {*} _value
       */
      static updateDefaultParams(_type, _value) {
          // if (!_type || !_value) {
          // }
      }
      /**
       * Get the default properties to set in the UI for this type of editor.
       * @returns {Array}
       */
      static get defaultPropertiesToUpdate() {
          return [];
      }
      /**
       * Check if this kind of editor is able to handle the given mime type for
       * pasting.
       * @param {string} mime
       * @returns {boolean}
       */
      static isHandlingMimeForPasting(mime) {
          if (!mime) {
              return;
          }
          return false;
      }
      /**
       * Extract the data from the clipboard item and delegate the creation of the
       * editor to the parent.
       * @param {DataTransferItem} item
       * @param {AnnotationEditorLayer} parent
       */
      static paste(item, parent) {
          if (!item || !parent) {
              /* no-empty */
          }
          // unreachable("Not implemented");
      }
      /**
       * Get the properties to update in the UI for this editor.
       * @returns {Array}
       */
      get propertiesToUpdate() {
          return [];
      }
      get _isDraggable() {
          return __classPrivateFieldGet(this, _AnnotationEditor_isDraggable, "f");
      }
      set _isDraggable(value) {
          var _b;
          __classPrivateFieldSet(this, _AnnotationEditor_isDraggable, value, "f");
          // this.div?.classList.toggle("draggable", value);
          (_b = this.div) === null || _b === void 0 ? void 0 : _b.classList.toggle("k-draggable", value);
      }
      /**
       * @returns {boolean} true if the editor handles the Enter key itself.
       */
      get isEnterHandled() {
          return true;
      }
      center() {
          const [pageWidth, pageHeight] = this.pageDimensions;
          switch (this.parentRotation) {
              case 90:
                  this.x -= (this.height * pageHeight) / (pageWidth * 2);
                  this.y += (this.width * pageWidth) / (pageHeight * 2);
                  break;
              case 180:
                  this.x += this.width / 2;
                  this.y += this.height / 2;
                  break;
              case 270:
                  this.x += (this.height * pageHeight) / (pageWidth * 2);
                  this.y -= (this.width * pageWidth) / (pageHeight * 2);
                  break;
              default:
                  this.x -= this.width / 2;
                  this.y -= this.height / 2;
                  break;
          }
          this.fixAndSetPosition();
      }
      /**
       * Add some commands into the CommandManager (undo/redo stuff).
       * @param {Object} params
       */
      addCommands(params) {
          this._uiManager.addCommands(params);
      }
      get currentLayer() {
          return this._uiManager.currentLayer;
      }
      /**
       * This editor will be behind the others.
       */
      setInBackground() {
          this.div.style.zIndex = 0;
      }
      /**
       * This editor will be in the foreground.
       */
      setInForeground() {
          this.div.style.zIndex = __classPrivateFieldGet(this, _AnnotationEditor_zIndex, "f");
      }
      setParent(parent) {
          if (parent !== null) {
              this.pageIndex = parent.pageIndex;
              this.pageDimensions = parent.pageDimensions;
          }
          else {
              // The editor is being removed from the DOM, so we need to stop resizing.
              __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_stopResizing).call(this);
          }
          this.parent = parent;
      }
      /**
       * onfocus callback.
       */
      focusin(event) {
          if (!event) {
              return;
          }
          if (!this._focusEventsAllowed) {
              return;
          }
          if (!__classPrivateFieldGet(this, _AnnotationEditor_hasBeenClicked, "f")) {
              this.parent.setSelected(this);
          }
          else {
              __classPrivateFieldSet(this, _AnnotationEditor_hasBeenClicked, false, "f");
          }
      }
      /**
       * onblur callback.
       * @param {FocusEvent} event
       */
      focusout(event) {
          var _b;
          if (!this._focusEventsAllowed) {
              return;
          }
          if (!this.isAttachedToDOM) {
              return;
          }
          // In case of focusout, the relatedTarget is the element which
          // is grabbing the focus.
          // So if the related target is an element under the div for this
          // editor, then the editor isn't unactive.
          const target = event.relatedTarget;
          if (target === null || target === void 0 ? void 0 : target.closest(`#${this.id}`)) {
              return;
          }
          event.preventDefault();
          if (!((_b = this.parent) === null || _b === void 0 ? void 0 : _b.isMultipleSelection)) {
              this.commitOrRemove();
          }
      }
      commitOrRemove() {
          if (this.isEmpty()) {
              this.remove();
          }
          else {
              this.commit();
          }
      }
      /**
       * Commit the data contained in this editor.
       */
      commit() {
          this.addToAnnotationStorage();
      }
      addToAnnotationStorage() {
          this._uiManager.addToAnnotationStorage(this);
      }
      /**
       * Set the editor position within its parent.
       * @param {number} x
       * @param {number} y
       * @param {number} tx - x-translation in screen coordinates.
       * @param {number} ty - y-translation in screen coordinates.
       */
      setAt(x, y, tx, ty) {
          const [width, height] = this.parentDimensions;
          [tx, ty] = this.screenToPageTranslation(tx, ty);
          this.x = (x + tx) / width;
          this.y = (y + ty) / height;
          this.fixAndSetPosition();
      }
      /**
       * Translate the editor position within its parent.
       * @param {number} x - x-translation in screen coordinates.
       * @param {number} y - y-translation in screen coordinates.
       */
      translate(x, y) {
          // We don't change the initial position because the move here hasn't been
          // done by the user.
          __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_translate).call(this, this.parentDimensions, x, y);
      }
      /**
       * Translate the editor position within its page and adjust the scroll
       * in order to have the editor in the view.
       * @param {number} x - x-translation in page coordinates.
       * @param {number} y - y-translation in page coordinates.
       */
      translateInPage(x, y) {
          __classPrivateFieldSet(this, _AnnotationEditor_initialPosition, __classPrivateFieldGet(this, _AnnotationEditor_initialPosition, "f") || [this.x, this.y], "f");
          __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_translate).call(this, this.pageDimensions, x, y);
          this.div.scrollIntoView({ block: "nearest" });
      }
      drag(tx, ty) {
          __classPrivateFieldSet(this, _AnnotationEditor_initialPosition, __classPrivateFieldGet(this, _AnnotationEditor_initialPosition, "f") || [this.x, this.y], "f");
          const [parentWidth, parentHeight] = this.parentDimensions;
          this.x += tx / parentWidth;
          this.y += ty / parentHeight;
          if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
              // It's possible to not have a parent: for example, when the user is
              // dragging all the selected editors but this one on a page which has been
              // destroyed.
              // It's why we need to check for it. In such a situation, it isn't really
              // a problem to not find a new parent: it's something which is related to
              // what the user is seeing, hence it depends on how pages are layed out.
              // The element will be outside of its parent so change the parent.
              const { x: xValue, y: yValue } = this.div.getBoundingClientRect();
              if (this.parent.findNewParent(this, xValue, yValue)) {
                  this.x -= Math.floor(this.x);
                  this.y -= Math.floor(this.y);
              }
          }
          // The editor can be moved wherever the user wants, so we don't need to fix
          // the position: it'll be done when the user will release the mouse button.
          let { x, y } = this;
          const [bx, by] = this.getBaseTranslation();
          x += bx;
          y += by;
          this.div.style.left = `${(100 * x).toFixed(2)}%`;
          this.div.style.top = `${(100 * y).toFixed(2)}%`;
          this.div.scrollIntoView({ block: "nearest" });
      }
      get _hasBeenMoved() {
          return (!!__classPrivateFieldGet(this, _AnnotationEditor_initialPosition, "f") &&
              (__classPrivateFieldGet(this, _AnnotationEditor_initialPosition, "f")[0] !== this.x ||
                  __classPrivateFieldGet(this, _AnnotationEditor_initialPosition, "f")[1] !== this.y));
      }
      /**
       * Get the translation to take into account the editor border.
       * The CSS engine positions the element by taking the border into account so
       * we must apply the opposite translation to have the editor in the right
       * position.
       * @returns {Array<number>}
       */
      getBaseTranslation() {
          const [parentWidth, parentHeight] = this.parentDimensions;
          const { _borderLineWidth } = _a$6;
          const x = _borderLineWidth / parentWidth;
          const y = _borderLineWidth / parentHeight;
          switch (this.rotation) {
              case 90:
                  return [-x, y];
              case 180:
                  return [x, y];
              case 270:
                  return [x, -y];
              default:
                  return [-x, -y];
          }
      }
      /**
       * @returns {boolean} true if position must be fixed (i.e. make the x and y
       * living in the page).
       */
      get _mustFixPosition() {
          return true;
      }
      /**
       * Fix the position of the editor in order to keep it inside its parent page.
       * @param {number} [rotation] - the rotation of the page.
       */
      fixAndSetPosition(rotation = this.rotation) {
          if (rotation === undefined) {
              return;
          }
          const [pageWidth, pageHeight] = this.pageDimensions;
          let { x, y, width, height } = this;
          width *= pageWidth;
          height *= pageHeight;
          x *= pageWidth;
          y *= pageHeight;
          if (this._mustFixPosition) {
              switch (rotation) {
                  case 0:
                      x = Math.max(0, Math.min(pageWidth - width, x));
                      y = Math.max(0, Math.min(pageHeight - height, y));
                      break;
                  case 90:
                      x = Math.max(0, Math.min(pageWidth - height, x));
                      y = Math.min(pageHeight, Math.max(width, y));
                      break;
                  case 180:
                      x = Math.min(pageWidth, Math.max(width, x));
                      y = Math.min(pageHeight, Math.max(height, y));
                      break;
                  case 270:
                      x = Math.min(pageWidth, Math.max(height, x));
                      y = Math.max(0, Math.min(pageHeight - width, y));
                      break;
                  default: break;
              }
          }
          this.x = x /= pageWidth;
          this.y = y /= pageHeight;
          const [bx, by] = this.getBaseTranslation();
          x += bx;
          y += by;
          const { style } = this.div;
          style.left = `${(100 * x).toFixed(2)}%`;
          style.top = `${(100 * y).toFixed(2)}%`;
          this.moveInDOM();
      }
      /**
       * Convert a screen translation into a page one.
       * @param {number} x
       * @param {number} y
       */
      screenToPageTranslation(x, y) {
          return __classPrivateFieldGet(_a$6, _a$6, "m", _AnnotationEditor_rotatePoint).call(_a$6, x, y, this.parentRotation);
      }
      /**
       * Convert a page translation into a screen one.
       * @param {number} x
       * @param {number} y
       */
      pageTranslationToScreen(x, y) {
          return __classPrivateFieldGet(_a$6, _a$6, "m", _AnnotationEditor_rotatePoint).call(_a$6, x, y, 360 - this.parentRotation);
      }
      // #getRotationMatrix(rotation) {
      //     switch (rotation) {
      //         case 90: {
      //             const [pageWidth, pageHeight] = this.pageDimensions;
      //             return [0, -pageWidth / pageHeight, pageHeight / pageWidth, 0];
      //         }
      //         case 180:
      //             return [-1, 0, 0, -1];
      //         case 270: {
      //             const [pageWidth, pageHeight] = this.pageDimensions;
      //             return [0, pageWidth / pageHeight, -pageHeight / pageWidth, 0];
      //         }
      //         default:
      //             return [1, 0, 0, 1];
      //     }
      // }
      get parentScale() {
          return this._uiManager.viewParameters.realScale;
      }
      get parentRotation() {
          return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
      }
      get parentDimensions() {
          const { parentScale, pageDimensions: [pageWidth, pageHeight] } = this;
          const scaledWidth = pageWidth * parentScale;
          const scaledHeight = pageHeight * parentScale;
          return kendo_pdfjs_loader_js.FeatureTest.isCSSRoundSupported
              ? [Math.round(scaledWidth), Math.round(scaledHeight)]
              : [scaledWidth, scaledHeight];
      }
      /**
       * Set the dimensions of this editor.
       * @param {number} width
       * @param {number} height
       */
      setDims(width, height) {
          const [parentWidth, parentHeight] = this.parentDimensions;
          this.div.style.width = `${((100 * width) / parentWidth).toFixed(2)}%`;
          if (!__classPrivateFieldGet(this, _AnnotationEditor_keepAspectRatio, "f")) {
              this.div.style.height = `${((100 * height) / parentHeight).toFixed(2)}%`;
          }
      }
      fixDims() {
          //     const { style } = this.div;
          //     const { height, width } = style;
          //     const widthPercent = width.endsWith("%");
          //     const heightPercent = !this.#keepAspectRatio && height.endsWith("%");
          //     if (widthPercent && heightPercent) {
          //         return;
          //     }
          //     const [parentWidth, parentHeight] = this.parentDimensions;
          //     if (!widthPercent) {
          //         style.width = `${((100 * parseFloat(width)) / parentWidth).toFixed(2)}%`;
          //     }
          //     if (!this.#keepAspectRatio && !heightPercent) {
          //         style.height = `${((100 * parseFloat(height)) / parentHeight).toFixed(
          //             2
          //         )}%`;
          //     }
      }
      /**
       * Get the translation used to position this editor when it's created.
       * @returns {Array<number>}
       */
      getInitialTranslation() {
          return [0, 0];
      }
      // #createResizers() {
      //     if (this.#resizersDiv) {
      //         return;
      //     }
      //     this.#resizersDiv = document.createElement("div");
      //     this.#resizersDiv.classList.add("resizers");
      //     // When the resizers are used with the keyboard, they're focusable, hence
      //     // we want to have them in this order (top left, top middle, top right, ...)
      //     // in the DOM to have the focus order correct.
      //     const classes = this._willKeepAspectRatio
      //         ? ["topLeft", "topRight", "bottomRight", "bottomLeft"]
      //         : [
      //             "topLeft",
      //             "topMiddle",
      //             "topRight",
      //             "middleRight",
      //             "bottomRight",
      //             "bottomMiddle",
      //             "bottomLeft",
      //             "middleLeft",
      //         ];
      //     const signal = this._uiManager._signal;
      //     for (const name of classes) {
      //         const div = document.createElement("div");
      //         this.#resizersDiv.append(div);
      //         div.classList.add("resizer", name);
      //         div.setAttribute("data-resizer-name", name);
      //         div.addEventListener(
      //             "pointerdown",
      //             this.#resizerPointerdown.bind(this, name),
      //             { signal }
      //         );
      //         div.addEventListener("contextmenu", noContextMenu, { signal });
      //         div.tabIndex = -1;
      //     }
      //     this.div.prepend(this.#resizersDiv);
      // }
      // #resizerPointerdown(name, event) {
      //     event.preventDefault();
      //     const { isMac } = FeatureTest.platform;
      //     if (event.button !== 0 || (event.ctrlKey && isMac)) {
      //         return;
      //     }
      //     this.#altText?.toggle(false);
      //     const savedDraggable = this._isDraggable;
      //     this._isDraggable = false;
      //     const ac = new AbortController();
      //     const signal = this._uiManager.combinedSignal(ac);
      //     this.parent.togglePointerEvents(false);
      //     window.addEventListener(
      //         "pointermove",
      //         this.#resizerPointermove.bind(this, name),
      //         { passive: true, capture: true, signal }
      //     );
      //     window.addEventListener("contextmenu", noContextMenu, { signal });
      //     const savedX = this.x;
      //     const savedY = this.y;
      //     const savedWidth = this.width;
      //     const savedHeight = this.height;
      //     const savedParentCursor = this.parent.div.style.cursor;
      //     const savedCursor = this.div.style.cursor;
      //     this.div.style.cursor = this.parent.div.style.cursor =
      //         window.getComputedStyle(event.target).cursor;
      //     const pointerUpCallback = () => {
      //         ac.abort();
      //         this.parent.togglePointerEvents(true);
      //         this.#altText?.toggle(true);
      //         this._isDraggable = savedDraggable;
      //         this.parent.div.style.cursor = savedParentCursor;
      //         this.div.style.cursor = savedCursor;
      //         this.#addResizeToUndoStack(savedX, savedY, savedWidth, savedHeight);
      //     };
      //     window.addEventListener("pointerup", pointerUpCallback, { signal });
      //     // If the user switches to another window (with alt+tab), then we end the
      //     // resize session.
      //     window.addEventListener("blur", pointerUpCallback, { signal });
      // }
      // #addResizeToUndoStack(savedX, savedY, savedWidth, savedHeight) {
      //     const newX = this.x;
      //     const newY = this.y;
      //     const newWidth = this.width;
      //     const newHeight = this.height;
      //     if (
      //         newX === savedX &&
      //         newY === savedY &&
      //         newWidth === savedWidth &&
      //         newHeight === savedHeight
      //     ) {
      //         return;
      //     }
      //     this.addCommands({
      //         cmd: () => {
      //             this.width = newWidth;
      //             this.height = newHeight;
      //             this.x = newX;
      //             this.y = newY;
      //             const [parentWidth, parentHeight] = this.parentDimensions;
      //             this.setDims(parentWidth * newWidth, parentHeight * newHeight);
      //             this.fixAndSetPosition();
      //         },
      //         undo: () => {
      //             this.width = savedWidth;
      //             this.height = savedHeight;
      //             this.x = savedX;
      //             this.y = savedY;
      //             const [parentWidth, parentHeight] = this.parentDimensions;
      //             this.setDims(parentWidth * savedWidth, parentHeight * savedHeight);
      //             this.fixAndSetPosition();
      //         },
      //         mustExec: true,
      //     });
      // }
      // #resizerPointermove(name, event) {
      //     const [parentWidth, parentHeight] = this.parentDimensions;
      //     const savedX = this.x;
      //     const savedY = this.y;
      //     const savedWidth = this.width;
      //     const savedHeight = this.height;
      //     const minWidth = AnnotationEditor.MIN_SIZE / parentWidth;
      //     const minHeight = AnnotationEditor.MIN_SIZE / parentHeight;
      //     // 10000 because we multiply by 100 and use toFixed(2) in fixAndSetPosition.
      //     // Without rounding, the positions of the corners other than the top left
      //     // one can be slightly wrong.
      //     const round = x => Math.round(x * 10000) / 10000;
      //     const rotationMatrix = this.#getRotationMatrix(this.rotation);
      //     const transf = (x, y) => [
      //         rotationMatrix[0] * x + rotationMatrix[2] * y,
      //         rotationMatrix[1] * x + rotationMatrix[3] * y,
      //     ];
      //     const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
      //     const invTransf = (x, y) => [
      //         invRotationMatrix[0] * x + invRotationMatrix[2] * y,
      //         invRotationMatrix[1] * x + invRotationMatrix[3] * y,
      //     ];
      //     let getPoint;
      //     let getOpposite;
      //     let isDiagonal = false;
      //     let isHorizontal = false;
      //     switch (name) {
      //         case "topLeft":
      //             isDiagonal = true;
      //             getPoint = (w, h) => [0, 0];
      //             getOpposite = (w, h) => [w, h];
      //             break;
      //         case "topMiddle":
      //             getPoint = (w, h) => [w / 2, 0];
      //             getOpposite = (w, h) => [w / 2, h];
      //             break;
      //         case "topRight":
      //             isDiagonal = true;
      //             getPoint = (w, h) => [w, 0];
      //             getOpposite = (w, h) => [0, h];
      //             break;
      //         case "middleRight":
      //             isHorizontal = true;
      //             getPoint = (w, h) => [w, h / 2];
      //             getOpposite = (w, h) => [0, h / 2];
      //             break;
      //         case "bottomRight":
      //             isDiagonal = true;
      //             getPoint = (w, h) => [w, h];
      //             getOpposite = (w, h) => [0, 0];
      //             break;
      //         case "bottomMiddle":
      //             getPoint = (w, h) => [w / 2, h];
      //             getOpposite = (w, h) => [w / 2, 0];
      //             break;
      //         case "bottomLeft":
      //             isDiagonal = true;
      //             getPoint = (w, h) => [0, h];
      //             getOpposite = (w, h) => [w, 0];
      //             break;
      //         case "middleLeft":
      //             isHorizontal = true;
      //             getPoint = (w, h) => [0, h / 2];
      //             getOpposite = (w, h) => [w, h / 2];
      //             break;
      //     }
      //     const point = getPoint(savedWidth, savedHeight);
      //     const oppositePoint = getOpposite(savedWidth, savedHeight);
      //     let transfOppositePoint = transf(...oppositePoint);
      //     const oppositeX = round(savedX + transfOppositePoint[0]);
      //     const oppositeY = round(savedY + transfOppositePoint[1]);
      //     let ratioX = 1;
      //     let ratioY = 1;
      //     let [deltaX, deltaY] = this.screenToPageTranslation(
      //         event.movementX,
      //         event.movementY
      //     );
      //     [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
      //     if (isDiagonal) {
      //         const oldDiag = Math.hypot(savedWidth, savedHeight);
      //         ratioX = ratioY = Math.max(
      //             Math.min(
      //                 Math.hypot(
      //                     oppositePoint[0] - point[0] - deltaX,
      //                     oppositePoint[1] - point[1] - deltaY
      //                 ) / oldDiag,
      //                 // Avoid the editor to be larger than the page.
      //                 1 / savedWidth,
      //                 1 / savedHeight
      //             ),
      //             // Avoid the editor to be smaller than the minimum size.
      //             minWidth / savedWidth,
      //             minHeight / savedHeight
      //         );
      //     } else if (isHorizontal) {
      //         ratioX =
      //             Math.max(
      //                 minWidth,
      //                 Math.min(1, Math.abs(oppositePoint[0] - point[0] - deltaX))
      //             ) / savedWidth;
      //     } else {
      //         ratioY =
      //             Math.max(
      //                 minHeight,
      //                 Math.min(1, Math.abs(oppositePoint[1] - point[1] - deltaY))
      //             ) / savedHeight;
      //     }
      //     const newWidth = round(savedWidth * ratioX);
      //     const newHeight = round(savedHeight * ratioY);
      //     transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
      //     const newX = oppositeX - transfOppositePoint[0];
      //     const newY = oppositeY - transfOppositePoint[1];
      //     this.width = newWidth;
      //     this.height = newHeight;
      //     this.x = newX;
      //     this.y = newY;
      //     this.setDims(parentWidth * newWidth, parentHeight * newHeight);
      //     this.fixAndSetPosition();
      // }
      // /**
      //  * Called when the alt text dialog is closed.
      //  */
      // altTextFinish() {
      //     this.#altText?.finish();
      // }
      // /**
      //  * Add a toolbar for this editor.
      //  * @returns {Promise<EditorToolbar|null>}
      //  */
      // async addEditToolbar() {
      addEditToolbar() {
          var _b;
          (_b = this._uiManager) === null || _b === void 0 ? void 0 : _b.showEditorToolBar(this.div);
          // if (this._editToolbar || this.#isInEditMode) {
          //     return this._editToolbar;
          // }
          // this._editToolbar = new EditorToolbar(this);
          // this.div.append(this._editToolbar.render());
          // if (this.#altText) {
          //     this._editToolbar.addAltTextButton(await this.#altText.render());
          // }
          // return this._editToolbar;
      }
      removeEditToolbar() {
          this._uiManager.hideEditorToolBar();
          // if (!this._editToolbar) {
          //     return;
          // }
          // this._editToolbar.remove();
          // this._editToolbar = null;
          // // We destroy the alt text but we don't null it because we want to be able
          // // to restore it in case the user undoes the deletion.
          // this.#altText?.destroy();
      }
      getClientDimensions() {
          return this.div.getBoundingClientRect();
      }
      // async addAltTextButton() {
      //     if (this.#altText) {
      //         return;
      //     }
      //     AltText.initialize(AnnotationEditor._l10nPromise);
      //     this.#altText = new AltText(this);
      //     if (this.#accessibilityData) {
      //         this.#altText.data = this.#accessibilityData;
      //         this.#accessibilityData = null;
      //     }
      //     await this.addEditToolbar();
      // }
      // get altTextData() {
      //     return this.#altText?.data;
      // }
      // /**
      //  * Set the alt text data.
      //  */
      // set altTextData(data) {
      //     if (!this.#altText) {
      //         return;
      //     }
      //     this.#altText.data = data;
      // }
      // get guessedAltText() {
      //     return this.#altText?.guessedText;
      // }
      // async setGuessedAltText(text) {
      //     await this.#altText?.setGuessedText(text);
      // }
      // serializeAltText(isForCopying) {
      //     return this.#altText?.serialize(isForCopying);
      // }
      // hasAltText() {
      //     return !!this.#altText && !this.#altText.isEmpty();
      // }
      // hasAltTextData() {
      //     return this.#altText?.hasData() ?? false;
      // }
      /**
       * Render this editor in a div.
       * @returns {HTMLDivElement | null}
       */
      render() {
          this.div = document.createElement("div");
          this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
          this.div.className = this.name;
          this.div.setAttribute("id", this.id);
          this.div.tabIndex = __classPrivateFieldGet(this, _AnnotationEditor_disabled, "f") ? -1 : 0;
          if (!this._isVisible) {
              // this.div.classList.add("hidden");
              this.div.classList.add("k-hidden");
          }
          this.setInForeground();
          __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_addFocusListeners).call(this);
          const [parentWidth, parentHeight] = this.parentDimensions;
          if (this.parentRotation % 180 !== 0) {
              this.div.style.maxWidth = `${((100 * parentHeight) / parentWidth).toFixed(2)}%`;
              this.div.style.maxHeight = `${((100 * parentWidth) /
                parentHeight).toFixed(2)}%`;
          }
          const [tx, ty] = this.getInitialTranslation();
          this.translate(tx, ty);
          bindEvents(this, this.div, ["pointerdown"]);
          return this.div;
      }
      /**
       * Onpointerdown callback.
       * @param {PointerEvent} event
       */
      pointerdown(event) {
          var _b;
          const { isMac } = kendo_pdfjs_loader_js.FeatureTest.platform;
          if (event.button !== 0 || (event.ctrlKey && isMac)) {
              // Avoid to focus this editor because of a non-left click.
              event.preventDefault();
              return;
          }
          __classPrivateFieldSet(this, _AnnotationEditor_hasBeenClicked, true, "f");
          if (this._isDraggable) {
              (_b = this._uiManager) === null || _b === void 0 ? void 0 : _b.hideEditorToolBar();
              __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_setUpDragSession).call(this, event);
              return;
          }
          __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_selectOnPointerEvent).call(this, event);
      }
      moveInDOM() {
          // Moving the editor in the DOM can be expensive, so we wait a bit before.
          // It's important to not block the UI (for example when changing the font
          // size in a FreeText).
          if (__classPrivateFieldGet(this, _AnnotationEditor_moveInDOMTimeout, "f")) {
              clearTimeout(__classPrivateFieldGet(this, _AnnotationEditor_moveInDOMTimeout, "f"));
          }
          __classPrivateFieldSet(this, _AnnotationEditor_moveInDOMTimeout, setTimeout(() => {
              var _b;
              __classPrivateFieldSet(this, _AnnotationEditor_moveInDOMTimeout, null, "f");
              (_b = this.parent) === null || _b === void 0 ? void 0 : _b.moveEditorInDOM(this);
          }, 0), "f");
      }
      _setParentAndPosition(parent, x, y) {
          parent.changeParent(this);
          this.x = x;
          this.y = y;
          this.fixAndSetPosition();
      }
      /*
       * Convert the current rect into a page one.
       * @param {number} tx - x-translation in screen coordinates.
       * @param {number} ty - y-translation in screen coordinates.
       * @param {number} [rotation] - the rotation of the page.
       */
      getRect(tx, ty, rotation = this.rotation) {
          const scale = this.parentScale;
          const [pageWidth, pageHeight] = this.pageDimensions;
          const [pageX, pageY] = this.pageTranslation;
          const shiftX = tx / scale;
          const shiftY = ty / scale;
          const x = this.x * pageWidth;
          const y = this.y * pageHeight;
          const width = this.width * pageWidth;
          const height = this.height * pageHeight;
          switch (rotation) {
              case 0:
                  return [
                      x + shiftX + pageX,
                      pageHeight - y - shiftY - height + pageY,
                      x + shiftX + width + pageX,
                      pageHeight - y - shiftY + pageY
                  ];
              case 90:
                  return [
                      x + shiftY + pageX,
                      pageHeight - y + shiftX + pageY,
                      x + shiftY + height + pageX,
                      pageHeight - y + shiftX + width + pageY
                  ];
              case 180:
                  return [
                      x - shiftX - width + pageX,
                      pageHeight - y + shiftY + pageY,
                      x - shiftX + pageX,
                      pageHeight - y + shiftY + height + pageY
                  ];
              case 270:
                  return [
                      x - shiftY - height + pageX,
                      pageHeight - y - shiftX - width + pageY,
                      x - shiftY + pageX,
                      pageHeight - y - shiftX + pageY
                  ];
              default:
                  throw new Error("Invalid rotation");
          }
      }
      getRectInCurrentCoords(rect, pageHeight) {
          const [x1, y1, x2, y2] = rect;
          const width = x2 - x1;
          const height = y2 - y1;
          switch (this.rotation) {
              case 0:
                  return [x1, pageHeight - y2, width, height];
              case 90:
                  return [x1, pageHeight - y1, height, width];
              case 180:
                  return [x2, pageHeight - y1, width, height];
              case 270:
                  return [x2, pageHeight - y2, height, width];
              default:
                  // throw new Error("Invalid rotation");
                  break;
          }
      }
      // /**
      //  * Executed once this editor has been rendered.
      //  */
      onceAdded() { }
      // /**
      //  * Check if the editor contains something.
      //  * @returns {boolean}
      //  */
      isEmpty() {
          return false;
      }
      /**
       * Enable edit mode.
       */
      enableEditMode() {
          __classPrivateFieldSet(this, _AnnotationEditor_isInEditMode, true, "f");
      }
      /**
       * Disable edit mode.
       */
      disableEditMode() {
          __classPrivateFieldSet(this, _AnnotationEditor_isInEditMode, false, "f");
      }
      /**
       * Check if the editor is edited.
       * @returns {boolean}
       */
      isInEditMode() {
          return __classPrivateFieldGet(this, _AnnotationEditor_isInEditMode, "f");
      }
      // /**
      //  * If it returns true, then this editor handles the keyboard
      //  * events itself.
      //  * @returns {boolean}
      //  */
      // shouldGetKeyboardEvents() {
      //     return this.#isResizerEnabledForKeyboard;
      // }
      /**
       * Check if this editor needs to be rebuilt or not.
       * @returns {boolean}
       */
      needsToBeRebuilt() {
          return this.div && !this.isAttachedToDOM;
      }
      /**
       * Rebuild the editor in case it has been removed on undo.
       *
       * To implement in subclasses.
       */
      rebuild() {
          __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_addFocusListeners).call(this);
      }
      /**
       * Rotate the editor.
       * @param {number} angle
       */
      rotate(angle) {
          if (angle === undefined || angle === null) {
              /* no-empty */
          }
      }
      /**
       * Serialize the editor.
       * The result of the serialization will be used to construct a
       * new annotation to add to the pdf document.
       *
       * To implement in subclasses.
       * @param {boolean} [_isForCopying]
       * @param {Object | null} [_context]
       * @returns {Object | null}
       */
      serialize(_isForCopying = false, _context = null) {
          // serialize() {
      }
      /**
       * Deserialize the editor.
       * The result of the deserialization is a new editor.
       *
       * @param {Object} data
       * @param {AnnotationEditorLayer} parent
       * @param {AnnotationEditorUIManager} uiManager
       * @returns {AnnotationEditor | null}
       */
      static deserialize(data, parent, uiManager) {
          // @ts-expect-error TS(2556):
          const editor = new this.prototype.constructor({
              parent,
              id: parent.getNextId(),
              uiManager
          });
          editor.rotation = data.rotation;
          // editor.#accessibilityData = data.accessibilityData;
          const [pageWidth, pageHeight] = editor.pageDimensions;
          const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
          editor.x = x / pageWidth;
          editor.y = y / pageHeight;
          editor.width = width / pageWidth;
          editor.height = height / pageHeight;
          return editor;
      }
      /**
       * Check if an existing annotation associated with this editor has been
       * modified.
       * @returns {boolean}
       */
      get hasBeenModified() {
          return (!!this.annotationElementId && (this.deleted || this.serialize() !== null));
      }
      /**
       * Remove this editor.
       * It's used on ctrl+backspace action.
       */
      remove() {
          var _b;
          (_b = __classPrivateFieldGet(this, _AnnotationEditor_focusAC, "f")) === null || _b === void 0 ? void 0 : _b.abort();
          __classPrivateFieldSet(this, _AnnotationEditor_focusAC, null, "f");
          if (!this.isEmpty()) {
              // The editor is removed but it can be back at some point thanks to
              // undo/redo so we must commit it before.
              this.commit();
          }
          if (this.parent) {
              this.parent.remove(this);
          }
          else {
              this._uiManager.removeEditor(this);
          }
          if (__classPrivateFieldGet(this, _AnnotationEditor_moveInDOMTimeout, "f")) {
              clearTimeout(__classPrivateFieldGet(this, _AnnotationEditor_moveInDOMTimeout, "f"));
              __classPrivateFieldSet(this, _AnnotationEditor_moveInDOMTimeout, null, "f");
          }
          __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_stopResizing).call(this);
          this.removeEditToolbar();
          // if (this.#telemetryTimeouts) {
          //     for (const timeout of this.#telemetryTimeouts.values()) {
          //         clearTimeout(timeout);
          //     }
          //     this.#telemetryTimeouts = null;
          // }
          this.parent = null;
      }
      /**
       * @returns {boolean} true if this editor can be resized.
       */
      get isResizable() {
          return false;
      }
      /**
       * Add the resizers to this editor.
       */
      makeResizable() {
          //     if (this.isResizable) {
          //         this.#createResizers();
          //         this.#resizersDiv.classList.remove("hidden");
          //         this.#resizersDiv.classList.remove("k-hidden");
          //         bindEvents(this, this.div, ["keydown"]);
          //     }
      }
      get toolbarPosition() {
          return null;
      }
      _stopResizingWithKeyboard() {
          //     this.#stopResizing();
          //     this.div.focus();
      }
      /**
       * Select this editor.
       */
      select() {
          var _b;
          // this.makeResizable();
          // this.div?.classList.add("selectedEditor");
          (_b = this.div) === null || _b === void 0 ? void 0 : _b.classList.add("k-selected");
          // todo: manually show annotation toolbar
          this.addEditToolbar();
          // if (!this._editToolbar) {
          //     this.addEditToolbar().then(() => {
          //         if (this.div?.classList.contains("k-selected selectedEditor")) {
          //             // The editor can have been unselected while we were waiting for the
          //             // edit toolbar to be created, hence we want to be sure that this
          //             // editor is still selected.
          //             this._editToolbar?.show();
          //         }
          //     });
          //     return;
          // }
          // this._editToolbar?.show();
          // this.#altText?.toggleAltTextBadge(false);
      }
      /**
       * Unselect this editor.
       */
      unselect() {
          var _b, _c;
          // this.#resizersDiv?.classList.add("hidden");
          // this.div?.classList.remove("selectedEditor");
          (_b = this.div) === null || _b === void 0 ? void 0 : _b.classList.remove("k-selected");
          if ((_c = this.div) === null || _c === void 0 ? void 0 : _c.contains(document.activeElement)) {
              // Don't use this.div.blur() because we don't know where the focus will
              // go.
              this._uiManager.currentLayer.div.focus({
                  preventScroll: true
              });
          }
          // this._editToolbar?.hide();
          // this.#altText?.toggleAltTextBadge(true);
      }
      /**
       * Update some parameters which have been changed through the UI.
       * @param {number} type
       * @param {*} value
       */
      updateParams(type, value) {
          if (type === undefined || !value) {
              /* no-empty */
          }
      }
      /**
       * When the user disables the editing mode some editors can change some of
       * their properties.
       */
      disableEditing() { }
      /**
       * When the user enables the editing mode some editors can change some of
       * their properties.
       */
      enableEditing() { }
      /**
       * The editor is about to be edited.
       */
      enterInEditMode() { }
      /**
       * @returns {HTMLElement | null} the element requiring an alt text.
       */
      getImageForAltText() {
          return null;
      }
      /**
       * Get the div which really contains the displayed content.
       * @returns {HTMLDivElement | undefined}
       */
      get contentDiv() {
          return this.div;
      }
      /**
       * If true then the editor is currently edited.
       * @type {boolean}
       */
      get isEditing() {
          return __classPrivateFieldGet(this, _AnnotationEditor_isEditing, "f");
      }
      /**
       * When set to true, it means that this editor is currently edited.
       * @param {boolean} value
       */
      set isEditing(value) {
          __classPrivateFieldSet(this, _AnnotationEditor_isEditing, value, "f");
          if (!this.parent) {
              return;
          }
          if (value) {
              this.parent.setSelected(this);
              this.parent.setActiveEditor(this);
          }
          else {
              this.parent.setActiveEditor(null);
          }
      }
      /**
       * Set the aspect ratio to use when resizing.
       * @param {number} width
       * @param {number} height
       */
      setAspectRatio(width, height) {
          __classPrivateFieldSet(this, _AnnotationEditor_keepAspectRatio, true, "f");
          const aspectRatio = width / height;
          const { style } = this.div;
          style.aspectRatio = aspectRatio;
          style.height = "auto";
      }
      static get MIN_SIZE() {
          return 16;
      }
      static canCreateNewEmptyEditor() {
          return true;
      }
      /**
       * Get the data to report to the telemetry when the editor is added.
       * @returns {Object}
       */
      get telemetryInitialData() {
          return { action: "added" };
      }
      /**
       * The telemetry data to use when saving/printing.
       * @returns {Object|null}
       */
      get telemetryFinalData() {
          return null;
      }
      _reportTelemetry() { }
      // _reportTelemetry(data, mustWait = false) {
      //     if (mustWait) {
      //         this.#telemetryTimeouts ||= new Map();
      //         const { action } = data;
      //         let timeout = this.#telemetryTimeouts.get(action);
      //         if (timeout) {
      //             clearTimeout(timeout);
      //         }
      //         timeout = setTimeout(() => {
      //             this._reportTelemetry(data);
      //             this.#telemetryTimeouts.delete(action);
      //             if (this.#telemetryTimeouts.size === 0) {
      //                 this.#telemetryTimeouts = null;
      //             }
      //         }, AnnotationEditor._telemetryTimeout);
      //         this.#telemetryTimeouts.set(action, timeout);
      //         return;
      //     }
      //     data.type ||= this.editorType;
      //     this._uiManager._eventBus.dispatch("reporttelemetry", {
      //         source: this,
      //         details: {
      //             type: "editing",
      //             data,
      //         },
      //     });
      // }
      /**
       * Show or hide this editor.
       * @param {boolean|undefined} visible
       */
      show(visible = this._isVisible) {
          // this.div.classList.toggle("hidden", !visible);
          this.div.classList.toggle("k-hidden", !visible);
          this._isVisible = visible;
      }
      enable() {
          if (this.div) {
              this.div.tabIndex = 0;
          }
          __classPrivateFieldSet(this, _AnnotationEditor_disabled, false, "f");
      }
      disable() {
          if (this.div) {
              this.div.tabIndex = -1;
          }
          __classPrivateFieldSet(this, _AnnotationEditor_disabled, true, "f");
      }
      /**
       * Render an annotation in the annotation layer.
       * @param {Object} annotation
       * @returns {HTMLElement}
       */
      renderAnnotationElement(annotation) {
          let content = annotation.container.querySelector(".annotationContent") ||
              annotation.container.querySelector(".k-annotation-content");
          if (!content) {
              content = document.createElement("div");
              // content.classList.add("annotationContent", this.editorType);
              content.classList.add("k-annotation-content", this.editorType);
              annotation.container.prepend(content);
          }
          else if (content.nodeName === "CANVAS") {
              const canvas = content;
              content = document.createElement("div");
              // content.classList.add("annotationContent", this.editorType);
              content.classList.add("k-annotation-content", this.editorType);
              canvas.before(content);
          }
          return content;
      }
      resetAnnotationElement(annotation) {
          const { firstChild } = annotation.container;
          if (firstChild.nodeName === "DIV" &&
              (firstChild.classList.contains("annotationContent") ||
                  firstChild.classList.contains("k-annotation-content"))) {
              firstChild.remove();
          }
      }
  }
  _a$6 = AnnotationEditor, _AnnotationEditor_x = new WeakMap(), _AnnotationEditor_y = new WeakMap(), _AnnotationEditor_disabled = new WeakMap(), _AnnotationEditor_keepAspectRatio = new WeakMap(), _AnnotationEditor_focusAC = new WeakMap(), _AnnotationEditor_hasBeenClicked = new WeakMap(), _AnnotationEditor_initialPosition = new WeakMap(), _AnnotationEditor_isEditing = new WeakMap(), _AnnotationEditor_isInEditMode = new WeakMap(), _AnnotationEditor_moveInDOMTimeout = new WeakMap(), _AnnotationEditor_prevDragX = new WeakMap(), _AnnotationEditor_prevDragY = new WeakMap(), _AnnotationEditor_isDraggable = new WeakMap(), _AnnotationEditor_zIndex = new WeakMap(), _AnnotationEditor_instances = new WeakSet(), _AnnotationEditor_translate = function _AnnotationEditor_translate([width, height], x, y) {
      [x, y] = this.screenToPageTranslation(x, y);
      this.x += x / width;
      this.y += y / height;
      this.fixAndSetPosition();
  }, _AnnotationEditor_rotatePoint = function _AnnotationEditor_rotatePoint(x, y, angle) {
      switch (angle) {
          case 90:
              return [y, -x];
          case 180:
              return [-x, -y];
          case 270:
              return [-y, x];
          default:
              return [x, y];
      }
  }, _AnnotationEditor_selectOnPointerEvent = function _AnnotationEditor_selectOnPointerEvent(event) {
      const { isMac } = kendo_pdfjs_loader_js.FeatureTest.platform;
      const highlightEditor = event.target.closest(".k-highlight-editor");
      const freeTextEditor = event.target.closest(".k-free-text-editor");
      const annotationEditorMode = this._uiManager.getMode();
      // todo: manually prevent selecting a highlight annotation in freetext mode
      if ((annotationEditorMode === AnnotationEditorType.HIGHLIGHT && !highlightEditor) ||
          (annotationEditorMode === AnnotationEditorType.FREETEXT && !freeTextEditor)) {
          return;
      }
      if ((event.ctrlKey && !isMac) ||
          event.shiftKey ||
          (event.metaKey && isMac)) {
          this.parent.toggleSelected(this);
      }
      else {
          this.parent.setSelected(this);
      }
  }, _AnnotationEditor_setUpDragSession = function _AnnotationEditor_setUpDragSession(event) {
      const isSelected = this._uiManager.isSelected(this);
      this._uiManager.setUpDragSession();
      const ac = new AbortController();
      const signal = this._uiManager.combinedSignal(ac);
      if (isSelected) {
          // this.div.classList.add("moving");
          __classPrivateFieldSet(this, _AnnotationEditor_prevDragX, event.clientX, "f");
          __classPrivateFieldSet(this, _AnnotationEditor_prevDragY, event.clientY, "f");
          const pointerMoveCallback = e => {
              const { clientX: x, clientY: y } = e;
              const [tx, ty] = this.screenToPageTranslation(x - __classPrivateFieldGet(this, _AnnotationEditor_prevDragX, "f"), y - __classPrivateFieldGet(this, _AnnotationEditor_prevDragY, "f"));
              __classPrivateFieldSet(this, _AnnotationEditor_prevDragX, x, "f");
              __classPrivateFieldSet(this, _AnnotationEditor_prevDragY, y, "f");
              this._uiManager.dragSelectedEditors(tx, ty);
          };
          window.addEventListener("pointermove", pointerMoveCallback, {
              passive: true,
              capture: true,
              signal
          });
      }
      const pointerUpCallback = () => {
          ac.abort();
          if (isSelected) {
              this.div.classList.remove("moving");
          }
          __classPrivateFieldSet(this, _AnnotationEditor_hasBeenClicked, false, "f");
          if (!this._uiManager.endDragSession()) {
              __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_selectOnPointerEvent).call(this, event);
          }
      };
      window.addEventListener("pointerup", pointerUpCallback, { signal });
      // If the user is using alt+tab during the dragging session, the pointerup
      // event could be not fired, but a blur event is fired so we can use it in
      // order to interrupt the dragging session.
      window.addEventListener("blur", pointerUpCallback, { signal });
  }, _AnnotationEditor_addFocusListeners = function _AnnotationEditor_addFocusListeners() {
      if (__classPrivateFieldGet(this, _AnnotationEditor_focusAC, "f") || !this.div) {
          return;
      }
      __classPrivateFieldSet(this, _AnnotationEditor_focusAC, new AbortController(), "f");
      const signal = this._uiManager.combinedSignal(__classPrivateFieldGet(this, _AnnotationEditor_focusAC, "f"));
      this.div.addEventListener("focusin", this.focusin.bind(this), { signal });
      this.div.addEventListener("focusout", this.focusout.bind(this), { signal });
  }, _AnnotationEditor_stopResizing = function _AnnotationEditor_stopResizing() {
      // this.#isResizerEnabledForKeyboard = false;
      // this.#setResizerTabIndex(-1);
      // if (this.#savedDimensions) {
      //     const { savedX, savedY, savedWidth, savedHeight } = this.#savedDimensions;
      //     this.#addResizeToUndoStack(savedX, savedY, savedWidth, savedHeight);
      //     this.#savedDimensions = null;
      // }
  };
  AnnotationEditor.idManager = new IdManager("annotation_editor_id_");
  AnnotationEditor._borderLineWidth = -1;
  AnnotationEditor._colorManager = new ColorManager();
  AnnotationEditor._zIndex = 1;
  // Time to wait (in ms) before sending the telemetry data.
  // We wait a bit to avoid sending too many requests when changing something
  // like the thickness of a line.
  AnnotationEditor._telemetryTimeout = 1000;
  // This class is used to fake an editor which has been deleted.
  class FakeEditor extends AnnotationEditor {
      constructor(params) {
          super(params);
          this.annotationElementId = params.annotationElementId;
          this.deleted = true;
      }
      serialize() {
          return {
              id: this.annotationElementId,
              deleted: true,
              pageIndex: this.pageIndex
          };
      }
  }

  /* Copyright 2014 Opera Software ASA
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *
   *
   * Based on https://code.google.com/p/smhasher/wiki/MurmurHash3.
   * Hashes roughly 100 KB per millisecond on i7 3.4 GHz.
   */
  const SEED = 0xc3d2e1f0;
  // Workaround for missing math precision in JS.
  const MASK_HIGH = 0xffff0000;
  const MASK_LOW = 0xffff;
  class MurmurHash3_64 {
      // todo: props
      constructor(seed) {
          // todo: props
          this.h1 = null;
          this.h2 = null;
          this.h1 = seed ? seed & 0xffffffff : SEED;
          this.h2 = seed ? seed & 0xffffffff : SEED;
      }
      update(input) {
          let data, length;
          if (typeof input === "string") {
              data = new Uint8Array(input.length * 2);
              length = 0;
              for (let i = 0, ii = input.length; i < ii; i++) {
                  const code = input.charCodeAt(i);
                  if (code <= 0xff) {
                      data[length++] = code;
                  }
                  else {
                      data[length++] = code >>> 8;
                      data[length++] = code & 0xff;
                  }
              }
          }
          else if (ArrayBuffer.isView(input)) {
              data = input.slice();
              length = data.byteLength;
          }
          else {
              throw new Error("Invalid data format, must be a string or TypedArray.");
          }
          const blockCounts = length >> 2;
          const tailLength = length - blockCounts * 4;
          // We don't care about endianness here.
          const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
          let k1 = 0, k2 = 0;
          let h1 = this.h1, h2 = this.h2;
          const C1 = 0xcc9e2d51, C2 = 0x1b873593;
          const C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
          for (let i = 0; i < blockCounts; i++) {
              if (i & 1) {
                  k1 = dataUint32[i];
                  k1 = ((k1 * C1) & MASK_HIGH) | ((k1 * C1_LOW) & MASK_LOW);
                  k1 = (k1 << 15) | (k1 >>> 17);
                  k1 = ((k1 * C2) & MASK_HIGH) | ((k1 * C2_LOW) & MASK_LOW);
                  h1 ^= k1;
                  h1 = (h1 << 13) | (h1 >>> 19);
                  h1 = h1 * 5 + 0xe6546b64;
              }
              else {
                  k2 = dataUint32[i];
                  k2 = ((k2 * C1) & MASK_HIGH) | ((k2 * C1_LOW) & MASK_LOW);
                  k2 = (k2 << 15) | (k2 >>> 17);
                  k2 = ((k2 * C2) & MASK_HIGH) | ((k2 * C2_LOW) & MASK_LOW);
                  h2 ^= k2;
                  h2 = (h2 << 13) | (h2 >>> 19);
                  h2 = h2 * 5 + 0xe6546b64;
              }
          }
          k1 = 0;
          switch (tailLength) {
              case 3:
                  k1 ^= data[blockCounts * 4 + 2] << 16;
              /* falls through */
              case 2:
                  k1 ^= data[blockCounts * 4 + 1] << 8;
              /* falls through */
              case 1:
                  k1 ^= data[blockCounts * 4];
                  /* falls through */
                  k1 = ((k1 * C1) & MASK_HIGH) | ((k1 * C1_LOW) & MASK_LOW);
                  k1 = (k1 << 15) | (k1 >>> 17);
                  k1 = ((k1 * C2) & MASK_HIGH) | ((k1 * C2_LOW) & MASK_LOW);
                  if (blockCounts & 1) {
                      h1 ^= k1;
                  }
                  else {
                      h2 ^= k1;
                  }
                  break;
              default: break;
          }
          this.h1 = h1;
          this.h2 = h2;
      }
      hexdigest() {
          let h1 = this.h1, h2 = this.h2;
          h1 ^= h2 >>> 1;
          h1 = ((h1 * 0xed558ccd) & MASK_HIGH) | ((h1 * 0x8ccd) & MASK_LOW);
          h2 =
              ((h2 * 0xff51afd7) & MASK_HIGH) |
                  (((((h2 << 16) | (h1 >>> 16)) * 0xafd7ed55) & MASK_HIGH) >>> 16);
          h1 ^= h2 >>> 1;
          h1 = ((h1 * 0x1a85ec53) & MASK_HIGH) | ((h1 * 0xec53) & MASK_LOW);
          h2 =
              ((h2 * 0xc4ceb9fe) & MASK_HIGH) |
                  (((((h2 << 16) | (h1 >>> 16)) * 0xb9fe1a85) & MASK_HIGH) >>> 16);
          h1 ^= h2 >>> 1;
          return ((h1 >>> 0).toString(16).padStart(8, "0") +
              (h2 >>> 0).toString(16).padStart(8, "0"));
      }
  }

  /* Copyright 2020 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _AnnotationStorage_instances, _AnnotationStorage_modified, _AnnotationStorage_modifiedIds, _AnnotationStorage_storage, _AnnotationStorage_setModified, _PrintAnnotationStorage_serializable;
  const SerializableEmpty = Object.freeze({
      map: null,
      hash: "",
      transfer: undefined
  });
  /**
   * Key/value storage for annotation data in forms.
   */
  class AnnotationStorage {
      constructor() {
          _AnnotationStorage_instances.add(this);
          // todo: props
          this.onSetModified = null;
          this.onResetModified = null;
          this.onAnnotationEditor = null;
          // todo: props
          _AnnotationStorage_modified.set(this, false);
          _AnnotationStorage_modifiedIds.set(this, null);
          _AnnotationStorage_storage.set(this, new Map());
          // Callbacks to signal when the modification state is set or reset.
          // This is used by the viewer to only bind on `beforeunload` if forms
          // are actually edited to prevent doing so unconditionally since that
          // can have undesirable effects.
          this.onSetModified = null;
          this.onResetModified = null;
          this.onAnnotationEditor = null;
      }
      /**
      * Get the value for the storage - used purely for debugging purposes.
      * @returns {Object}
      */
      getStorage() {
          return __classPrivateFieldGet(this, _AnnotationStorage_storage, "f");
      }
      /**
       * Get the modified flag for the storage - used purely for debugging purposes.
       * @returns {Object}
       */
      getModified() {
          return __classPrivateFieldGet(this, _AnnotationStorage_modified, "f");
      }
      /**
       * Get the value for a given key if it exists, or return the default value.
       * @param {string} key
       * @param {Object} defaultValue
       * @returns {Object}
       */
      getValue(key, defaultValue) {
          const value = __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").get(key);
          if (value === undefined) {
              return defaultValue;
          }
          return Object.assign(defaultValue, value);
      }
      /**
       * Get the value for a given key.
       * @param {string} key
       * @returns {Object}
       */
      getRawValue(key) {
          return __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").get(key);
      }
      /**
       * Remove a value from the storage.
       * @param {string} key
       */
      remove(key) {
          __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").delete(key);
          if (__classPrivateFieldGet(this, _AnnotationStorage_storage, "f").size === 0) {
              this.resetModified();
          }
          if (typeof this.onAnnotationEditor === "function") {
              for (const value of __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").values()) {
                  if (value instanceof AnnotationEditor) {
                      return;
                  }
              }
              this.onAnnotationEditor(null);
          }
      }
      /**
       * Set the value for a given key
       * @param {string} key
       * @param {Object} value
       */
      setValue(key, value) {
          const obj = __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").get(key);
          let modified = false;
          if (obj !== undefined) {
              for (const [entry, val] of Object.entries(value)) {
                  if (obj[entry] !== val) {
                      modified = true;
                      obj[entry] = val;
                  }
              }
          }
          else {
              modified = true;
              __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").set(key, value);
          }
          if (modified) {
              __classPrivateFieldGet(this, _AnnotationStorage_instances, "m", _AnnotationStorage_setModified).call(this);
          }
          if (value instanceof AnnotationEditor &&
              typeof this.onAnnotationEditor === "function") {
              this.onAnnotationEditor(value.constructor._type);
          }
      }
      /**
       * Check if the storage contains the given key.
       * @param {string} key
       * @returns {boolean}
       */
      has(key) {
          return __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").has(key);
      }
      /**
       * @returns {Object | null}
       */
      getAll() {
          return __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").size > 0 ? objectFromMap(__classPrivateFieldGet(this, _AnnotationStorage_storage, "f")) : null;
      }
      /**
       * @param {Object} obj
       */
      setAll(obj) {
          for (const [key, val] of Object.entries(obj)) {
              this.setValue(key, val);
          }
      }
      get size() {
          return __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").size;
      }
      resetModified() {
          if (__classPrivateFieldGet(this, _AnnotationStorage_modified, "f")) {
              __classPrivateFieldSet(this, _AnnotationStorage_modified, false, "f");
              if (typeof this.onResetModified === "function") {
                  this.onResetModified();
              }
          }
      }
      /**
       * @returns {PrintAnnotationStorage}
       */
      get print() {
          return new PrintAnnotationStorage(this);
      }
      /**
       * PLEASE NOTE: Only intended for usage within the API itself.
       * @ignore
       */
      get serializable() {
          if (__classPrivateFieldGet(this, _AnnotationStorage_storage, "f").size === 0) {
              return SerializableEmpty;
          }
          const map = new Map(), hash = new MurmurHash3_64(null), transfer = [];
          const context = Object.create(null);
          let hasBitmap = false;
          for (const [key, val] of __classPrivateFieldGet(this, _AnnotationStorage_storage, "f")) {
              const serialized = val instanceof AnnotationEditor
                  ? val.serialize(/* isForCopying = */ false, context)
                  : val;
              if (serialized) {
                  map.set(key, serialized);
                  hash.update(`${key}:${JSON.stringify(serialized)}`);
                  hasBitmap || (hasBitmap = !!serialized.bitmap);
              }
          }
          if (hasBitmap) {
              // We must transfer the bitmap data separately, since it can be changed
              // during serialization with SVG images.
              for (const value of map.values()) {
                  if (value.bitmap) {
                      transfer.push(value.bitmap);
                  }
              }
          }
          return map.size > 0
              ? { map, hash: hash.hexdigest(), transfer }
              : SerializableEmpty;
      }
      get editorStats() {
          var _a;
          let stats = null;
          const typeToEditor = new Map();
          for (const value of __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").values()) {
              if (!(value instanceof AnnotationEditor)) {
                  continue;
              }
              const editorStats = value.telemetryFinalData;
              if (!editorStats) {
                  continue;
              }
              const { type } = editorStats;
              if (!typeToEditor.has(type)) {
                  typeToEditor.set(type, Object.getPrototypeOf(value).constructor);
              }
              stats || (stats = Object.create(null));
              const map = (stats[type] || (stats[type] = new Map()));
              for (const [key, val] of Object.entries(editorStats)) {
                  if (key === "type") {
                      continue;
                  }
                  let counters = map.get(key);
                  if (!counters) {
                      counters = new Map();
                      map.set(key, counters);
                  }
                  const count = (_a = counters.get(val)) !== null && _a !== void 0 ? _a : 0;
                  counters.set(val, count + 1);
              }
          }
          for (const [type, editor] of typeToEditor) {
              stats[type] = editor.computeTelemetryFinalData(stats[type]);
          }
          return stats;
      }
      resetModifiedIds() {
          __classPrivateFieldSet(this, _AnnotationStorage_modifiedIds, null, "f");
      }
      /**
       * @returns {{ids: Set<string>, hash: string}}
       */
      get modifiedIds() {
          if (__classPrivateFieldGet(this, _AnnotationStorage_modifiedIds, "f")) {
              return __classPrivateFieldGet(this, _AnnotationStorage_modifiedIds, "f");
          }
          const ids = [];
          for (const value of __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").values()) {
              if (!(value instanceof AnnotationEditor) ||
                  !value.annotationElementId ||
                  !(value.serialize())) {
                  continue;
              }
              ids.push(value.annotationElementId);
          }
          return (__classPrivateFieldSet(this, _AnnotationStorage_modifiedIds, {
              ids: new Set(ids),
              hash: ids.join(",")
          }, "f"));
      }
  }
  _AnnotationStorage_modified = new WeakMap(), _AnnotationStorage_modifiedIds = new WeakMap(), _AnnotationStorage_storage = new WeakMap(), _AnnotationStorage_instances = new WeakSet(), _AnnotationStorage_setModified = function _AnnotationStorage_setModified() {
      if (!__classPrivateFieldGet(this, _AnnotationStorage_modified, "f")) {
          __classPrivateFieldSet(this, _AnnotationStorage_modified, true, "f");
          if (typeof this.onSetModified === "function") {
              this.onSetModified();
          }
      }
  };
  /**
   * A special `AnnotationStorage` for use during printing, where the serializable
   * data is *frozen* upon initialization, to prevent scripting from modifying its
   * contents. (Necessary since printing is triggered synchronously in browsers.)
   */
  class PrintAnnotationStorage extends AnnotationStorage {
      constructor(parent) {
          super();
          _PrintAnnotationStorage_serializable.set(this, void 0);
          const { map, hash, transfer } = parent.serializable;
          // Create a *copy* of the data, since Objects are passed by reference in JS.
          const clone = structuredClone(map, transfer ? { transfer } : null);
          __classPrivateFieldSet(this, _PrintAnnotationStorage_serializable, { map: clone, hash, transfer }, "f");
      }
      /**
       * @returns {PrintAnnotationStorage}
       */
      get print() {
          // unreachable("Should not call PrintAnnotationStorage.print");
          return null;
      }
      /**
       * PLEASE NOTE: Only intended for usage within the API itself.
       * @ignore
       */
      get serializable() {
          return __classPrivateFieldGet(this, _PrintAnnotationStorage_serializable, "f");
      }
      get modifiedIds() {
          return kendo_pdfjs_loader_js.shadow(this, "modifiedIds", {
              ids: new Set(),
              hash: ""
          });
      }
  }
  _PrintAnnotationStorage_serializable = new WeakMap();

  /* Copyright 2014 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _AnnotationElement_instances, _AnnotationElement_updates, _AnnotationElement_hasBorder, _AnnotationElement_popupElement, _AnnotationElement_setRectEdited, _LinkAnnotationElement_instances, _LinkAnnotationElement_setInternalLink, _LinkAnnotationElement_bindAttachment, _LinkAnnotationElement_bindSetOCGState, _PopupElement_instances, _PopupElement_boundKeyDown, _PopupElement_boundHide, _PopupElement_boundShow, _PopupElement_boundToggle, _PopupElement_color, _PopupElement_container, _PopupElement_contentsObj, _PopupElement_dateObj, _PopupElement_elements, _PopupElement_parent, _PopupElement_parentRect, _PopupElement_pinned, _PopupElement_popup, _PopupElement_position, _PopupElement_rect, _PopupElement_richText, _PopupElement_titleObj, _PopupElement_updates, _PopupElement_wasVisible, _PopupElement_html_get, _PopupElement_fontSize_get, _PopupElement_fontColor_get, _PopupElement_makePopupContent, _PopupElement_keyDown, _PopupElement_setPosition, _PopupElement_toggle, _PopupElement_show, _PopupElement_hide, _AnnotationLayer_instances, _AnnotationLayer_accessibilityManager, _AnnotationLayer_annotationCanvasMap, _AnnotationLayer_editableAnnotations, _AnnotationLayer_appendElement, _AnnotationLayer_setAnnotationCanvasMap;
  // const DEFAULT_TAB_INDEX = 1000;
  // it is unclear why the value 1000 is chosen by pdf.js
  // kendo a11y tests fail if this is not 0
  const DEFAULT_TAB_INDEX = 0;
  const DEFAULT_FONT_SIZE = 9;
  const GetElementsByNameSet = new WeakSet();
  function getRectDims(rect) {
      return {
          width: rect[2] - rect[0],
          height: rect[3] - rect[1]
      };
  }
  class AnnotationElementFactory {
      /**
       * @param {AnnotationElementParameters} parameters
       * @returns {AnnotationElement}
       */
      static create(parameters) {
          const subtype = parameters.data.annotationType;
          switch (subtype) {
              case AnnotationType.LINK:
                  return new LinkAnnotationElement(parameters);
              // case AnnotationType.TEXT:
              //     return new TextAnnotationElement(parameters);
              case AnnotationType.WIDGET:
                  const fieldType = parameters.data.fieldType;
                  switch (fieldType) {
                      case "Tx":
                          return new TextWidgetAnnotationElement(parameters);
                      case "Btn":
                          if (parameters.data.radioButton) {
                              return new RadioButtonWidgetAnnotationElement(parameters);
                          }
                          else if (parameters.data.checkBox) {
                              return new CheckboxWidgetAnnotationElement(parameters);
                          }
                          return new PushButtonWidgetAnnotationElement(parameters);
                      case "Ch":
                          return new ChoiceWidgetAnnotationElement(parameters);
                      // case "Sig":
                      //     return new SignatureWidgetAnnotationElement(parameters);
                      default:
                          break;
                  }
              // return new WidgetAnnotationElement(parameters);
              // case AnnotationType.POPUP:
              //     return new PopupAnnotationElement(parameters);
              case AnnotationType.FREETEXT:
                  return new FreeTextAnnotationElement(parameters);
              // case AnnotationType.LINE:
              //     return new LineAnnotationElement(parameters);
              // case AnnotationType.SQUARE:
              //     return new SquareAnnotationElement(parameters);
              // case AnnotationType.CIRCLE:
              //     return new CircleAnnotationElement(parameters);
              // case AnnotationType.POLYLINE:
              //     return new PolylineAnnotationElement(parameters);
              // case AnnotationType.CARET:
              //     return new CaretAnnotationElement(parameters);
              // case AnnotationType.INK:
              //     return new InkAnnotationElement(parameters);
              // case AnnotationType.POLYGON:
              //     return new PolygonAnnotationElement(parameters);
              case AnnotationType.HIGHLIGHT:
                  return new HighlightAnnotationElement(parameters);
              // case AnnotationType.UNDERLINE:
              //     return new UnderlineAnnotationElement(parameters);
              // case AnnotationType.SQUIGGLY:
              //     return new SquigglyAnnotationElement(parameters);
              // case AnnotationType.STRIKEOUT:
              //     return new StrikeOutAnnotationElement(parameters);
              // case AnnotationType.STAMP:
              //     return new StampAnnotationElement(parameters);
              // case AnnotationType.FILEATTACHMENT:
              //     return new FileAttachmentAnnotationElement(parameters);
              default:
                  return new AnnotationElement(parameters);
          }
      }
  }
  class AnnotationElement {
      constructor(parameters, { isRenderable = false, ignoreBorder = false, createQuadrilaterals = false } = {}) {
          _AnnotationElement_instances.add(this);
          // todo: props
          this.isRenderable = null;
          this.data = null;
          this.layer = null;
          this.linkService = null;
          this.downloadManager = null;
          this.imageResourcesPath = null;
          this.renderForms = null;
          this.svgFactory = null;
          this.annotationStorage = null;
          this.enableScripting = null;
          this.hasJSActions = null;
          this._fieldObjects = null;
          this.parent = null;
          this.container = null;
          this.popup = null;
          this.annotationEditorType = null;
          // todo: props
          _AnnotationElement_updates.set(this, null);
          _AnnotationElement_hasBorder.set(this, false);
          _AnnotationElement_popupElement.set(this, null);
          this.isRenderable = isRenderable;
          this.data = parameters.data;
          this.layer = parameters.layer;
          this.linkService = parameters.linkService;
          this.downloadManager = parameters.downloadManager;
          this.imageResourcesPath = parameters.imageResourcesPath;
          this.renderForms = parameters.renderForms;
          this.svgFactory = parameters.svgFactory;
          this.annotationStorage = parameters.annotationStorage;
          this.enableScripting = parameters.enableScripting;
          this.hasJSActions = parameters.hasJSActions;
          this._fieldObjects = parameters.fieldObjects;
          this.parent = parameters.parent;
          if (isRenderable) {
              this.container = this._createContainer(ignoreBorder);
          }
          if (createQuadrilaterals) {
              this._createQuadrilaterals();
          }
      }
      static _hasPopupData({ titleObj, contentsObj, richText }) {
          return !!((titleObj === null || titleObj === void 0 ? void 0 : titleObj.str) || (contentsObj === null || contentsObj === void 0 ? void 0 : contentsObj.str) || (richText === null || richText === void 0 ? void 0 : richText.str));
      }
      get _isEditable() {
          return this.data.isEditable;
      }
      get hasPopupData() {
          return AnnotationElement._hasPopupData(this.data);
      }
      updateEdited(params) {
          var _a;
          if (!this.container) {
              return;
          }
          __classPrivateFieldSet(this, _AnnotationElement_updates, __classPrivateFieldGet(this, _AnnotationElement_updates, "f") || {
              rect: this.data.rect.slice(0)
          }, "f");
          const { rect } = params;
          if (rect) {
              __classPrivateFieldGet(this, _AnnotationElement_instances, "m", _AnnotationElement_setRectEdited).call(this, rect);
          }
          (_a = __classPrivateFieldGet(this, _AnnotationElement_popupElement, "f")) === null || _a === void 0 ? void 0 : _a.popup.updateEdited(params);
      }
      resetEdited() {
          var _a;
          if (!__classPrivateFieldGet(this, _AnnotationElement_updates, "f")) {
              return;
          }
          __classPrivateFieldGet(this, _AnnotationElement_instances, "m", _AnnotationElement_setRectEdited).call(this, __classPrivateFieldGet(this, _AnnotationElement_updates, "f").rect);
          (_a = __classPrivateFieldGet(this, _AnnotationElement_popupElement, "f")) === null || _a === void 0 ? void 0 : _a.popup.resetEdited();
          __classPrivateFieldSet(this, _AnnotationElement_updates, null, "f");
      }
      /**
       * Create an empty container for the annotation's HTML element.
       *
       * @private
       * @param {boolean} ignoreBorder
       * @memberof AnnotationElement
       * @returns {HTMLElement} A section element.
       */
      _createContainer(ignoreBorder) {
          const { data, parent: { page, viewport } } = this;
          const container = document.createElement("section");
          container.setAttribute("data-annotation-id", data.id);
          if (!(this instanceof WidgetAnnotationElement)) {
              container.tabIndex = DEFAULT_TAB_INDEX;
          }
          const { style } = container;
          // The accessibility manager will move the annotation in the DOM in
          // order to match the visual ordering.
          // But if an annotation is above an other one, then we must draw it
          // after the other one whatever the order is in the DOM, hence the
          // use of the z-index.
          style.zIndex = (this.parent.zIndex++).toString();
          if (data.popupRef) {
              container.setAttribute("aria-haspopup", "dialog");
          }
          if (data.alternativeText) {
              container.title = data.alternativeText;
          }
          if (data.noRotate) {
              // container.classList.add("norotate");
          }
          if (!data.rect || this instanceof PopupAnnotationElement) {
              const { rotation: rotationValue } = data;
              if (!data.hasOwnCanvas && rotationValue !== 0) {
                  this.setRotation(rotationValue, container);
              }
              return container;
          }
          const { width, height } = getRectDims(data.rect);
          if (!ignoreBorder && data.borderStyle.width > 0) {
              style.borderWidth = `${data.borderStyle.width}px`;
              const horizontalRadius = data.borderStyle.horizontalCornerRadius;
              const verticalRadius = data.borderStyle.verticalCornerRadius;
              if (horizontalRadius > 0 || verticalRadius > 0) {
                  const radius = `calc(${horizontalRadius}px * var(--scale-factor)) / calc(${verticalRadius}px * var(--scale-factor))`;
                  style.borderRadius = radius;
              }
              else if (this instanceof RadioButtonWidgetAnnotationElement) {
                  const radius = `calc(${width}px * var(--scale-factor)) / calc(${height}px * var(--scale-factor))`;
                  style.borderRadius = radius;
              }
              switch (data.borderStyle.style) {
                  case AnnotationBorderStyleType.SOLID:
                      style.borderStyle = "solid";
                      break;
                  case AnnotationBorderStyleType.DASHED:
                      style.borderStyle = "dashed";
                      break;
                  case AnnotationBorderStyleType.BEVELED:
                      // warn("Unimplemented border style: beveled");
                      break;
                  case AnnotationBorderStyleType.INSET:
                      // warn("Unimplemented border style: inset");
                      break;
                  case AnnotationBorderStyleType.UNDERLINE:
                      style.borderBottomStyle = "solid";
                      break;
                  default:
                      break;
              }
              const borderColor = data.borderColor || null;
              if (borderColor) {
                  __classPrivateFieldSet(this, _AnnotationElement_hasBorder, true, "f");
                  style.borderColor = kendo_pdfjs_loader_js.Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
              }
              else {
                  // Transparent (invisible) border, so do not draw it at all.
                  style.borderWidth = (0).toString();
              }
          }
          // Do *not* modify `data.rect`, since that will corrupt the annotation
          // position on subsequent calls to `_createContainer` (see issue 6804).
          const rect = kendo_pdfjs_loader_js.Util.normalizeRect([
              data.rect[0],
              page.view[3] - data.rect[1] + page.view[1],
              data.rect[2],
              page.view[3] - data.rect[3] + page.view[1]
          ]);
          const { pageWidth, pageHeight, pageX, pageY } = viewport.rawDims;
          style.left = `${(100 * (rect[0] - pageX)) / pageWidth}%`;
          style.top = `${(100 * (rect[1] - pageY)) / pageHeight}%`;
          const { rotation } = data;
          if (data.hasOwnCanvas || rotation === 0) {
              style.width = `${(100 * width) / pageWidth}%`;
              style.height = `${(100 * height) / pageHeight}%`;
          }
          else {
              this.setRotation(rotation, container);
          }
          return container;
      }
      setRotation(angle, container = this.container) {
          if (!this.data.rect) {
              return;
          }
          const { pageWidth, pageHeight } = this.parent.viewport.rawDims;
          const { width, height } = getRectDims(this.data.rect);
          let elementWidth, elementHeight;
          if (angle % 180 === 0) {
              elementWidth = (100 * width) / pageWidth;
              elementHeight = (100 * height) / pageHeight;
          }
          else {
              elementWidth = (100 * height) / pageWidth;
              elementHeight = (100 * width) / pageHeight;
          }
          container.style.width = `${elementWidth}%`;
          container.style.height = `${elementHeight}%`;
          container.setAttribute("data-main-rotation", (360 - angle) % 360);
      }
      get _commonActions() {
          const setColor = (jsName, styleName, event) => {
              const color = event.detail[jsName];
              const colorType = color[0];
              const colorArray = color.slice(1);
              event.target.style[styleName] =
                  ColorConverters[`${colorType}_HTML`](colorArray);
              this.annotationStorage.setValue(this.data.id, {
                  [styleName]: ColorConverters[`${colorType}_rgb`](colorArray)
              });
          };
          return kendo_pdfjs_loader_js.shadow(this, "_commonActions", {
              display: event => {
                  const { display } = event.detail;
                  // See scripting/constants.js for the values of `Display`.
                  // 0 = visible, 1 = hidden, 2 = noPrint and 3 = noView.
                  const hidden = display % 2 === 1;
                  this.container.style.visibility = hidden ? "hidden" : "visible";
                  this.annotationStorage.setValue(this.data.id, {
                      noView: hidden,
                      noPrint: display === 1 || display === 2
                  });
              },
              print: event => {
                  this.annotationStorage.setValue(this.data.id, {
                      noPrint: !event.detail.print
                  });
              },
              hidden: event => {
                  const { hidden } = event.detail;
                  this.container.style.visibility = hidden ? "hidden" : "visible";
                  this.annotationStorage.setValue(this.data.id, {
                      noPrint: hidden,
                      noView: hidden
                  });
              },
              focus: event => {
                  setTimeout(() => event.target.focus({ preventScroll: false }), 0);
              },
              userName: event => {
                  // tooltip
                  event.target.title = event.detail.userName;
              },
              readonly: event => {
                  event.target.disabled = event.detail.readonly;
              },
              required: event => {
                  this._setRequired(event.target, event.detail.required);
              },
              bgColor: event => {
                  setColor("bgColor", "backgroundColor", event);
              },
              fillColor: event => {
                  setColor("fillColor", "backgroundColor", event);
              },
              fgColor: event => {
                  setColor("fgColor", "color", event);
              },
              textColor: event => {
                  setColor("textColor", "color", event);
              },
              borderColor: event => {
                  setColor("borderColor", "borderColor", event);
              },
              strokeColor: event => {
                  setColor("strokeColor", "borderColor", event);
              },
              rotation: event => {
                  const angle = event.detail.rotation;
                  this.setRotation(angle);
                  this.annotationStorage.setValue(this.data.id, {
                      rotation: angle
                  });
              }
          });
      }
      _dispatchEventFromSandbox(actions, jsEvent) {
          const commonActions = this._commonActions;
          for (const name of Object.keys(jsEvent.detail)) {
              const action = actions[name] || commonActions[name];
              action === null || action === void 0 ? void 0 : action(jsEvent);
          }
      }
      _setDefaultPropertiesFromJS(element) {
          if (!this.enableScripting) {
              return;
          }
          // Some properties may have been updated thanks to JS.
          const storedData = this.annotationStorage.getRawValue(this.data.id);
          if (!storedData) {
              return;
          }
          const commonActions = this._commonActions;
          for (const [actionName, detail] of Object.entries(storedData)) {
              const action = commonActions[actionName];
              if (action) {
                  const eventProxy = {
                      detail: {
                          [actionName]: detail
                      },
                      target: element
                  };
                  action(eventProxy);
                  // The action has been consumed: no need to keep it.
                  delete storedData[actionName];
              }
          }
      }
      /**
       * Create quadrilaterals from the annotation's quadpoints.
       *
       * @private
       * @memberof AnnotationElement
       */
      _createQuadrilaterals() {
          if (!this.container) {
              return;
          }
          const { quadPoints } = this.data;
          if (!quadPoints) {
              return;
          }
          const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect.map(x => Math.fround(x));
          if (quadPoints.length === 8) {
              const [trX, trY, blX, blY] = quadPoints.subarray(2, 6);
              if (rectTrX === trX &&
                  rectTrY === trY &&
                  rectBlX === blX &&
                  rectBlY === blY) {
                  // The quadpoints cover the whole annotation rectangle, so no need to
                  // create a quadrilateral.
                  return;
              }
          }
          const { style } = this.container;
          let svgBuffer;
          if (__classPrivateFieldGet(this, _AnnotationElement_hasBorder, "f")) {
              const { borderColor, borderWidth } = style;
              style.borderWidth = 0;
              svgBuffer = [
                  "url('data:image/svg+xml;utf8,",
                  `<svg xmlns="http://www.w3.org/2000/svg"`,
                  ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
                  `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`
              ];
              // this.container.classList.add("hasBorder");
          }
          // todo: debug
          // if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("TESTING")) {
          // this.container.classList.add("hasClipPath");
          // }
          const width = rectTrX - rectBlX;
          const height = rectTrY - rectBlY;
          const { svgFactory } = this;
          const svg = svgFactory.createElement("svg");
          // svg.classList.add("quadrilateralsContainer");
          svg.setAttribute("width", 0);
          svg.setAttribute("height", 0);
          const defs = svgFactory.createElement("defs");
          svg.append(defs);
          const clipPath = svgFactory.createElement("clipPath");
          const id = `clippath_${this.data.id}`;
          clipPath.setAttribute("id", id);
          clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
          defs.append(clipPath);
          for (let i = 2, ii = quadPoints.length; i < ii; i += 8) {
              const trX = quadPoints[i];
              const trY = quadPoints[i + 1];
              const blX = quadPoints[i + 2];
              const blY = quadPoints[i + 3];
              const rect = svgFactory.createElement("rect");
              const x = (blX - rectBlX) / width;
              const y = (rectTrY - trY) / height;
              const rectWidth = (trX - blX) / width;
              const rectHeight = (trY - blY) / height;
              rect.setAttribute("x", x);
              rect.setAttribute("y", y);
              rect.setAttribute("width", rectWidth);
              rect.setAttribute("height", rectHeight);
              clipPath.append(rect);
              svgBuffer === null || svgBuffer === void 0 ? void 0 : svgBuffer.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
          }
          if (__classPrivateFieldGet(this, _AnnotationElement_hasBorder, "f")) {
              svgBuffer.push(`</g></svg>')`);
              style.backgroundImage = svgBuffer.join("");
          }
          this.container.append(svg);
          this.container.style.clipPath = `url(#${id})`;
      }
      /**
       * Create a popup for the annotation's HTML element. This is used for
       * annotations that do not have a Popup entry in the dictionary, but
       * are of a type that works with popups (such as Highlight annotations).
       *
       * @private
       * @memberof AnnotationElement
       */
      _createPopup() {
          // const { container, data } = this;
          // container.setAttribute("aria-haspopup", "dialog");
          // const popup = (this.#popupElement = new PopupAnnotationElement({
          //     data: {
          //         color: data.color,
          //         titleObj: data.titleObj,
          //         modificationDate: data.modificationDate,
          //         contentsObj: data.contentsObj,
          //         richText: data.richText,
          //         parentRect: data.rect,
          //         borderStyle: 0,
          //         id: `popup_${data.id}`,
          //         rotation: data.rotation,
          //     },
          //     parent: this.parent,
          //     elements: [this],
          // }));
          // this.parent.div.append(popup.render());
      }
      /**
       * Render the annotation's HTML element(s).
       *
       * @public
       * @memberof AnnotationElement
       */
      render() {
          // unreachable("Abstract method `AnnotationElement.render` called");
      }
      /**
       * @private
       * @returns {Array}
       */
      _getElementsByName(name, skipId = null) {
          const fields = [];
          if (this._fieldObjects) {
              const fieldObj = this._fieldObjects[name];
              if (fieldObj) {
                  for (const { page, id, exportValues } of fieldObj) {
                      if (page === -1) {
                          continue;
                      }
                      if (id === skipId) {
                          continue;
                      }
                      const exportValue = typeof exportValues === "string" ? exportValues : null;
                      const domElement = document.querySelector(`[data-element-id="${id}"]`);
                      if (domElement && !GetElementsByNameSet.has(domElement)) {
                          // warn(`_getElementsByName - element not allowed: ${id}`);
                          continue;
                      }
                      fields.push({ id, exportValue, domElement });
                  }
              }
              return fields;
          }
          // Fallback to a regular DOM lookup, to ensure that the standalone
          // viewer components won't break.
          for (const domElement of document.getElementsByName(name)) {
              const { exportValue } = domElement;
              const id = domElement.getAttribute("data-element-id");
              if (id === skipId) {
                  continue;
              }
              if (!GetElementsByNameSet.has(domElement)) {
                  continue;
              }
              fields.push({ id, exportValue, domElement });
          }
          return fields;
      }
      show() {
          var _a;
          if (this.container) {
              this.container.hidden = false;
          }
          (_a = this.popup) === null || _a === void 0 ? void 0 : _a.maybeShow();
      }
      hide() {
          var _a;
          if (this.container) {
              this.container.hidden = true;
          }
          (_a = this.popup) === null || _a === void 0 ? void 0 : _a.forceHide();
      }
      /**
       * Get the HTML element(s) which can trigger a popup when clicked or hovered.
       *
       * @public
       * @memberof AnnotationElement
       * @returns {Array<HTMLElement>|HTMLElement} An array of elements or an
       *          element.
       */
      getElementsToTriggerPopup() {
          return this.container;
      }
      addHighlightArea() {
          const triggers = this.getElementsToTriggerPopup();
          if (Array.isArray(triggers)) {
              // for (const element of triggers) {
              // element.classList.add("highlightArea");
              // }
          }
          else {
              // triggers.classList.add("highlightArea");
          }
      }
      _editOnDoubleClick() {
          if (!this._isEditable) {
              return;
          }
          const { annotationEditorType: mode, data: { id: editId } } = this;
          this.container.addEventListener("dblclick", () => {
              var _a, _b;
              (_b = (_a = this.linkService) === null || _a === void 0 ? void 0 : _a.eventBus) === null || _b === void 0 ? void 0 : _b.dispatch("switchannotationeditormode", {
                  source: this,
                  mode,
                  editId
              });
          });
      }
      _setRequired(element, isRequired) {
          if (isRequired) {
              element.setAttribute("required", true);
          }
          else {
              element.removeAttribute("required");
          }
          element.setAttribute("aria-required", isRequired);
      }
  }
  _AnnotationElement_updates = new WeakMap(), _AnnotationElement_hasBorder = new WeakMap(), _AnnotationElement_popupElement = new WeakMap(), _AnnotationElement_instances = new WeakSet(), _AnnotationElement_setRectEdited = function _AnnotationElement_setRectEdited(rect) {
      const { container: { style }, data: { rect: currentRect, rotation }, parent: { viewport: { rawDims: { pageWidth, pageHeight, pageX, pageY } } } } = this;
      currentRect === null || currentRect === void 0 ? void 0 : currentRect.splice(0, 4, ...rect);
      const { width, height } = getRectDims(rect);
      style.left = `${(100 * (rect[0] - pageX)) / pageWidth}%`;
      style.top = `${(100 * (pageHeight - rect[3] + pageY)) / pageHeight}%`;
      if (rotation === 0) {
          style.width = `${(100 * width) / pageWidth}%`;
          style.height = `${(100 * height) / pageHeight}%`;
      }
      else {
          this.setRotation(rotation);
      }
  };
  class LinkAnnotationElement extends AnnotationElement {
      constructor(parameters, options = null) {
          super(parameters, {
              isRenderable: true,
              ignoreBorder: !!(options === null || options === void 0 ? void 0 : options.ignoreBorder),
              createQuadrilaterals: true
          });
          _LinkAnnotationElement_instances.add(this);
          this.isTooltipOnly = false;
          this.isTooltipOnly = parameters.data.isTooltipOnly;
      }
      render() {
          const { data, linkService } = this;
          const link = document.createElement("a");
          link.setAttribute("data-element-id", data.id);
          let isBound = false;
          if (data.url) {
              linkService.addLinkAttributes(link, data.url, data.newWindow);
              isBound = true;
          }
          else if (data.action) {
              this._bindNamedAction(link, data.action);
              isBound = true;
          }
          else if (data.attachment) {
              __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_bindAttachment).call(this, link, data.attachment, data.attachmentDest);
              isBound = true;
          }
          else if (data.setOCGState) {
              __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_bindSetOCGState).call(this, link, data.setOCGState);
              isBound = true;
          }
          else if (data.dest) {
              this._bindLink(link, data.dest);
              isBound = true;
          }
          else {
              if (data.actions &&
                  (data.actions.Action ||
                      data.actions["Mouse Up"] ||
                      data.actions["Mouse Down"]) &&
                  this.enableScripting &&
                  this.hasJSActions) {
                  this._bindJSAction(link, data);
                  isBound = true;
              }
              if (data.resetForm) {
                  this._bindResetFormAction(link, data.resetForm);
                  isBound = true;
              }
              else if (this.isTooltipOnly && !isBound) {
                  this._bindLink(link, "");
                  isBound = true;
              }
          }
          // todo: do not render the class as the rendering is yet to be determined
          // this.container.classList.add("linkAnnotation");
          this.container.classList.add("k-link-annotation");
          if (isBound) {
              this.container.append(link);
          }
          return this.container;
      }
      /**
       * Bind internal links to the link element.
       *
       * @private
       * @param {Object} link
       * @param {Object} destination
       * @memberof LinkAnnotationElement
       */
      _bindLink(link, destination) {
          link.href = this.linkService.getDestinationHash(destination);
          link.onclick = () => {
              if (destination) {
                  this.linkService.goToDestination(destination);
              }
              return false;
          };
          if (destination || destination === /* isTooltipOnly = */ "") {
              __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_setInternalLink).call(this);
          }
      }
      /**
       * Bind named actions to the link element.
       *
       * @private
       * @param {Object} link
       * @param {Object} action
       * @memberof LinkAnnotationElement
       */
      _bindNamedAction(link, action) {
          link.href = this.linkService.getAnchorUrl("");
          link.onclick = () => {
              this.linkService.executeNamedAction(action);
              return false;
          };
          __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_setInternalLink).call(this);
      }
      /**
       * Bind JS actions to the link element.
       *
       * @private
       * @param {Object} link
       * @param {Object} data
       * @memberof LinkAnnotationElement
       */
      _bindJSAction(link, data) {
          link.href = this.linkService.getAnchorUrl("");
          const map = new Map([
              ["Action", "onclick"],
              ["Mouse Up", "onmouseup"],
              ["Mouse Down", "onmousedown"]
          ]);
          for (const name of Object.keys(data.actions)) {
              const jsName = map.get(name);
              if (!jsName) {
                  continue;
              }
              link[jsName] = () => {
                  var _a;
                  (_a = this.linkService.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                          id: data.id,
                          name
                      }
                  });
                  return false;
              };
          }
          if (!link.onclick) {
              link.onclick = () => false;
          }
          __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_setInternalLink).call(this);
      }
      _bindResetFormAction(link, resetForm) {
          const otherClickAction = link.onclick;
          if (!otherClickAction) {
              link.href = this.linkService.getAnchorUrl("");
          }
          __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_setInternalLink).call(this);
          if (!this._fieldObjects) {
              // warn(
              //     `_bindResetFormAction - "resetForm" action not supported, ` +
              //     "ensure that the `fieldObjects` parameter is provided."
              // );
              if (!otherClickAction) {
                  link.onclick = () => false;
              }
              return;
          }
          link.onclick = () => {
              var _a;
              otherClickAction === null || otherClickAction === void 0 ? void 0 : otherClickAction();
              const { fields: resetFormFields, refs: resetFormRefs, include } = resetForm;
              const allFields = [];
              if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                  const fieldIds = new Set(resetFormRefs);
                  for (const fieldName of resetFormFields) {
                      const fields = this._fieldObjects[fieldName] || [];
                      for (const { id } of fields) {
                          fieldIds.add(id);
                      }
                  }
                  for (const fields of Object.values(this._fieldObjects)) {
                      for (const field of fields) {
                          if (fieldIds.has(field.id) === include) {
                              allFields.push(field);
                          }
                      }
                  }
              }
              else {
                  for (const fields of Object.values(this._fieldObjects)) {
                      allFields.push(...fields);
                  }
              }
              const storage = this.annotationStorage;
              const allIds = [];
              for (const field of allFields) {
                  const { id } = field;
                  allIds.push(id);
                  switch (field.type) {
                      case "text": {
                          const value = field.defaultValue || "";
                          storage.setValue(id, { value });
                          break;
                      }
                      case "checkbox":
                      case "radiobutton": {
                          const value = field.defaultValue === field.exportValues;
                          storage.setValue(id, { value });
                          break;
                      }
                      case "combobox":
                      case "listbox": {
                          const value = field.defaultValue || "";
                          storage.setValue(id, { value });
                          break;
                      }
                      default:
                          continue;
                  }
                  const domElement = document.querySelector(`[data-element-id="${id}"]`);
                  if (!domElement) {
                      continue;
                  }
                  else if (!GetElementsByNameSet.has(domElement)) {
                      // warn(`_bindResetFormAction - element not allowed: ${id}`);
                      continue;
                  }
                  domElement.dispatchEvent(new Event("resetform"));
              }
              if (this.enableScripting) {
                  // Update the values in the sandbox.
                  (_a = this.linkService.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                          id: "app",
                          ids: allIds,
                          name: "ResetForm"
                      }
                  });
              }
              return false;
          };
      }
  }
  _LinkAnnotationElement_instances = new WeakSet(), _LinkAnnotationElement_setInternalLink = function _LinkAnnotationElement_setInternalLink() {
      this.container.setAttribute("data-internal-link", "");
  }, _LinkAnnotationElement_bindAttachment = function _LinkAnnotationElement_bindAttachment(link, attachment, dest = null) {
      link.href = this.linkService.getAnchorUrl("");
      if (attachment.description) {
          link.title = attachment.description;
      }
      link.onclick = () => {
          var _a;
          (_a = this.downloadManager) === null || _a === void 0 ? void 0 : _a.openOrDownloadData(attachment.content, attachment.filename, dest);
          return false;
      };
      __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_setInternalLink).call(this);
  }, _LinkAnnotationElement_bindSetOCGState = function _LinkAnnotationElement_bindSetOCGState(link, action) {
      link.href = this.linkService.getAnchorUrl("");
      link.onclick = () => {
          this.linkService.executeSetOCGState(action);
          return false;
      };
      __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_setInternalLink).call(this);
  };
  // class TextAnnotationElement extends AnnotationElement {
  //     constructor(parameters) {
  //         super(parameters, { isRenderable: true });
  //     }
  //     render() {
  //         this.container.classList.add("textAnnotation");
  //         const image = document.createElement("img");
  //         image.src =
  //             this.imageResourcesPath +
  //             "annotation-" +
  //             this.data.name.toLowerCase() +
  //             ".svg";
  //         image.setAttribute("data-l10n-id", "pdfjs-text-annotation-type");
  //         image.setAttribute(
  //             "data-l10n-args",
  //             JSON.stringify({ type: this.data.name })
  //         );
  //         if (!this.data.popupRef && this.hasPopupData) {
  //             this._createPopup();
  //         }
  //         this.container.append(image);
  //         return this.container;
  //     }
  // }
  class WidgetAnnotationElement extends AnnotationElement {
      render() {
          // Show only the container for unsupported field types.
          return this.container;
      }
      showElementAndHideCanvas(element) {
          var _a;
          if (this.data.hasOwnCanvas) {
              if (((_a = element.previousSibling) === null || _a === void 0 ? void 0 : _a.nodeName) === "CANVAS") {
                  element.previousSibling.hidden = true;
              }
              element.hidden = false;
          }
      }
      _getKeyModifier(event) {
          return kendo_pdfjs_loader_js.FeatureTest.platform.isMac ? event.metaKey : event.ctrlKey;
      }
      _setEventListener(element, elementData, baseName, eventName, valueGetter) {
          if (baseName.includes("mouse")) {
              // Mouse events
              element.addEventListener(baseName, event => {
                  var _a;
                  (_a = this.linkService.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                          id: this.data.id,
                          name: eventName,
                          value: valueGetter(event),
                          shift: event.shiftKey,
                          modifier: this._getKeyModifier(event)
                      }
                  });
              });
          }
          else {
              // Non-mouse events
              element.addEventListener(baseName, event => {
                  var _a;
                  if (baseName === "blur") {
                      if (!elementData.focused || !event.relatedTarget) {
                          return;
                      }
                      elementData.focused = false;
                  }
                  else if (baseName === "focus") {
                      if (elementData.focused) {
                          return;
                      }
                      elementData.focused = true;
                  }
                  if (!valueGetter) {
                      return;
                  }
                  (_a = this.linkService.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                          id: this.data.id,
                          name: eventName,
                          value: valueGetter(event)
                      }
                  });
              });
          }
      }
      _setEventListeners(element, elementData, names, getter) {
          var _a, _b, _c;
          for (const [baseName, eventName] of names) {
              if (eventName === "Action" || ((_a = this.data.actions) === null || _a === void 0 ? void 0 : _a[eventName])) {
                  if (eventName === "Focus" || eventName === "Blur") {
                      elementData || (elementData = { focused: false });
                  }
                  this._setEventListener(element, elementData, baseName, eventName, getter);
                  if (eventName === "Focus" && !((_b = this.data.actions) === null || _b === void 0 ? void 0 : _b.Blur)) {
                      // Ensure that elementData will have the correct value.
                      this._setEventListener(element, elementData, "blur", "Blur", null);
                  }
                  else if (eventName === "Blur" && !((_c = this.data.actions) === null || _c === void 0 ? void 0 : _c.Focus)) {
                      this._setEventListener(element, elementData, "focus", "Focus", null);
                  }
              }
          }
      }
      _setBackgroundColor(element) {
          const color = this.data.backgroundColor || null;
          element.style.backgroundColor =
              color === null
                  ? "transparent"
                  : kendo_pdfjs_loader_js.Util.makeHexColor(color[0], color[1], color[2]);
      }
      /**
       * Apply text styles to the text in the element.
       *
       * @private
       * @param {HTMLDivElement} element
       * @memberof TextWidgetAnnotationElement
       */
      _setTextStyle(element) {
          const TEXT_ALIGNMENT = ["left", "center", "right"];
          const { fontColor } = this.data.defaultAppearanceData;
          const fontSize = this.data.defaultAppearanceData.fontSize || DEFAULT_FONT_SIZE;
          const style = element.style;
          // TODO: If the font-size is zero, calculate it based on the height and
          //       width of the element.
          // Not setting `style.fontSize` will use the default font-size for now.
          // We don't use the font, as specified in the PDF document, for the <input>
          // element. Hence using the original `fontSize` could look bad, which is why
          // it's instead based on the field height.
          // If the height is "big" then it could lead to a too big font size
          // so in this case use the one we've in the pdf (hence the min).
          let computedFontSize;
          const BORDER_SIZE = 2;
          const roundToOneDecimal = x => Math.round(10 * x) / 10;
          if (this.data.multiLine) {
              const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
              const numberOfLines = Math.round(height / (LINE_FACTOR * fontSize)) || 1;
              const lineHeight = height / numberOfLines;
              computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / LINE_FACTOR));
          }
          else {
              const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
              computedFontSize = Math.min(fontSize, roundToOneDecimal(height / LINE_FACTOR));
          }
          style.fontSize = `calc(${computedFontSize}px * var(--scale-factor))`;
          style.color = kendo_pdfjs_loader_js.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
          if (this.data.textAlignment !== null) {
              style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
          }
      }
      _setRequired(element, isRequired) {
          if (isRequired) {
              element.setAttribute("required", true);
          }
          else {
              element.removeAttribute("required");
          }
          element.setAttribute("aria-required", isRequired);
      }
  }
  class TextWidgetAnnotationElement extends WidgetAnnotationElement {
      constructor(parameters) {
          const isRenderable = parameters.renderForms ||
              parameters.data.hasOwnCanvas ||
              (!parameters.data.hasAppearance && !!parameters.data.fieldValue);
          super(parameters, { isRenderable });
      }
      setPropertyOnSiblings(base, key, value, keyInStorage) {
          const storage = this.annotationStorage;
          for (const element of this._getElementsByName(base.name, 
          /* skipId = */ base.id)) {
              if (element.domElement) {
                  element.domElement[key] = value;
              }
              storage.setValue(element.id, { [keyInStorage]: value });
          }
      }
      render() {
          var _a, _b;
          const storage = this.annotationStorage;
          const id = this.data.id;
          // this.container.classList.add("textWidgetAnnotation");
          this.container.classList.add("k-text-widget-annotation");
          let element = null;
          if (this.renderForms) {
              // NOTE: We cannot set the values using `element.value` below, since it
              //       prevents the AnnotationLayer rasterizer in `test/driver.js`
              //       from parsing the elements correctly for the reference tests.
              const storedData = storage.getValue(id, {
                  value: this.data.fieldValue
              });
              let textContent = storedData.value || "";
              const maxLen = storage.getValue(id, {
                  charLimit: this.data.maxLen
              }).charLimit;
              if (maxLen && textContent.length > maxLen) {
                  textContent = textContent.slice(0, maxLen);
              }
              let fieldFormattedValues = storedData.formattedValue || ((_a = this.data.textContent) === null || _a === void 0 ? void 0 : _a.join("\n")) || null;
              if (fieldFormattedValues && this.data.comb) {
                  fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
              }
              const elementData = {
                  userValue: textContent,
                  formattedValue: fieldFormattedValues,
                  lastCommittedValue: null,
                  commitKey: 1,
                  focused: false
              };
              if (this.data.multiLine) {
                  element = document.createElement("textarea");
                  element.textContent = fieldFormattedValues !== null && fieldFormattedValues !== void 0 ? fieldFormattedValues : textContent;
                  if (this.data.doNotScroll) {
                      element.style.overflowY = "hidden";
                  }
              }
              else {
                  element = document.createElement("input");
                  element.type = "text";
                  element.setAttribute("value", fieldFormattedValues !== null && fieldFormattedValues !== void 0 ? fieldFormattedValues : textContent);
                  if (this.data.doNotScroll) {
                      element.style.overflowX = "hidden";
                  }
              }
              if (this.data.hasOwnCanvas) {
                  element.hidden = true;
              }
              GetElementsByNameSet.add(element);
              element.setAttribute("data-element-id", id);
              element.disabled = this.data.readOnly;
              element.name = this.data.fieldName;
              element.tabIndex = DEFAULT_TAB_INDEX;
              this._setRequired(element, this.data.required);
              if (maxLen) {
                  element.maxLength = maxLen;
              }
              element.addEventListener("input", event => {
                  storage.setValue(id, { value: event.target.value });
                  this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                  elementData.formattedValue = null;
              });
              element.addEventListener("resetform", () => {
                  var _a;
                  const defaultValue = (_a = this.data.defaultFieldValue) !== null && _a !== void 0 ? _a : "";
                  element.value = elementData.userValue = defaultValue;
                  elementData.formattedValue = null;
              });
              let blurListener = event => {
                  const { formattedValue } = elementData;
                  if (formattedValue !== null && formattedValue !== undefined) {
                      event.target.value = formattedValue;
                  }
                  // Reset the cursor position to the start of the field (issue 12359).
                  event.target.scrollLeft = 0;
              };
              if (this.enableScripting && this.hasJSActions) {
                  element.addEventListener("focus", event => {
                      var _a;
                      if (elementData.focused) {
                          return;
                      }
                      const { target } = event;
                      if (elementData.userValue) {
                          target.value = elementData.userValue;
                      }
                      elementData.lastCommittedValue = target.value;
                      elementData.commitKey = 1;
                      if (!((_a = this.data.actions) === null || _a === void 0 ? void 0 : _a.Focus)) {
                          elementData.focused = true;
                      }
                  });
                  element.addEventListener("updatefromsandbox", jsEvent => {
                      this.showElementAndHideCanvas(jsEvent.target);
                      const actions = {
                          value(event) {
                              var _a;
                              elementData.userValue = (_a = event.detail.value) !== null && _a !== void 0 ? _a : "";
                              storage.setValue(id, { value: elementData.userValue.toString() });
                              event.target.value = elementData.userValue;
                          },
                          formattedValue(event) {
                              const { formattedValue } = event.detail;
                              elementData.formattedValue = formattedValue;
                              if (formattedValue !== null &&
                                  formattedValue !== undefined &&
                                  event.target !== document.activeElement) {
                                  // Input hasn't the focus so display formatted string
                                  event.target.value = formattedValue;
                              }
                              storage.setValue(id, {
                                  formattedValue
                              });
                          },
                          selRange(event) {
                              event.target.setSelectionRange(...event.detail.selRange);
                          },
                          charLimit: event => {
                              var _a;
                              const { charLimit } = event.detail;
                              const { target } = event;
                              if (charLimit === 0) {
                                  target.removeAttribute("maxLength");
                                  return;
                              }
                              target.setAttribute("maxLength", charLimit);
                              let value = elementData.userValue;
                              if (!value || value.length <= charLimit) {
                                  return;
                              }
                              value = value.slice(0, charLimit);
                              target.value = elementData.userValue = value;
                              storage.setValue(id, { value });
                              (_a = this.linkService.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch("dispatcheventinsandbox", {
                                  source: this,
                                  detail: {
                                      id,
                                      name: "Keystroke",
                                      value,
                                      willCommit: true,
                                      commitKey: 1,
                                      selStart: target.selectionStart,
                                      selEnd: target.selectionEnd
                                  }
                              });
                          }
                      };
                      this._dispatchEventFromSandbox(actions, jsEvent);
                  });
                  // Even if the field hasn't any actions
                  // leaving it can still trigger some actions with Calculate
                  element.addEventListener("keydown", event => {
                      var _a;
                      elementData.commitKey = 1;
                      // If the key is one of Escape, Enter then the data are committed.
                      // If we've a Tab then data will be committed on blur.
                      let commitKey = -1;
                      if (event.key === "Escape") {
                          commitKey = 0;
                      }
                      else if (event.key === "Enter" && !this.data.multiLine) {
                          // When we've a multiline field, "Enter" key is a key as the other
                          // hence we don't commit the data (Acrobat behaves the same way)
                          // (see issue #15627).
                          commitKey = 2;
                      }
                      else if (event.key === "Tab") {
                          elementData.commitKey = 3;
                      }
                      if (commitKey === -1) {
                          return;
                      }
                      const { value } = event.target;
                      if (elementData.lastCommittedValue === value) {
                          return;
                      }
                      elementData.lastCommittedValue = value;
                      // Save the entered value
                      elementData.userValue = value;
                      (_a = this.linkService.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch("dispatcheventinsandbox", {
                          source: this,
                          detail: {
                              id,
                              name: "Keystroke",
                              value,
                              willCommit: true,
                              commitKey,
                              selStart: event.target.selectionStart,
                              selEnd: event.target.selectionEnd
                          }
                      });
                  });
                  const _blurListener = blurListener;
                  blurListener = null;
                  element.addEventListener("blur", event => {
                      var _a, _b;
                      if (!elementData.focused || !event.relatedTarget) {
                          return;
                      }
                      if (!((_a = this.data.actions) === null || _a === void 0 ? void 0 : _a.Blur)) {
                          elementData.focused = false;
                      }
                      const { value } = event.target;
                      elementData.userValue = value;
                      if (elementData.lastCommittedValue !== value) {
                          (_b = this.linkService.eventBus) === null || _b === void 0 ? void 0 : _b.dispatch("dispatcheventinsandbox", {
                              source: this,
                              detail: {
                                  id,
                                  name: "Keystroke",
                                  value,
                                  willCommit: true,
                                  commitKey: elementData.commitKey,
                                  selStart: event.target.selectionStart,
                                  selEnd: event.target.selectionEnd
                              }
                          });
                      }
                      _blurListener(event);
                  });
                  if ((_b = this.data.actions) === null || _b === void 0 ? void 0 : _b.Keystroke) {
                      element.addEventListener("beforeinput", event => {
                          var _a;
                          elementData.lastCommittedValue = null;
                          const { data, target } = event;
                          const { value, selectionStart, selectionEnd } = target;
                          let selStart = selectionStart, selEnd = selectionEnd;
                          switch (event.inputType) {
                              // https://rawgit.com/w3c/input-events/v1/index.html#interface-InputEvent-Attributes
                              case "deleteWordBackward": {
                                  const match = value
                                      .substring(0, selectionStart)
                                      .match(/\w*[^\w]*$/);
                                  if (match) {
                                      selStart -= match[0].length;
                                  }
                                  break;
                              }
                              case "deleteWordForward": {
                                  const match = value
                                      .substring(selectionStart)
                                      .match(/^[^\w]*\w*/);
                                  if (match) {
                                      selEnd += match[0].length;
                                  }
                                  break;
                              }
                              case "deleteContentBackward":
                                  if (selectionStart === selectionEnd) {
                                      selStart -= 1;
                                  }
                                  break;
                              case "deleteContentForward":
                                  if (selectionStart === selectionEnd) {
                                      selEnd += 1;
                                  }
                                  break;
                              default: break;
                          }
                          // We handle the event ourselves.
                          event.preventDefault();
                          (_a = this.linkService.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch("dispatcheventinsandbox", {
                              source: this,
                              detail: {
                                  id,
                                  name: "Keystroke",
                                  value,
                                  change: data || "",
                                  willCommit: false,
                                  selStart,
                                  selEnd
                              }
                          });
                      });
                  }
                  this._setEventListeners(element, elementData, [
                      ["focus", "Focus"],
                      ["blur", "Blur"],
                      ["mousedown", "Mouse Down"],
                      ["mouseenter", "Mouse Enter"],
                      ["mouseleave", "Mouse Exit"],
                      ["mouseup", "Mouse Up"]
                  ], event => event.target.value);
              }
              if (blurListener) {
                  element.addEventListener("blur", blurListener);
              }
              if (this.data.comb) {
                  const fieldWidth = this.data.rect[2] - this.data.rect[0];
                  const combWidth = fieldWidth / maxLen;
                  element.classList.add("comb");
                  element.style.letterSpacing = `calc(${combWidth}px * var(--scale-factor) - 1ch)`;
              }
          }
          else {
              element = document.createElement("div");
              element.textContent = this.data.fieldValue;
              element.style.verticalAlign = "middle";
              element.style.display = "table-cell";
              if (this.data.hasOwnCanvas) {
                  element.hidden = true;
              }
          }
          this._setTextStyle(element);
          this._setBackgroundColor(element);
          this._setDefaultPropertiesFromJS(element);
          this.container.append(element);
          return this.container;
      }
  }
  // class SignatureWidgetAnnotationElement extends WidgetAnnotationElement {
  //     constructor(parameters) {
  //         super(parameters, { isRenderable: !!parameters.data.hasOwnCanvas });
  //     }
  // }
  class CheckboxWidgetAnnotationElement extends WidgetAnnotationElement {
      constructor(parameters) {
          super(parameters, { isRenderable: parameters.renderForms });
      }
      render() {
          const storage = this.annotationStorage;
          const data = this.data;
          const id = data.id;
          let value = storage.getValue(id, {
              value: data.exportValue === data.fieldValue
          }).value;
          if (typeof value === "string") {
              // The value has been changed through js and set in annotationStorage.
              value = value !== "Off";
              storage.setValue(id, { value });
          }
          // this.container.classList.add("buttonWidgetAnnotation", "checkBox");
          this.container.classList.add("k-button-widget-annotation", "k-checkbox-widget-annotation");
          const element = document.createElement("input");
          GetElementsByNameSet.add(element);
          element.setAttribute("data-element-id", id);
          element.disabled = data.readOnly;
          this._setRequired(element, this.data.required);
          element.type = "checkbox";
          element.name = data.fieldName;
          if (value) {
              element.setAttribute("checked", (true).toString());
          }
          element.setAttribute("exportValue", data.exportValue);
          element.tabIndex = DEFAULT_TAB_INDEX;
          element.addEventListener("change", event => {
              const { name, checked } = event.target;
              for (const checkbox of this._getElementsByName(name, /* skipId = */ id)) {
                  const curChecked = checked && checkbox.exportValue === data.exportValue;
                  if (checkbox.domElement) {
                      checkbox.domElement.checked = curChecked;
                  }
                  storage.setValue(checkbox.id, { value: curChecked });
              }
              storage.setValue(id, { value: checked });
          });
          element.addEventListener("resetform", event => {
              const defaultValue = data.defaultFieldValue || "Off";
              // @ts-expect-error(TS)
              event.target.checked = defaultValue === data.exportValue;
          });
          if (this.enableScripting && this.hasJSActions) {
              element.addEventListener("updatefromsandbox", jsEvent => {
                  const actions = {
                      value(event) {
                          event.target.checked = event.detail.value !== "Off";
                          storage.setValue(id, { value: event.target.checked });
                      }
                  };
                  this._dispatchEventFromSandbox(actions, jsEvent);
              });
              this._setEventListeners(element, null, [
                  ["change", "Validate"],
                  ["change", "Action"],
                  ["focus", "Focus"],
                  ["blur", "Blur"],
                  ["mousedown", "Mouse Down"],
                  ["mouseenter", "Mouse Enter"],
                  ["mouseleave", "Mouse Exit"],
                  ["mouseup", "Mouse Up"]
              ], event => event.target.checked);
          }
          if (this.enableScripting && this.hasJSActions) {
              element.addEventListener("updatefromsandbox", jsEvent => {
                  const actions = {
                      value(event) {
                          event.target.checked = event.detail.value !== "Off";
                          storage.setValue(id, { value: event.target.checked });
                      }
                  };
                  this._dispatchEventFromSandbox(actions, jsEvent);
              });
              this._setEventListeners(element, null, [
                  ["change", "Validate"],
                  ["change", "Action"],
                  ["focus", "Focus"],
                  ["blur", "Blur"],
                  ["mousedown", "Mouse Down"],
                  ["mouseenter", "Mouse Enter"],
                  ["mouseleave", "Mouse Exit"],
                  ["mouseup", "Mouse Up"]
              ], event => event.target.checked);
          }
          this._setBackgroundColor(element);
          this._setDefaultPropertiesFromJS(element);
          this.container.append(element);
          return this.container;
      }
  }
  class RadioButtonWidgetAnnotationElement extends WidgetAnnotationElement {
      constructor(parameters) {
          super(parameters, { isRenderable: parameters.renderForms });
      }
      render() {
          //this.container.classList.add("buttonWidgetAnnotation", "radioButton");
          this.container.classList.add("k-button-widget-annotation", "k-radio-button-widget-annotation");
          const storage = this.annotationStorage;
          const data = this.data;
          const id = data.id;
          let value = storage.getValue(id, {
              value: data.fieldValue === data.buttonValue
          }).value;
          if (typeof value === "string") {
              // The value has been changed through js and set in annotationStorage.
              value = value !== data.buttonValue;
              storage.setValue(id, { value });
          }
          if (value) {
              // It's possible that multiple radio buttons are checked.
              // So if this one is checked we just reset the other ones.
              // (see bug 1864136). Then when the other ones will be rendered they will
              // unchecked (because of their value in the storage).
              // Consequently, the first checked radio button will be the only checked
              // one.
              for (const radio of this._getElementsByName(data.fieldName, 
              /* skipId = */ id)) {
                  storage.setValue(radio.id, { value: false });
              }
          }
          const element = document.createElement("input");
          GetElementsByNameSet.add(element);
          element.setAttribute("data-element-id", id);
          element.disabled = data.readOnly;
          this._setRequired(element, this.data.required);
          element.type = "radio";
          element.name = data.fieldName;
          if (value) {
              element.setAttribute("checked", (true).toString());
          }
          element.tabIndex = DEFAULT_TAB_INDEX;
          element.addEventListener("change", event => {
              const { name, checked } = event.target;
              for (const radio of this._getElementsByName(name, /* skipId = */ id)) {
                  storage.setValue(radio.id, { value: false });
              }
              storage.setValue(id, { value: checked });
          });
          element.addEventListener("resetform", event => {
              const defaultValue = data.defaultFieldValue;
              // @ts-expect-error(TS)
              event.target.checked =
                  defaultValue !== null &&
                      defaultValue !== undefined &&
                      defaultValue === data.buttonValue;
          });
          if (this.enableScripting && this.hasJSActions) {
              const pdfButtonValue = data.buttonValue;
              element.addEventListener("updatefromsandbox", jsEvent => {
                  const actions = {
                      value: event => {
                          const checked = pdfButtonValue === event.detail.value;
                          for (const radio of this._getElementsByName(event.target.name)) {
                              const curChecked = checked && radio.id === id;
                              if (radio.domElement) {
                                  radio.domElement.checked = curChecked;
                              }
                              storage.setValue(radio.id, { value: curChecked });
                          }
                      }
                  };
                  this._dispatchEventFromSandbox(actions, jsEvent);
              });
              this._setEventListeners(element, null, [
                  ["change", "Validate"],
                  ["change", "Action"],
                  ["focus", "Focus"],
                  ["blur", "Blur"],
                  ["mousedown", "Mouse Down"],
                  ["mouseenter", "Mouse Enter"],
                  ["mouseleave", "Mouse Exit"],
                  ["mouseup", "Mouse Up"]
              ], event => event.target.checked);
          }
          this._setBackgroundColor(element);
          this._setDefaultPropertiesFromJS(element);
          this.container.append(element);
          return this.container;
      }
  }
  class PushButtonWidgetAnnotationElement extends LinkAnnotationElement {
      constructor(parameters) {
          super(parameters, { ignoreBorder: parameters.data.hasAppearance });
      }
      render() {
          // The rendering and functionality of a push button widget annotation is
          // equal to that of a link annotation, but may have more functionality, such
          // as performing actions on form fields (resetting, submitting, et cetera).
          const container = super.render();
          //container.classList.add("buttonWidgetAnnotation", "pushButton");
          this.container.classList.add("k-button-widget-annotation", "k-push-button-widget-annotation");
          const linkElement = container.lastChild;
          if (this.enableScripting && this.hasJSActions && linkElement) {
              this._setDefaultPropertiesFromJS(linkElement);
              linkElement.addEventListener("updatefromsandbox", jsEvent => {
                  this._dispatchEventFromSandbox({}, jsEvent);
              });
          }
          return container;
      }
  }
  class ChoiceWidgetAnnotationElement extends WidgetAnnotationElement {
      constructor(parameters) {
          super(parameters, { isRenderable: parameters.renderForms });
      }
      render() {
          this.container.classList.add("choiceWidgetAnnotation");
          const storage = this.annotationStorage;
          const id = this.data.id;
          const storedData = storage.getValue(id, {
              value: this.data.fieldValue
          });
          const selectElement = document.createElement("select");
          GetElementsByNameSet.add(selectElement);
          selectElement.setAttribute("data-element-id", id);
          selectElement.disabled = this.data.readOnly;
          this._setRequired(selectElement, this.data.required);
          selectElement.name = this.data.fieldName;
          selectElement.tabIndex = DEFAULT_TAB_INDEX;
          let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
          if (!this.data.combo) {
              // List boxes have a size and (optionally) multiple selection.
              selectElement.size = this.data.options.length;
              if (this.data.multiSelect) {
                  selectElement.multiple = true;
              }
          }
          selectElement.addEventListener("resetform", () => {
              const defaultValue = this.data.defaultFieldValue;
              for (const option of selectElement.options) {
                  option.selected = option.value === defaultValue;
              }
          });
          // Insert the options into the choice field.
          for (const option of this.data.options) {
              const optionElement = document.createElement("option");
              optionElement.textContent = option.displayValue;
              optionElement.value = option.exportValue;
              if (storedData.value.includes(option.exportValue)) {
                  optionElement.setAttribute("selected", (true).toString());
                  addAnEmptyEntry = false;
              }
              selectElement.append(optionElement);
          }
          let removeEmptyEntry = null;
          if (addAnEmptyEntry) {
              const noneOptionElement = document.createElement("option");
              noneOptionElement.value = " ";
              noneOptionElement.setAttribute("hidden", (true).toString());
              noneOptionElement.setAttribute("selected", (true).toString());
              selectElement.prepend(noneOptionElement);
              removeEmptyEntry = () => {
                  noneOptionElement.remove();
                  selectElement.removeEventListener("input", removeEmptyEntry);
                  removeEmptyEntry = null;
              };
              selectElement.addEventListener("input", removeEmptyEntry);
          }
          const getValue = isExport => {
              const name = isExport ? "value" : "textContent";
              const { options, multiple } = selectElement;
              if (!multiple) {
                  return options.selectedIndex === -1
                      ? null
                      : options[options.selectedIndex][name];
              }
              return Array.prototype.filter
                  .call(options, option => option.selected)
                  .map(option => option[name]);
          };
          let selectedValues = getValue(/* isExport */ false);
          const getItems = event => {
              const options = event.target.options;
              return Array.prototype.map.call(options, option => ({
                  displayValue: option.textContent,
                  exportValue: option.value
              }));
          };
          if (this.enableScripting && this.hasJSActions) {
              selectElement.addEventListener("updatefromsandbox", jsEvent => {
                  const actions = {
                      value(event) {
                          removeEmptyEntry === null || removeEmptyEntry === void 0 ? void 0 : removeEmptyEntry();
                          const value = event.detail.value;
                          const values = new Set(Array.isArray(value) ? value : [value]);
                          for (const option of selectElement.options) {
                              option.selected = values.has(option.value);
                          }
                          storage.setValue(id, {
                              value: getValue(/* isExport */ true)
                          });
                          selectedValues = getValue(/* isExport */ false);
                      },
                      multipleSelection() {
                          selectElement.multiple = true;
                      },
                      remove(event) {
                          const options = selectElement.options;
                          const index = event.detail.remove;
                          options[index].selected = false;
                          selectElement.remove(index);
                          if (options.length > 0) {
                              const i = Array.prototype.findIndex.call(options, option => option.selected);
                              if (i === -1) {
                                  options[0].selected = true;
                              }
                          }
                          storage.setValue(id, {
                              value: getValue(/* isExport */ true),
                              items: getItems(event)
                          });
                          selectedValues = getValue(/* isExport */ false);
                      },
                      clear() {
                          while (selectElement.length !== 0) {
                              selectElement.remove(0);
                          }
                          storage.setValue(id, { value: null, items: [] });
                          selectedValues = getValue(/* isExport */ false);
                      },
                      insert(event) {
                          const { index, displayValue, exportValue } = event.detail.insert;
                          const selectChild = selectElement.children[index];
                          const optionElement = document.createElement("option");
                          optionElement.textContent = displayValue;
                          optionElement.value = exportValue;
                          if (selectChild) {
                              selectChild.before(optionElement);
                          }
                          else {
                              selectElement.append(optionElement);
                          }
                          storage.setValue(id, {
                              value: getValue(/* isExport */ true),
                              items: getItems(event)
                          });
                          selectedValues = getValue(/* isExport */ false);
                      },
                      items(event) {
                          const { items } = event.detail;
                          while (selectElement.length !== 0) {
                              selectElement.remove(0);
                          }
                          for (const item of items) {
                              const { displayValue, exportValue } = item;
                              const optionElement = document.createElement("option");
                              optionElement.textContent = displayValue;
                              optionElement.value = exportValue;
                              selectElement.append(optionElement);
                          }
                          if (selectElement.options.length > 0) {
                              selectElement.options[0].selected = true;
                          }
                          storage.setValue(id, {
                              value: getValue(/* isExport */ true),
                              items: getItems(event)
                          });
                          selectedValues = getValue(/* isExport */ false);
                      },
                      indices(event) {
                          const indices = new Set(event.detail.indices);
                          for (const option of event.target.options) {
                              option.selected = indices.has(option.index);
                          }
                          storage.setValue(id, {
                              value: getValue(/* isExport */ true)
                          });
                          selectedValues = getValue(/* isExport */ false);
                      },
                      editable(event) {
                          event.target.disabled = !event.detail.editable;
                      }
                  };
                  this._dispatchEventFromSandbox(actions, jsEvent);
              });
              selectElement.addEventListener("input", event => {
                  var _a;
                  const exportValue = getValue(/* isExport */ true);
                  const change = getValue(/* isExport */ false);
                  storage.setValue(id, { value: exportValue });
                  event.preventDefault();
                  (_a = this.linkService.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                          id,
                          name: "Keystroke",
                          value: selectedValues,
                          change,
                          changeEx: exportValue,
                          willCommit: false,
                          commitKey: 1,
                          keyDown: false
                      }
                  });
              });
              this._setEventListeners(selectElement, null, [
                  ["focus", "Focus"],
                  ["blur", "Blur"],
                  ["mousedown", "Mouse Down"],
                  ["mouseenter", "Mouse Enter"],
                  ["mouseleave", "Mouse Exit"],
                  ["mouseup", "Mouse Up"],
                  ["input", "Action"],
                  ["input", "Validate"]
              ], event => event.target.value);
          }
          else {
              selectElement.addEventListener("input", function () {
                  storage.setValue(id, { value: getValue(/* isExport */ true) });
              });
          }
          if (this.data.combo) {
              this._setTextStyle(selectElement);
          }
          else {
              // Just use the default font size...
              // it's a bit hard to guess what is a good size.
          }
          this._setBackgroundColor(selectElement);
          this._setDefaultPropertiesFromJS(selectElement);
          this.container.append(selectElement);
          return this.container;
      }
  }
  class PopupAnnotationElement extends AnnotationElement {
      // todo: props
      constructor(parameters) {
          const { data, elements } = parameters;
          super(parameters, { isRenderable: AnnotationElement._hasPopupData(data) });
          // todo: props
          this.elements = [];
          this.elements = elements;
          this.popup = null;
      }
      render() {
          this.container.classList.add("popupAnnotation");
          const popup = (this.popup = new PopupElement({
              container: this.container,
              color: this.data.color,
              titleObj: this.data.titleObj,
              modificationDate: this.data.modificationDate,
              contentsObj: this.data.contentsObj,
              richText: this.data.richText,
              rect: this.data.rect,
              parentRect: this.data.parentRect || null,
              parent: this.parent,
              elements: this.elements,
              open: this.data.open
          }));
          const elementIds = [];
          for (const element of this.elements) {
              element.popup = popup;
              elementIds.push(element.data.id);
              element.addHighlightArea();
          }
          this.container.setAttribute("aria-controls", elementIds.map(id => `${AnnotationPrefix}${id}`).join(","));
          return this.container;
      }
  }
  class PopupElement {
      constructor({ container, color, elements, titleObj, modificationDate, contentsObj, richText, parent, rect, parentRect, open }) {
          var _a;
          _PopupElement_instances.add(this);
          // todo: props
          this.trigger = null;
          // todo: props
          _PopupElement_boundKeyDown.set(this, __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_keyDown).bind(this));
          _PopupElement_boundHide.set(this, __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_hide).bind(this));
          _PopupElement_boundShow.set(this, __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_show).bind(this));
          _PopupElement_boundToggle.set(this, __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_toggle).bind(this));
          _PopupElement_color.set(this, null);
          _PopupElement_container.set(this, null);
          _PopupElement_contentsObj.set(this, null);
          _PopupElement_dateObj.set(this, null);
          _PopupElement_elements.set(this, null);
          _PopupElement_parent.set(this, null);
          _PopupElement_parentRect.set(this, null);
          _PopupElement_pinned.set(this, false);
          _PopupElement_popup.set(this, null);
          _PopupElement_position.set(this, null);
          _PopupElement_rect.set(this, null);
          _PopupElement_richText.set(this, null);
          _PopupElement_titleObj.set(this, null);
          _PopupElement_updates.set(this, null);
          _PopupElement_wasVisible.set(this, false);
          __classPrivateFieldSet(this, _PopupElement_container, container, "f");
          __classPrivateFieldSet(this, _PopupElement_titleObj, titleObj, "f");
          __classPrivateFieldSet(this, _PopupElement_contentsObj, contentsObj, "f");
          __classPrivateFieldSet(this, _PopupElement_richText, richText, "f");
          __classPrivateFieldSet(this, _PopupElement_parent, parent, "f");
          __classPrivateFieldSet(this, _PopupElement_color, color, "f");
          __classPrivateFieldSet(this, _PopupElement_rect, rect, "f");
          __classPrivateFieldSet(this, _PopupElement_parentRect, parentRect, "f");
          __classPrivateFieldSet(this, _PopupElement_elements, elements, "f");
          // The modification date is shown in the popup instead of the creation
          // date if it is available and can be parsed correctly, which is
          // consistent with other viewers such as Adobe Acrobat.
          __classPrivateFieldSet(this, _PopupElement_dateObj, kendo_pdfjs_loader_js.PDFDateString.toDateObject(modificationDate), "f");
          this.trigger = elements.flatMap(e => e.getElementsToTriggerPopup());
          // Attach the event listeners to the trigger element.
          for (const element of this.trigger) {
              element.addEventListener("click", __classPrivateFieldGet(this, _PopupElement_boundToggle, "f"));
              element.addEventListener("mouseenter", __classPrivateFieldGet(this, _PopupElement_boundShow, "f"));
              element.addEventListener("mouseleave", __classPrivateFieldGet(this, _PopupElement_boundHide, "f"));
              element.classList.add("popupTriggerArea");
          }
          // Attach the event listener to toggle the popup with the keyboard.
          for (const element of elements) {
              (_a = element.container) === null || _a === void 0 ? void 0 : _a.addEventListener("keydown", __classPrivateFieldGet(this, _PopupElement_boundKeyDown, "f"));
          }
          __classPrivateFieldGet(this, _PopupElement_container, "f").hidden = true;
          if (open) {
              __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_toggle).call(this);
          }
          // if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("TESTING")) {
          // Since the popup is lazily created, we need to ensure that it'll be
          // created and displayed during reference tests.
          __classPrivateFieldGet(this, _PopupElement_parent, "f").popupShow.push(() => __awaiter(this, void 0, void 0, function* () {
              if (__classPrivateFieldGet(this, _PopupElement_container, "f").hidden) {
                  __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_show).call(this);
              }
          }));
          // }
      }
      render() {
          if (__classPrivateFieldGet(this, _PopupElement_popup, "f")) {
              return;
          }
          const popup = (__classPrivateFieldSet(this, _PopupElement_popup, document.createElement("div"), "f"));
          popup.className = "popup";
          if (__classPrivateFieldGet(this, _PopupElement_color, "f")) {
              const baseColor = (popup.style.outlineColor = kendo_pdfjs_loader_js.Util.makeHexColor(
              // @ts-expect-error TS(2556):
              ...__classPrivateFieldGet(this, _PopupElement_color, "f")));
              if (
              // (typeof PDFJSDev !== "undefined" && PDFJSDev.test("MOZCENTRAL")) ||
              CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) {
                  popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
              }
              else {
                  // color-mix isn't supported in some browsers hence this version.
                  // See https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/color-mix#browser_compatibility
                  // TODO: Use color-mix when it's supported everywhere.
                  // Enlighten the color.
                  const BACKGROUND_ENLIGHT = 0.7;
                  popup.style.backgroundColor = kendo_pdfjs_loader_js.Util.makeHexColor(
                  // @ts-expect-error TS(2556):
                  ...__classPrivateFieldGet(this, _PopupElement_color, "f").map(c => Math.floor(BACKGROUND_ENLIGHT * (255 - c) + c)));
              }
          }
          const header = document.createElement("span");
          header.className = "header";
          const title = document.createElement("h1");
          header.append(title);
          ({ dir: title.dir, str: title.textContent } = __classPrivateFieldGet(this, _PopupElement_titleObj, "f"));
          popup.append(header);
          if (__classPrivateFieldGet(this, _PopupElement_dateObj, "f")) {
              const modificationDate = document.createElement("span");
              modificationDate.classList.add("popupDate");
              modificationDate.setAttribute("data-l10n-id", "pdfjs-annotation-date-string");
              modificationDate.setAttribute("data-l10n-args", JSON.stringify({
                  date: __classPrivateFieldGet(this, _PopupElement_dateObj, "f").toLocaleDateString(),
                  time: __classPrivateFieldGet(this, _PopupElement_dateObj, "f").toLocaleTimeString()
              }));
              header.append(modificationDate);
          }
          const html = __classPrivateFieldGet(this, _PopupElement_instances, "a", _PopupElement_html_get);
          if (html) {
              // @ts-expect-error TS(2556):
              kendo_pdfjs_loader_js.XfaLayer.render({
                  xfaHtml: html,
                  intent: "richText",
                  div: popup
              });
              // @ts-expect-error TS(2556):
              popup.lastChild.classList.add("richText", "popupContent");
          }
          else {
              const contents = this._formatContents(__classPrivateFieldGet(this, _PopupElement_contentsObj, "f"));
              popup.append(contents);
          }
          __classPrivateFieldGet(this, _PopupElement_container, "f").append(popup);
      }
      /**
       * Format the contents of the popup by adding newlines where necessary.
       *
       * @private
       * @param {Object<string, string>} contentsObj
       * @memberof PopupElement
       * @returns {HTMLParagraphElement}
       */
      _formatContents({ str, dir }) {
          const p = document.createElement("p");
          p.classList.add("popupContent");
          p.dir = dir;
          const lines = str.split(/(?:\r\n?|\n)/);
          for (let i = 0, ii = lines.length; i < ii; ++i) {
              const line = lines[i];
              p.append(document.createTextNode(line));
              if (i < ii - 1) {
                  p.append(document.createElement("br"));
              }
          }
          return p;
      }
      updateEdited({ rect, popupContent }) {
          var _a;
          __classPrivateFieldSet(this, _PopupElement_updates, __classPrivateFieldGet(this, _PopupElement_updates, "f") || {
              contentsObj: __classPrivateFieldGet(this, _PopupElement_contentsObj, "f"),
              richText: __classPrivateFieldGet(this, _PopupElement_richText, "f")
          }, "f");
          if (rect) {
              __classPrivateFieldSet(this, _PopupElement_position, null, "f");
          }
          if (popupContent) {
              __classPrivateFieldSet(this, _PopupElement_richText, __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_makePopupContent).call(this, popupContent), "f");
              __classPrivateFieldSet(this, _PopupElement_contentsObj, null, "f");
          }
          (_a = __classPrivateFieldGet(this, _PopupElement_popup, "f")) === null || _a === void 0 ? void 0 : _a.remove();
          __classPrivateFieldSet(this, _PopupElement_popup, null, "f");
      }
      resetEdited() {
          var _a;
          var _b, _c;
          if (!__classPrivateFieldGet(this, _PopupElement_updates, "f")) {
              return;
          }
          (_b = this, _c = this, { contentsObj: ({ set value(_a) { __classPrivateFieldSet(_b, _PopupElement_contentsObj, _a, "f"); } }).value, richText: ({ set value(_a) { __classPrivateFieldSet(_c, _PopupElement_richText, _a, "f"); } }).value } =
              __classPrivateFieldGet(this, _PopupElement_updates, "f"));
          __classPrivateFieldSet(this, _PopupElement_updates, null, "f");
          (_a = __classPrivateFieldGet(this, _PopupElement_popup, "f")) === null || _a === void 0 ? void 0 : _a.remove();
          __classPrivateFieldSet(this, _PopupElement_popup, null, "f");
          __classPrivateFieldSet(this, _PopupElement_position, null, "f");
      }
      forceHide() {
          __classPrivateFieldSet(this, _PopupElement_wasVisible, this.isVisible, "f");
          if (!__classPrivateFieldGet(this, _PopupElement_wasVisible, "f")) {
              return;
          }
          __classPrivateFieldGet(this, _PopupElement_container, "f").hidden = true;
      }
      maybeShow() {
          if (!__classPrivateFieldGet(this, _PopupElement_wasVisible, "f")) {
              return;
          }
          if (!__classPrivateFieldGet(this, _PopupElement_popup, "f")) {
              __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_show).call(this);
          }
          __classPrivateFieldSet(this, _PopupElement_wasVisible, false, "f");
          __classPrivateFieldGet(this, _PopupElement_container, "f").hidden = false;
      }
      get isVisible() {
          return __classPrivateFieldGet(this, _PopupElement_container, "f").hidden === false;
      }
  }
  _PopupElement_boundKeyDown = new WeakMap(), _PopupElement_boundHide = new WeakMap(), _PopupElement_boundShow = new WeakMap(), _PopupElement_boundToggle = new WeakMap(), _PopupElement_color = new WeakMap(), _PopupElement_container = new WeakMap(), _PopupElement_contentsObj = new WeakMap(), _PopupElement_dateObj = new WeakMap(), _PopupElement_elements = new WeakMap(), _PopupElement_parent = new WeakMap(), _PopupElement_parentRect = new WeakMap(), _PopupElement_pinned = new WeakMap(), _PopupElement_popup = new WeakMap(), _PopupElement_position = new WeakMap(), _PopupElement_rect = new WeakMap(), _PopupElement_richText = new WeakMap(), _PopupElement_titleObj = new WeakMap(), _PopupElement_updates = new WeakMap(), _PopupElement_wasVisible = new WeakMap(), _PopupElement_instances = new WeakSet(), _PopupElement_html_get = function _PopupElement_html_get() {
      const richText = __classPrivateFieldGet(this, _PopupElement_richText, "f");
      const contentsObj = __classPrivateFieldGet(this, _PopupElement_contentsObj, "f");
      if ((richText === null || richText === void 0 ? void 0 : richText.str) &&
          (!(contentsObj === null || contentsObj === void 0 ? void 0 : contentsObj.str) || contentsObj.str === richText.str)) {
          return __classPrivateFieldGet(this, _PopupElement_richText, "f").html || null;
      }
      return null;
  }, _PopupElement_fontSize_get = function _PopupElement_fontSize_get() {
      var _a, _b, _c;
      return ((_c = (_b = (_a = __classPrivateFieldGet(this, _PopupElement_instances, "a", _PopupElement_html_get)) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.style) === null || _c === void 0 ? void 0 : _c.fontSize) || 0;
  }, _PopupElement_fontColor_get = function _PopupElement_fontColor_get() {
      var _a, _b, _c;
      return ((_c = (_b = (_a = __classPrivateFieldGet(this, _PopupElement_instances, "a", _PopupElement_html_get)) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.style) === null || _c === void 0 ? void 0 : _c.color) || null;
  }, _PopupElement_makePopupContent = function _PopupElement_makePopupContent(text) {
      const popupLines = [];
      const popupContent = {
          str: text,
          html: {
              name: "div",
              attributes: {
                  dir: "auto"
              },
              children: [
                  {
                      name: "p",
                      children: popupLines
                  }
              ]
          }
      };
      const lineAttributes = {
          style: {
              color: __classPrivateFieldGet(this, _PopupElement_instances, "a", _PopupElement_fontColor_get),
              fontSize: __classPrivateFieldGet(this, _PopupElement_instances, "a", _PopupElement_fontSize_get)
                  ? `calc(${__classPrivateFieldGet(this, _PopupElement_instances, "a", _PopupElement_fontSize_get)}px * var(--scale-factor))`
                  : ""
          }
      };
      for (const line of text.split("\n")) {
          popupLines.push({
              name: "span",
              value: line,
              attributes: lineAttributes
          });
      }
      return popupContent;
  }, _PopupElement_keyDown = function _PopupElement_keyDown(event) {
      if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) {
          return;
      }
      if (event.key === "Enter" || (event.key === "Escape" && __classPrivateFieldGet(this, _PopupElement_pinned, "f"))) {
          __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_toggle).call(this);
      }
  }, _PopupElement_setPosition = function _PopupElement_setPosition() {
      if (__classPrivateFieldGet(this, _PopupElement_position, "f") !== null) {
          return;
      }
      const { page: { view }, viewport: { rawDims: { pageWidth, pageHeight, pageX, pageY } } } = __classPrivateFieldGet(this, _PopupElement_parent, "f");
      let useParentRect = !!__classPrivateFieldGet(this, _PopupElement_parentRect, "f");
      let rect = useParentRect ? __classPrivateFieldGet(this, _PopupElement_parentRect, "f") : __classPrivateFieldGet(this, _PopupElement_rect, "f");
      for (const element of __classPrivateFieldGet(this, _PopupElement_elements, "f")) {
          if (!rect || kendo_pdfjs_loader_js.Util.intersect(element.data.rect, rect) !== null) {
              rect = element.data.rect;
              useParentRect = true;
              break;
          }
      }
      const normalizedRect = kendo_pdfjs_loader_js.Util.normalizeRect([
          rect[0],
          view[3] - rect[1] + view[1],
          rect[2],
          view[3] - rect[3] + view[1]
      ]);
      const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
      const parentWidth = useParentRect
          ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION
          : 0;
      const popupLeft = normalizedRect[0] + parentWidth;
      const popupTop = normalizedRect[1];
      __classPrivateFieldSet(this, _PopupElement_position, [
          (100 * (popupLeft - pageX)) / pageWidth,
          (100 * (popupTop - pageY)) / pageHeight
      ], "f");
      const { style } = __classPrivateFieldGet(this, _PopupElement_container, "f");
      style.left = `${__classPrivateFieldGet(this, _PopupElement_position, "f")[0]}%`;
      style.top = `${__classPrivateFieldGet(this, _PopupElement_position, "f")[1]}%`;
  }, _PopupElement_toggle = function _PopupElement_toggle() {
      __classPrivateFieldSet(this, _PopupElement_pinned, !__classPrivateFieldGet(this, _PopupElement_pinned, "f"), "f");
      if (__classPrivateFieldGet(this, _PopupElement_pinned, "f")) {
          __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_show).call(this);
          __classPrivateFieldGet(this, _PopupElement_container, "f").addEventListener("click", __classPrivateFieldGet(this, _PopupElement_boundToggle, "f"));
          __classPrivateFieldGet(this, _PopupElement_container, "f").addEventListener("keydown", __classPrivateFieldGet(this, _PopupElement_boundKeyDown, "f"));
      }
      else {
          __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_hide).call(this);
          __classPrivateFieldGet(this, _PopupElement_container, "f").removeEventListener("click", __classPrivateFieldGet(this, _PopupElement_boundToggle, "f"));
          __classPrivateFieldGet(this, _PopupElement_container, "f").removeEventListener("keydown", __classPrivateFieldGet(this, _PopupElement_boundKeyDown, "f"));
      }
  }, _PopupElement_show = function _PopupElement_show() {
      if (!__classPrivateFieldGet(this, _PopupElement_popup, "f")) {
          this.render();
      }
      if (!this.isVisible) {
          __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_setPosition).call(this);
          __classPrivateFieldGet(this, _PopupElement_container, "f").hidden = false;
          __classPrivateFieldGet(this, _PopupElement_container, "f").style.zIndex = (parseInt(__classPrivateFieldGet(this, _PopupElement_container, "f").style.zIndex, 10) + 1000).toString();
      }
      else if (__classPrivateFieldGet(this, _PopupElement_pinned, "f")) {
          __classPrivateFieldGet(this, _PopupElement_container, "f").classList.add("focused");
      }
  }, _PopupElement_hide = function _PopupElement_hide() {
      __classPrivateFieldGet(this, _PopupElement_container, "f").classList.remove("focused");
      if (__classPrivateFieldGet(this, _PopupElement_pinned, "f") || !this.isVisible) {
          return;
      }
      __classPrivateFieldGet(this, _PopupElement_container, "f").hidden = true;
      __classPrivateFieldGet(this, _PopupElement_container, "f").style.zIndex = (parseInt(__classPrivateFieldGet(this, _PopupElement_container, "f").style.zIndex, 10) - 1000).toString();
  };
  class FreeTextAnnotationElement extends AnnotationElement {
      // todo: props
      constructor(parameters) {
          super(parameters, { isRenderable: true, ignoreBorder: true });
          // todo: props
          this.textContent = null;
          this.textPosition = null;
          this.textContent = parameters.data.textContent;
          this.textPosition = parameters.data.textPosition;
          this.annotationEditorType = kendo_pdfjs_loader_js.AnnotationEditorType.FREETEXT;
      }
      render() {
          // this.container.classList.add("freeTextAnnotation");
          // this.container.classList.add("freeTextAnnotation");
          this.container.classList.add("k-free-text-annotation");
          if (this.textContent) {
              const content = document.createElement("div");
              // content.classList.add("annotationTextContent");
              content.classList.add("k-annotation-text-content");
              content.setAttribute("role", "comment");
              for (const line of this.textContent) {
                  const lineSpan = document.createElement("span");
                  lineSpan.textContent = line;
                  content.append(lineSpan);
              }
              this.container.append(content);
          }
          // if (!this.data.popupRef && this.hasPopupData) {
          //     this._createPopup();
          // }
          this._editOnDoubleClick();
          return this.container;
      }
  }
  // class LineAnnotationElement extends AnnotationElement {
  //     #line = null;
  //     constructor(parameters) {
  //         super(parameters, { isRenderable: true, ignoreBorder: true });
  //     }
  //     render() {
  //         this.container.classList.add("lineAnnotation");
  //         // Create an invisible line with the same starting and ending coordinates
  //         // that acts as the trigger for the popup. Only the line itself should
  //         // trigger the popup, not the entire container.
  //         const data = this.data;
  //         const { width, height } = getRectDims(data.rect);
  //         const svg = this.svgFactory.create(
  //             width,
  //             height,
  //             /* skipDimensions = */ true
  //         );
  //         // PDF coordinates are calculated from a bottom left origin, so transform
  //         // the line coordinates to a top left origin for the SVG element.
  //         const line = (this.#line = this.svgFactory.createElement("svg:line"));
  //         line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
  //         line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
  //         line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
  //         line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
  //         // Ensure that the 'stroke-width' is always non-zero, since otherwise it
  //         // won't be possible to open/close the popup (note e.g. issue 11122).
  //         line.setAttribute("stroke-width", data.borderStyle.width || 1);
  //         line.setAttribute("stroke", "transparent");
  //         line.setAttribute("fill", "transparent");
  //         svg.append(line);
  //         this.container.append(svg);
  //         // Create the popup ourselves so that we can bind it to the line instead
  //         // of to the entire container (which is the default).
  //         if (!data.popupRef && this.hasPopupData) {
  //             this._createPopup();
  //         }
  //         return this.container;
  //     }
  //     getElementsToTriggerPopup() {
  //         return this.#line;
  //     }
  //     addHighlightArea() {
  //         this.container.classList.add("highlightArea");
  //     }
  // }
  // class SquareAnnotationElement extends AnnotationElement {
  //     #square = null;
  //     constructor(parameters) {
  //         super(parameters, { isRenderable: true, ignoreBorder: true });
  //     }
  //     render() {
  //         this.container.classList.add("squareAnnotation");
  //         // Create an invisible square with the same rectangle that acts as the
  //         // trigger for the popup. Only the square itself should trigger the
  //         // popup, not the entire container.
  //         const data = this.data;
  //         const { width, height } = getRectDims(data.rect);
  //         const svg = this.svgFactory.create(
  //             width,
  //             height,
  //             /* skipDimensions = */ true
  //         );
  //         // The browser draws half of the borders inside the square and half of
  //         // the borders outside the square by default. This behavior cannot be
  //         // changed programmatically, so correct for that here.
  //         const borderWidth = data.borderStyle.width;
  //         const square = (this.#square = this.svgFactory.createElement("svg:rect"));
  //         square.setAttribute("x", borderWidth / 2);
  //         square.setAttribute("y", borderWidth / 2);
  //         square.setAttribute("width", width - borderWidth);
  //         square.setAttribute("height", height - borderWidth);
  //         // Ensure that the 'stroke-width' is always non-zero, since otherwise it
  //         // won't be possible to open/close the popup (note e.g. issue 11122).
  //         square.setAttribute("stroke-width", borderWidth || 1);
  //         square.setAttribute("stroke", "transparent");
  //         square.setAttribute("fill", "transparent");
  //         svg.append(square);
  //         this.container.append(svg);
  //         // Create the popup ourselves so that we can bind it to the square instead
  //         // of to the entire container (which is the default).
  //         if (!data.popupRef && this.hasPopupData) {
  //             this._createPopup();
  //         }
  //         return this.container;
  //     }
  //     getElementsToTriggerPopup() {
  //         return this.#square;
  //     }
  //     addHighlightArea() {
  //         this.container.classList.add("highlightArea");
  //     }
  // }
  // class CircleAnnotationElement extends AnnotationElement {
  //     #circle = null;
  //     constructor(parameters) {
  //         super(parameters, { isRenderable: true, ignoreBorder: true });
  //     }
  //     render() {
  //         this.container.classList.add("circleAnnotation");
  //         // Create an invisible circle with the same ellipse that acts as the
  //         // trigger for the popup. Only the circle itself should trigger the
  //         // popup, not the entire container.
  //         const data = this.data;
  //         const { width, height } = getRectDims(data.rect);
  //         const svg = this.svgFactory.create(
  //             width,
  //             height,
  //             /* skipDimensions = */ true
  //         );
  //         // The browser draws half of the borders inside the circle and half of
  //         // the borders outside the circle by default. This behavior cannot be
  //         // changed programmatically, so correct for that here.
  //         const borderWidth = data.borderStyle.width;
  //         const circle = (this.#circle =
  //             this.svgFactory.createElement("svg:ellipse"));
  //         circle.setAttribute("cx", width / 2);
  //         circle.setAttribute("cy", height / 2);
  //         circle.setAttribute("rx", width / 2 - borderWidth / 2);
  //         circle.setAttribute("ry", height / 2 - borderWidth / 2);
  //         // Ensure that the 'stroke-width' is always non-zero, since otherwise it
  //         // won't be possible to open/close the popup (note e.g. issue 11122).
  //         circle.setAttribute("stroke-width", borderWidth || 1);
  //         circle.setAttribute("stroke", "transparent");
  //         circle.setAttribute("fill", "transparent");
  //         svg.append(circle);
  //         this.container.append(svg);
  //         // Create the popup ourselves so that we can bind it to the circle instead
  //         // of to the entire container (which is the default).
  //         if (!data.popupRef && this.hasPopupData) {
  //             this._createPopup();
  //         }
  //         return this.container;
  //     }
  //     getElementsToTriggerPopup() {
  //         return this.#circle;
  //     }
  //     addHighlightArea() {
  //         this.container.classList.add("highlightArea");
  //     }
  // }
  // class PolylineAnnotationElement extends AnnotationElement {
  //     // todo: props
  //     containerClassName: any = null;
  //     svgElementName: any = null;
  //     // todo: props
  //     #polyline = null;
  //     constructor(parameters) {
  //         super(parameters, { isRenderable: true, ignoreBorder: true });
  //         this.containerClassName = "polylineAnnotation";
  //         this.svgElementName = "svg:polyline";
  //     }
  //     render() {
  //         this.container.classList.add(this.containerClassName);
  //         // Create an invisible polyline with the same points that acts as the
  //         // trigger for the popup. Only the polyline itself should trigger the
  //         // popup, not the entire container.
  //         const {
  //             data: { rect, vertices, borderStyle, popupRef },
  //         } = this;
  //         if (!vertices) {
  //             return this.container;
  //         }
  //         const { width, height } = getRectDims(rect);
  //         const svg = this.svgFactory.create(
  //             width,
  //             height,
  //             /* skipDimensions = */ true
  //         );
  //         // Convert the vertices array to a single points string that the SVG
  //         // polyline element expects ("x1,y1 x2,y2 ..."). PDF coordinates are
  //         // calculated from a bottom left origin, so transform the polyline
  //         // coordinates to a top left origin for the SVG element.
  //         const pointsArray = [];
  //         for (let i = 0, ii = vertices.length; i < ii; i += 2) {
  //             const x = vertices[i] - rect[0];
  //             const y = rect[3] - vertices[i + 1];
  //             pointsArray.push(`${x},${y}`);
  //         }
  //         const points = pointsArray.join(" ");
  //         const polyline = (this.#polyline = this.svgFactory.createElement(
  //             this.svgElementName
  //         ));
  //         polyline.setAttribute("points", points);
  //         // Ensure that the 'stroke-width' is always non-zero, since otherwise it
  //         // won't be possible to open/close the popup (note e.g. issue 11122).
  //         polyline.setAttribute("stroke-width", borderStyle.width || 1);
  //         polyline.setAttribute("stroke", "transparent");
  //         polyline.setAttribute("fill", "transparent");
  //         svg.append(polyline);
  //         this.container.append(svg);
  //         // Create the popup ourselves so that we can bind it to the polyline
  //         // instead of to the entire container (which is the default).
  //         if (!popupRef && this.hasPopupData) {
  //             this._createPopup();
  //         }
  //         return this.container;
  //     }
  //     getElementsToTriggerPopup() {
  //         return this.#polyline;
  //     }
  //     addHighlightArea() {
  //         this.container.classList.add("highlightArea");
  //     }
  // }
  // class PolygonAnnotationElement extends PolylineAnnotationElement {
  //     constructor(parameters) {
  //         // Polygons are specific forms of polylines, so reuse their logic.
  //         super(parameters);
  //         this.containerClassName = "polygonAnnotation";
  //         this.svgElementName = "svg:polygon";
  //     }
  // }
  // class CaretAnnotationElement extends AnnotationElement {
  //     constructor(parameters) {
  //         super(parameters, { isRenderable: true, ignoreBorder: true });
  //     }
  //     render() {
  //         this.container.classList.add("caretAnnotation");
  //         if (!this.data.popupRef && this.hasPopupData) {
  //             this._createPopup();
  //         }
  //         return this.container;
  //     }
  // }
  // class InkAnnotationElement extends AnnotationElement {
  //     // todo: props
  //     containerClassName: any = null;
  //     svgElementName: any = null;
  //     // todo: props
  //     #polylines = [];
  //     constructor(parameters) {
  //         super(parameters, { isRenderable: true, ignoreBorder: true });
  //         this.containerClassName = "inkAnnotation";
  //         // Use the polyline SVG element since it allows us to use coordinates
  //         // directly and to draw both straight lines and curves.
  //         this.svgElementName = "svg:polyline";
  //         this.annotationEditorType = AnnotationEditorType.INK;
  //     }
  //     render() {
  //         this.container.classList.add(this.containerClassName);
  //         // Create an invisible polyline with the same points that acts as the
  //         // trigger for the popup.
  //         const {
  //             data: { rect, inkLists, borderStyle, popupRef },
  //         } = this;
  //         const { width, height } = getRectDims(rect);
  //         const svg = this.svgFactory.create(
  //             width,
  //             height,
  //             /* skipDimensions = */ true
  //         );
  //         for (const inkList of inkLists) {
  //             // Convert the ink list to a single points string that the SVG
  //             // polyline element expects ("x1,y1 x2,y2 ..."). PDF coordinates are
  //             // calculated from a bottom left origin, so transform the polyline
  //             // coordinates to a top left origin for the SVG element.
  //             const pointsArray = [];
  //             for (let i = 0, ii = inkList.length; i < ii; i += 2) {
  //                 const x = inkList[i] - rect[0];
  //                 const y = rect[3] - inkList[i + 1];
  //                 pointsArray.push(`${x},${y}`);
  //             }
  //             const points = pointsArray.join(" ");
  //             const polyline = this.svgFactory.createElement(this.svgElementName);
  //             this.#polylines.push(polyline);
  //             polyline.setAttribute("points", points);
  //             // Ensure that the 'stroke-width' is always non-zero, since otherwise it
  //             // won't be possible to open/close the popup (note e.g. issue 11122).
  //             polyline.setAttribute("stroke-width", borderStyle.width || 1);
  //             polyline.setAttribute("stroke", "transparent");
  //             polyline.setAttribute("fill", "transparent");
  //             // Create the popup ourselves so that we can bind it to the polyline
  //             // instead of to the entire container (which is the default).
  //             if (!popupRef && this.hasPopupData) {
  //                 this._createPopup();
  //             }
  //             svg.append(polyline);
  //         }
  //         this.container.append(svg);
  //         return this.container;
  //     }
  //     getElementsToTriggerPopup() {
  //         return this.#polylines;
  //     }
  //     addHighlightArea() {
  //         this.container.classList.add("highlightArea");
  //     }
  // }
  class HighlightAnnotationElement extends AnnotationElement {
      constructor(parameters) {
          super(parameters, {
              isRenderable: true,
              ignoreBorder: true,
              createQuadrilaterals: true
          });
      }
      render() {
          // if (!this.data.popupRef && this.hasPopupData) {
          //     this._createPopup();
          // }
          // this.container.classList.add("highlightAnnotation");
          this.container.classList.add("k-highlight-annotation");
          return this.container;
      }
  }
  // class UnderlineAnnotationElement extends AnnotationElement {
  //     constructor(parameters) {
  //         super(parameters, {
  //             isRenderable: true,
  //             ignoreBorder: true,
  //             createQuadrilaterals: true,
  //         });
  //     }
  //     render() {
  //         if (!this.data.popupRef && this.hasPopupData) {
  //             this._createPopup();
  //         }
  //         this.container.classList.add("underlineAnnotation");
  //         return this.container;
  //     }
  // }
  // class SquigglyAnnotationElement extends AnnotationElement {
  //     constructor(parameters) {
  //         super(parameters, {
  //             isRenderable: true,
  //             ignoreBorder: true,
  //             createQuadrilaterals: true,
  //         });
  //     }
  //     render() {
  //         if (!this.data.popupRef && this.hasPopupData) {
  //             this._createPopup();
  //         }
  //         this.container.classList.add("squigglyAnnotation");
  //         return this.container;
  //     }
  // }
  // class StrikeOutAnnotationElement extends AnnotationElement {
  //     constructor(parameters) {
  //         super(parameters, {
  //             isRenderable: true,
  //             ignoreBorder: true,
  //             createQuadrilaterals: true,
  //         });
  //     }
  //     render() {
  //         if (!this.data.popupRef && this.hasPopupData) {
  //             this._createPopup();
  //         }
  //         this.container.classList.add("strikeoutAnnotation");
  //         return this.container;
  //     }
  // }
  // class StampAnnotationElement extends AnnotationElement {
  //     constructor(parameters) {
  //         super(parameters, { isRenderable: true, ignoreBorder: true });
  //     }
  //     render() {
  //         this.container.classList.add("stampAnnotation");
  //         if (!this.data.popupRef && this.hasPopupData) {
  //             this._createPopup();
  //         }
  //         return this.container;
  //     }
  // }
  // class FileAttachmentAnnotationElement extends AnnotationElement {
  //     // todo: props
  //     filename: any = null;
  //     content: any = null;
  //     // todo: props
  //     #trigger = null;
  //     constructor(parameters) {
  //         super(parameters, { isRenderable: true });
  //         const { file } = this.data;
  //         this.filename = file.filename;
  //         this.content = file.content;
  //         this.linkService.eventBus?.dispatch("fileattachmentannotation", {
  //             source: this,
  //             ...file,
  //         });
  //     }
  //     render() {
  //         this.container.classList.add("fileAttachmentAnnotation");
  //         const { container, data } = this;
  //         let trigger;
  //         if (data.hasAppearance || data.fillAlpha === 0) {
  //             trigger = document.createElement("div");
  //         } else {
  //             // Unfortunately it seems that it's not clearly specified exactly what
  //             // names are actually valid, since Table 184 contains:
  //             //   Conforming readers shall provide predefined icon appearances for at
  //             //   least the following standard names: GraphPushPin, PaperclipTag.
  //             //   Additional names may be supported as well. Default value: PushPin.
  //             trigger = document.createElement("img");
  //             trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ?
  //                 "paperclip" : "pushpin"}.svg`;
  //             if (data.fillAlpha && data.fillAlpha < 1) {
  //                 trigger.style = `filter: opacity(${Math.round(
  //                     data.fillAlpha * 100
  //                 )}%);`;
  //                 // todo: debug
  //                 // if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("TESTING")) {
  //                 //     this.container.classList.add("hasFillAlpha");
  //                 // }
  //             }
  //         }
  //         trigger.addEventListener("dblclick", this.#download.bind(this));
  //         this.#trigger = trigger;
  //         const { isMac } = FeatureTest.platform;
  //         container.addEventListener("keydown", evt => {
  //             if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) {
  //                 this.#download();
  //             }
  //         });
  //         if (!data.popupRef && this.hasPopupData) {
  //             this._createPopup();
  //         } else {
  //             trigger.classList.add("popupTriggerArea");
  //         }
  //         container.append(trigger);
  //         return container;
  //     }
  //     getElementsToTriggerPopup() {
  //         return this.#trigger;
  //     }
  //     addHighlightArea() {
  //         this.container.classList.add("highlightArea");
  //     }
  //     /**
  //      * Download the file attachment associated with this annotation.
  //      */
  //     #download() {
  //         this.downloadManager?.openOrDownloadData(this.content, this.filename);
  //     }
  // }
  /**
   * Manage the layer containing all the annotations.
   */
  class AnnotationLayer {
      constructor({ div, accessibilityManager, annotationCanvasMap, annotationEditorUIManager, page, viewport }) {
          _AnnotationLayer_instances.add(this);
          this.div = null;
          this.page = null;
          this.viewport = null;
          this.zIndex = null;
          this._annotationEditorUIManager = null;
          _AnnotationLayer_accessibilityManager.set(this, null);
          _AnnotationLayer_annotationCanvasMap.set(this, null);
          _AnnotationLayer_editableAnnotations.set(this, new Map());
          this.div = div;
          __classPrivateFieldSet(this, _AnnotationLayer_accessibilityManager, accessibilityManager, "f");
          __classPrivateFieldSet(this, _AnnotationLayer_annotationCanvasMap, annotationCanvasMap, "f");
          this.page = page;
          this.viewport = viewport;
          this.zIndex = 0;
          this._annotationEditorUIManager = annotationEditorUIManager;
          // if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("TESTING")) {
          //     // For testing purposes.
          //     Object.defineProperty(this, "showPopups", {
          //         value: async () => {
          //             for (const show of this.popupShow) {
          //                 await show();
          //             }
          //         },
          //     });
          //     this.popupShow = [];
          // }
      }
      // todo: ported from AnnotationLayerBuilder
      hide() {
          if (!this.div) {
              return;
          }
          this.div.hidden = true;
      }
      // todo: ported from AnnotationLayerBuilder
      hasEditableAnnotations() {
          return __classPrivateFieldGet(this, _AnnotationLayer_editableAnnotations, "f").size > 0;
      }
      /**
       * Render a new annotation layer with all annotation elements.
       *
       * @param {AnnotationLayerParameters} params
       * @memberof AnnotationLayer
       */
      // async render(params) {
      render(params) {
          var _a;
          const { annotations } = params;
          const layer = this.div;
          kendo_pdfjs_loader_js.setLayerDimensions(layer, this.viewport);
          const popupToElements = new Map();
          const elementParams = {
              data: null,
              layer,
              linkService: params.linkService,
              downloadManager: params.downloadManager,
              imageResourcesPath: params.imageResourcesPath || "",
              renderForms: params.renderForms !== false,
              svgFactory: new kendo_pdfjs_loader_js.DOMSVGFactory(),
              annotationStorage: params.annotationStorage || new AnnotationStorage(),
              enableScripting: params.enableScripting === true,
              hasJSActions: params.hasJSActions,
              fieldObjects: params.fieldObjects,
              parent: this,
              elements: null
          };
          for (const data of annotations) {
              if (data.noHTML) {
                  continue;
              }
              const isPopupAnnotation = data.annotationType === AnnotationType.POPUP;
              if (!isPopupAnnotation) {
                  const { width, height } = getRectDims(data.rect);
                  if (width <= 0 || height <= 0) {
                      continue; // Ignore empty annotations.
                  }
              }
              else {
                  const elements = popupToElements.get(data.id);
                  if (!elements) {
                      // Ignore popup annotations without a corresponding annotation.
                      continue;
                  }
                  elementParams.elements = elements;
              }
              elementParams.data = data;
              const element = AnnotationElementFactory.create(elementParams);
              if (!element.isRenderable) {
                  continue;
              }
              if (!isPopupAnnotation && data.popupRef) {
                  const elements = popupToElements.get(data.popupRef);
                  if (!elements) {
                      popupToElements.set(data.popupRef, [element]);
                  }
                  else {
                      elements.push(element);
                  }
              }
              const rendered = element.render();
              if (data.hidden) {
                  rendered.style.visibility = "hidden";
              }
              __classPrivateFieldGet(this, _AnnotationLayer_instances, "m", _AnnotationLayer_appendElement).call(this, rendered, data.id);
              if (element._isEditable) {
                  __classPrivateFieldGet(this, _AnnotationLayer_editableAnnotations, "f").set(element.data.id, element);
                  (_a = this._annotationEditorUIManager) === null || _a === void 0 ? void 0 : _a.renderAnnotationElement(element);
              }
          }
          __classPrivateFieldGet(this, _AnnotationLayer_instances, "m", _AnnotationLayer_setAnnotationCanvasMap).call(this);
      }
      /**
       * Update the annotation elements on existing annotation layer.
       *
       * @param {AnnotationLayerParameters} viewport
       * @memberof AnnotationLayer
       */
      update({ viewport }) {
          const layer = this.div;
          this.viewport = viewport;
          // setLayerDimensions(layer, { rotation: viewport.rotation });
          kendo_pdfjs_loader_js.setLayerDimensions(layer, viewport);
          __classPrivateFieldGet(this, _AnnotationLayer_instances, "m", _AnnotationLayer_setAnnotationCanvasMap).call(this);
          layer.hidden = false;
      }
      getEditableAnnotations() {
          return Array.from(__classPrivateFieldGet(this, _AnnotationLayer_editableAnnotations, "f").values());
      }
      getEditableAnnotation(id) {
          return __classPrivateFieldGet(this, _AnnotationLayer_editableAnnotations, "f").get(id);
      }
      destroy() {
          var _a, _b;
          (_a = __classPrivateFieldGet(this, _AnnotationLayer_annotationCanvasMap, "f")) === null || _a === void 0 ? void 0 : _a.clear();
          (_b = this.div) === null || _b === void 0 ? void 0 : _b.remove();
          this.div = null;
      }
  }
  _AnnotationLayer_accessibilityManager = new WeakMap(), _AnnotationLayer_annotationCanvasMap = new WeakMap(), _AnnotationLayer_editableAnnotations = new WeakMap(), _AnnotationLayer_instances = new WeakSet(), _AnnotationLayer_appendElement = function _AnnotationLayer_appendElement(element, id) {
      var _a;
      const contentElement = element.firstChild || element;
      contentElement.id = `${AnnotationPrefix}${id}`;
      this.div.append(element);
      (_a = __classPrivateFieldGet(this, _AnnotationLayer_accessibilityManager, "f")) === null || _a === void 0 ? void 0 : _a.moveElementInDOM(this.div, element, contentElement, 
      /* isRemovable = */ false);
  }, _AnnotationLayer_setAnnotationCanvasMap = function _AnnotationLayer_setAnnotationCanvasMap() {
      if (!__classPrivateFieldGet(this, _AnnotationLayer_annotationCanvasMap, "f")) {
          return;
      }
      const layer = this.div;
      for (const [id, canvas] of __classPrivateFieldGet(this, _AnnotationLayer_annotationCanvasMap, "f")) {
          const element = layer.querySelector(`[data-annotation-id="${id}"]`);
          if (!element) {
              continue;
          }
          canvas.className = "annotationContent k-annotation-content";
          const { firstChild } = element;
          if (!firstChild) {
              element.append(canvas);
          }
          else if (firstChild.nodeName === "CANVAS") {
              firstChild.replaceWith(canvas);
          }
          else if (!firstChild.classList.contains("annotationContent") ||
              !firstChild.classList.contains("k-annotation-content")) {
              firstChild.before(canvas);
          }
          else {
              firstChild.after(canvas);
          }
      }
      __classPrivateFieldGet(this, _AnnotationLayer_annotationCanvasMap, "f").clear();
  };

  /* Copyright 2014 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _AnnotationLayerBuilder_instances, _AnnotationLayerBuilder_onAppend, _AnnotationLayerBuilder_eventAbortController, _AnnotationLayerBuilder_updatePresentationModeState;
  // import { PresentationModeState } from "./shared/ui_utils";
  /**
   * @typedef {Object} AnnotationLayerBuilderOptions
   * @property {PDFPageProxy} pdfPage
   * @property {AnnotationStorage} [annotationStorage]
   * @property {string} [imageResourcesPath] - Path for image resources, mainly
   *   for annotation icons. Include trailing slash.
   * @property {boolean} renderForms
   * @property {IPDFLinkService} linkService
   * @property {IDownloadManager} [downloadManager]
   * @property {boolean} [enableScripting]
   * @property {Promise<boolean>} [hasJSActionsPromise]
   * @property {Promise<Object<string, Array<Object>> | null>}
   *   [fieldObjectsPromise]
   * @property {Map<string, HTMLCanvasElement>} [annotationCanvasMap]
   * @property {TextAccessibilityManager} [accessibilityManager]
   * @property {AnnotationEditorUIManager} [annotationEditorUIManager]
   * @property {function} [onAppend]
   */
  class AnnotationLayerBuilder {
      /**
       * @param {AnnotationLayerBuilderOptions} options
       */
      constructor({ pdfPage, eventBus, linkService = null, 
      // downloadManager,
      annotationStorage = null, 
      // imageResourcesPath = "",
      renderForms = true, 
      // enableScripting = false,
      // hasJSActionsPromise = null,
      // fieldObjectsPromise = null,
      annotationCanvasMap = null, accessibilityManager = null, annotationEditorUIManager = null, onAppend = null }) {
          _AnnotationLayerBuilder_instances.add(this);
          // todo: props ported from pdf.js
          this.annotationLayer = null;
          this.pdfPage = null;
          this.linkService = null;
          this.annotationStorage = null;
          this._annotationCanvasMap = null;
          this._annotationEditorUIManager = null;
          this.div = null;
          this._cancelled = null;
          this._eventBus = null;
          this._accessibilityManager = null;
          // todo: props ported from pdf.js
          _AnnotationLayerBuilder_onAppend.set(this, null);
          _AnnotationLayerBuilder_eventAbortController.set(this, null);
          this.renderForms = null;
          this.pdfPage = pdfPage;
          this.linkService = linkService;
          // this.downloadManager = downloadManager;
          // this.imageResourcesPath = imageResourcesPath;
          this.renderForms = renderForms;
          this.annotationStorage = annotationStorage;
          // this.enableScripting = enableScripting;
          // this._hasJSActionsPromise = hasJSActionsPromise || Promise.resolve(false);
          // this._fieldObjectsPromise = fieldObjectsPromise || Promise.resolve(null);
          this._annotationCanvasMap = annotationCanvasMap;
          this._accessibilityManager = accessibilityManager;
          this._annotationEditorUIManager = annotationEditorUIManager;
          __classPrivateFieldSet(this, _AnnotationLayerBuilder_onAppend, onAppend, "f");
          this.annotationLayer = null;
          this.div = null;
          this._cancelled = false;
          this._eventBus = (linkService === null || linkService === void 0 ? void 0 : linkService.eventBus) || eventBus;
      }
      /**
       * @param {PageViewport} viewport
       * @param {string} intent (default value is 'display')
       * @returns {Promise<void>} A promise that is resolved when rendering of the
       *   annotations is complete.
       */
      render(viewport_1) {
          return __awaiter(this, arguments, void 0, function* (viewport, intent = "display") {
              var _a, _b, _c;
              if (this.div) {
                  if (this._cancelled || !this.annotationLayer) {
                      return;
                  }
                  // If an annotationLayer already exists, refresh its children's
                  // transformation matrices.
                  this.annotationLayer.update({
                      viewport: viewport.clone({ dontFlip: true })
                  });
                  return;
              }
              // const [annotations, hasJSActions, fieldObjects] = await Promise.all([
              const [annotations] = yield Promise.all([
                  this.pdfPage.getAnnotations({ intent })
                  // this._hasJSActionsPromise,
                  // this._fieldObjectsPromise,
              ]);
              if (this._cancelled) {
                  return;
              }
              // Create an annotation layer div and render the annotations
              // if there is at least one annotation.
              // const div = (this.div = document.createElement("div"));
              // div.className = "annotationLayer";
              // this.#onAppend?.(div);
              if (annotations.length === 0) {
                  this.hide();
                  return;
              }
              const page = this.pdfPage;
              const pageView = (_a = page._pageInfo) === null || _a === void 0 ? void 0 : _a.view;
              const pageWidthAnnotationLayer = (pageView[2] || 0) + "px";
              const pageHeightAnnotationLayer = (pageView[3] || 0) + "px";
              const div = convertToHtml(`
            <div class="k-annotation-layer"
                 data-main-rotation="0"
                 style="width: round(var(--scale-factor) * ${pageWidthAnnotationLayer}, 1px);
                        height: round(var(--scale-factor) * ${pageHeightAnnotationLayer}, 1px);">
            </div>
        `);
              this.div = div;
              (_b = __classPrivateFieldGet(this, _AnnotationLayerBuilder_onAppend, "f")) === null || _b === void 0 ? void 0 : _b.call(this, div);
              this.annotationLayer = new AnnotationLayer({
                  div,
                  accessibilityManager: this._accessibilityManager,
                  // accessibilityManager: null,
                  annotationCanvasMap: this._annotationCanvasMap,
                  annotationEditorUIManager: this._annotationEditorUIManager,
                  page: this.pdfPage,
                  viewport: viewport.clone({ dontFlip: true })
              });
              yield this.annotationLayer.render({
                  annotations,
                  // imageResourcesPath: this.imageResourcesPath,
                  renderForms: this.renderForms,
                  linkService: this.linkService,
                  // downloadManager: this.downloadManager,
                  annotationStorage: this.annotationStorage
                  // enableScripting: this.enableScripting,
                  // hasJSActions,
                  // fieldObjects,
              });
              // Ensure that interactive form elements in the annotationLayer are
              // disabled while PresentationMode is active (see issue 12232).
              if (this.linkService.isInPresentationMode) {
                  __classPrivateFieldGet(this, _AnnotationLayerBuilder_instances, "m", _AnnotationLayerBuilder_updatePresentationModeState).call(this, PresentationModeState.FULLSCREEN);
              }
              if (!__classPrivateFieldGet(this, _AnnotationLayerBuilder_eventAbortController, "f")) {
                  __classPrivateFieldSet(this, _AnnotationLayerBuilder_eventAbortController, new AbortController(), "f");
                  (_c = this._eventBus) === null || _c === void 0 ? void 0 : _c._on("presentationmodechanged", evt => {
                      __classPrivateFieldGet(this, _AnnotationLayerBuilder_instances, "m", _AnnotationLayerBuilder_updatePresentationModeState).call(this, evt.state);
                  }, { signal: __classPrivateFieldGet(this, _AnnotationLayerBuilder_eventAbortController, "f").signal });
              }
          });
      }
      cancel() {
          var _a;
          this._cancelled = true;
          (_a = __classPrivateFieldGet(this, _AnnotationLayerBuilder_eventAbortController, "f")) === null || _a === void 0 ? void 0 : _a.abort();
          __classPrivateFieldSet(this, _AnnotationLayerBuilder_eventAbortController, null, "f");
      }
      hide() {
          if (!this.div) {
              return;
          }
          this.div.hidden = true;
      }
      hasEditableAnnotations() {
          var _a;
          return !!((_a = this.annotationLayer) === null || _a === void 0 ? void 0 : _a.hasEditableAnnotations());
      }
      destroy() {
          var _a, _b, _c;
          this.cancel();
          (_a = this.annotationLayer) === null || _a === void 0 ? void 0 : _a.destroy();
          this.annotationLayer = null;
          (_b = __classPrivateFieldGet(this, _AnnotationLayerBuilder_eventAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
          __classPrivateFieldSet(this, _AnnotationLayerBuilder_eventAbortController, null, "f");
          (_c = this.div) === null || _c === void 0 ? void 0 : _c.remove();
          this.div = null;
      }
  }
  _AnnotationLayerBuilder_onAppend = new WeakMap(), _AnnotationLayerBuilder_eventAbortController = new WeakMap(), _AnnotationLayerBuilder_instances = new WeakSet(), _AnnotationLayerBuilder_updatePresentationModeState = function _AnnotationLayerBuilder_updatePresentationModeState(state) {
      if (!this.div) {
          return;
      }
      let disableFormElements = false;
      switch (state) {
          case PresentationModeState.FULLSCREEN:
              disableFormElements = true;
              break;
          case PresentationModeState.NORMAL:
              break;
          default:
              return;
      }
      for (const section of this.div.childNodes) {
          if (section.hasAttribute("data-internal-link")) {
              continue;
          }
          section.inert = disableFormElements;
      }
  };

  /* Copyright 2023 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _DrawLayer_instances, _a$5, _DrawLayer_parent, _DrawLayer_id, _DrawLayer_mapping, _DrawLayer_toUpdate, _DrawLayer_setBox, _DrawLayer_createSVG, _DrawLayer_createClipPath;
  /**
   * Manage the SVGs drawn on top of the page canvas.
   * It's important to have them directly on top of the canvas because we want to
   * be able to use mix-blend-mode for some of them.
   */
  class DrawLayer {
      constructor({ pageIndex }) {
          _DrawLayer_instances.add(this);
          // todo: props
          this.pageIndex = 0;
          // todo: props
          _DrawLayer_parent.set(this, null);
          _DrawLayer_id.set(this, 0);
          _DrawLayer_mapping.set(this, new Map());
          _DrawLayer_toUpdate.set(this, new Map());
          this.pageIndex = pageIndex;
      }
      setParent(parent) {
          if (!__classPrivateFieldGet(this, _DrawLayer_parent, "f")) {
              __classPrivateFieldSet(this, _DrawLayer_parent, parent, "f");
              return;
          }
          if (__classPrivateFieldGet(this, _DrawLayer_parent, "f") !== parent) {
              if (__classPrivateFieldGet(this, _DrawLayer_mapping, "f").size > 0) {
                  for (const root of __classPrivateFieldGet(this, _DrawLayer_mapping, "f").values()) {
                      root.remove();
                      parent.append(root);
                  }
              }
              __classPrivateFieldSet(this, _DrawLayer_parent, parent, "f");
          }
      }
      static get _svgFactory() {
          return kendo_pdfjs_loader_js.shadow(this, "_svgFactory", new kendo_pdfjs_loader_js.DOMSVGFactory());
      }
      highlight(outlines, color, opacity, isPathUpdatable = false) {
          var _b, _c;
          const id = (__classPrivateFieldSet(this, _DrawLayer_id, (_c = __classPrivateFieldGet(this, _DrawLayer_id, "f"), _b = _c++, _c), "f"), _b);
          const root = __classPrivateFieldGet(this, _DrawLayer_instances, "m", _DrawLayer_createSVG).call(this, outlines.box);
          // root.classList.add("highlight");
          root.classList.add("k-highlight");
          if (outlines.free) {
              // root.classList.add("free");
          }
          const defs = _a$5._svgFactory.createElement("defs");
          root.append(defs);
          const path = _a$5._svgFactory.createElement("path");
          defs.append(path);
          const pathId = `path_p${this.pageIndex}_${id}`;
          path.setAttribute("id", pathId);
          path.setAttribute("d", outlines.toSVGPath());
          if (isPathUpdatable) {
              __classPrivateFieldGet(this, _DrawLayer_toUpdate, "f").set(id, path);
          }
          // Create the clipping path for the editor div.
          const clipPathId = __classPrivateFieldGet(this, _DrawLayer_instances, "m", _DrawLayer_createClipPath).call(this, defs, pathId);
          const use = _a$5._svgFactory.createElement("use");
          root.append(use);
          root.setAttribute("fill", color);
          root.setAttribute("fill-opacity", opacity);
          use.setAttribute("href", `#${pathId}`);
          __classPrivateFieldGet(this, _DrawLayer_mapping, "f").set(id, root);
          return { id, clipPathId: `url(#${clipPathId})` };
      }
      highlightOutline(outlines) {
          var _b, _c;
          // We cannot draw the outline directly in the SVG for highlights because
          // it composes with its parent with mix-blend-mode: multiply.
          // But the outline has a different mix-blend-mode, so we need to draw it in
          // its own SVG.
          const id = (__classPrivateFieldSet(this, _DrawLayer_id, (_c = __classPrivateFieldGet(this, _DrawLayer_id, "f"), _b = _c++, _c), "f"), _b);
          const root = __classPrivateFieldGet(this, _DrawLayer_instances, "m", _DrawLayer_createSVG).call(this, outlines.box);
          // root.classList.add("highlightOutline");
          root.classList.add("k-highlight-outline");
          const defs = _a$5._svgFactory.createElement("defs");
          root.append(defs);
          const path = _a$5._svgFactory.createElement("path");
          defs.append(path);
          const pathId = `path_p${this.pageIndex}_${id}`;
          path.setAttribute("id", pathId);
          path.setAttribute("d", outlines.toSVGPath());
          path.setAttribute("vector-effect", "non-scaling-stroke");
          let maskId;
          if (outlines.free) {
              // root.classList.add("free");
              const mask = _a$5._svgFactory.createElement("mask");
              defs.append(mask);
              maskId = `mask_p${this.pageIndex}_${id}`;
              mask.setAttribute("id", maskId);
              mask.setAttribute("maskUnits", "objectBoundingBox");
              const rect = _a$5._svgFactory.createElement("rect");
              mask.append(rect);
              rect.setAttribute("width", "1");
              rect.setAttribute("height", "1");
              rect.setAttribute("fill", "white");
              const use = _a$5._svgFactory.createElement("use");
              mask.append(use);
              use.setAttribute("href", `#${pathId}`);
              use.setAttribute("stroke", "none");
              use.setAttribute("fill", "black");
              use.setAttribute("fill-rule", "nonzero");
              // use.classList.add("mask");
          }
          const use1 = _a$5._svgFactory.createElement("use");
          root.append(use1);
          use1.setAttribute("href", `#${pathId}`);
          if (maskId) {
              use1.setAttribute("mask", `url(#${maskId})`);
          }
          const use2 = use1.cloneNode();
          root.append(use2);
          // use1.classList.add("mainOutline");
          // use2.classList.add("secondaryOutline");
          __classPrivateFieldGet(this, _DrawLayer_mapping, "f").set(id, root);
          return id;
      }
      finalizeLine(id, line) {
          const path = __classPrivateFieldGet(this, _DrawLayer_toUpdate, "f").get(id);
          __classPrivateFieldGet(this, _DrawLayer_toUpdate, "f").delete(id);
          this.updateBox(id, line.box);
          path.setAttribute("d", line.toSVGPath());
      }
      updateLine(id, line) {
          const root = __classPrivateFieldGet(this, _DrawLayer_mapping, "f").get(id);
          const defs = root.firstChild;
          const path = defs.firstChild;
          path.setAttribute("d", line.toSVGPath());
      }
      removeFreeHighlight(id) {
          this.remove(id);
          __classPrivateFieldGet(this, _DrawLayer_toUpdate, "f").delete(id);
      }
      updatePath(id, line) {
          __classPrivateFieldGet(this, _DrawLayer_toUpdate, "f").get(id).setAttribute("d", line.toSVGPath());
      }
      updateBox(id, box) {
          __classPrivateFieldGet(_a$5, _a$5, "m", _DrawLayer_setBox).call(_a$5, __classPrivateFieldGet(this, _DrawLayer_mapping, "f").get(id), box);
      }
      show(id, visible) {
          // this.#mapping.get(id).classList.toggle("hidden", !visible);
          __classPrivateFieldGet(this, _DrawLayer_mapping, "f").get(id).classList.toggle("k-hidden", !visible);
      }
      rotate(id, angle) {
          __classPrivateFieldGet(this, _DrawLayer_mapping, "f").get(id).setAttribute("data-main-rotation", angle);
      }
      changeColor(id, color) {
          __classPrivateFieldGet(this, _DrawLayer_mapping, "f").get(id).setAttribute("fill", color);
      }
      changeOpacity(id, opacity) {
          __classPrivateFieldGet(this, _DrawLayer_mapping, "f").get(id).setAttribute("fill-opacity", opacity);
      }
      addClass(id, className) {
          __classPrivateFieldGet(this, _DrawLayer_mapping, "f").get(id).classList.add(className);
      }
      removeClass(id, className) {
          __classPrivateFieldGet(this, _DrawLayer_mapping, "f").get(id).classList.remove(className);
      }
      remove(id) {
          if (__classPrivateFieldGet(this, _DrawLayer_parent, "f") === null) {
              return;
          }
          __classPrivateFieldGet(this, _DrawLayer_mapping, "f").get(id).remove();
          __classPrivateFieldGet(this, _DrawLayer_mapping, "f").delete(id);
      }
      destroy() {
          __classPrivateFieldSet(this, _DrawLayer_parent, null, "f");
          for (const root of __classPrivateFieldGet(this, _DrawLayer_mapping, "f").values()) {
              root.remove();
          }
          __classPrivateFieldGet(this, _DrawLayer_mapping, "f").clear();
      }
  }
  _a$5 = DrawLayer, _DrawLayer_parent = new WeakMap(), _DrawLayer_id = new WeakMap(), _DrawLayer_mapping = new WeakMap(), _DrawLayer_toUpdate = new WeakMap(), _DrawLayer_instances = new WeakSet(), _DrawLayer_setBox = function _DrawLayer_setBox(element, { x = 0, y = 0, width = 1, height = 1 } = {}) {
      const { style } = element;
      style.top = `${100 * y}%`;
      style.left = `${100 * x}%`;
      // style.width = `${100 * width}%`;
      // style.height = `${100 * height}%`;
      // todo: reduce the dimensions, so that the annotation editor toolbar
      // does not overlap the outline
      style.width = `${100 * width - 0.2}%`;
      style.height = `${100 * height - 0.2}%`;
  }, _DrawLayer_createSVG = function _DrawLayer_createSVG(box) {
      const svg = _a$5._svgFactory.create(1, 1, /* skipDimensions = */ true);
      __classPrivateFieldGet(this, _DrawLayer_parent, "f").append(svg);
      svg.setAttribute("aria-hidden", true);
      __classPrivateFieldGet(_a$5, _a$5, "m", _DrawLayer_setBox).call(_a$5, svg, box);
      return svg;
  }, _DrawLayer_createClipPath = function _DrawLayer_createClipPath(defs, pathId) {
      const clipPath = _a$5._svgFactory.createElement("clipPath");
      defs.append(clipPath);
      const clipPathId = `clip_${pathId}`;
      clipPath.setAttribute("id", clipPathId);
      clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
      const clipPathUse = _a$5._svgFactory.createElement("use");
      clipPath.append(clipPathUse);
      clipPathUse.setAttribute("href", `#${pathId}`);
      // clipPathUse.classList.add("clip");
      return clipPathId;
  };

  /* Copyright 2022 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _DrawLayerBuilder_drawLayer;
  /**
   * @typedef {Object} DrawLayerBuilderOptions
   * @property {number} pageIndex
   */
  class DrawLayerBuilder {
      /**
       * @param {DrawLayerBuilderOptions} options
       */
      constructor(options) {
          // todo: props
          this.pageIndex = null;
          this._cancelled = null;
          // todo: props
          _DrawLayerBuilder_drawLayer.set(this, null);
          this.pageIndex = options.pageIndex;
      }
      /**
       * @param {string} intent (default value is 'display')
       */
      render() {
          return __awaiter(this, arguments, void 0, function* (intent = "display") {
              // if (intent !== "display" || this.#drawLayer || this._cancelled) {
              if (intent !== "display" || __classPrivateFieldGet(this, _DrawLayerBuilder_drawLayer, "f")) {
                  return;
              }
              __classPrivateFieldSet(this, _DrawLayerBuilder_drawLayer, new DrawLayer({
                  pageIndex: this.pageIndex
              }), "f");
          });
      }
      cancel() {
          // this._cancelled = true;
          var _a;
          if (!__classPrivateFieldGet(this, _DrawLayerBuilder_drawLayer, "f")) {
              return;
          }
          (_a = __classPrivateFieldGet(this, _DrawLayerBuilder_drawLayer, "f")) === null || _a === void 0 ? void 0 : _a.destroy();
          __classPrivateFieldSet(this, _DrawLayerBuilder_drawLayer, null, "f");
      }
      setParent(parent) {
          var _a;
          (_a = __classPrivateFieldGet(this, _DrawLayerBuilder_drawLayer, "f")) === null || _a === void 0 ? void 0 : _a.setParent(parent);
      }
      getDrawLayer() {
          return __classPrivateFieldGet(this, _DrawLayerBuilder_drawLayer, "f");
      }
      destroy() {
          this.cancel();
      }
  }
  _DrawLayerBuilder_drawLayer = new WeakMap();

  /* Copyright 2022 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _FreeTextEditor_instances, _a$4, _FreeTextEditor_color, _FreeTextEditor_content, _FreeTextEditor_editorDivId, _FreeTextEditor_editModeAC, _FreeTextEditor_fontSize, _FreeTextEditor_initialData, _FreeTextEditor_updateFontSize, _FreeTextEditor_updateColor, _FreeTextEditor_extractText, _FreeTextEditor_setEditorDimensions, _FreeTextEditor_getNodeContent, _FreeTextEditor_setContent, _FreeTextEditor_serializeContent, _FreeTextEditor_deserializeContent, _FreeTextEditor_hasElementChanged;
  // import { FreeTextAnnotationElement } from "../annotation-layer";
  const EOL_PATTERN = /\r\n?|\n/g;
  class FreeTextEditor extends AnnotationEditor {
      constructor(params) {
          super(Object.assign(Object.assign({}, params), { name: "k-free-text-editor freeTextEditor" }));
          _FreeTextEditor_instances.add(this);
          // todo: props
          this.editorDiv = null;
          this.overlayDiv = null;
          // todo: props
          _FreeTextEditor_color.set(this, void 0);
          _FreeTextEditor_content.set(this, "");
          _FreeTextEditor_editorDivId.set(this, `${this.id}-editor`);
          _FreeTextEditor_editModeAC.set(this, null);
          _FreeTextEditor_fontSize.set(this, void 0);
          _FreeTextEditor_initialData.set(this, null);
          __classPrivateFieldSet(this, _FreeTextEditor_color, params.color ||
              _a$4._defaultColor ||
              AnnotationEditor._defaultLineColor, "f");
          __classPrivateFieldSet(this, _FreeTextEditor_fontSize, params.fontSize || _a$4._defaultFontSize, "f");
      }
      /** @inheritdoc */
      static initialize(l10n, uiManager) {
          AnnotationEditor.initialize(l10n, uiManager, {
              strings: ["pdfjs-free-text-default-content"]
          });
          const style = getComputedStyle(document.documentElement);
          // if (typeof PDFJSDev === "undefined" || PDFJSDev.test("TESTING")) {
          //     const lineHeight = parseFloat(
          //         style.getPropertyValue("--freetext-line-height")
          //     );
          //     assert(
          //         lineHeight === LINE_FACTOR,
          //         "Update the CSS variable to agree with the constant."
          //     );
          // }
          // todo: read the variable
          this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding")) || 2;
      }
      /** @inheritdoc */
      static updateDefaultParams(type, value) {
          switch (type) {
              case kendo_pdfjs_loader_js.AnnotationEditorParamsType.FREETEXT_SIZE:
                  _a$4._defaultFontSize = value;
                  break;
              case kendo_pdfjs_loader_js.AnnotationEditorParamsType.FREETEXT_COLOR:
                  _a$4._defaultColor = value;
                  break;
              default: break;
          }
      }
      /** @inheritdoc */
      updateParams(type, value) {
          switch (type) {
              case kendo_pdfjs_loader_js.AnnotationEditorParamsType.FREETEXT_SIZE:
                  __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_updateFontSize).call(this, value);
                  break;
              case kendo_pdfjs_loader_js.AnnotationEditorParamsType.FREETEXT_COLOR:
                  __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_updateColor).call(this, value);
                  break;
              default: break;
          }
      }
      /** @inheritdoc */
      static get defaultPropertiesToUpdate() {
          return [
              [
                  kendo_pdfjs_loader_js.AnnotationEditorParamsType.FREETEXT_SIZE,
                  _a$4._defaultFontSize
              ],
              [
                  kendo_pdfjs_loader_js.AnnotationEditorParamsType.FREETEXT_COLOR,
                  _a$4._defaultColor || AnnotationEditor._defaultLineColor
              ]
          ];
      }
      /** @inheritdoc */
      get propertiesToUpdate() {
          return [
              [kendo_pdfjs_loader_js.AnnotationEditorParamsType.FREETEXT_SIZE, __classPrivateFieldGet(this, _FreeTextEditor_fontSize, "f")],
              [kendo_pdfjs_loader_js.AnnotationEditorParamsType.FREETEXT_COLOR, __classPrivateFieldGet(this, _FreeTextEditor_color, "f")]
          ];
      }
      /**
       * Helper to translate the editor with the keyboard when it's empty.
       * @param {number} x in page units.
       * @param {number} y in page units.
       */
      _translateEmpty(x, y) {
          this._uiManager.translateSelectedEditors(x, y, /* noCommit = */ true);
      }
      getInitialTranslation() {
          // The start of the base line is where the user clicked.
          const scale = this.parentScale;
          return [
              -_a$4._internalPadding * scale,
              -(_a$4._internalPadding + __classPrivateFieldGet(this, _FreeTextEditor_fontSize, "f")) * scale
          ];
      }
      /** @inheritdoc */
      rebuild() {
          if (!this.parent) {
              return;
          }
          super.rebuild();
          if (this.div === null) {
              return;
          }
          if (!this.isAttachedToDOM) {
              // At some point this editor was removed and we're rebuilting it,
              // hence we must add it to its parent.
              this.parent.add(this);
          }
      }
      enableEditMode() {
          if (this.isInEditMode()) {
              return;
          }
          this.parent.setEditingState(false);
          this.parent.updateToolbar(kendo_pdfjs_loader_js.AnnotationEditorType.FREETEXT);
          super.enableEditMode();
          this.overlayDiv.classList.remove("enabled");
          this.editorDiv.contentEditable = true;
          this._isDraggable = false;
          this.div.removeAttribute("aria-activedescendant");
          // if (typeof PDFJSDev === "undefined" || PDFJSDev.test("TESTING")) {
          //     assert(
          //         !this.#editModeAC,
          //         "No `this.#editModeAC` AbortController should exist."
          //     );
          // }
          __classPrivateFieldSet(this, _FreeTextEditor_editModeAC, new AbortController(), "f");
          const signal = this._uiManager.combinedSignal(__classPrivateFieldGet(this, _FreeTextEditor_editModeAC, "f"));
          this.editorDiv.addEventListener("keydown", this.editorDivKeydown.bind(this), { signal });
          this.editorDiv.addEventListener("focus", this.editorDivFocus.bind(this), {
              signal
          });
          this.editorDiv.addEventListener("blur", this.editorDivBlur.bind(this), {
              signal
          });
          this.editorDiv.addEventListener("input", this.editorDivInput.bind(this), {
              signal
          });
          this.editorDiv.addEventListener("paste", this.editorDivPaste.bind(this), {
              signal
          });
      }
      disableEditMode() {
          var _b;
          if (!this.isInEditMode()) {
              return;
          }
          this.parent.setEditingState(true);
          super.disableEditMode();
          // this.overlayDiv.classList.add("enabled");
          this.editorDiv.contentEditable = false;
          this.div.setAttribute("aria-activedescendant", __classPrivateFieldGet(this, _FreeTextEditor_editorDivId, "f"));
          this._isDraggable = true;
          (_b = __classPrivateFieldGet(this, _FreeTextEditor_editModeAC, "f")) === null || _b === void 0 ? void 0 : _b.abort();
          __classPrivateFieldSet(this, _FreeTextEditor_editModeAC, null, "f");
          // On Chrome, the focus is given to <body> when contentEditable is set to
          // false, hence we focus the div.
          this.div.focus({
              preventScroll: true /* See issue #15744 */
          });
          // In case the blur callback hasn't been called.
          this.isEditing = false;
          // this.parent.div.classList.add("freetextEditing");
      }
      focusin(event) {
          var _b;
          if (!this._focusEventsAllowed) {
              return;
          }
          if (((_b = this._uiManager) === null || _b === void 0 ? void 0 : _b.getMode()) !== kendo_pdfjs_loader_js.AnnotationEditorType.FREETEXT) {
              // prevent focusing the freetext editor while in highlight mode
              // in pdf.js this situation does free highlight annotation isntead
              // which is not currently implemented
              return;
          }
          super.focusin(event);
          if (event.target !== this.editorDiv) {
              this.editorDiv.focus();
          }
      }
      /** @inheritdoc */
      onceAdded() {
          var _b;
          if (this.width) {
              // The editor was created in using ctrl+c.
              return;
          }
          this.enableEditMode();
          this.editorDiv.focus();
          if ((_b = this._initialOptions) === null || _b === void 0 ? void 0 : _b.isCentered) {
              this.center();
          }
          this._initialOptions = null;
      }
      /** @inheritdoc */
      isEmpty() {
          var _b, _c;
          return !this.editorDiv || ((_c = (_b = this.editorDiv) === null || _b === void 0 ? void 0 : _b.innerText) === null || _c === void 0 ? void 0 : _c.trim()) === "";
      }
      /** @inheritdoc */
      remove() {
          this.isEditing = false;
          if (this.parent) {
              this.parent.setEditingState(true);
              // this.parent.div.classList.add("freetextEditing");
          }
          super.remove();
      }
      /**
       * Commit the content we have in this editor.
       * @returns {undefined}
       */
      commit() {
          if (!this.isInEditMode()) {
              return;
          }
          super.commit();
          this.disableEditMode();
          const savedText = __classPrivateFieldGet(this, _FreeTextEditor_content, "f");
          const newText = (__classPrivateFieldSet(this, _FreeTextEditor_content, __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_extractText).call(this).trimEnd(), "f"));
          if (savedText === newText) {
              return;
          }
          const setText = text => {
              __classPrivateFieldSet(this, _FreeTextEditor_content, text, "f");
              if (!text) {
                  this.remove();
                  return;
              }
              __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_setContent).call(this);
              this._uiManager.rebuild(this);
              __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_setEditorDimensions).call(this);
          };
          this.addCommands({
              cmd: () => {
                  setText(newText);
              },
              undo: () => {
                  setText(savedText);
              },
              mustExec: false
          });
          __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_setEditorDimensions).call(this);
      }
      /** @inheritdoc */
      shouldGetKeyboardEvents() {
          return this.isInEditMode();
      }
      /** @inheritdoc */
      enterInEditMode() {
          this.enableEditMode();
          this.editorDiv.focus();
      }
      /**
       * ondblclick callback.
       * @param {MouseEvent} event
       */
      dblclick(event) {
          if (!event) {
              return;
          }
          this.enterInEditMode();
      }
      /**
       * onkeydown callback.
       * @param {KeyboardEvent} event
       */
      keydown(event) {
          if (event.target === this.div && event.key === "Enter") {
              this.enterInEditMode();
              // Avoid to add an unwanted new line.
              event.preventDefault();
          }
      }
      editorDivKeydown() {
          // FreeTextEditor._keyboardManager.exec(this, event);
      }
      editorDivFocus() {
          this.isEditing = true;
      }
      editorDivBlur() {
          this.isEditing = false;
      }
      editorDivInput() {
          // this.parent.div.classList.toggle("freetextEditing", this.isEmpty());
      }
      /** @inheritdoc */
      disableEditing() {
          this.editorDiv.setAttribute("role", "comment");
          this.editorDiv.removeAttribute("aria-multiline");
      }
      /** @inheritdoc */
      enableEditing() {
          this.editorDiv.setAttribute("role", "textbox");
          this.editorDiv.setAttribute("aria-multiline", true);
      }
      /** @inheritdoc */
      render() {
          var _b;
          if (this.div) {
              return this.div;
          }
          let baseX, baseY;
          if (this.width) {
              baseX = this.x;
              baseY = this.y;
          }
          super.render();
          this.editorDiv = document.createElement("div");
          this.editorDiv.className = "k-internal internal";
          // todo: move to CSS
          // this.editorDiv.style.position = "absolute";
          // this.div.style.position = "absolute";
          this.editorDiv.setAttribute("id", __classPrivateFieldGet(this, _FreeTextEditor_editorDivId, "f"));
          this.editorDiv.setAttribute("data-l10n-id", "pdfjs-free-text");
          this.enableEditing();
          // AnnotationEditor._l10nPromise
          //     .get("pdfjs-free-text-default-content")
          //     .then(msg => this.editorDiv?.setAttribute("default-content", msg));
          // todo: fix localization
          (_b = this.editorDiv) === null || _b === void 0 ? void 0 : _b.setAttribute("default-content", this._uiManager.pdfViewer.options.messages.freeTextEditorPlaceholder);
          this.editorDiv.contentEditable = true;
          const { style } = this.editorDiv;
          style.fontSize = `calc(${__classPrivateFieldGet(this, _FreeTextEditor_fontSize, "f")}px * var(--scale-factor))`;
          style.color = __classPrivateFieldGet(this, _FreeTextEditor_color, "f");
          this.div.append(this.editorDiv);
          this.overlayDiv = document.createElement("div");
          // this.overlayDiv.classList.add("overlay", "enabled");
          this.div.append(this.overlayDiv);
          bindEvents(this, this.div, ["dblclick", "keydown"]);
          if (this.width) {
              // This editor was created in using copy (ctrl+c).
              const [parentWidth, parentHeight] = this.parentDimensions;
              if (this.annotationElementId) {
                  // This stuff is hard to test: if something is changed here, please
                  // test with the following PDF file:
                  //  - freetexts.pdf
                  //  - rotated_freetexts.pdf
                  // Only small variations between the original annotation and its editor
                  // are allowed.
                  // position is the position of the first glyph in the annotation
                  // and it's relative to its container.
                  const { position } = __classPrivateFieldGet(this, _FreeTextEditor_initialData, "f");
                  let [tx, ty] = this.getInitialTranslation();
                  [tx, ty] = this.pageTranslationToScreen(tx, ty);
                  const [pageWidth, pageHeight] = this.pageDimensions;
                  const [pageX, pageY] = this.pageTranslation;
                  let posX, posY;
                  switch (this.rotation) {
                      case 0:
                          posX = baseX + (position[0] - pageX) / pageWidth;
                          posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                          break;
                      case 90:
                          posX = baseX + (position[0] - pageX) / pageWidth;
                          posY = baseY - (position[1] - pageY) / pageHeight;
                          [tx, ty] = [ty, -tx];
                          break;
                      case 180:
                          posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                          posY = baseY - (position[1] - pageY) / pageHeight;
                          [tx, ty] = [-tx, -ty];
                          break;
                      case 270:
                          posX =
                              baseX +
                                  (position[0] - pageX - this.height * pageHeight) / pageWidth;
                          posY =
                              baseY +
                                  (position[1] - pageY - this.width * pageWidth) / pageHeight;
                          [tx, ty] = [-ty, tx];
                          break;
                      default: break;
                  }
                  this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
              }
              else {
                  this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
              }
              __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_setContent).call(this);
              this._isDraggable = true;
              this.editorDiv.contentEditable = false;
          }
          else {
              this._isDraggable = false;
              this.editorDiv.contentEditable = true;
          }
          // if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("TESTING")) {
          //     this.div.setAttribute("annotation-id", this.annotationElementId);
          // }
          return this.div;
      }
      editorDivPaste(event) {
          // @ts-expect-error TS(2551):
          const clipboardData = event.clipboardData || window.clipboardData;
          const { types } = clipboardData;
          if (types.length === 1 && types[0] === "text/plain") {
              return;
          }
          event.preventDefault();
          const paste = __classPrivateFieldGet(_a$4, _a$4, "m", _FreeTextEditor_deserializeContent).call(_a$4, clipboardData.getData("text") || "").replaceAll(EOL_PATTERN, "\n");
          if (!paste) {
              return;
          }
          const selection = window.getSelection();
          if (!selection.rangeCount) {
              return;
          }
          this.editorDiv.normalize();
          selection.deleteFromDocument();
          const range = selection.getRangeAt(0);
          if (!paste.includes("\n")) {
              range.insertNode(document.createTextNode(paste));
              this.editorDiv.normalize();
              selection.collapseToStart();
              return;
          }
          // Collect the text before and after the caret.
          const { startContainer, startOffset } = range;
          const bufferBefore = [];
          const bufferAfter = [];
          if (startContainer.nodeType === Node.TEXT_NODE) {
              const parent = startContainer.parentElement;
              bufferAfter.push(
              // @ts-expect-error TS(2556):
              startContainer.nodeValue.slice(startOffset).replaceAll(EOL_PATTERN, ""));
              if (parent !== this.editorDiv) {
                  let buffer = bufferBefore;
                  for (const child of this.editorDiv.childNodes) {
                      if (child === parent) {
                          buffer = bufferAfter;
                          continue;
                      }
                      buffer.push(__classPrivateFieldGet(_a$4, _a$4, "m", _FreeTextEditor_getNodeContent).call(_a$4, child));
                  }
              }
              bufferBefore.push(startContainer.nodeValue
                  .slice(0, startOffset)
                  // @ts-expect-error TS(2556):
                  .replaceAll(EOL_PATTERN, ""));
          }
          else if (startContainer === this.editorDiv) {
              let buffer = bufferBefore;
              let i = 0;
              for (const child of this.editorDiv.childNodes) {
                  if (i++ === startOffset) {
                      buffer = bufferAfter;
                  }
                  buffer.push(__classPrivateFieldGet(_a$4, _a$4, "m", _FreeTextEditor_getNodeContent).call(_a$4, child));
              }
          }
          __classPrivateFieldSet(this, _FreeTextEditor_content, `${bufferBefore.join("\n")}${paste}${bufferAfter.join("\n")}`, "f");
          __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_setContent).call(this);
          // Set the caret at the right position.
          const newRange = new Range();
          let beforeLength = bufferBefore.reduce((acc, line) => acc + line.length, 0);
          for (const { firstChild } of this.editorDiv.childNodes) {
              // Each child is either a div with a text node or a br element.
              if (firstChild.nodeType === Node.TEXT_NODE) {
                  const length = firstChild.nodeValue.length;
                  if (beforeLength <= length) {
                      newRange.setStart(firstChild, beforeLength);
                      newRange.setEnd(firstChild, beforeLength);
                      break;
                  }
                  beforeLength -= length;
              }
          }
          selection.removeAllRanges();
          selection.addRange(newRange);
      }
      /** @inheritdoc */
      get contentDiv() {
          return this.editorDiv;
      }
      /** @inheritdoc */
      static deserialize(data, parent, uiManager) {
          let initialData = null;
          if (data instanceof FreeTextAnnotationElement) {
              const { data: { defaultAppearanceData: { fontSize, fontColor }, rect, rotation, id }, textContent, textPosition, parent: { page: { pageNumber } } } = data;
              // textContent is supposed to be an array of strings containing each line
              // of text. However, it can be null or empty.
              if (!textContent || textContent.length === 0) {
                  // Empty annotation.
                  return null;
              }
              initialData = data = {
                  annotationType: kendo_pdfjs_loader_js.AnnotationEditorType.FREETEXT,
                  color: Array.from(fontColor),
                  fontSize,
                  value: textContent.join("\n"),
                  position: textPosition,
                  pageIndex: pageNumber - 1,
                  rect: rect.slice(0),
                  rotation,
                  id,
                  deleted: false
              };
          }
          const editor = super.deserialize(data, parent, uiManager);
          __classPrivateFieldSet(editor, _FreeTextEditor_fontSize, data.fontSize, "f");
          // @ts-expect-error TS(2556):
          __classPrivateFieldSet(editor, _FreeTextEditor_color, kendo_pdfjs_loader_js.Util.makeHexColor(...data.color), "f");
          __classPrivateFieldSet(editor, _FreeTextEditor_content, __classPrivateFieldGet(_a$4, _a$4, "m", _FreeTextEditor_deserializeContent).call(_a$4, data.value), "f");
          editor.annotationElementId = data.id || null;
          __classPrivateFieldSet(editor, _FreeTextEditor_initialData, initialData, "f");
          return editor;
      }
      /** @inheritdoc */
      serialize(isForCopying = false) {
          if (this.isEmpty()) {
              return null;
          }
          if (this.deleted) {
              return {
                  pageIndex: this.pageIndex,
                  id: this.annotationElementId,
                  deleted: true
              };
          }
          const padding = _a$4._internalPadding * this.parentScale;
          const rect = this.getRect(padding, padding);
          const color = AnnotationEditor._colorManager.convert(this.isAttachedToDOM
              ? getComputedStyle(this.editorDiv).color
              : __classPrivateFieldGet(this, _FreeTextEditor_color, "f"));
          const serialized = {
              annotationType: kendo_pdfjs_loader_js.AnnotationEditorType.FREETEXT,
              color,
              fontSize: __classPrivateFieldGet(this, _FreeTextEditor_fontSize, "f"),
              value: __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_serializeContent).call(this),
              pageIndex: this.pageIndex,
              rect,
              rotation: this.rotation,
              structTreeParentId: this._structTreeParentId
          };
          if (isForCopying) {
              // Don't add the id when copying because the pasted editor mustn't be
              // linked to an existing annotation.
              return serialized;
          }
          if (this.annotationElementId && !__classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_hasElementChanged).call(this, serialized)) {
              return null;
          }
          // @ts-expect-error TS(2556):
          serialized.id = this.annotationElementId;
          return serialized;
      }
      /** @inheritdoc */
      renderAnnotationElement(annotation) {
          const content = super.renderAnnotationElement(annotation);
          if (this.deleted) {
              return content;
          }
          const { style } = content;
          style.fontSize = `calc(${__classPrivateFieldGet(this, _FreeTextEditor_fontSize, "f")}px * var(--scale-factor))`;
          style.color = __classPrivateFieldGet(this, _FreeTextEditor_color, "f");
          content.replaceChildren();
          for (const line of __classPrivateFieldGet(this, _FreeTextEditor_content, "f").split("\n")) {
              const div = document.createElement("div");
              div.append(line ? document.createTextNode(line) : document.createElement("br"));
              content.append(div);
          }
          const padding = _a$4._internalPadding * this.parentScale;
          annotation.updateEdited({
              rect: this.getRect(padding, padding),
              popupContent: __classPrivateFieldGet(this, _FreeTextEditor_content, "f")
          });
          return content;
      }
      resetAnnotationElement(annotation) {
          super.resetAnnotationElement(annotation);
          annotation.resetEdited();
      }
      // todo: this is necessary
      // saveDocument() has checks that test "editor instanceof AnnotationEditor", but they fail
      // because AnnotationEditor from "pdfjs-dist/legacy/build/pdf.mjs" is not exported
      // thus replace instances of editors with their serialized version
      toJSON() {
          const data = this.serialize();
          return data;
      }
  }
  _a$4 = FreeTextEditor, _FreeTextEditor_color = new WeakMap(), _FreeTextEditor_content = new WeakMap(), _FreeTextEditor_editorDivId = new WeakMap(), _FreeTextEditor_editModeAC = new WeakMap(), _FreeTextEditor_fontSize = new WeakMap(), _FreeTextEditor_initialData = new WeakMap(), _FreeTextEditor_instances = new WeakSet(), _FreeTextEditor_updateFontSize = function _FreeTextEditor_updateFontSize(fontSize) {
      const setFontsize = size => {
          this.editorDiv.style.fontSize = `calc(${size}px * var(--scale-factor))`;
          this.translate(0, -(size - __classPrivateFieldGet(this, _FreeTextEditor_fontSize, "f")) * this.parentScale);
          __classPrivateFieldSet(this, _FreeTextEditor_fontSize, size, "f");
          __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_setEditorDimensions).call(this);
      };
      const savedFontsize = __classPrivateFieldGet(this, _FreeTextEditor_fontSize, "f");
      this.addCommands({
          cmd: setFontsize.bind(this, fontSize),
          undo: setFontsize.bind(this, savedFontsize),
          post: this._uiManager.updateUI.bind(this._uiManager, this),
          mustExec: true,
          type: kendo_pdfjs_loader_js.AnnotationEditorParamsType.FREETEXT_SIZE,
          overwriteIfSameType: true,
          keepUndo: true
      });
  }, _FreeTextEditor_updateColor = function _FreeTextEditor_updateColor(color) {
      const setColor = col => {
          __classPrivateFieldSet(this, _FreeTextEditor_color, this.editorDiv.style.color = col, "f");
      };
      const savedColor = __classPrivateFieldGet(this, _FreeTextEditor_color, "f");
      this.addCommands({
          cmd: setColor.bind(this, color),
          undo: setColor.bind(this, savedColor),
          post: this._uiManager.updateUI.bind(this._uiManager, this),
          mustExec: true,
          type: kendo_pdfjs_loader_js.AnnotationEditorParamsType.FREETEXT_COLOR,
          overwriteIfSameType: true,
          keepUndo: true
      });
  }, _FreeTextEditor_extractText = function _FreeTextEditor_extractText() {
      // We don't use innerText because there are some bugs with line breaks.
      const buffer = [];
      this.editorDiv.normalize();
      for (const child of this.editorDiv.childNodes) {
          buffer.push(__classPrivateFieldGet(_a$4, _a$4, "m", _FreeTextEditor_getNodeContent).call(_a$4, child));
      }
      return buffer.join("\n");
  }, _FreeTextEditor_setEditorDimensions = function _FreeTextEditor_setEditorDimensions() {
      const [parentWidth, parentHeight] = this.parentDimensions;
      let rect;
      if (this.isAttachedToDOM) {
          rect = this.div.getBoundingClientRect();
      }
      else {
          // This editor isn't on screen but we need to get its dimensions, so
          // we just insert it in the DOM, get its bounding box and then remove it.
          const { currentLayer, div } = this;
          const savedDisplay = div.style.display;
          const savedVisibility = div.classList.contains("hidden") || div.classList.contains("k-hidden");
          div.classList.remove("hidden");
          div.classList.remove("k-hidden");
          div.style.display = "hidden";
          currentLayer.div.append(this.div);
          rect = div.getBoundingClientRect();
          div.remove();
          div.style.display = savedDisplay;
          // div.classList.toggle("hidden", savedVisibility);
          div.classList.toggle("k-hidden", savedVisibility);
      }
      // The dimensions are relative to the rotation of the page, hence we need to
      // take that into account (see issue #16636).
      if (this.rotation % 180 === this.parentRotation % 180) {
          this.width = rect.width / parentWidth;
          this.height = rect.height / parentHeight;
      }
      else {
          this.width = rect.height / parentWidth;
          this.height = rect.width / parentHeight;
      }
      this.fixAndSetPosition();
  }, _FreeTextEditor_getNodeContent = function _FreeTextEditor_getNodeContent(node) {
      return (node.nodeType === Node.TEXT_NODE ? node.nodeValue : node.innerText).replaceAll(EOL_PATTERN, "");
  }, _FreeTextEditor_setContent = function _FreeTextEditor_setContent() {
      this.editorDiv.replaceChildren();
      if (!__classPrivateFieldGet(this, _FreeTextEditor_content, "f")) {
          return;
      }
      for (const line of __classPrivateFieldGet(this, _FreeTextEditor_content, "f").split("\n")) {
          const div = document.createElement("div");
          div.append(line ? document.createTextNode(line) : document.createElement("br"));
          this.editorDiv.append(div);
      }
  }, _FreeTextEditor_serializeContent = function _FreeTextEditor_serializeContent() {
      // @ts-expect-error TS(2556):
      return __classPrivateFieldGet(this, _FreeTextEditor_content, "f").replaceAll("\xa0", " ");
  }, _FreeTextEditor_deserializeContent = function _FreeTextEditor_deserializeContent(content) {
      return content.replaceAll(" ", "\xa0");
  }, _FreeTextEditor_hasElementChanged = function _FreeTextEditor_hasElementChanged(serialized) {
      const { value, fontSize, color, pageIndex } = __classPrivateFieldGet(this, _FreeTextEditor_initialData, "f");
      return (this._hasBeenMoved ||
          serialized.value !== value ||
          serialized.fontSize !== fontSize ||
          serialized.color.some((c, i) => c !== color[i]) ||
          serialized.pageIndex !== pageIndex);
  };
  FreeTextEditor._freeTextDefaultContent = "";
  FreeTextEditor._internalPadding = 0;
  // static _defaultColor = null;
  FreeTextEditor._defaultColor = "#000000";
  FreeTextEditor._defaultFontSize = 10;
  // static get _keyboardManager() {
  //     const proto = FreeTextEditor.prototype;
  //     const arrowChecker = self => self.isEmpty();
  //     const small = AnnotationEditorUIManager.TRANSLATE_SMALL;
  //     const big = AnnotationEditorUIManager.TRANSLATE_BIG;
  //     return shadow(
  //         this,
  //         "_keyboardManager",
  //         new KeyboardManager([
  //             [
  //                 // Commit the text in case the user use ctrl+s to save the document.
  //                 // The event must bubble in order to be caught by the viewer.
  //                 // See bug 1831574.
  //                 ["ctrl+s", "mac+meta+s", "ctrl+p", "mac+meta+p"],
  //                 proto.commitOrRemove,
  //                 { bubbles: true },
  //             ],
  //             [
  //                 ["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"],
  //                 proto.commitOrRemove,
  //             ],
  //             [
  //                 ["ArrowLeft", "mac+ArrowLeft"],
  //                 proto._translateEmpty,
  //                 { args: [-small, 0], checker: arrowChecker },
  //             ],
  //             [
  //                 ["ctrl+ArrowLeft", "mac+shift+ArrowLeft"],
  //                 proto._translateEmpty,
  //                 { args: [-big, 0], checker: arrowChecker },
  //             ],
  //             [
  //                 ["ArrowRight", "mac+ArrowRight"],
  //                 proto._translateEmpty,
  //                 { args: [small, 0], checker: arrowChecker },
  //             ],
  //             [
  //                 ["ctrl+ArrowRight", "mac+shift+ArrowRight"],
  //                 proto._translateEmpty,
  //                 { args: [big, 0], checker: arrowChecker },
  //             ],
  //             [
  //                 ["ArrowUp", "mac+ArrowUp"],
  //                 proto._translateEmpty,
  //                 { args: [0, -small], checker: arrowChecker },
  //             ],
  //             [
  //                 ["ctrl+ArrowUp", "mac+shift+ArrowUp"],
  //                 proto._translateEmpty,
  //                 { args: [0, -big], checker: arrowChecker },
  //             ],
  //             [
  //                 ["ArrowDown", "mac+ArrowDown"],
  //                 proto._translateEmpty,
  //                 { args: [0, small], checker: arrowChecker },
  //             ],
  //             [
  //                 ["ctrl+ArrowDown", "mac+shift+ArrowDown"],
  //                 proto._translateEmpty,
  //                 { args: [0, big], checker: arrowChecker },
  //             ],
  //         ])
  //     );
  // }
  FreeTextEditor._type = "freetext";
  FreeTextEditor._editorType = kendo_pdfjs_loader_js.AnnotationEditorType.FREETEXT;

  /* Copyright 2023 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _Outliner_instances, _Outliner_box, _Outliner_verticalEdges, _Outliner_intervals, _Outliner_getOutlines, _Outliner_binarySearch, _Outliner_insert, _Outliner_remove, _Outliner_breakEdge, _HighlightOutline_box, _HighlightOutline_outlines, _FreeOutliner_instances, _a$3, _FreeOutliner_box, _FreeOutliner_bottom, _FreeOutliner_innerMargin, _FreeOutliner_isLTR, _FreeOutliner_top, _FreeOutliner_last, _FreeOutliner_lastX, _FreeOutliner_lastY, _FreeOutliner_min, _FreeOutliner_min_dist, _FreeOutliner_scaleFactor, _FreeOutliner_thickness, _FreeOutliner_points, _FreeOutliner_MIN_DIST, _FreeOutliner_MIN_DIFF, _FreeOutliner_MIN, _FreeOutliner_getLastCoords, _FreeHighlightOutline_instances, _FreeHighlightOutline_box, _FreeHighlightOutline_bbox, _FreeHighlightOutline_innerMargin, _FreeHighlightOutline_isLTR, _FreeHighlightOutline_points, _FreeHighlightOutline_scaleFactor, _FreeHighlightOutline_outline, _FreeHighlightOutline_rescale, _FreeHighlightOutline_rescaleAndSwap, _FreeHighlightOutline_computeMinMax;
  // import { Util } from "../../shared/utils";
  class Outliner {
      /*
       * Construct an outliner.
       * @param {Array<Object>} boxes - An array of axis-aligned rectangles.
       * @param {number} borderWidth - The width of the border of the boxes, it
       *   allows to make the boxes bigger (or smaller).
       * @param {number} innerMargin - The margin between the boxes and the
       *   outlines. It's important to not have a null innerMargin when we want to
       *   draw the outline else the stroked outline could be clipped because of its
       *   width.
       * @param {boolean} isLTR - true if we're in LTR mode. It's used to determine
       *   the last point of the boxes.
       */
      constructor(boxes, borderWidth = 0, innerMargin = 0, isLTR = true) {
          _Outliner_instances.add(this);
          _Outliner_box.set(this, void 0);
          _Outliner_verticalEdges.set(this, []);
          _Outliner_intervals.set(this, []);
          let minX = Infinity;
          let maxX = -Infinity;
          let minY = Infinity;
          let maxY = -Infinity;
          // We round the coordinates to slightly reduce the number of edges in the
          // final outlines.
          const NUMBER_OF_DIGITS = 4;
          const EPSILON = Math.pow(10, -NUMBER_OF_DIGITS);
          // The coordinates of the boxes are in the page coordinate system.
          for (const { x, y, width, height } of boxes) {
              const x1 = Math.floor((x - borderWidth) / EPSILON) * EPSILON;
              const x2 = Math.ceil((x + width + borderWidth) / EPSILON) * EPSILON;
              const y1 = Math.floor((y - borderWidth) / EPSILON) * EPSILON;
              const y2 = Math.ceil((y + height + borderWidth) / EPSILON) * EPSILON;
              const left = [x1, y1, y2, true];
              const right = [x2, y1, y2, false];
              __classPrivateFieldGet(this, _Outliner_verticalEdges, "f").push(left, right);
              minX = Math.min(minX, x1);
              maxX = Math.max(maxX, x2);
              minY = Math.min(minY, y1);
              maxY = Math.max(maxY, y2);
          }
          const bboxWidth = maxX - minX + 2 * innerMargin;
          const bboxHeight = maxY - minY + 2 * innerMargin;
          const shiftedMinX = minX - innerMargin;
          const shiftedMinY = minY - innerMargin;
          const lastEdge = __classPrivateFieldGet(this, _Outliner_verticalEdges, "f").at(isLTR ? -1 : -2);
          const lastPoint = [lastEdge[0], lastEdge[2]];
          // Convert the coordinates of the edges into box coordinates.
          for (const edge of __classPrivateFieldGet(this, _Outliner_verticalEdges, "f")) {
              const [x, y1, y2] = edge;
              edge[0] = (x - shiftedMinX) / bboxWidth;
              edge[1] = (y1 - shiftedMinY) / bboxHeight;
              edge[2] = (y2 - shiftedMinY) / bboxHeight;
          }
          __classPrivateFieldSet(this, _Outliner_box, {
              x: shiftedMinX,
              y: shiftedMinY,
              width: bboxWidth,
              height: bboxHeight,
              lastPoint
          }, "f");
      }
      getOutlines() {
          // We begin to sort lexicographically the vertical edges by their abscissa,
          // and then by their ordinate.
          __classPrivateFieldGet(this, _Outliner_verticalEdges, "f").sort((a, b) => a[0] - b[0] || a[1] - b[1] || a[2] - b[2]);
          // We're now using a sweep line algorithm to find the outlines.
          // We start with the leftmost vertical edge, and we're going to iterate
          // over all the vertical edges from left to right.
          // Each time we encounter a left edge, we're going to insert the interval
          // [y1, y2] in the set of intervals.
          // This set of intervals is used to break the vertical edges into chunks:
          // we only take the part of the vertical edge that isn't in the union of
          // the intervals.
          const outlineVerticalEdges = [];
          for (const edge of __classPrivateFieldGet(this, _Outliner_verticalEdges, "f")) {
              if (edge[3]) {
                  // Left edge.
                  outlineVerticalEdges.push(...__classPrivateFieldGet(this, _Outliner_instances, "m", _Outliner_breakEdge).call(this, edge));
                  __classPrivateFieldGet(this, _Outliner_instances, "m", _Outliner_insert).call(this, edge);
              }
              else {
                  // Right edge.
                  __classPrivateFieldGet(this, _Outliner_instances, "m", _Outliner_remove).call(this, edge);
                  outlineVerticalEdges.push(...__classPrivateFieldGet(this, _Outliner_instances, "m", _Outliner_breakEdge).call(this, edge));
              }
          }
          return __classPrivateFieldGet(this, _Outliner_instances, "m", _Outliner_getOutlines).call(this, outlineVerticalEdges);
      }
  }
  _Outliner_box = new WeakMap(), _Outliner_verticalEdges = new WeakMap(), _Outliner_intervals = new WeakMap(), _Outliner_instances = new WeakSet(), _Outliner_getOutlines = function _Outliner_getOutlines(outlineVerticalEdges) {
      const edges = [];
      const allEdges = new Set();
      for (const edge of outlineVerticalEdges) {
          const [x, y1, y2] = edge;
          edges.push([x, y1, edge], [x, y2, edge]);
      }
      // We sort lexicographically the vertices of each edge by their ordinate and
      // by their abscissa.
      // Every pair (v_2i, v_{2i + 1}) of vertices defines a horizontal edge.
      // So for every vertical edge, we're going to add the two vertical edges
      // which are connected to it through a horizontal edge.
      edges.sort((a, b) => a[1] - b[1] || a[0] - b[0]);
      for (let i = 0, ii = edges.length; i < ii; i += 2) {
          const edge1 = edges[i][2];
          const edge2 = edges[i + 1][2];
          edge1.push(edge2);
          edge2.push(edge1);
          allEdges.add(edge1);
          allEdges.add(edge2);
      }
      const outlines = [];
      let outline;
      while (allEdges.size > 0) {
          const edge = allEdges.values().next().value;
          let [x, y1, y2, edge1, edge2] = edge;
          allEdges.delete(edge);
          let lastPointX = x;
          let lastPointY = y1;
          outline = [x, y2];
          outlines.push(outline);
          while (true) {
              let e;
              if (allEdges.has(edge1)) {
                  e = edge1;
              }
              else if (allEdges.has(edge2)) {
                  e = edge2;
              }
              else {
                  break;
              }
              allEdges.delete(e);
              [x, y1, y2, edge1, edge2] = e;
              if (lastPointX !== x) {
                  outline.push(lastPointX, lastPointY, x, lastPointY === y1 ? y1 : y2);
                  lastPointX = x;
              }
              lastPointY = lastPointY === y1 ? y2 : y1;
          }
          outline.push(lastPointX, lastPointY);
      }
      return new HighlightOutline(outlines, __classPrivateFieldGet(this, _Outliner_box, "f"));
  }, _Outliner_binarySearch = function _Outliner_binarySearch(y) {
      const array = __classPrivateFieldGet(this, _Outliner_intervals, "f");
      let start = 0;
      let end = array.length - 1;
      while (start <= end) {
          const middle = (start + end) >> 1;
          const y1 = array[middle][0];
          if (y1 === y) {
              return middle;
          }
          if (y1 < y) {
              start = middle + 1;
          }
          else {
              end = middle - 1;
          }
      }
      return end + 1;
  }, _Outliner_insert = function _Outliner_insert([, y1, y2]) {
      const index = __classPrivateFieldGet(this, _Outliner_instances, "m", _Outliner_binarySearch).call(this, y1);
      __classPrivateFieldGet(this, _Outliner_intervals, "f").splice(index, 0, [y1, y2]);
  }, _Outliner_remove = function _Outliner_remove([, y1, y2]) {
      const index = __classPrivateFieldGet(this, _Outliner_instances, "m", _Outliner_binarySearch).call(this, y1);
      for (let i = index; i < __classPrivateFieldGet(this, _Outliner_intervals, "f").length; i++) {
          const [start, end] = __classPrivateFieldGet(this, _Outliner_intervals, "f")[i];
          if (start !== y1) {
              break;
          }
          if (start === y1 && end === y2) {
              __classPrivateFieldGet(this, _Outliner_intervals, "f").splice(i, 1);
              return;
          }
      }
      for (let i = index - 1; i >= 0; i--) {
          const [start, end] = __classPrivateFieldGet(this, _Outliner_intervals, "f")[i];
          if (start !== y1) {
              break;
          }
          if (start === y1 && end === y2) {
              __classPrivateFieldGet(this, _Outliner_intervals, "f").splice(i, 1);
              return;
          }
      }
  }, _Outliner_breakEdge = function _Outliner_breakEdge(edge) {
      const [x, y1, y2] = edge;
      const results = [[x, y1, y2]];
      const index = __classPrivateFieldGet(this, _Outliner_instances, "m", _Outliner_binarySearch).call(this, y2);
      for (let i = 0; i < index; i++) {
          const [start, end] = __classPrivateFieldGet(this, _Outliner_intervals, "f")[i];
          for (let j = 0, jj = results.length; j < jj; j++) {
              const [, y3, y4] = results[j];
              if (end <= y3 || y4 <= start) {
                  // There is no intersection between the interval and the edge, hence
                  // we keep it as is.
                  continue;
              }
              if (y3 >= start) {
                  if (y4 > end) {
                      results[j][1] = end;
                  }
                  else {
                      if (jj === 1) {
                          return [];
                      }
                      // The edge is included in the interval, hence we remove it.
                      results.splice(j, 1);
                      j--;
                      jj--;
                  }
                  continue;
              }
              results[j][2] = start;
              if (y4 > end) {
                  results.push([x, end, y4]);
              }
          }
      }
      return results;
  };
  class Outline {
      /**
       * @returns {string} The SVG path of the outline.
       */
      toSVGPath() {
          throw new Error("Abstract method `toSVGPath` must be implemented.");
      }
      /**
       * @type {Object|null} The bounding box of the outline.
       */
      get box() {
          throw new Error("Abstract getter `box` must be implemented.");
      }
      // serialize() {
      // serialize(_bbox, _rotation) {
      serialize([blX, blY, trX, trY]) {
          // throw new Error("Abstract method `serialize` must be implemented.");
          if (!blX || !blY || !trX || !trY) {
              /* no-empty */
          }
      }
      get free() {
          return this instanceof FreeHighlightOutline;
          // return false;
      }
  }
  class HighlightOutline extends Outline {
      constructor(outlines, box) {
          super();
          _HighlightOutline_box.set(this, void 0);
          _HighlightOutline_outlines.set(this, void 0);
          __classPrivateFieldSet(this, _HighlightOutline_outlines, outlines, "f");
          __classPrivateFieldSet(this, _HighlightOutline_box, box, "f");
      }
      toSVGPath() {
          const buffer = [];
          for (const polygon of __classPrivateFieldGet(this, _HighlightOutline_outlines, "f")) {
              let [prevX, prevY] = polygon;
              buffer.push(`M${prevX} ${prevY}`);
              for (let i = 2; i < polygon.length; i += 2) {
                  const x = polygon[i];
                  const y = polygon[i + 1];
                  if (x === prevX) {
                      buffer.push(`V${y}`);
                      prevY = y;
                  }
                  else if (y === prevY) {
                      buffer.push(`H${x}`);
                      prevX = x;
                  }
              }
              buffer.push("Z");
          }
          return buffer.join(" ");
      }
      /*
       * Serialize the outlines into the PDF page coordinate system.
       * @param {Array<number>} _bbox - the bounding box of the annotation.
       * @param {number} _rotation - the rotation of the annotation.
       * @returns {Array<Array<number>>}
       */
      // serialize([blX, blY, trX, trY], _rotation) {
      serialize([blX, blY, trX, trY]) {
          const outlines = [];
          const width = trX - blX;
          const height = trY - blY;
          for (const outline of __classPrivateFieldGet(this, _HighlightOutline_outlines, "f")) {
              const points = new Array(outline.length);
              for (let i = 0; i < outline.length; i += 2) {
                  points[i] = blX + outline[i] * width;
                  points[i + 1] = trY - outline[i + 1] * height;
              }
              outlines.push(points);
          }
          return outlines;
      }
      get box() {
          return __classPrivateFieldGet(this, _HighlightOutline_box, "f");
      }
  }
  _HighlightOutline_box = new WeakMap(), _HighlightOutline_outlines = new WeakMap();
  class FreeOutliner {
      constructor({ x, y }, box, scaleFactor, thickness, isLTR, innerMargin = 0) {
          _FreeOutliner_instances.add(this);
          _FreeOutliner_box.set(this, void 0);
          _FreeOutliner_bottom.set(this, []);
          _FreeOutliner_innerMargin.set(this, void 0);
          _FreeOutliner_isLTR.set(this, void 0);
          _FreeOutliner_top.set(this, []);
          // The first 6 elements are the last 3 points of the top part of the outline.
          // The next 6 elements are the last 3 points of the line.
          // The next 6 elements are the last 3 points of the bottom part of the
          // outline.
          // We track the last 3 points in order to be able to:
          //  - compute the normal of the line,
          //  - compute the control points of the quadratic Bézier curve.
          _FreeOutliner_last.set(this, new Float64Array(18));
          _FreeOutliner_lastX.set(this, void 0);
          _FreeOutliner_lastY.set(this, void 0);
          _FreeOutliner_min.set(this, void 0);
          _FreeOutliner_min_dist.set(this, void 0);
          _FreeOutliner_scaleFactor.set(this, void 0);
          _FreeOutliner_thickness.set(this, void 0);
          _FreeOutliner_points.set(this, []);
          __classPrivateFieldSet(this, _FreeOutliner_box, box, "f");
          __classPrivateFieldSet(this, _FreeOutliner_thickness, thickness * scaleFactor, "f");
          __classPrivateFieldSet(this, _FreeOutliner_isLTR, isLTR, "f");
          __classPrivateFieldGet(this, _FreeOutliner_last, "f").set([NaN, NaN, NaN, NaN, x, y], 6);
          __classPrivateFieldSet(this, _FreeOutliner_innerMargin, innerMargin, "f");
          __classPrivateFieldSet(this, _FreeOutliner_min_dist, __classPrivateFieldGet(_a$3, _a$3, "f", _FreeOutliner_MIN_DIST) * scaleFactor, "f");
          __classPrivateFieldSet(this, _FreeOutliner_min, __classPrivateFieldGet(_a$3, _a$3, "f", _FreeOutliner_MIN) * scaleFactor, "f");
          __classPrivateFieldSet(this, _FreeOutliner_scaleFactor, scaleFactor, "f");
          __classPrivateFieldGet(this, _FreeOutliner_points, "f").push(x, y);
      }
      get free() {
          return true;
      }
      isEmpty() {
          // When we add a second point then this.#last.slice(6) will be something
          // like [NaN, NaN, firstX, firstY, secondX, secondY,...] so having a NaN
          // at index 8 means that we've only one point.
          return isNaN(__classPrivateFieldGet(this, _FreeOutliner_last, "f")[8]);
      }
      add({ x, y }) {
          var _b;
          __classPrivateFieldSet(this, _FreeOutliner_lastX, x, "f");
          __classPrivateFieldSet(this, _FreeOutliner_lastY, y, "f");
          const [layerX, layerY, layerWidth, layerHeight] = __classPrivateFieldGet(this, _FreeOutliner_box, "f");
          let [x1, y1, x2, y2] = __classPrivateFieldGet(this, _FreeOutliner_last, "f").subarray(8, 12);
          const diffX = x - x2;
          const diffY = y - y2;
          const d = Math.hypot(diffX, diffY);
          if (d < __classPrivateFieldGet(this, _FreeOutliner_min, "f")) {
              // The idea is to avoid garbage points around the last point.
              // When the points are too close, it just leads to bad normal vectors and
              // control points.
              return false;
          }
          const diffD = d - __classPrivateFieldGet(this, _FreeOutliner_min_dist, "f");
          const K = diffD / d;
          const shiftX = K * diffX;
          const shiftY = K * diffY;
          // We update the last 3 points of the line.
          let x0 = x1;
          let y0 = y1;
          x1 = x2;
          y1 = y2;
          x2 += shiftX;
          y2 += shiftY;
          // We keep track of the points in order to be able to compute the focus
          // outline.
          (_b = __classPrivateFieldGet(this, _FreeOutliner_points, "f")) === null || _b === void 0 ? void 0 : _b.push(x, y);
          // Create the normal unit vector.
          // |(shiftX, shiftY)| = |K| * |(diffX, diffY)| = |K| * d = diffD.
          const nX = -shiftY / diffD;
          const nY = shiftX / diffD;
          const thX = nX * __classPrivateFieldGet(this, _FreeOutliner_thickness, "f");
          const thY = nY * __classPrivateFieldGet(this, _FreeOutliner_thickness, "f");
          __classPrivateFieldGet(this, _FreeOutliner_last, "f").set(__classPrivateFieldGet(this, _FreeOutliner_last, "f").subarray(2, 8), 0);
          __classPrivateFieldGet(this, _FreeOutliner_last, "f").set([x2 + thX, y2 + thY], 4);
          __classPrivateFieldGet(this, _FreeOutliner_last, "f").set(__classPrivateFieldGet(this, _FreeOutliner_last, "f").subarray(14, 18), 12);
          __classPrivateFieldGet(this, _FreeOutliner_last, "f").set([x2 - thX, y2 - thY], 16);
          if (isNaN(__classPrivateFieldGet(this, _FreeOutliner_last, "f")[6])) {
              if (__classPrivateFieldGet(this, _FreeOutliner_top, "f").length === 0) {
                  __classPrivateFieldGet(this, _FreeOutliner_last, "f").set([x1 + thX, y1 + thY], 2);
                  __classPrivateFieldGet(this, _FreeOutliner_top, "f").push(NaN, NaN, NaN, NaN, (x1 + thX - layerX) / layerWidth, (y1 + thY - layerY) / layerHeight);
                  __classPrivateFieldGet(this, _FreeOutliner_last, "f").set([x1 - thX, y1 - thY], 14);
                  __classPrivateFieldGet(this, _FreeOutliner_bottom, "f").push(NaN, NaN, NaN, NaN, (x1 - thX - layerX) / layerWidth, (y1 - thY - layerY) / layerHeight);
              }
              __classPrivateFieldGet(this, _FreeOutliner_last, "f").set([x0, y0, x1, y1, x2, y2], 6);
              return !this.isEmpty();
          }
          __classPrivateFieldGet(this, _FreeOutliner_last, "f").set([x0, y0, x1, y1, x2, y2], 6);
          const angle = Math.abs(Math.atan2(y0 - y1, x0 - x1) - Math.atan2(shiftY, shiftX));
          if (angle < Math.PI / 2) {
              // In order to avoid some possible artifacts, we're going to use the a
              // straight line instead of a quadratic Bézier curve.
              [x1, y1, x2, y2] = __classPrivateFieldGet(this, _FreeOutliner_last, "f").subarray(2, 6);
              __classPrivateFieldGet(this, _FreeOutliner_top, "f").push(NaN, NaN, NaN, NaN, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
              [x1, y1, x0, y0] = __classPrivateFieldGet(this, _FreeOutliner_last, "f").subarray(14, 18);
              __classPrivateFieldGet(this, _FreeOutliner_bottom, "f").push(NaN, NaN, NaN, NaN, ((x0 + x1) / 2 - layerX) / layerWidth, ((y0 + y1) / 2 - layerY) / layerHeight);
              return true;
          }
          // Control points and the final point for the quadratic Bézier curve.
          [x0, y0, x1, y1, x2, y2] = __classPrivateFieldGet(this, _FreeOutliner_last, "f").subarray(0, 6);
          __classPrivateFieldGet(this, _FreeOutliner_top, "f").push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
          [x2, y2, x1, y1, x0, y0] = __classPrivateFieldGet(this, _FreeOutliner_last, "f").subarray(12, 18);
          __classPrivateFieldGet(this, _FreeOutliner_bottom, "f").push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
          return true;
      }
      toSVGPath() {
          if (this.isEmpty()) {
              // We've only one point.
              return "";
          }
          const top = __classPrivateFieldGet(this, _FreeOutliner_top, "f");
          const bottom = __classPrivateFieldGet(this, _FreeOutliner_bottom, "f");
          const lastTop = __classPrivateFieldGet(this, _FreeOutliner_last, "f").subarray(4, 6);
          const lastBottom = __classPrivateFieldGet(this, _FreeOutliner_last, "f").subarray(16, 18);
          const [x, y, width, height] = __classPrivateFieldGet(this, _FreeOutliner_box, "f");
          const [lastTopX, lastTopY, lastBottomX, lastBottomY] = __classPrivateFieldGet(this, _FreeOutliner_instances, "m", _FreeOutliner_getLastCoords).call(this);
          if (isNaN(__classPrivateFieldGet(this, _FreeOutliner_last, "f")[6]) && !this.isEmpty()) {
              // We've only two points.
              return `M${(__classPrivateFieldGet(this, _FreeOutliner_last, "f")[2] - x) / width} ${(__classPrivateFieldGet(this, _FreeOutliner_last, "f")[3] - y) / height} L${(__classPrivateFieldGet(this, _FreeOutliner_last, "f")[4] - x) / width} ${(__classPrivateFieldGet(this, _FreeOutliner_last, "f")[5] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(__classPrivateFieldGet(this, _FreeOutliner_last, "f")[16] - x) / width} ${(__classPrivateFieldGet(this, _FreeOutliner_last, "f")[17] - y) / height} L${(__classPrivateFieldGet(this, _FreeOutliner_last, "f")[14] - x) / width} ${(__classPrivateFieldGet(this, _FreeOutliner_last, "f")[15] - y) / height} Z`;
          }
          const buffer = [];
          buffer.push(`M${top[4]} ${top[5]}`);
          for (let i = 6; i < top.length; i += 6) {
              if (isNaN(top[i])) {
                  buffer.push(`L${top[i + 4]} ${top[i + 5]}`);
              }
              else {
                  buffer.push(`C${top[i]} ${top[i + 1]} ${top[i + 2]} ${top[i + 3]} ${top[i + 4]} ${top[i + 5]}`);
              }
          }
          buffer.push(`L${(lastTop[0] - x) / width} ${(lastTop[1] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(lastBottom[0] - x) / width} ${(lastBottom[1] - y) / height}`);
          for (let i = bottom.length - 6; i >= 6; i -= 6) {
              if (isNaN(bottom[i])) {
                  buffer.push(`L${bottom[i + 4]} ${bottom[i + 5]}`);
              }
              else {
                  buffer.push(`C${bottom[i]} ${bottom[i + 1]} ${bottom[i + 2]} ${bottom[i + 3]} ${bottom[i + 4]} ${bottom[i + 5]}`);
              }
          }
          buffer.push(`L${bottom[4]} ${bottom[5]} Z`);
          return buffer.join(" ");
      }
      getOutlines() {
          var _b, _c;
          const top = __classPrivateFieldGet(this, _FreeOutliner_top, "f");
          const bottom = __classPrivateFieldGet(this, _FreeOutliner_bottom, "f");
          const last = __classPrivateFieldGet(this, _FreeOutliner_last, "f");
          const lastTop = last.subarray(4, 6);
          const lastBottom = last.subarray(16, 18);
          const [layerX, layerY, layerWidth, layerHeight] = __classPrivateFieldGet(this, _FreeOutliner_box, "f");
          const points = new Float64Array(((_c = (_b = __classPrivateFieldGet(this, _FreeOutliner_points, "f")) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) + 2);
          for (let i = 0, ii = points.length - 2; i < ii; i += 2) {
              points[i] = (__classPrivateFieldGet(this, _FreeOutliner_points, "f")[i] - layerX) / layerWidth;
              points[i + 1] = (__classPrivateFieldGet(this, _FreeOutliner_points, "f")[i + 1] - layerY) / layerHeight;
          }
          points[points.length - 2] = (__classPrivateFieldGet(this, _FreeOutliner_lastX, "f") - layerX) / layerWidth;
          points[points.length - 1] = (__classPrivateFieldGet(this, _FreeOutliner_lastY, "f") - layerY) / layerHeight;
          const [lastTopX, lastTopY, lastBottomX, lastBottomY] = __classPrivateFieldGet(this, _FreeOutliner_instances, "m", _FreeOutliner_getLastCoords).call(this);
          if (isNaN(last[6]) && !this.isEmpty()) {
              // We've only two points.
              const outlineObj = new Float64Array(36);
              outlineObj.set([
                  NaN,
                  NaN,
                  NaN,
                  NaN,
                  (last[2] - layerX) / layerWidth,
                  (last[3] - layerY) / layerHeight,
                  NaN,
                  NaN,
                  NaN,
                  NaN,
                  (last[4] - layerX) / layerWidth,
                  (last[5] - layerY) / layerHeight,
                  NaN,
                  NaN,
                  NaN,
                  NaN,
                  lastTopX,
                  lastTopY,
                  NaN,
                  NaN,
                  NaN,
                  NaN,
                  lastBottomX,
                  lastBottomY,
                  NaN,
                  NaN,
                  NaN,
                  NaN,
                  (last[16] - layerX) / layerWidth,
                  (last[17] - layerY) / layerHeight,
                  NaN,
                  NaN,
                  NaN,
                  NaN,
                  (last[14] - layerX) / layerWidth,
                  (last[15] - layerY) / layerHeight
              ], 0);
              return new FreeHighlightOutline(outlineObj, points, __classPrivateFieldGet(this, _FreeOutliner_box, "f"), __classPrivateFieldGet(this, _FreeOutliner_scaleFactor, "f"), __classPrivateFieldGet(this, _FreeOutliner_innerMargin, "f"), __classPrivateFieldGet(this, _FreeOutliner_isLTR, "f"));
          }
          const outline = new Float64Array(__classPrivateFieldGet(this, _FreeOutliner_top, "f").length + 24 + __classPrivateFieldGet(this, _FreeOutliner_bottom, "f").length);
          let N = top.length;
          for (let i = 0; i < N; i += 2) {
              if (isNaN(top[i])) {
                  outline[i] = outline[i + 1] = NaN;
                  continue;
              }
              outline[i] = top[i];
              outline[i + 1] = top[i + 1];
          }
          outline.set([
              NaN,
              NaN,
              NaN,
              NaN,
              (lastTop[0] - layerX) / layerWidth,
              (lastTop[1] - layerY) / layerHeight,
              NaN,
              NaN,
              NaN,
              NaN,
              lastTopX,
              lastTopY,
              NaN,
              NaN,
              NaN,
              NaN,
              lastBottomX,
              lastBottomY,
              NaN,
              NaN,
              NaN,
              NaN,
              (lastBottom[0] - layerX) / layerWidth,
              (lastBottom[1] - layerY) / layerHeight
          ], N);
          N += 24;
          for (let i = bottom.length - 6; i >= 6; i -= 6) {
              for (let j = 0; j < 6; j += 2) {
                  if (isNaN(bottom[i + j])) {
                      outline[N] = outline[N + 1] = NaN;
                      N += 2;
                      continue;
                  }
                  outline[N] = bottom[i + j];
                  outline[N + 1] = bottom[i + j + 1];
                  N += 2;
              }
          }
          outline.set([NaN, NaN, NaN, NaN, bottom[4], bottom[5]], N);
          return new FreeHighlightOutline(outline, points, __classPrivateFieldGet(this, _FreeOutliner_box, "f"), __classPrivateFieldGet(this, _FreeOutliner_scaleFactor, "f"), __classPrivateFieldGet(this, _FreeOutliner_innerMargin, "f"), __classPrivateFieldGet(this, _FreeOutliner_isLTR, "f"));
      }
  }
  _a$3 = FreeOutliner, _FreeOutliner_box = new WeakMap(), _FreeOutliner_bottom = new WeakMap(), _FreeOutliner_innerMargin = new WeakMap(), _FreeOutliner_isLTR = new WeakMap(), _FreeOutliner_top = new WeakMap(), _FreeOutliner_last = new WeakMap(), _FreeOutliner_lastX = new WeakMap(), _FreeOutliner_lastY = new WeakMap(), _FreeOutliner_min = new WeakMap(), _FreeOutliner_min_dist = new WeakMap(), _FreeOutliner_scaleFactor = new WeakMap(), _FreeOutliner_thickness = new WeakMap(), _FreeOutliner_points = new WeakMap(), _FreeOutliner_instances = new WeakSet(), _FreeOutliner_getLastCoords = function _FreeOutliner_getLastCoords() {
      const lastTop = __classPrivateFieldGet(this, _FreeOutliner_last, "f").subarray(4, 6);
      const lastBottom = __classPrivateFieldGet(this, _FreeOutliner_last, "f").subarray(16, 18);
      const [x, y, width, height] = __classPrivateFieldGet(this, _FreeOutliner_box, "f");
      return [
          (__classPrivateFieldGet(this, _FreeOutliner_lastX, "f") + (lastTop[0] - lastBottom[0]) / 2 - x) / width,
          (__classPrivateFieldGet(this, _FreeOutliner_lastY, "f") + (lastTop[1] - lastBottom[1]) / 2 - y) / height,
          (__classPrivateFieldGet(this, _FreeOutliner_lastX, "f") + (lastBottom[0] - lastTop[0]) / 2 - x) / width,
          (__classPrivateFieldGet(this, _FreeOutliner_lastY, "f") + (lastBottom[1] - lastTop[1]) / 2 - y) / height
      ];
  };
  _FreeOutliner_MIN_DIST = { value: 8 };
  _FreeOutliner_MIN_DIFF = { value: 2 };
  _FreeOutliner_MIN = { value: __classPrivateFieldGet(_a$3, _a$3, "f", _FreeOutliner_MIN_DIST) + __classPrivateFieldGet(_a$3, _a$3, "f", _FreeOutliner_MIN_DIFF) };
  class FreeHighlightOutline extends Outline {
      constructor(outline, points, box, scaleFactor, innerMargin, isLTR) {
          super();
          _FreeHighlightOutline_instances.add(this);
          _FreeHighlightOutline_box.set(this, void 0);
          _FreeHighlightOutline_bbox.set(this, null);
          _FreeHighlightOutline_innerMargin.set(this, void 0);
          _FreeHighlightOutline_isLTR.set(this, void 0);
          _FreeHighlightOutline_points.set(this, void 0);
          _FreeHighlightOutline_scaleFactor.set(this, void 0);
          _FreeHighlightOutline_outline.set(this, void 0);
          __classPrivateFieldSet(this, _FreeHighlightOutline_outline, outline, "f");
          __classPrivateFieldSet(this, _FreeHighlightOutline_points, points, "f");
          __classPrivateFieldSet(this, _FreeHighlightOutline_box, box, "f");
          __classPrivateFieldSet(this, _FreeHighlightOutline_scaleFactor, scaleFactor, "f");
          __classPrivateFieldSet(this, _FreeHighlightOutline_innerMargin, innerMargin, "f");
          __classPrivateFieldSet(this, _FreeHighlightOutline_isLTR, isLTR, "f");
          __classPrivateFieldGet(this, _FreeHighlightOutline_instances, "m", _FreeHighlightOutline_computeMinMax).call(this, isLTR);
          const { x, y, width, height } = __classPrivateFieldGet(this, _FreeHighlightOutline_bbox, "f");
          for (let i = 0, ii = outline.length; i < ii; i += 2) {
              outline[i] = (outline[i] - x) / width;
              outline[i + 1] = (outline[i + 1] - y) / height;
          }
          for (let i = 0, ii = points.length; i < ii; i += 2) {
              points[i] = (points[i] - x) / width;
              points[i + 1] = (points[i + 1] - y) / height;
          }
      }
      toSVGPath() {
          const buffer = [`M${__classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f")[4]} ${__classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f")[5]}`];
          for (let i = 6, ii = __classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f").length; i < ii; i += 6) {
              if (isNaN(__classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f")[i])) {
                  buffer.push(`L${__classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f")[i + 4]} ${__classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f")[i + 5]}`);
                  continue;
              }
              buffer.push(`C${__classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f")[i]} ${__classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f")[i + 1]} ${__classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f")[i + 2]} ${__classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f")[i + 3]} ${__classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f")[i + 4]} ${__classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f")[i + 5]}`);
          }
          buffer.push("Z");
          return buffer.join(" ");
      }
      // @ts-expect-error(TS:2556)
      serialize([blX, blY, trX, trY], rotation) {
          const width = trX - blX;
          const height = trY - blY;
          let outline;
          let points;
          switch (rotation) {
              case 0:
                  outline = __classPrivateFieldGet(this, _FreeHighlightOutline_instances, "m", _FreeHighlightOutline_rescale).call(this, __classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f"), blX, trY, width, -height);
                  points = __classPrivateFieldGet(this, _FreeHighlightOutline_instances, "m", _FreeHighlightOutline_rescale).call(this, __classPrivateFieldGet(this, _FreeHighlightOutline_points, "f"), blX, trY, width, -height);
                  break;
              case 90:
                  outline = __classPrivateFieldGet(this, _FreeHighlightOutline_instances, "m", _FreeHighlightOutline_rescaleAndSwap).call(this, __classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f"), blX, blY, width, height);
                  points = __classPrivateFieldGet(this, _FreeHighlightOutline_instances, "m", _FreeHighlightOutline_rescaleAndSwap).call(this, __classPrivateFieldGet(this, _FreeHighlightOutline_points, "f"), blX, blY, width, height);
                  break;
              case 180:
                  outline = __classPrivateFieldGet(this, _FreeHighlightOutline_instances, "m", _FreeHighlightOutline_rescale).call(this, __classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f"), trX, blY, -width, height);
                  points = __classPrivateFieldGet(this, _FreeHighlightOutline_instances, "m", _FreeHighlightOutline_rescale).call(this, __classPrivateFieldGet(this, _FreeHighlightOutline_points, "f"), trX, blY, -width, height);
                  break;
              case 270:
                  outline = __classPrivateFieldGet(this, _FreeHighlightOutline_instances, "m", _FreeHighlightOutline_rescaleAndSwap).call(this, __classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f"), trX, trY, -width, -height);
                  points = __classPrivateFieldGet(this, _FreeHighlightOutline_instances, "m", _FreeHighlightOutline_rescaleAndSwap).call(this, __classPrivateFieldGet(this, _FreeHighlightOutline_points, "f"), trX, trY, -width, -height);
                  break;
              default: break;
          }
          return { outline: Array.from(outline), points: [Array.from(points)] };
      }
      get box() {
          return __classPrivateFieldGet(this, _FreeHighlightOutline_bbox, "f");
      }
      getNewOutline(thickness, innerMargin) {
          // Build the outline of the highlight to use as the focus outline.
          const { x, y, width, height } = __classPrivateFieldGet(this, _FreeHighlightOutline_bbox, "f");
          const [layerX, layerY, layerWidth, layerHeight] = __classPrivateFieldGet(this, _FreeHighlightOutline_box, "f");
          const sx = width * layerWidth;
          const sy = height * layerHeight;
          const tx = x * layerWidth + layerX;
          const ty = y * layerHeight + layerY;
          const outliner = new FreeOutliner({
              x: __classPrivateFieldGet(this, _FreeHighlightOutline_points, "f")[0] * sx + tx,
              y: __classPrivateFieldGet(this, _FreeHighlightOutline_points, "f")[1] * sy + ty
          }, __classPrivateFieldGet(this, _FreeHighlightOutline_box, "f"), __classPrivateFieldGet(this, _FreeHighlightOutline_scaleFactor, "f"), thickness, __classPrivateFieldGet(this, _FreeHighlightOutline_isLTR, "f"), innerMargin !== null && innerMargin !== void 0 ? innerMargin : __classPrivateFieldGet(this, _FreeHighlightOutline_innerMargin, "f"));
          for (let i = 2; i < __classPrivateFieldGet(this, _FreeHighlightOutline_points, "f").length; i += 2) {
              outliner.add({
                  x: __classPrivateFieldGet(this, _FreeHighlightOutline_points, "f")[i] * sx + tx,
                  y: __classPrivateFieldGet(this, _FreeHighlightOutline_points, "f")[i + 1] * sy + ty
              });
          }
          return outliner.getOutlines();
      }
  }
  _FreeHighlightOutline_box = new WeakMap(), _FreeHighlightOutline_bbox = new WeakMap(), _FreeHighlightOutline_innerMargin = new WeakMap(), _FreeHighlightOutline_isLTR = new WeakMap(), _FreeHighlightOutline_points = new WeakMap(), _FreeHighlightOutline_scaleFactor = new WeakMap(), _FreeHighlightOutline_outline = new WeakMap(), _FreeHighlightOutline_instances = new WeakSet(), _FreeHighlightOutline_rescale = function _FreeHighlightOutline_rescale(src, tx, ty, sx, sy) {
      const dest = new Float64Array(src.length);
      for (let i = 0, ii = src.length; i < ii; i += 2) {
          dest[i] = tx + src[i] * sx;
          dest[i + 1] = ty + src[i + 1] * sy;
      }
      return dest;
  }, _FreeHighlightOutline_rescaleAndSwap = function _FreeHighlightOutline_rescaleAndSwap(src, tx, ty, sx, sy) {
      const dest = new Float64Array(src.length);
      for (let i = 0, ii = src.length; i < ii; i += 2) {
          dest[i] = tx + src[i + 1] * sx;
          dest[i + 1] = ty + src[i] * sy;
      }
      return dest;
  }, _FreeHighlightOutline_computeMinMax = function _FreeHighlightOutline_computeMinMax(isLTR) {
      const outline = __classPrivateFieldGet(this, _FreeHighlightOutline_outline, "f");
      let lastX = outline[4];
      let lastY = outline[5];
      let minX = lastX;
      let minY = lastY;
      let maxX = lastX;
      let maxY = lastY;
      let lastPointX = lastX;
      let lastPointY = lastY;
      const ltrCallback = isLTR ? Math.max : Math.min;
      for (let i = 6, ii = outline.length; i < ii; i += 6) {
          if (isNaN(outline[i])) {
              minX = Math.min(minX, outline[i + 4]);
              minY = Math.min(minY, outline[i + 5]);
              maxX = Math.max(maxX, outline[i + 4]);
              maxY = Math.max(maxY, outline[i + 5]);
              if (lastPointY < outline[i + 5]) {
                  lastPointX = outline[i + 4];
                  lastPointY = outline[i + 5];
              }
              else if (lastPointY === outline[i + 5]) {
                  lastPointX = ltrCallback(lastPointX, outline[i + 4]);
              }
          }
          else {
              const bbox = kendo_pdfjs_loader_js.Util.bezierBoundingBox(lastX, lastY, 
              // @ts-expect-error(TS:2556)
              ...outline.slice(i, i + 6));
              minX = Math.min(minX, bbox[0]);
              minY = Math.min(minY, bbox[1]);
              maxX = Math.max(maxX, bbox[2]);
              maxY = Math.max(maxY, bbox[3]);
              if (lastPointY < bbox[3]) {
                  lastPointX = bbox[2];
                  lastPointY = bbox[3];
              }
              else if (lastPointY === bbox[3]) {
                  lastPointX = ltrCallback(lastPointX, bbox[2]);
              }
          }
          lastX = outline[i + 4];
          lastY = outline[i + 5];
      }
      const x = minX - __classPrivateFieldGet(this, _FreeHighlightOutline_innerMargin, "f"), y = minY - __classPrivateFieldGet(this, _FreeHighlightOutline_innerMargin, "f"), width = maxX - minX + 2 * __classPrivateFieldGet(this, _FreeHighlightOutline_innerMargin, "f"), height = maxY - minY + 2 * __classPrivateFieldGet(this, _FreeHighlightOutline_innerMargin, "f");
      __classPrivateFieldSet(this, _FreeHighlightOutline_bbox, { x, y, width, height, lastPoint: [lastPointX, lastPointY] }, "f");
  };
  // export { Outliner };

  /* Copyright 2022 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _HighlightEditor_instances, _a$2, _HighlightEditor_anchorNode, _HighlightEditor_anchorOffset, _HighlightEditor_boxes, _HighlightEditor_clipPathId, _HighlightEditor_focusOutlines, _HighlightEditor_focusNode, _HighlightEditor_focusOffset, _HighlightEditor_highlightDiv, _HighlightEditor_highlightOutlines, _HighlightEditor_id, _HighlightEditor_isFreeHighlight, _HighlightEditor_lastPoint, _HighlightEditor_opacity, _HighlightEditor_outlineId, _HighlightEditor_text, _HighlightEditor_thickness, _HighlightEditor_methodOfCreation, _HighlightEditor_createOutlines, _HighlightEditor_createFreeOutlines, _HighlightEditor_updateColor, _HighlightEditor_updateThickness, _HighlightEditor_cleanDrawLayer, _HighlightEditor_addToDrawLayer, _HighlightEditor_rotateBbox, _HighlightEditor_keydown, _HighlightEditor_setCaret, _HighlightEditor_getRotation, _HighlightEditor_serializeBoxes, _HighlightEditor_serializeOutlines, _HighlightEditor_highlightMove, _HighlightEditor_endHighlight;
  // import { ColorPicker } from "./color_picker.js";
  // import { noContextMenu } from "../../shared/display_utils";
  /**
   * Basic draw editor in order to generate an Highlight annotation.
   */
  class HighlightEditor extends AnnotationEditor {
      // static get _keyboardManager() {
      //     const proto = HighlightEditor.prototype;
      //     return shadow(
      //         this,
      //         "_keyboardManager",
      //         new KeyboardManager([
      //             [["ArrowLeft", "mac+ArrowLeft"], proto._moveCaret, { args: [0] }],
      //             [["ArrowRight", "mac+ArrowRight"], proto._moveCaret, { args: [1] }],
      //             [["ArrowUp", "mac+ArrowUp"], proto._moveCaret, { args: [2] }],
      //             [["ArrowDown", "mac+ArrowDown"], proto._moveCaret, { args: [3] }],
      //         ])
      //     );
      // }
      constructor(params) {
          super(Object.assign(Object.assign({}, params), { name: "k-highlight-editor" }));
          _HighlightEditor_instances.add(this);
          // todo: props
          this.color = "";
          // parent = null;
          // width = null;
          // height = null;
          // x = null;
          // y = null;
          // todo: props
          _HighlightEditor_anchorNode.set(this, null);
          _HighlightEditor_anchorOffset.set(this, 0);
          _HighlightEditor_boxes.set(this, void 0);
          _HighlightEditor_clipPathId.set(this, null);
          // #colorPicker = null;
          _HighlightEditor_focusOutlines.set(this, null);
          _HighlightEditor_focusNode.set(this, null);
          _HighlightEditor_focusOffset.set(this, 0);
          _HighlightEditor_highlightDiv.set(this, null);
          _HighlightEditor_highlightOutlines.set(this, null);
          _HighlightEditor_id.set(this, null);
          _HighlightEditor_isFreeHighlight.set(this, false);
          _HighlightEditor_lastPoint.set(this, null);
          _HighlightEditor_opacity.set(this, void 0);
          _HighlightEditor_outlineId.set(this, null);
          _HighlightEditor_text.set(this, "");
          _HighlightEditor_thickness.set(this, void 0);
          _HighlightEditor_methodOfCreation.set(this, "");
          this.color = params.color || _a$2._defaultColor;
          __classPrivateFieldSet(this, _HighlightEditor_thickness, params.thickness || _a$2._defaultThickness, "f");
          __classPrivateFieldSet(this, _HighlightEditor_opacity, params.opacity || _a$2._defaultOpacity, "f");
          __classPrivateFieldSet(this, _HighlightEditor_boxes, params.boxes || null, "f");
          __classPrivateFieldSet(this, _HighlightEditor_methodOfCreation, params.methodOfCreation || "", "f");
          __classPrivateFieldSet(this, _HighlightEditor_text, params.text || "", "f");
          this._isDraggable = false;
          if (params.highlightId > -1) {
              __classPrivateFieldSet(this, _HighlightEditor_isFreeHighlight, true, "f");
              __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_createFreeOutlines).call(this, params);
              __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_addToDrawLayer).call(this);
          }
          else {
              __classPrivateFieldSet(this, _HighlightEditor_anchorNode, params.anchorNode, "f");
              __classPrivateFieldSet(this, _HighlightEditor_anchorOffset, params.anchorOffset, "f");
              __classPrivateFieldSet(this, _HighlightEditor_focusNode, params.focusNode, "f");
              __classPrivateFieldSet(this, _HighlightEditor_focusOffset, params.focusOffset, "f");
              __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_createOutlines).call(this);
              __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_addToDrawLayer).call(this);
              this.rotate(this.rotation);
          }
      }
      /** @inheritdoc */
      get telemetryInitialData() {
          return {
              action: "added",
              type: __classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f") ? "free_highlight" : "highlight",
              color: this._uiManager.highlightColorNames.get(this.color),
              thickness: __classPrivateFieldGet(this, _HighlightEditor_thickness, "f"),
              methodOfCreation: __classPrivateFieldGet(this, _HighlightEditor_methodOfCreation, "f")
          };
      }
      /** @inheritdoc */
      get telemetryFinalData() {
          return {
              type: "highlight",
              color: this._uiManager.highlightColorNames.get(this.color)
          };
      }
      static computeTelemetryFinalData(data) {
          // We want to know how many colors have been used.
          return { numberOfColors: data.get("color").size };
      }
      /** @inheritdoc */
      static initialize(l10n, uiManager) {
          var _b, _c, _d, _e;
          AnnotationEditor.initialize(l10n, uiManager, {});
          _a$2._defaultColor || (_a$2._defaultColor = 
          // uiManager.highlightColors?.values().next().value || "#fff066";
          // uiManager.highlightColors?.values().next().value || "#ffff00";
          ((_e = (_d = (_c = (_b = uiManager.viewer) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.annotations) === null || _d === void 0 ? void 0 : _d.highlight) === null || _e === void 0 ? void 0 : _e.color) || "#ffff00");
      }
      /** @inheritdoc */
      static updateDefaultParams(type, value) {
          switch (type) {
              case kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR:
                  _a$2._defaultColor = value;
                  break;
              case kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_THICKNESS:
                  _a$2._defaultThickness = value;
                  break;
              default: break;
          }
      }
      /** @inheritdoc */
      // translateInPage(x, y) { }
      translateInPage() { }
      /** @inheritdoc */
      get toolbarPosition() {
          return __classPrivateFieldGet(this, _HighlightEditor_lastPoint, "f");
      }
      /** @inheritdoc */
      updateParams(type, value) {
          switch (type) {
              case kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_COLOR:
                  __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_updateColor).call(this, value);
                  break;
              case kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_THICKNESS:
                  __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_updateThickness).call(this, value);
                  break;
              default: break;
          }
      }
      static get defaultPropertiesToUpdate() {
          return [
              [
                  kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR,
                  _a$2._defaultColor
              ],
              [
                  kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_THICKNESS,
                  _a$2._defaultThickness
              ]
          ];
      }
      /** @inheritdoc */
      get propertiesToUpdate() {
          return [
              [
                  kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_COLOR,
                  this.color || _a$2._defaultColor
              ],
              [
                  kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_THICKNESS,
                  __classPrivateFieldGet(this, _HighlightEditor_thickness, "f") || _a$2._defaultThickness
              ],
              [kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_FREE, __classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")]
          ];
      }
      /** @inheritdoc */
      // async addEditToolbar() {
      //     // const toolbar = await super.addEditToolbar();
      //     // if (!toolbar) {
      //     //     return null;
      //     // }
      //     // if (this._uiManager.highlightColors) {
      //     //     // this.#colorPicker = new ColorPicker({ editor: this });
      //     //     // toolbar.addColorPicker(this.#colorPicker);
      //     // }
      //     // return toolbar;
      // }
      /** @inheritdoc */
      disableEditing() {
          super.disableEditing();
          // this.div.classList.toggle("disabled", true);
          this.div.classList.toggle("k-highlight-editor-disabled", true);
      }
      /** @inheritdoc */
      enableEditing() {
          super.enableEditing();
          // this.div.classList.toggle("disabled", false);
          this.div.classList.toggle("k-highlight-editor-disabled", false);
      }
      /** @inheritdoc */
      fixAndSetPosition() {
          return super.fixAndSetPosition(__classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_getRotation).call(this));
      }
      /** @inheritdoc */
      getBaseTranslation() {
          // The editor itself doesn't have any CSS border (we're drawing one
          // ourselves in using SVG).
          return [0, 0];
      }
      /** @inheritdoc */
      getRect(tx, ty) {
          return super.getRect(tx, ty, __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_getRotation).call(this));
      }
      /** @inheritdoc */
      onceAdded() {
          this.parent.addUndoableEditor(this);
          this.div.focus();
      }
      /** @inheritdoc */
      remove() {
          __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_cleanDrawLayer).call(this);
          // this._reportTelemetry({
          //     action: "deleted",
          // });
          super.remove();
      }
      /** @inheritdoc */
      rebuild() {
          if (!this.parent) {
              return;
          }
          super.rebuild();
          if (this.div === null) {
              return;
          }
          __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_addToDrawLayer).call(this);
          if (!this.isAttachedToDOM) {
              // At some point this editor was removed and we're rebuilding it,
              // hence we must add it to its parent.
              this.parent.add(this);
          }
      }
      setParent(parent) {
          var _b, _c;
          let mustBeSelected = false;
          if (this.parent && !parent) {
              __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_cleanDrawLayer).call(this);
          }
          else if (parent) {
              __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_addToDrawLayer).call(this, parent);
              // If mustBeSelected is true it means that this editor was selected
              // when its parent has been destroyed, hence we must select it again.
              mustBeSelected =
                  !this.parent &&
                      (((_b = this.div) === null || _b === void 0 ? void 0 : _b.classList.contains("selectedEditor")) ||
                          ((_c = this.div) === null || _c === void 0 ? void 0 : _c.classList.contains("k-selected")));
          }
          super.setParent(parent);
          this.show(this._isVisible);
          if (mustBeSelected) {
              // We select it after the parent has been set.
              this.select();
          }
      }
      /** @inheritdoc */
      rotate(angle) {
          // We need to rotate the svgs because of the coordinates system.
          const { drawLayer } = this.parent;
          let box;
          if (__classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")) {
              angle = (angle - this.rotation + 360) % 360;
              box = __classPrivateFieldGet(_a$2, _a$2, "m", _HighlightEditor_rotateBbox).call(_a$2, __classPrivateFieldGet(this, _HighlightEditor_highlightOutlines, "f").box, angle);
          }
          else {
              // An highlight annotation is always drawn horizontally.
              box = __classPrivateFieldGet(_a$2, _a$2, "m", _HighlightEditor_rotateBbox).call(_a$2, this, angle);
          }
          drawLayer.rotate(__classPrivateFieldGet(this, _HighlightEditor_id, "f"), angle);
          drawLayer.rotate(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), angle);
          drawLayer.updateBox(__classPrivateFieldGet(this, _HighlightEditor_id, "f"), box);
          drawLayer.updateBox(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), __classPrivateFieldGet(_a$2, _a$2, "m", _HighlightEditor_rotateBbox).call(_a$2, __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f").box, angle));
      }
      /** @inheritdoc */
      render() {
          if (this.div) {
              return this.div;
          }
          const div = super.render();
          if (__classPrivateFieldGet(this, _HighlightEditor_text, "f")) {
              div.setAttribute("aria-label", __classPrivateFieldGet(this, _HighlightEditor_text, "f"));
              div.setAttribute("role", "mark");
          }
          if (__classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")) {
              div.classList.add("free");
          }
          else {
              this.div.addEventListener("keydown", __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_keydown).bind(this), {
                  signal: this._uiManager._signal
              });
          }
          const highlightDiv = (__classPrivateFieldSet(this, _HighlightEditor_highlightDiv, document.createElement("div"), "f"));
          div.append(highlightDiv);
          highlightDiv.setAttribute("aria-hidden", "true");
          highlightDiv.className = "k-internal internal";
          highlightDiv.style.clipPath = __classPrivateFieldGet(this, _HighlightEditor_clipPathId, "f");
          const [parentWidth, parentHeight] = this.parentDimensions;
          this.setDims(this.width * parentWidth, this.height * parentHeight);
          bindEvents(this, __classPrivateFieldGet(this, _HighlightEditor_highlightDiv, "f"), ["pointerover", "pointerleave"]);
          this.enableEditing();
          return div;
      }
      pointerover() {
          this.parent.drawLayer.addClass(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), "hovered");
      }
      pointerleave() {
          this.parent.drawLayer.removeClass(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), "hovered");
      }
      _moveCaret(direction) {
          this.parent.unselect(this);
          switch (direction) {
              case 0 /* left */:
              case 2 /* up */:
                  __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_setCaret).call(this, /* start = */ true);
                  break;
              case 1 /* right */:
              case 3 /* down */:
                  __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_setCaret).call(this, /* start = */ false);
                  break;
              default: break;
          }
      }
      /** @inheritdoc */
      select() {
          var _b, _c, _d;
          super.select();
          if (!__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f")) {
              return;
          }
          (_b = this.parent) === null || _b === void 0 ? void 0 : _b.drawLayer.removeClass(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), "hovered");
          (_c = this.parent) === null || _c === void 0 ? void 0 : _c.drawLayer.addClass(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), "selected");
          (_d = this.parent) === null || _d === void 0 ? void 0 : _d.drawLayer.addClass(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), "k-selected");
      }
      /** @inheritdoc */
      unselect() {
          var _b, _c;
          super.unselect();
          if (!__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f")) {
              return;
          }
          (_b = this.parent) === null || _b === void 0 ? void 0 : _b.drawLayer.removeClass(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), "selected");
          (_c = this.parent) === null || _c === void 0 ? void 0 : _c.drawLayer.removeClass(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), "k-selected");
          if (!__classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")) {
              __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_setCaret).call(this, /* start = */ false);
          }
      }
      /** @inheritdoc */
      get _mustFixPosition() {
          return !__classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f");
      }
      /** @inheritdoc */
      show(visible = this._isVisible) {
          super.show(visible);
          if (this.parent) {
              this.parent.drawLayer.show(__classPrivateFieldGet(this, _HighlightEditor_id, "f"), visible);
              this.parent.drawLayer.show(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), visible);
          }
      }
      static startHighlighting(parent, isLTR, { target: textLayer, x, y }) {
          const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
          const ac = new AbortController();
          const signal = parent.combinedSignal(ac);
          const pointerDown = e => {
              // Avoid to have undesired clicks during the drawing.
              e.preventDefault();
              e.stopPropagation();
          };
          const pointerUpCallback = e => {
              ac.abort();
              __classPrivateFieldGet(this, _a$2, "m", _HighlightEditor_endHighlight).call(this, parent, e);
          };
          window.addEventListener("blur", pointerUpCallback, { signal });
          window.addEventListener("pointerup", pointerUpCallback, { signal });
          window.addEventListener("pointerdown", pointerDown, {
              capture: true,
              passive: false,
              signal
          });
          window.addEventListener("contextmenu", kendo_pdfjs_loader_js.noContextMenu, { signal });
          textLayer.addEventListener("pointermove", __classPrivateFieldGet(this, _a$2, "m", _HighlightEditor_highlightMove).bind(this, parent), { signal });
          this._freeHighlight = new FreeOutliner({ x, y }, [layerX, layerY, parentWidth, parentHeight], parent.scale, this._defaultThickness / 2, isLTR, 
          /* innerMargin = */ 0.001);
          ({ id: this._freeHighlightId, clipPathId: this._freeHighlightClipId } =
              parent.drawLayer.highlight(this._freeHighlight, this._defaultColor, this._defaultOpacity, 
              /* isPathUpdatable = */ true));
      }
      /** @inheritdoc */
      static deserialize(data, parent, uiManager) {
          const editor = super.deserialize(data, parent, uiManager);
          const { rect: [blX, blY, trX, trY], color, quadPoints } = data;
          // @ts-expect-error TS()
          editor.color = kendo_pdfjs_loader_js.Util.makeHexColor(...color);
          __classPrivateFieldSet(editor, _HighlightEditor_opacity, data.opacity, "f");
          const [pageWidth, pageHeight] = editor.pageDimensions;
          editor.width = (trX - blX) / pageWidth;
          editor.height = (trY - blY) / pageHeight;
          const boxes = (__classPrivateFieldSet(editor, _HighlightEditor_boxes, [], "f"));
          for (let i = 0; i < quadPoints.length; i += 8) {
              boxes.push({
                  x: (quadPoints[4] - trX) / pageWidth,
                  y: (trY - (1 - quadPoints[i + 5])) / pageHeight,
                  width: (quadPoints[i + 2] - quadPoints[i]) / pageWidth,
                  height: (quadPoints[i + 5] - quadPoints[i + 1]) / pageHeight
              });
          }
          __classPrivateFieldGet(editor, _HighlightEditor_instances, "m", _HighlightEditor_createOutlines).call(editor);
          return editor;
      }
      /** @inheritdoc */
      serialize(isForCopying = false) {
          // It doesn't make sense to copy/paste a highlight annotation.
          if (this.isEmpty() || isForCopying) {
              return null;
          }
          const rect = this.getRect(0, 0);
          const color = AnnotationEditor._colorManager.convert(this.color);
          return {
              annotationType: kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT,
              color,
              opacity: __classPrivateFieldGet(this, _HighlightEditor_opacity, "f"),
              thickness: __classPrivateFieldGet(this, _HighlightEditor_thickness, "f"),
              quadPoints: __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_serializeBoxes).call(this),
              outlines: __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_serializeOutlines).call(this, rect),
              pageIndex: this.pageIndex,
              rect,
              rotation: __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_getRotation).call(this),
              structTreeParentId: this._structTreeParentId
          };
      }
      static canCreateNewEmptyEditor() {
          return false;
      }
      // todo: this is necessary
      // saveDocument() has checks that test "editor instanceof AnnotationEditor", but they fail
      // because AnnotationEditor from "pdfjs-dist/legacy/build/pdf.mjs" is not exported
      // thus replace instances of editors with their serialized version
      toJSON() {
          const data = this.serialize();
          return data;
      }
  }
  _a$2 = HighlightEditor, _HighlightEditor_anchorNode = new WeakMap(), _HighlightEditor_anchorOffset = new WeakMap(), _HighlightEditor_boxes = new WeakMap(), _HighlightEditor_clipPathId = new WeakMap(), _HighlightEditor_focusOutlines = new WeakMap(), _HighlightEditor_focusNode = new WeakMap(), _HighlightEditor_focusOffset = new WeakMap(), _HighlightEditor_highlightDiv = new WeakMap(), _HighlightEditor_highlightOutlines = new WeakMap(), _HighlightEditor_id = new WeakMap(), _HighlightEditor_isFreeHighlight = new WeakMap(), _HighlightEditor_lastPoint = new WeakMap(), _HighlightEditor_opacity = new WeakMap(), _HighlightEditor_outlineId = new WeakMap(), _HighlightEditor_text = new WeakMap(), _HighlightEditor_thickness = new WeakMap(), _HighlightEditor_methodOfCreation = new WeakMap(), _HighlightEditor_instances = new WeakSet(), _HighlightEditor_createOutlines = function _HighlightEditor_createOutlines() {
      const outliner = new Outliner(__classPrivateFieldGet(this, _HighlightEditor_boxes, "f"), /* borderWidth = */ 0.001);
      __classPrivateFieldSet(this, _HighlightEditor_highlightOutlines, outliner.getOutlines(), "f");
      ({
          x: this.x,
          y: this.y,
          width: this.width,
          height: this.height
      } = __classPrivateFieldGet(this, _HighlightEditor_highlightOutlines, "f").box);
      const outlinerForOutline = new Outliner(__classPrivateFieldGet(this, _HighlightEditor_boxes, "f"), 
      /* borderWidth = */ 0.0025, 
      /* innerMargin = */ 0.001, this._uiManager.direction === "ltr");
      __classPrivateFieldSet(this, _HighlightEditor_focusOutlines, outlinerForOutline.getOutlines(), "f");
      // The last point is in the pages coordinate system.
      const { lastPoint } = __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f").box;
      __classPrivateFieldSet(this, _HighlightEditor_lastPoint, [
          (lastPoint[0] - this.x) / this.width,
          (lastPoint[1] - this.y) / this.height
      ], "f");
  }, _HighlightEditor_createFreeOutlines = function _HighlightEditor_createFreeOutlines({ highlightOutlines, highlightId, clipPathId }) {
      __classPrivateFieldSet(this, _HighlightEditor_highlightOutlines, highlightOutlines, "f");
      const extraThickness = 1.5;
      __classPrivateFieldSet(this, _HighlightEditor_focusOutlines, highlightOutlines.getNewOutline(
      /* Slightly bigger than the highlight in order to have a little
         space between the highlight and the outline. */
      __classPrivateFieldGet(this, _HighlightEditor_thickness, "f") / 2 + extraThickness, 
      /* innerMargin = */ 0.0025), "f");
      if (highlightId >= 0) {
          __classPrivateFieldSet(this, _HighlightEditor_id, highlightId, "f");
          __classPrivateFieldSet(this, _HighlightEditor_clipPathId, clipPathId, "f");
          // We need to redraw the highlight because we change the coordinates to be
          // in the box coordinate system.
          this.parent.drawLayer.finalizeLine(highlightId, highlightOutlines);
          __classPrivateFieldSet(this, _HighlightEditor_outlineId, this.parent.drawLayer.highlightOutline(__classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f")), "f");
      }
      else if (this.parent) {
          const angle = this.parent.viewport.rotation;
          this.parent.drawLayer.updateLine(__classPrivateFieldGet(this, _HighlightEditor_id, "f"), highlightOutlines);
          this.parent.drawLayer.updateBox(__classPrivateFieldGet(this, _HighlightEditor_id, "f"), __classPrivateFieldGet(_a$2, _a$2, "m", _HighlightEditor_rotateBbox).call(_a$2, __classPrivateFieldGet(this, _HighlightEditor_highlightOutlines, "f").box, (angle - this.rotation + 360) % 360));
          this.parent.drawLayer.updateLine(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f"));
          this.parent.drawLayer.updateBox(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), __classPrivateFieldGet(_a$2, _a$2, "m", _HighlightEditor_rotateBbox).call(_a$2, __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f").box, angle));
      }
      const { x, y, width, height } = highlightOutlines.box;
      switch (this.rotation) {
          case 0:
              this.x = x;
              this.y = y;
              this.width = width;
              this.height = height;
              break;
          case 90: {
              const [pageWidth, pageHeight] = this.parentDimensions;
              this.x = y;
              this.y = 1 - x;
              this.width = (width * pageHeight) / pageWidth;
              this.height = (height * pageWidth) / pageHeight;
              break;
          }
          case 180:
              this.x = 1 - x;
              this.y = 1 - y;
              this.width = width;
              this.height = height;
              break;
          case 270: {
              const [pageWidth, pageHeight] = this.parentDimensions;
              this.x = 1 - y;
              this.y = x;
              this.width = (width * pageHeight) / pageWidth;
              this.height = (height * pageWidth) / pageHeight;
              break;
          }
          default: break;
      }
      const { lastPoint } = __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f").box;
      __classPrivateFieldSet(this, _HighlightEditor_lastPoint, [(lastPoint[0] - x) / width, (lastPoint[1] - y) / height], "f");
  }, _HighlightEditor_updateColor = function _HighlightEditor_updateColor(color) {
      if (!color) {
          return;
      }
      const setColor = col => {
          var _b;
          this.color = col;
          (_b = this.parent) === null || _b === void 0 ? void 0 : _b.drawLayer.changeColor(__classPrivateFieldGet(this, _HighlightEditor_id, "f"), col);
          // this.#colorPicker?.updateColor(col);
      };
      const savedColor = this.color;
      this.addCommands({
          cmd: setColor.bind(this, color),
          undo: setColor.bind(this, savedColor),
          post: this._uiManager.updateUI.bind(this._uiManager, this),
          mustExec: true,
          type: kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_COLOR,
          overwriteIfSameType: true,
          keepUndo: true
      });
      // this._reportTelemetry(
      //     {
      //         action: "color_changed",
      //         color: this._uiManager.highlightColorNames.get(color),
      //     },
      //     /* mustWait = */ true
      // );
  }, _HighlightEditor_updateThickness = function _HighlightEditor_updateThickness(thickness) {
      if (!thickness) {
          /* no-empty */
      }
      // const savedThickness = this.#thickness;
      // const setThickness = th => {
      //     this.#thickness = th;
      //     this.#changeThickness(th);
      // };
      // this.addCommands({
      //     cmd: setThickness.bind(this, thickness),
      //     undo: setThickness.bind(this, savedThickness),
      //     post: this._uiManager.updateUI.bind(this._uiManager, this),
      //     mustExec: true,
      //     type: AnnotationEditorParamsType.INK_THICKNESS,
      //     overwriteIfSameType: true,
      //     keepUndo: true,
      // });
      // this._reportTelemetry(
      //     { action: "thickness_changed", thickness },
      // /* mustWait = */ true
      // );
  }, _HighlightEditor_cleanDrawLayer = function _HighlightEditor_cleanDrawLayer() {
      if (__classPrivateFieldGet(this, _HighlightEditor_id, "f") === null || !this.parent) {
          return;
      }
      this.parent.drawLayer.remove(__classPrivateFieldGet(this, _HighlightEditor_id, "f"));
      __classPrivateFieldSet(this, _HighlightEditor_id, null, "f");
      this.parent.drawLayer.remove(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"));
      __classPrivateFieldSet(this, _HighlightEditor_outlineId, null, "f");
  }, _HighlightEditor_addToDrawLayer = function _HighlightEditor_addToDrawLayer(parent = this.parent) {
      var _b, _c;
      if (__classPrivateFieldGet(this, _HighlightEditor_id, "f") !== null) {
          return;
      }
      (_b = this, _c = this, { id: ({ set value(_d) { __classPrivateFieldSet(_b, _HighlightEditor_id, _d, "f"); } }).value, clipPathId: ({ set value(_d) { __classPrivateFieldSet(_c, _HighlightEditor_clipPathId, _d, "f"); } }).value } =
          parent.drawLayer.highlight(__classPrivateFieldGet(this, _HighlightEditor_highlightOutlines, "f"), this.color, __classPrivateFieldGet(this, _HighlightEditor_opacity, "f")));
      __classPrivateFieldSet(this, _HighlightEditor_outlineId, parent.drawLayer.highlightOutline(__classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f")), "f");
      // // todo: manually set styles, so that SVG elements are properly displayed
      // if (parent.drawLayer.parent) {
      //     Array.from(parent.drawLayer.parent.querySelectorAll(".highlight")).forEach(x => {
      //         const element = x as any;
      //         element.style["--blend-mode"] = "multiply";
      //         element.style.position = "absolute";
      //         element.style["mix-blend-mode"] = "var(--blend-mode)";
      //         element.style.transform = "none";
      //     });
      // }
      if (__classPrivateFieldGet(this, _HighlightEditor_highlightDiv, "f")) {
          __classPrivateFieldGet(this, _HighlightEditor_highlightDiv, "f").style.clipPath = __classPrivateFieldGet(this, _HighlightEditor_clipPathId, "f");
      }
  }, _HighlightEditor_rotateBbox = function _HighlightEditor_rotateBbox({ x, y, width, height }, angle) {
      switch (angle) {
          case 90:
              return {
                  x: 1 - y - height,
                  y: x,
                  width: height,
                  height: width
              };
          case 180:
              return {
                  x: 1 - x - width,
                  y: 1 - y - height,
                  width,
                  height
              };
          case 270:
              return {
                  x: y,
                  y: 1 - x - width,
                  width: height,
                  height: width
              };
          default: break;
      }
      return {
          x,
          y,
          width,
          height
      };
  }, _HighlightEditor_keydown = function _HighlightEditor_keydown(event) {
      if (!event) {
          /* no-empty */
      }
      // HighlightEditor._keyboardManager.exec(this, event);
  }, _HighlightEditor_setCaret = function _HighlightEditor_setCaret(start) {
      if (!__classPrivateFieldGet(this, _HighlightEditor_anchorNode, "f")) {
          return;
      }
      const selection = window.getSelection();
      if (start) {
          selection.setPosition(__classPrivateFieldGet(this, _HighlightEditor_anchorNode, "f"), __classPrivateFieldGet(this, _HighlightEditor_anchorOffset, "f"));
      }
      else {
          selection.setPosition(__classPrivateFieldGet(this, _HighlightEditor_focusNode, "f"), __classPrivateFieldGet(this, _HighlightEditor_focusOffset, "f"));
      }
  }, _HighlightEditor_getRotation = function _HighlightEditor_getRotation() {
      // Highlight annotations are always drawn horizontally but if
      // a free highlight annotation can be rotated.
      return __classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f") ? this.rotation : 0;
  }, _HighlightEditor_serializeBoxes = function _HighlightEditor_serializeBoxes() {
      if (__classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")) {
          return null;
      }
      const [pageWidth, pageHeight] = this.pageDimensions;
      const [pageX, pageY] = this.pageTranslation;
      const boxes = __classPrivateFieldGet(this, _HighlightEditor_boxes, "f");
      const quadPoints = new Float32Array(boxes.length * 8);
      let i = 0;
      for (const { x, y, width, height } of boxes) {
          const sx = x * pageWidth + pageX;
          const sy = (1 - y - height) * pageHeight + pageY;
          // The specifications say that the rectangle should start from the bottom
          // left corner and go counter-clockwise.
          // But when opening the file in Adobe Acrobat it appears that this isn't
          // correct hence the 4th and 6th numbers are just swapped.
          quadPoints[i] = quadPoints[i + 4] = sx;
          quadPoints[i + 1] = quadPoints[i + 3] = sy;
          quadPoints[i + 2] = quadPoints[i + 6] = sx + width * pageWidth;
          quadPoints[i + 5] = quadPoints[i + 7] = sy + height * pageHeight;
          i += 8;
      }
      return quadPoints;
  }, _HighlightEditor_serializeOutlines = function _HighlightEditor_serializeOutlines(rect) {
      return __classPrivateFieldGet(this, _HighlightEditor_highlightOutlines, "f").serialize(rect, __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_getRotation).call(this));
  }, _HighlightEditor_highlightMove = function _HighlightEditor_highlightMove(parent, event) {
      if (this._freeHighlight.add(event)) {
          // Redraw only if the point has been added.
          parent.drawLayer.updatePath(this._freeHighlightId, this._freeHighlight);
      }
  }, _HighlightEditor_endHighlight = function _HighlightEditor_endHighlight(parent, event) {
      if (!this._freeHighlight.isEmpty()) {
          parent.createAndAddNewEditor(event, false, {
              highlightId: this._freeHighlightId,
              highlightOutlines: this._freeHighlight.getOutlines(),
              clipPathId: this._freeHighlightClipId,
              methodOfCreation: "main_toolbar"
          });
      }
      else {
          parent.drawLayer.removeFreeHighlight(this._freeHighlightId);
      }
      this._freeHighlightId = -1;
      this._freeHighlight = null;
      this._freeHighlightClipId = "";
  };
  HighlightEditor._defaultColor = null;
  HighlightEditor._defaultOpacity = 1;
  HighlightEditor._defaultThickness = 12;
  HighlightEditor._type = "highlight";
  HighlightEditor._editorType = kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT;
  HighlightEditor._freeHighlightId = -1;
  HighlightEditor._freeHighlight = null;
  HighlightEditor._freeHighlightClipId = "";

  /* Copyright 2022 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _AnnotationEditorLayer_instances, _a$1, _AnnotationEditorLayer_accessibilityManager, _AnnotationEditorLayer_allowClick, _AnnotationEditorLayer_annotationLayer, _AnnotationEditorLayer_clickAC, _AnnotationEditorLayer_editorFocusTimeoutId, _AnnotationEditorLayer_editors, _AnnotationEditorLayer_hadPointerDown, _AnnotationEditorLayer_isCleaningUp, _AnnotationEditorLayer_isDisabling, _AnnotationEditorLayer_textLayer, _AnnotationEditorLayer_textSelectionAC, _AnnotationEditorLayer_uiManager, _AnnotationEditorLayer_editorTypes, _AnnotationEditorLayer_textLayerPointerDown, _AnnotationEditorLayer_currentEditorType_get, _AnnotationEditorLayer_createNewEditor, _AnnotationEditorLayer_getCenterPoint, _AnnotationEditorLayer_cleanup;
  class AnnotationEditorLayer {
      /**
       * @param {AnnotationEditorLayerOptions} options
       */
      constructor({ uiManager, pageIndex, div, accessibilityManager, annotationLayer, drawLayer, textLayer, viewport
      // l10n
       }) {
          _AnnotationEditorLayer_instances.add(this);
          // todo: props
          this.drawLayer = null;
          this.pageIndex = 0;
          this.div = null;
          this.viewport = null;
          // todo: props
          _AnnotationEditorLayer_accessibilityManager.set(this, void 0);
          _AnnotationEditorLayer_allowClick.set(this, false);
          _AnnotationEditorLayer_annotationLayer.set(this, null);
          _AnnotationEditorLayer_clickAC.set(this, null);
          _AnnotationEditorLayer_editorFocusTimeoutId.set(this, null);
          _AnnotationEditorLayer_editors.set(this, new Map());
          _AnnotationEditorLayer_hadPointerDown.set(this, false);
          _AnnotationEditorLayer_isCleaningUp.set(this, false);
          _AnnotationEditorLayer_isDisabling.set(this, false);
          _AnnotationEditorLayer_textLayer.set(this, null);
          _AnnotationEditorLayer_textSelectionAC.set(this, null);
          _AnnotationEditorLayer_uiManager.set(this, null);
          const editorTypes = [...__classPrivateFieldGet(_a$1, _a$1, "f", _AnnotationEditorLayer_editorTypes).values()];
          if (!_a$1._initialized) {
              _a$1._initialized = true;
              for (const editorType of editorTypes) {
                  // editorType.initialize(l10n, uiManager);
                  editorType.initialize({}, uiManager);
              }
          }
          uiManager.registerEditorTypes(editorTypes);
          __classPrivateFieldSet(this, _AnnotationEditorLayer_uiManager, uiManager, "f");
          this.pageIndex = pageIndex;
          this.div = div;
          __classPrivateFieldSet(this, _AnnotationEditorLayer_accessibilityManager, accessibilityManager, "f");
          __classPrivateFieldSet(this, _AnnotationEditorLayer_annotationLayer, annotationLayer, "f");
          this.viewport = viewport;
          __classPrivateFieldSet(this, _AnnotationEditorLayer_textLayer, textLayer, "f");
          this.drawLayer = drawLayer;
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addLayer(this);
          // if (!this.#annotationLayer || !this.#textLayer) {
          // }
      }
      // todo: ported from AnnotationEditorLayerBuilder
      hide() {
          if (!this.div) {
              return;
          }
          this.div.hidden = true;
      }
      show() {
          if (!this.div || this.isInvisible) {
              return;
          }
          this.div.hidden = false;
      }
      // todo: ported from AnnotationEditorLayerBuilder
      get isEmpty() {
          return __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").size === 0;
      }
      get isInvisible() {
          return (this.isEmpty && __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getMode() === kendo_pdfjs_loader_js.AnnotationEditorType.NONE);
      }
      /**
       * Update the toolbar if it's required to reflect the tool currently used.
       * @param {number} mode
       */
      // updateToolbar(mode) {
      updateToolbar() {
          // this.#uiManager.updateToolbar(mode);
      }
      /**
       * The mode has changed: it must be updated.
       * @param {number} mode
       */
      updateMode(mode = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getMode()) {
          __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_cleanup).call(this);
          switch (mode) {
              case kendo_pdfjs_loader_js.AnnotationEditorType.NONE:
                  this.disableTextSelection();
                  this.togglePointerEvents(false);
                  this.toggleAnnotationLayerPointerEvents(true);
                  this.disableClick();
                  return;
              case kendo_pdfjs_loader_js.AnnotationEditorType.INK:
                  // We always want to have an ink editor ready to draw in.
                  this.addInkEditorIfNeeded(false);
                  this.disableTextSelection();
                  this.togglePointerEvents(true);
                  this.disableClick();
                  break;
              case kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT:
                  this.enableTextSelection();
                  this.togglePointerEvents(false);
                  this.disableClick();
                  break;
              default:
                  this.disableTextSelection();
                  this.togglePointerEvents(true);
                  this.enableClick();
          }
          this.toggleAnnotationLayerPointerEvents(false);
          const { classList } = this.div;
          for (const editorType of __classPrivateFieldGet(_a$1, _a$1, "f", _AnnotationEditorLayer_editorTypes).values()) {
              classList.toggle(`${editorType._type}Editing`, mode === editorType._editorType);
          }
          this.div.hidden = false;
      }
      hasTextLayer(textLayer) {
          var _b;
          return textLayer === ((_b = __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f")) === null || _b === void 0 ? void 0 : _b.div);
          // return textLayer === this.#textLayer || textLayer === this.#textLayer?.div;
      }
      addInkEditorIfNeeded(isCommitting) {
          if (__classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getMode() !== kendo_pdfjs_loader_js.AnnotationEditorType.INK) {
              // We don't want to add an ink editor if we're not in ink mode!
              return;
          }
          if (!isCommitting) {
              // We're removing an editor but an empty one can already exist so in this
              // case we don't need to create a new one.
              for (const editor of __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").values()) {
                  if (editor.isEmpty()) {
                      editor.setInBackground();
                      return;
                  }
              }
          }
          const newEditor = this.createAndAddNewEditor({ offsetX: 0, offsetY: 0 }, 
          /* isCentered = */ false);
          newEditor.setInBackground();
      }
      /**
       * Set the editing state.
       * @param {boolean} isEditing
       */
      setEditingState(isEditing) {
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").setEditingState(isEditing);
      }
      /**
       * Add some commands into the CommandManager (undo/redo stuff).
       * @param {Object} params
       */
      addCommands(params) {
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addCommands(params);
      }
      toggleDrawing(enabled = false) {
          this.div.classList.toggle("drawing", !enabled);
          // this.div.classList.toggle("k-drawing", !enabled);
      }
      togglePointerEvents(enabled = false) {
          // this.div.classList.toggle("disabled", !enabled);
          this.div.classList.toggle("k-annotation-editor-layer-disabled", !enabled);
      }
      toggleAnnotationLayerPointerEvents(enabled = false) {
          var _b;
          // this.#annotationLayer?.div.classList.toggle("disabled", !enabled);
          (_b = __classPrivateFieldGet(this, _AnnotationEditorLayer_annotationLayer, "f")) === null || _b === void 0 ? void 0 : _b.div.classList.toggle("k-annotation-editor-layer-disabled", !enabled);
      }
      /**
       * Enable pointer events on the main div in order to enable
       * editor creation.
       */
      enable() {
          this.div.tabIndex = 0;
          this.togglePointerEvents(true);
          const annotationElementIds = new Set();
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").values()) {
              editor.enableEditing();
              editor.show(true);
              if (editor.annotationElementId) {
                  __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").removeChangedExistingAnnotation(editor);
                  annotationElementIds.add(editor.annotationElementId);
              }
          }
          if (!__classPrivateFieldGet(this, _AnnotationEditorLayer_annotationLayer, "f")) {
              return;
          }
          const editables = __classPrivateFieldGet(this, _AnnotationEditorLayer_annotationLayer, "f").getEditableAnnotations();
          for (const editable of editables) {
              // The element must be hidden whatever its state is.
              editable.hide();
              if (__classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").isDeletedAnnotationElement(editable.data.id)) {
                  continue;
              }
              if (annotationElementIds.has(editable.data.id)) {
                  continue;
              }
              const editor = this.deserialize(editable);
              if (!editor) {
                  continue;
              }
              this.addOrRebuild(editor);
              editor.enableEditing();
          }
      }
      /**
       * Disable editor creation.
       */
      disable() {
          var _b;
          __classPrivateFieldSet(this, _AnnotationEditorLayer_isDisabling, true, "f");
          this.div.tabIndex = -1;
          this.togglePointerEvents(false);
          const changedAnnotations = new Map();
          const resetAnnotations = new Map();
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").values()) {
              editor.disableEditing();
              if (!editor.annotationElementId) {
                  continue;
              }
              if (editor.serialize() !== null) {
                  changedAnnotations.set(editor.annotationElementId, editor);
                  continue;
              }
              else {
                  resetAnnotations.set(editor.annotationElementId, editor);
              }
              (_b = this.getEditableAnnotation(editor.annotationElementId)) === null || _b === void 0 ? void 0 : _b.show();
              editor.remove();
          }
          if (__classPrivateFieldGet(this, _AnnotationEditorLayer_annotationLayer, "f")) {
              // Show the annotations that were hidden in enable().
              const editables = __classPrivateFieldGet(this, _AnnotationEditorLayer_annotationLayer, "f").getEditableAnnotations();
              for (const editable of editables) {
                  const { id } = editable.data;
                  if (__classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").isDeletedAnnotationElement(id)) {
                      continue;
                  }
                  let editor = resetAnnotations.get(id);
                  if (editor) {
                      editor.resetAnnotationElement(editable);
                      editor.show(false);
                      editable.show();
                      continue;
                  }
                  editor = changedAnnotations.get(id);
                  if (editor) {
                      __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addChangedExistingAnnotation(editor);
                      editor.renderAnnotationElement(editable);
                      editor.show(false);
                  }
                  editable.show();
              }
          }
          __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_cleanup).call(this);
          if (this.isEmpty) {
              this.div.hidden = true;
          }
          const { classList } = this.div;
          for (const editorType of __classPrivateFieldGet(_a$1, _a$1, "f", _AnnotationEditorLayer_editorTypes).values()) {
              classList.remove(`${editorType._type}Editing`);
          }
          this.disableTextSelection();
          this.toggleAnnotationLayerPointerEvents(true);
          __classPrivateFieldSet(this, _AnnotationEditorLayer_isDisabling, false, "f");
      }
      getEditableAnnotation(id) {
          var _b;
          return ((_b = __classPrivateFieldGet(this, _AnnotationEditorLayer_annotationLayer, "f")) === null || _b === void 0 ? void 0 : _b.getEditableAnnotation(id)) || null;
      }
      /**
       * Set the current editor.
       * @param {AnnotationEditor} editor
       */
      setActiveEditor(editor) {
          const currentActive = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getActive();
          if (currentActive === editor) {
              return;
          }
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").setActiveEditor(editor);
      }
      enableTextSelection() {
          var _b;
          this.div.tabIndex = -1;
          if (((_b = __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f")) === null || _b === void 0 ? void 0 : _b.div) && !__classPrivateFieldGet(this, _AnnotationEditorLayer_textSelectionAC, "f")) {
              __classPrivateFieldSet(this, _AnnotationEditorLayer_textSelectionAC, new AbortController(), "f");
              const signal = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").combinedSignal(__classPrivateFieldGet(this, _AnnotationEditorLayer_textSelectionAC, "f"));
              __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div.addEventListener("pointerdown", __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_textLayerPointerDown).bind(this), { signal });
              // this.#textLayer.div.classList.add("highlighting");
          }
      }
      disableTextSelection() {
          var _b;
          this.div.tabIndex = 0;
          if (((_b = __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f")) === null || _b === void 0 ? void 0 : _b.div) && __classPrivateFieldGet(this, _AnnotationEditorLayer_textSelectionAC, "f")) {
              __classPrivateFieldGet(this, _AnnotationEditorLayer_textSelectionAC, "f").abort();
              __classPrivateFieldSet(this, _AnnotationEditorLayer_textSelectionAC, null, "f");
              __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div.classList.remove("highlighting");
          }
      }
      enableClick() {
          if (__classPrivateFieldGet(this, _AnnotationEditorLayer_clickAC, "f")) {
              return;
          }
          __classPrivateFieldSet(this, _AnnotationEditorLayer_clickAC, new AbortController(), "f");
          const signal = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").combinedSignal(__classPrivateFieldGet(this, _AnnotationEditorLayer_clickAC, "f"));
          this.div.addEventListener("pointerdown", this.pointerdown.bind(this), {
              signal
          });
          this.div.addEventListener("pointerup", this.pointerup.bind(this), {
              signal
          });
      }
      disableClick() {
          var _b;
          (_b = __classPrivateFieldGet(this, _AnnotationEditorLayer_clickAC, "f")) === null || _b === void 0 ? void 0 : _b.abort();
          __classPrivateFieldSet(this, _AnnotationEditorLayer_clickAC, null, "f");
      }
      attach(editor) {
          __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").set(editor.id, editor);
          const { annotationElementId } = editor;
          if (annotationElementId &&
              __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").isDeletedAnnotationElement(annotationElementId)) {
              __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").removeDeletedAnnotationElement(editor);
          }
      }
      detach(editor) {
          var _b;
          __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").delete(editor.id);
          (_b = __classPrivateFieldGet(this, _AnnotationEditorLayer_accessibilityManager, "f")) === null || _b === void 0 ? void 0 : _b.removePointerInTextLayer(editor.contentDiv);
          if (!__classPrivateFieldGet(this, _AnnotationEditorLayer_isDisabling, "f") && editor.annotationElementId) {
              __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addDeletedAnnotationElement(editor);
          }
      }
      /**
       * Remove an editor.
       * @param {AnnotationEditor} editor
       */
      remove(editor) {
          this.detach(editor);
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").removeEditor(editor);
          editor.div.remove();
          editor.isAttachedToDOM = false;
          if (!__classPrivateFieldGet(this, _AnnotationEditorLayer_isCleaningUp, "f")) {
              this.addInkEditorIfNeeded(/* isCommitting = */ false);
          }
      }
      /**
       * An editor can have a different parent, for example after having
       * being dragged and droped from a page to another.
       * @param {AnnotationEditor} editor
       */
      changeParent(editor) {
          var _b;
          if (editor.parent === this) {
              return;
          }
          if (editor.parent && editor.annotationElementId) {
              __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addDeletedAnnotationElement(editor.annotationElementId);
              AnnotationEditor.deleteAnnotationElement(editor);
              editor.annotationElementId = null;
          }
          this.attach(editor);
          (_b = editor.parent) === null || _b === void 0 ? void 0 : _b.detach(editor);
          editor.setParent(this);
          if (editor.div && editor.isAttachedToDOM) {
              editor.div.remove();
              this.div.append(editor.div);
          }
      }
      /**
       * Add a new editor in the current view.
       * @param {AnnotationEditor} editor
       */
      add(editor) {
          if (editor.parent === this && editor.isAttachedToDOM) {
              return;
          }
          this.changeParent(editor);
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addEditor(editor);
          this.attach(editor);
          if (!editor.isAttachedToDOM) {
              const div = editor.render();
              this.div.append(div);
              editor.isAttachedToDOM = true;
          }
          // The editor will be correctly moved into the DOM (see fixAndSetPosition).
          editor.fixAndSetPosition();
          editor.onceAdded();
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addToAnnotationStorage(editor);
          // editor._reportTelemetry(editor.telemetryInitialData);
          // todo: this differs from pdf.js
          // this.setActiveEditor(editor);
      }
      moveEditorInDOM(editor) {
          var _b;
          if (!editor.isAttachedToDOM) {
              return;
          }
          const { activeElement } = document;
          if (editor.div.contains(activeElement) && !__classPrivateFieldGet(this, _AnnotationEditorLayer_editorFocusTimeoutId, "f")) {
              // When the div is moved in the DOM the focus can move somewhere else,
              // so we want to be sure that the focus will stay on the editor but we
              // don't want to call any focus callbacks, hence we disable them and only
              // re-enable them when the editor has the focus.
              editor._focusEventsAllowed = false;
              __classPrivateFieldSet(this, _AnnotationEditorLayer_editorFocusTimeoutId, setTimeout(() => {
                  __classPrivateFieldSet(this, _AnnotationEditorLayer_editorFocusTimeoutId, null, "f");
                  if (!editor.div.contains(document.activeElement)) {
                      editor.div.addEventListener("focusin", () => {
                          editor._focusEventsAllowed = true;
                      }, { once: true, signal: __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f")._signal });
                      activeElement.focus();
                  }
                  else {
                      editor._focusEventsAllowed = true;
                  }
              }, 0), "f");
          }
          editor._structTreeParentId = (_b = __classPrivateFieldGet(this, _AnnotationEditorLayer_accessibilityManager, "f")) === null || _b === void 0 ? void 0 : _b.moveElementInDOM(this.div, editor.div, editor.contentDiv, 
          /* isRemovable = */ true);
      }
      /**
       * Add or rebuild depending if it has been removed or not.
       * @param {AnnotationEditor} editor
       */
      addOrRebuild(editor) {
          if (editor.needsToBeRebuilt()) {
              editor.parent || (editor.parent = this);
              editor.rebuild();
              editor.show();
          }
          else {
              this.add(editor);
          }
      }
      /**
       * Add a new editor and make this addition undoable.
       * @param {AnnotationEditor} editor
       */
      addUndoableEditor(editor) {
          const cmd = () => editor._uiManager.rebuild(editor);
          const undo = () => {
              editor.remove();
          };
          this.addCommands({ cmd, undo, mustExec: false });
      }
      /**
       * Get an id for an editor.
       * @returns {string}
       */
      getNextId() {
          return __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getId();
      }
      combinedSignal(abortController) {
          return __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").combinedSignal(abortController);
      }
      canCreateNewEmptyEditor() {
          var _b;
          return (_b = __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "a", _AnnotationEditorLayer_currentEditorType_get)) === null || _b === void 0 ? void 0 : _b.canCreateNewEmptyEditor();
      }
      /**
       * Paste some content into a new editor.
       * @param {number} mode
       * @param {Object} params
       */
      pasteEditor(mode, params) {
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").updateToolbar(mode);
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").updateMode(mode);
          const { offsetX, offsetY } = __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_getCenterPoint).call(this);
          const id = this.getNextId();
          const editor = __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_createNewEditor).call(this, Object.assign({ parent: this, id, x: offsetX, y: offsetY, uiManager: __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f"), isCentered: true }, params));
          if (editor) {
              this.add(editor);
          }
      }
      /**
       * Create a new editor
       * @param {Object} data
       * @returns {AnnotationEditor | null}
       */
      deserialize(data) {
          var _b, _c;
          return (((_c = __classPrivateFieldGet(_a$1, _a$1, "f", _AnnotationEditorLayer_editorTypes)
              .get((_b = data.annotationType) !== null && _b !== void 0 ? _b : data.annotationEditorType)) === null || _c === void 0 ? void 0 : _c.deserialize(data, this, __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f"))) || null);
      }
      /**
       * Create and add a new editor.
       * @param {PointerEvent} event
       * @param {boolean} isCentered
       * @param [Object] data
       * @returns {AnnotationEditor}
       */
      createAndAddNewEditor(event, isCentered, data = {}) {
          const id = this.getNextId();
          const editor = __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_createNewEditor).call(this, Object.assign({ parent: this, id, x: event.offsetX, y: event.offsetY, uiManager: __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f"), isCentered }, data));
          if (editor) {
              this.add(editor);
          }
          return editor;
      }
      /**
       * Create and add a new editor.
       */
      addNewEditor() {
          this.createAndAddNewEditor(__classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_getCenterPoint).call(this), /* isCentered = */ true);
      }
      /**
       * Set the last selected editor.
       * @param {AnnotationEditor} editor
       */
      setSelected(editor) {
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").setSelected(editor);
      }
      /**
       * Add or remove an editor the current selection.
       * @param {AnnotationEditor} editor
       */
      toggleSelected(editor) {
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").toggleSelected(editor);
      }
      /**
       * Check if the editor is selected.
       * @param {AnnotationEditor} editor
       */
      isSelected(editor) {
          return __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").isSelected(editor);
      }
      /**
       * Unselect an editor.
       * @param {AnnotationEditor} editor
       */
      unselect(editor) {
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").unselect(editor);
      }
      /**
       * Pointerup callback.
       * @param {PointerEvent} event
       */
      pointerup(event) {
          const { isMac } = kendo_pdfjs_loader_js.FeatureTest.platform;
          if (event.button !== 0 || (event.ctrlKey && isMac)) {
              // Don't create an editor on right click.
              return;
          }
          if (event.target !== this.div) {
              return;
          }
          if (!__classPrivateFieldGet(this, _AnnotationEditorLayer_hadPointerDown, "f")) {
              // It can happen when the user starts a drag inside a text editor
              // and then releases the mouse button outside of it. In such a case
              // we don't want to create a new editor, hence we check that a pointerdown
              // occurred on this div previously.
              return;
          }
          __classPrivateFieldSet(this, _AnnotationEditorLayer_hadPointerDown, false, "f");
          if (!__classPrivateFieldGet(this, _AnnotationEditorLayer_allowClick, "f")) {
              __classPrivateFieldSet(this, _AnnotationEditorLayer_allowClick, true, "f");
              return;
          }
          if (__classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getMode() === kendo_pdfjs_loader_js.AnnotationEditorType.STAMP) {
              __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").unselectAll();
              return;
          }
          this.createAndAddNewEditor(event, /* isCentered = */ false);
      }
      /**
       * Pointerdown callback.
       * @param {PointerEvent} event
       */
      pointerdown(event) {
          if (__classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getMode() === kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT) {
              this.enableTextSelection();
          }
          if (__classPrivateFieldGet(this, _AnnotationEditorLayer_hadPointerDown, "f")) {
              // It's possible to have a second pointerdown event before a pointerup one
              // when the user puts a finger on a touchscreen and then add a second one
              // to start a pinch-to-zoom gesture.
              // That said, in case it's possible to have two pointerdown events with
              // a mouse, we don't want to create a new editor in such a case either.
              __classPrivateFieldSet(this, _AnnotationEditorLayer_hadPointerDown, false, "f");
              return;
          }
          const { isMac } = kendo_pdfjs_loader_js.FeatureTest.platform;
          if (event.button !== 0 || (event.ctrlKey && isMac)) {
              // Do nothing on right click.
              return;
          }
          if (event.target !== this.div) {
              return;
          }
          __classPrivateFieldSet(this, _AnnotationEditorLayer_hadPointerDown, true, "f");
          const editor = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getActive();
          __classPrivateFieldSet(this, _AnnotationEditorLayer_allowClick, !editor || editor.isEmpty(), "f");
      }
      /**
       *
       * @param {AnnotationEditor} editor
       * @param {number} x
       * @param {number} y
       * @returns
       */
      findNewParent(editor, x, y) {
          const layer = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").findParent(x, y);
          if (layer === null || layer === this) {
              return false;
          }
          layer.changeParent(editor);
          return true;
      }
      /**
       * Destroy the main editor.
       */
      destroy() {
          var _b, _c;
          if (((_b = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getActive()) === null || _b === void 0 ? void 0 : _b.parent) === this) {
              // We need to commit the current editor before destroying the layer.
              __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").commitOrRemove();
              __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").setActiveEditor(null);
          }
          if (__classPrivateFieldGet(this, _AnnotationEditorLayer_editorFocusTimeoutId, "f")) {
              clearTimeout(__classPrivateFieldGet(this, _AnnotationEditorLayer_editorFocusTimeoutId, "f"));
              __classPrivateFieldSet(this, _AnnotationEditorLayer_editorFocusTimeoutId, null, "f");
          }
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").values()) {
              (_c = __classPrivateFieldGet(this, _AnnotationEditorLayer_accessibilityManager, "f")) === null || _c === void 0 ? void 0 : _c.removePointerInTextLayer(editor.contentDiv);
              editor.setParent(null);
              editor.isAttachedToDOM = false;
              editor.div.remove();
          }
          this.div = null;
          __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").clear();
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").removeLayer(this);
      }
      /**
       * Render the main editor.
       * @param {RenderEditorLayerOptions} parameters
       */
      render({ viewport }) {
          this.viewport = viewport;
          kendo_pdfjs_loader_js.setLayerDimensions(this.div, viewport);
          for (const editor of __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getEditors(this.pageIndex)) {
              this.add(editor);
              editor.rebuild();
          }
          // We're maybe rendering a layer which was invisible when we started to edit
          // so we must set the different callbacks for it.
          this.updateMode();
      }
      // /**
      //  * Update the main editor.
      //  * @param {RenderEditorLayerOptions} parameters
      //  */
      update({ viewport }) {
          // Editors have their dimensions/positions in percent so to avoid any
          // issues (see #15582), we must commit the current one before changing
          // the viewport.
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").commitOrRemove();
          __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_cleanup).call(this);
          const oldRotation = this.viewport.rotation;
          const rotation = viewport.rotation;
          this.viewport = viewport;
          // setLayerDimensions(this.div, { rotation });
          // todo: fix parameters
          // setLayerDimensions(this.div, { rotation } as PageViewport);
          kendo_pdfjs_loader_js.setLayerDimensions(this.div, viewport);
          if (oldRotation !== rotation) {
              for (const editor of __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").values()) {
                  editor.rotate(rotation);
              }
          }
          this.addInkEditorIfNeeded(/* isCommitting = */ false);
      }
      /**
       * Get page dimensions.
       * @returns {Object} dimensions.
       */
      get pageDimensions() {
          const { pageWidth, pageHeight } = this.viewport.rawDims;
          return [pageWidth, pageHeight];
      }
      get scale() {
          return __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").viewParameters.realScale;
      }
  }
  _a$1 = AnnotationEditorLayer, _AnnotationEditorLayer_accessibilityManager = new WeakMap(), _AnnotationEditorLayer_allowClick = new WeakMap(), _AnnotationEditorLayer_annotationLayer = new WeakMap(), _AnnotationEditorLayer_clickAC = new WeakMap(), _AnnotationEditorLayer_editorFocusTimeoutId = new WeakMap(), _AnnotationEditorLayer_editors = new WeakMap(), _AnnotationEditorLayer_hadPointerDown = new WeakMap(), _AnnotationEditorLayer_isCleaningUp = new WeakMap(), _AnnotationEditorLayer_isDisabling = new WeakMap(), _AnnotationEditorLayer_textLayer = new WeakMap(), _AnnotationEditorLayer_textSelectionAC = new WeakMap(), _AnnotationEditorLayer_uiManager = new WeakMap(), _AnnotationEditorLayer_instances = new WeakSet(), _AnnotationEditorLayer_textLayerPointerDown = function _AnnotationEditorLayer_textLayerPointerDown(event) {
      // Unselect all the editors in order to let the user select some text
      // without being annoyed by an editor toolbar.
      __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").unselectAll();
      const { target } = event;
      if (target === __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div ||
          (target.classList.contains("endOfContent") && __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div.contains(target))) {
          const { isMac } = kendo_pdfjs_loader_js.FeatureTest.platform;
          if (event.button !== 0 || (event.ctrlKey && isMac)) {
              // Do nothing on right click.
              return;
          }
          __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").showAllEditors("highlight", true
          // /* updateButton = */ true
          );
          // if (this.#uiManager.getMode() === AnnotationEditorType.HIGHLIGHT) {
          if (__classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getMode() === kendo_pdfjs_loader_js.AnnotationEditorType.NONE) {
              // todo: do not continue with free highlight
              return;
          }
          // this.#textLayer.div.classList.add("free");
          // todo: intentionally prevent free highlight
          // this.toggleDrawing();
          // HighlightEditor.startHighlighting(
          //     this,
          //     this.#uiManager.direction === "ltr",
          //     event
          // );
          __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div.addEventListener("pointerup", () => {
              __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div.classList.remove("free");
              this.toggleDrawing(true);
          }, { once: true, signal: __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f")._signal });
          event.preventDefault();
      }
  }, _AnnotationEditorLayer_currentEditorType_get = function _AnnotationEditorLayer_currentEditorType_get() {
      return __classPrivateFieldGet(_a$1, _a$1, "f", _AnnotationEditorLayer_editorTypes).get(__classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getMode());
  }, _AnnotationEditorLayer_createNewEditor = function _AnnotationEditorLayer_createNewEditor(params) {
      const editorType = __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "a", _AnnotationEditorLayer_currentEditorType_get);
      // return editorType ? new editorType.prototype.constructor(params) : null;
      return editorType ? new editorType(params) : null;
  }, _AnnotationEditorLayer_getCenterPoint = function _AnnotationEditorLayer_getCenterPoint() {
      const { x, y, width, height } = this.div.getBoundingClientRect();
      const tlX = Math.max(0, x);
      const tlY = Math.max(0, y);
      const brX = Math.min(window.innerWidth, x + width);
      const brY = Math.min(window.innerHeight, y + height);
      const centerX = (tlX + brX) / 2 - x;
      const centerY = (tlY + brY) / 2 - y;
      const [offsetX, offsetY] = this.viewport.rotation % 180 === 0
          ? [centerX, centerY]
          : [centerY, centerX];
      return { offsetX, offsetY };
  }, _AnnotationEditorLayer_cleanup = function _AnnotationEditorLayer_cleanup() {
      // When we're cleaning up, some editors are removed but we don't want
      // to add a new one which will induce an addition in this.#editors, hence
      // an infinite loop.
      __classPrivateFieldSet(this, _AnnotationEditorLayer_isCleaningUp, true, "f");
      for (const editor of __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").values()) {
          if (editor.isEmpty()) {
              editor.remove();
          }
      }
      __classPrivateFieldSet(this, _AnnotationEditorLayer_isCleaningUp, false, "f");
  };
  AnnotationEditorLayer._initialized = false;
  _AnnotationEditorLayer_editorTypes = { value: new Map(
      // [FreeTextEditor, InkEditor, StampEditor, HighlightEditor].map(type => [
      [FreeTextEditor, HighlightEditor].map(type => [
          type._editorType,
          type
      ])) };

  /* Copyright 2022 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _AnnotationEditorLayerBuilder_annotationLayer, _AnnotationEditorLayerBuilder_drawLayer, _AnnotationEditorLayerBuilder_onAppend, _AnnotationEditorLayerBuilder_textLayer, _AnnotationEditorLayerBuilder_uiManager;
  // import { GenericL10n } from "web-null_l10n";
  /**
   * @typedef {Object} AnnotationEditorLayerBuilderOptions
   * @property {AnnotationEditorUIManager} [uiManager]
   * @property {PDFPageProxy} pdfPage
   * @property {IL10n} [l10n]
   * @property {TextAccessibilityManager} [accessibilityManager]
   * @property {AnnotationLayer} [annotationLayer]
   * @property {TextLayer} [textLayer]
   * @property {DrawLayer} [drawLayer]
   * @property {function} [onAppend]
   */
  class AnnotationEditorLayerBuilder {
      /**
       * @param {AnnotationEditorLayerBuilderOptions} options
       */
      constructor(options) {
          // todo: props
          this.pdfPage = null;
          this.annotationEditorLayer = null;
          this._cancelled = null;
          this.div = null;
          this.accessibilityManager = null;
          // todo: props
          _AnnotationEditorLayerBuilder_annotationLayer.set(this, null);
          _AnnotationEditorLayerBuilder_drawLayer.set(this, null);
          _AnnotationEditorLayerBuilder_onAppend.set(this, null);
          _AnnotationEditorLayerBuilder_textLayer.set(this, null);
          _AnnotationEditorLayerBuilder_uiManager.set(this, null);
          this.pdfPage = options.pdfPage;
          this.accessibilityManager = options.accessibilityManager;
          // this.l10n = options.l10n;
          // if (typeof PDFJSDev === "undefined" || PDFJSDev.test("GENERIC")) {
          // this.l10n ||= new GenericL10n();
          // }
          this.annotationEditorLayer = null;
          this.div = null;
          this._cancelled = false;
          __classPrivateFieldSet(this, _AnnotationEditorLayerBuilder_uiManager, options.uiManager, "f");
          __classPrivateFieldSet(this, _AnnotationEditorLayerBuilder_annotationLayer, options.annotationLayer || null, "f");
          __classPrivateFieldSet(this, _AnnotationEditorLayerBuilder_textLayer, options.textLayer || null, "f");
          __classPrivateFieldSet(this, _AnnotationEditorLayerBuilder_drawLayer, options.drawLayer || null, "f");
          __classPrivateFieldSet(this, _AnnotationEditorLayerBuilder_onAppend, options.onAppend || null, "f");
      }
      /**
       * @param {PageViewport} viewport
       * @param {string} intent (default value is 'display')
       */
      render(viewport_1) {
          return __awaiter(this, arguments, void 0, function* (viewport, intent = "display") {
              var _a;
              if (intent !== "display") {
                  return;
              }
              if (this._cancelled) {
                  return;
              }
              const clonedViewport = viewport.clone({ dontFlip: true });
              if (this.div) {
                  this.annotationEditorLayer.update({ viewport: clonedViewport });
                  this.show();
                  return;
              }
              // Create an AnnotationEditor layer div
              const div = (this.div = document.createElement("div"));
              div.className = "k-annotation-editor-layer";
              div.hidden = true;
              div.dir = __classPrivateFieldGet(this, _AnnotationEditorLayerBuilder_uiManager, "f").direction;
              (_a = __classPrivateFieldGet(this, _AnnotationEditorLayerBuilder_onAppend, "f")) === null || _a === void 0 ? void 0 : _a.call(this, div);
              this.annotationEditorLayer = new AnnotationEditorLayer({
                  uiManager: __classPrivateFieldGet(this, _AnnotationEditorLayerBuilder_uiManager, "f"),
                  div,
                  accessibilityManager: this.accessibilityManager,
                  pageIndex: this.pdfPage.pageNumber - 1,
                  // l10n: this.l10n,
                  viewport: clonedViewport,
                  annotationLayer: __classPrivateFieldGet(this, _AnnotationEditorLayerBuilder_annotationLayer, "f"),
                  textLayer: __classPrivateFieldGet(this, _AnnotationEditorLayerBuilder_textLayer, "f"),
                  drawLayer: __classPrivateFieldGet(this, _AnnotationEditorLayerBuilder_drawLayer, "f")
              });
              const parameters = {
                  viewport: clonedViewport,
                  div,
                  annotations: null,
                  intent
              };
              this.annotationEditorLayer.render(parameters);
              this.show();
          });
      }
      cancel() {
          var _a;
          this._cancelled = true;
          if (!this.div) {
              return;
          }
          (_a = this.annotationEditorLayer) === null || _a === void 0 ? void 0 : _a.destroy();
      }
      hide() {
          if (!this.div) {
              return;
          }
          this.div.hidden = true;
      }
      show() {
          if (!this.div || this.annotationEditorLayer.isInvisible) {
              return;
          }
          this.div.hidden = false;
      }
      destroy() {
          var _a;
          (_a = this.annotationEditorLayer) === null || _a === void 0 ? void 0 : _a.destroy();
      }
  }
  _AnnotationEditorLayerBuilder_annotationLayer = new WeakMap(), _AnnotationEditorLayerBuilder_drawLayer = new WeakMap(), _AnnotationEditorLayerBuilder_onAppend = new WeakMap(), _AnnotationEditorLayerBuilder_textLayer = new WeakMap(), _AnnotationEditorLayerBuilder_uiManager = new WeakMap();

  var _Page_instances, _Page_annotationMode, _Page_isEditing, _Page_layerProperties, _Page_previousRotation, _Page_renderingState, _Page_textLayerMode, _Page_viewportMap, _Page_layers, _Page_addLayer, _Page_setDimensions, _Page_dispatchLayerRendered, _Page_renderAnnotationLayer, _Page_renderAnnotationEditorLayer, _Page_renderDrawLayer, _Page_renderTextLayer, _Page_finishRenderTask;
  const DEFAULT_ZOOM_LEVEL$1 = 1.25;
  const DEFAULT_LAYER_PROPERTIES = {
      annotationEditorUIManager: null,
      annotationStorage: null,
      downloadManager: null,
      enableScripting: false,
      fieldObjectsPromise: null,
      findController: null,
      hasJSActionsPromise: null,
      get linkService() {
          // return new SimpleLinkService();
          return null;
      }
  };
  const LAYERS_ORDER = new Map([
      ["canvasWrapper", 0],
      ["textLayer", 1],
      ["annotationLayer", 2],
      ["annotationEditorLayer", 3],
      ["xfaLayer", 3]
  ]);
  class Page extends Component {
      constructor(element, options) {
          super(element, options);
          _Page_instances.add(this);
          // todo: props
          this.eventBus = null;
          this.zoomLayer = null;
          this.div = null;
          this.viewport = null;
          this.id = 1;
          this._accessibilityManager = null;
          this._annotationCanvasMap = new Map();
          this.renderTask = null;
          this.pdfPageRotate = null;
          this.rotation = null;
          this.scale = null;
          this.pdfViewer = null;
          // todo: props
          // todo: props ported from pdf.js
          this.xfaLayer = null;
          _Page_annotationMode.set(this, kendo_pdfjs_loader_js.AnnotationMode.ENABLE);
          // #enableHWA = false;
          // #hasRestrictedScaling = false;
          // // @ts-expect-error(TS)
          _Page_isEditing.set(this, false);
          _Page_layerProperties.set(this, null);
          // #loadingId = null;
          _Page_previousRotation.set(this, null);
          // #renderError = null;
          _Page_renderingState.set(this, RenderingStates.INITIAL);
          _Page_textLayerMode.set(this, TextLayerMode.ENABLE);
          // #useThumbnailCanvas = {
          //   directDrawing: true,
          //   initialOptionalContent: true,
          //   regularAnnotations: true,
          // };
          _Page_viewportMap.set(this, new WeakMap());
          _Page_layers.set(this, [null, null, null, null]);
          // textLayer: HTMLDivElement;
          this.textLayer = null;
          this.textLayerBuilder = null;
          this.textAccessibilityManager = null;
          this.annotationLayer = null;
          this.drawLayer = null;
          this.annotationEditorLayer = null;
          this.options = {};
          this.state = {};
          this.pdfPage = null;
          this.extendOptions(options);
          // todo: ported from pdf.js
          this.div = element;
          this.viewport = this.options.viewport;
          this.id = this.options.id || this.options.number || 1;
          __classPrivateFieldSet(this, _Page_layerProperties, options.layerProperties || DEFAULT_LAYER_PROPERTIES, "f");
          this.eventBus = options.eventBus;
          this.initScale();
          // todo: ported from pdf.js
          this.pdfViewer = options.pdfViewer;
          this.pdfPage = options.pdfPage;
          __classPrivateFieldSet(this, _Page_annotationMode, this.pdfViewer.getAnnotationMode(), "f");
          this.resetState();
      }
      destroy() {
          var _a, _b, _c, _d, _e;
          this.destroyTextLayer();
          if (this.canvas) {
              this.canvas.width = 0;
              this.canvas.height = 0;
              this.canvas.remove();
              this.canvas = null;
          }
          if (this.canvasForPrint) {
              this.canvasForPrint.width = 0;
              this.canvasForPrint.height = 0;
              this.canvasForPrint.remove();
              this.canvasForPrint = null;
          }
          (_a = this.drawLayer) === null || _a === void 0 ? void 0 : _a.destroy();
          (_b = this.annotationLayer) === null || _b === void 0 ? void 0 : _b.destroy();
          (_c = this.annotationEditorLayer) === null || _c === void 0 ? void 0 : _c.destroy();
          (_d = this.div) === null || _d === void 0 ? void 0 : _d.remove();
          this.div = null;
          this.pdfViewer = null;
          (_e = this.pdfPage) === null || _e === void 0 ? void 0 : _e.cleanup();
          this.pdfPage = null;
      }
      get isEditing() {
          return __classPrivateFieldGet(this, _Page_isEditing, "f");
      }
      get rawWidth() {
          var _a, _b;
          return (_b = (_a = this.viewport) === null || _a === void 0 ? void 0 : _a.rawDims) === null || _b === void 0 ? void 0 : _b.pageWidth;
      }
      get rawHeight() {
          var _a, _b;
          return (_b = (_a = this.viewport) === null || _a === void 0 ? void 0 : _a.rawDims) === null || _b === void 0 ? void 0 : _b.pageWidth;
      }
      setState(newState) {
          this.state = deepExtend(this.state || {}, newState);
      }
      resetState() {
          this.setState({});
      }
      initScale() {
          this.scale = this.options.zoomLevel || this.options.scale || DEFAULT_SCALE;
      }
      createPromise() {
          return createPromise();
      }
      getViewport(options = { scale: 1 }) {
          const viewport = this.pdfPage ? this.pdfPage.getViewport(options) : { width: 0, height: 0 };
          return viewport;
      }
      destroyTextLayer() {
          var _a, _b;
          (_a = this.textLayer) === null || _a === void 0 ? void 0 : _a.cancel();
          (_b = this.textLayer) === null || _b === void 0 ? void 0 : _b.destroy();
          this.removeTextLayer();
          this.textLayer = null;
      }
      removeTextLayer() {
          var _a, _b;
          if (this.textLayer && ((_a = this.textLayer.div) === null || _a === void 0 ? void 0 : _a.parentNode)) {
              (_b = this.textLayer.div) === null || _b === void 0 ? void 0 : _b.parentNode.removeChild(this.textLayer.div);
          }
      }
      getPrintContentAsync() {
          const canvas = this.canvasForPrint;
          const printContentLoadPromise = this.createPromise();
          const printContent = new Image();
          const viewportRawDimensions = this.viewport.rawDims;
          const pageHeight = Math.floor(viewportRawDimensions.pageHeight);
          const pageWidth = Math.floor(viewportRawDimensions.pageWidth);
          printContent.src = canvas.toDataURL();
          printContent.width = pageWidth;
          printContent.height = pageHeight;
          printContent.onload = () => {
              // @ts-expect-error TS(2339):
              printContentLoadPromise.resolve(printContent);
          };
          return printContentLoadPromise;
      }
      loadForPrintAsync({ zoomLevel = DEFAULT_ZOOM_LEVEL$1, force = false }) {
          const that = this;
          const pageLoadPromise = this.createPromise();
          const pageZoomLevel = this.pdfViewer.state.zoomLevel;
          if (this.pdfPage && pageZoomLevel === zoomLevel && !force) {
              // @ts-expect-error TS(2339): Property 'resolve' does not exist on type 'Promise... Remove this comment to see the full error message
              return pageLoadPromise.resolve(that);
          }
          else if (this.pdfPage && pageZoomLevel && (pageZoomLevel !== zoomLevel || force)) {
              this.renderForPrintAsync()
                  .then(() => {
                  this.setState({
                      isPrintingInProgress: false
                  });
                  // @ts-expect-error TS(2339): Property 'resolve' does not exist on type 'Promise... Remove this comment to see the full error message
                  pageLoadPromise.resolve(that);
              });
              return pageLoadPromise;
          }
          const pageIndex = Math.max(0, this.pdfPage._pageIndex);
          const pagePromise = this.pdfViewer.state.pdfDocument.getPage(pageIndex + 1);
          pagePromise.then(() => {
              this.renderForPrintAsync()
                  .then(() => {
                  this.setState({
                      isPrintingInProgress: false
                  });
                  // @ts-expect-error TS(2339): Property 'resolve' does not exist on type 'Promise... Remove this comment to see the full error message
                  pageLoadPromise.resolve(that);
              });
          });
          return pageLoadPromise;
      }
      renderForPrintAsync() {
          var _a, _b;
          const printUnits = this.pdfViewer.getPrintUnits();
          const { canvasContext, canvas } = this.pdfViewer.createPageElements({
              pdfPage: this.pdfPage,
              zoom: 1,
              printUnits
          });
          this.canvasForPrint = canvas;
          // canvasWrapper.appendChild(canvas);
          // pageElement.appendChild(canvasWrapper);
          this.setState({
              isPrintingInProgress: true
          });
          const optionalContentConfigPromise = this.pdfViewer.state.pdfDocument.getOptionalContentConfig({
              intent: "print"
          });
          const renderContext = {
              canvasContext: canvasContext,
              transform: [printUnits, 0, 0, printUnits, 0, 0],
              viewport: this.pdfPage.getViewport({ scale: 1, rotation: this.viewport.rotation }),
              intent: "print",
              annotationMode: kendo_pdfjs_loader_js.AnnotationMode.ENABLE_STORAGE,
              optionalContentConfigPromise,
              printAnnotationStorage: (_b = (_a = this.pdfViewer) === null || _a === void 0 ? void 0 : _a.annotationStorage) === null || _b === void 0 ? void 0 : _b.print
          };
          const renderTask = this.pdfPage.render(renderContext);
          const resultPromise = renderTask.promise;
          return resultPromise;
      }
      isBlank() {
          return this.element && this.element.getAttribute("data-blank");
      }
      setBlank(isBlank) {
          if (!this.element) {
              return;
          }
          if (isBlank) {
              this.element.setAttribute("data-blank", true.toString());
          }
          else {
              this.element.removeAttribute("data-blank");
          }
      }
      get renderingState() {
          return __classPrivateFieldGet(this, _Page_renderingState, "f");
      }
      setPdfPage(pdfPage) {
          // if (
          //     (typeof PDFJSDev === "undefined" || PDFJSDev.test("GENERIC")) &&
          //     this._isStandalone &&
          //     (this.pageColors?.foreground === "CanvasText" ||
          //         this.pageColors?.background === "Canvas")
          // ) {
          //     this._container?.style.setProperty(
          //         "--hcm-highlight-filter",
          //         pdfPage.filterFactory.addHighlightHCMFilter(
          //             "highlight",
          //             "CanvasText",
          //             "Canvas",
          //             "HighlightText",
          //             "Highlight"
          //         )
          //     );
          //     this._container?.style.setProperty(
          //         "--hcm-highlight-selected-filter",
          //         pdfPage.filterFactory.addHighlightHCMFilter(
          //             "highlight_selected",
          //             "CanvasText",
          //             "Canvas",
          //             "HighlightText",
          //             "Highlight"
          //         )
          //     );
          // }
          this.pdfPage = pdfPage;
          this.pdfPageRotate = pdfPage.rotate;
          const totalRotation = (this.rotation + this.pdfPageRotate) % 360;
          this.viewport = pdfPage.getViewport({
              scale: this.scale * kendo_pdfjs_loader_js.PixelsPerInch.PDF_TO_CSS_UNITS,
              rotation: totalRotation
          });
          __classPrivateFieldGet(this, _Page_instances, "m", _Page_setDimensions).call(this);
          this.reset();
      }
      hasEditableAnnotations() {
          var _a;
          return !!((_a = this.annotationLayer) === null || _a === void 0 ? void 0 : _a.hasEditableAnnotations());
      }
      // /**
      //  * The structure tree is currently only supported when the text layer is
      //  * enabled and a canvas is used for rendering.
      //  *
      //  * The structure tree must be generated after the text layer for the
      //  * aria-owns to work.
      //  */
      // async #renderStructTreeLayer() {
      //     if (!this.textLayer) {
      //         return;
      //     }
      //     this.structTreeLayer ||= new StructTreeLayerBuilder();
      //     const tree = await (!this.structTreeLayer.renderingDone
      //         ? this.pdfPage.getStructTree()
      //         : null);
      //     const treeDom = this.structTreeLayer?.render(tree);
      //     if (treeDom) {
      //         // Pause translation when inserting the structTree in the DOM.
      //         this.l10n.pause();
      //         this.canvas?.append(treeDom);
      //         this.l10n.resume();
      //     }
      //     this.structTreeLayer?.show();
      // }
      // async #buildXfaTextContentItems(textDivs) {
      //     const text = await this.pdfPage.getTextContent();
      //     const items = [];
      //     for (const item of text.items) {
      //         items.push(item.str);
      //     }
      //     this._textHighlighter.setTextMapping(textDivs, items);
      //     this._textHighlighter.enable();
      // }
      _resetZoomLayer(removeFromDOM = false) {
          if (!this.zoomLayer) {
              return;
          }
          const zoomLayerCanvas = this.zoomLayer.firstChild;
          __classPrivateFieldGet(this, _Page_viewportMap, "f").delete(zoomLayerCanvas);
          // Zeroing the width and height causes Firefox to release graphics
          // resources immediately, which can greatly reduce memory consumption.
          zoomLayerCanvas.width = 0;
          zoomLayerCanvas.height = 0;
          if (removeFromDOM) {
              // Note: `ChildNode.remove` doesn't throw if the parent node is undefined.
              this.zoomLayer.remove();
          }
          this.zoomLayer = null;
      }
      reset({ keepZoomLayer = false, keepAnnotationLayer = false, keepAnnotationEditorLayer = false, keepXfaLayer = false, keepTextLayer = false } = {}) {
          // this.cancelRendering({
          //     keepAnnotationLayer,
          //     keepAnnotationEditorLayer,
          //     keepXfaLayer,
          //     keepTextLayer,
          // });
          // this.renderingState = RenderingStates.INITIAL;
          var _a, _b, _c, _d, _e, _f, _g, _h;
          const div = this.div;
          if (!div) {
              return;
          }
          const childNodes = div.childNodes, zoomLayerNode = (keepZoomLayer && this.zoomLayer) || null, annotationLayerNode = (keepAnnotationLayer && ((_a = this.annotationLayer) === null || _a === void 0 ? void 0 : _a.div)) || null, annotationEditorLayerNode = (keepAnnotationEditorLayer && ((_b = this.annotationEditorLayer) === null || _b === void 0 ? void 0 : _b.div)) || null, xfaLayerNode = (keepXfaLayer && ((_c = this.xfaLayer) === null || _c === void 0 ? void 0 : _c.div)) || null, textLayerNode = (keepTextLayer && ((_d = this.textLayer) === null || _d === void 0 ? void 0 : _d.div)) || null;
          for (let i = childNodes.length - 1; i >= 0; i--) {
              const node = childNodes[i];
              switch (node) {
                  case zoomLayerNode:
                  case annotationLayerNode:
                  case annotationEditorLayerNode:
                  case xfaLayerNode:
                  case textLayerNode:
                      continue;
                  default: break;
              }
              node.remove();
              const layerIndex = __classPrivateFieldGet(this, _Page_layers, "f").indexOf(node);
              if (layerIndex >= 0) {
                  __classPrivateFieldGet(this, _Page_layers, "f")[layerIndex] = null;
              }
          }
          div.removeAttribute("data-loaded");
          if (annotationLayerNode) {
              // Hide the annotation layer until all elements are resized
              // so they are not displayed on the already resized page.
              (_e = this.annotationLayer) === null || _e === void 0 ? void 0 : _e.hide();
          }
          if (annotationEditorLayerNode) {
              (_f = this.annotationEditorLayer) === null || _f === void 0 ? void 0 : _f.hide();
          }
          if (xfaLayerNode) {
              // Hide the XFA layer until all elements are resized
              // so they are not displayed on the already resized page.
              (_g = this.xfaLayer) === null || _g === void 0 ? void 0 : _g.hide();
          }
          if (textLayerNode) {
              (_h = this.textLayer) === null || _h === void 0 ? void 0 : _h.hide();
          }
          // this.structTreeLayer?.hide();
          if (!zoomLayerNode) {
              if (this.canvas) {
                  __classPrivateFieldGet(this, _Page_viewportMap, "f").delete(this.canvas);
                  // Zeroing the width and height causes Firefox to release graphics
                  // resources immediately, which can greatly reduce memory consumption.
                  this.canvas.width = 0;
                  this.canvas.height = 0;
                  delete this.canvas;
              }
              this._resetZoomLayer();
          }
      }
      toggleEditingMode(isEditing) {
          if (!this.hasEditableAnnotations()) {
              return;
          }
          __classPrivateFieldSet(this, _Page_isEditing, isEditing, "f");
          this.reset({
              keepZoomLayer: true,
              keepAnnotationLayer: true,
              keepAnnotationEditorLayer: true,
              keepXfaLayer: true,
              keepTextLayer: true
          });
      }
      draw() {
          return __awaiter(this, void 0, void 0, function* () {
              // if (this.renderingState !== RenderingStates.INITIAL) {
              //     console.error("Must be in new state before drawing");
              //     this.reset(); // Ensure that we reset all state to prevent issues.
              // }
              // const { div, l10n, pageColors, pdfPage: pdfPage, viewport } = this;
              // if (!pdfPage) {
              //     this.renderingState = RenderingStates.FINISHED;
              //     throw new Error("pdfPage is not loaded");
              // }
              // this.renderingState = RenderingStates.RUNNING;
              const { canvasContext, canvas, canvasWrapper, viewport, pageElement, styles } = this.pdfViewer.createPageElements({
                  pdfPage: this.pdfPage,
                  zoom: this.pdfViewer.options.zoomLevel || 1
              });
              if (this.isBlank()) {
                  this.element.replaceWith(pageElement);
                  this.element = this.div = pageElement;
                  this.canvas = canvas;
              }
              else {
                  this.element = this.div = this.element || this.div || pageElement;
                  this.canvas = this.canvas || canvas;
              }
              this.options.styles = styles;
              // Wrap the canvas so that if it has a CSS transform for high DPI the
              // overflow will be hidden in Firefox.
              // const canvasWrapper = document.createElement("div");
              // canvasWrapper.classList.add("canvasWrapper");
              canvasWrapper.appendChild(canvas);
              this.element.appendChild(canvasWrapper);
              __classPrivateFieldGet(this, _Page_instances, "m", _Page_addLayer).call(this, canvasWrapper, "canvasWrapper");
              const { div, 
              // l10n,
              // pageColors,
              pdfPage
              // viewport
               } = this;
              if (!this.textLayer && __classPrivateFieldGet(this, _Page_textLayerMode, "f") !== TextLayerMode.DISABLE && !pdfPage.isPureXfa) {
                  this._accessibilityManager || (this._accessibilityManager = new TextAccessibilityManager());
                  this.textLayer = new TextLayerBuilder({
                      // todo: not part of pdf.js
                      styles: this.options.styles,
                      pdfPage,
                      // highlighter: this._textHighlighter,
                      accessibilityManager: this._accessibilityManager,
                      // enablePermissions: this.#textLayerMode === TextLayerMode.ENABLE_PERMISSIONS,
                      onAppend: textLayerDiv => {
                          // Pause translation when inserting the textLayer in the DOM.
                          // this.l10n.pause();
                          __classPrivateFieldGet(this, _Page_instances, "m", _Page_addLayer).call(this, textLayerDiv, "textLayer");
                          // this.l10n.resume();
                      }
                  });
              }
              if (!this.annotationLayer && __classPrivateFieldGet(this, _Page_annotationMode, "f") !== kendo_pdfjs_loader_js.AnnotationMode.DISABLE) {
                  const { annotationStorage, annotationEditorUIManager, 
                  // downloadManager,
                  // enableScripting,
                  // fieldObjectsPromise,
                  // hasJSActionsPromise,
                  linkService } = __classPrivateFieldGet(this, _Page_layerProperties, "f");
                  this._annotationCanvasMap || (this._annotationCanvasMap = new Map());
                  this.annotationLayer = new AnnotationLayerBuilder({
                      pdfPage,
                      eventBus: this.eventBus || this.pdfViewer.eventBus,
                      annotationStorage,
                      // imageResourcesPath: this.imageResourcesPath,
                      renderForms: __classPrivateFieldGet(this, _Page_annotationMode, "f") === kendo_pdfjs_loader_js.AnnotationMode.ENABLE_FORMS,
                      linkService,
                      // downloadManager,
                      // enableScripting,
                      // hasJSActionsPromise,
                      // fieldObjectsPromise,
                      annotationCanvasMap: this._annotationCanvasMap,
                      accessibilityManager: this._accessibilityManager,
                      annotationEditorUIManager,
                      onAppend: annotationLayerDiv => {
                          __classPrivateFieldGet(this, _Page_instances, "m", _Page_addLayer).call(this, annotationLayerDiv, "annotationLayer");
                      }
                  });
              }
              // const renderContinueCallback = cont => {
              //     showCanvas?.(false);
              //     if (this.renderingQueue && !this.renderingQueue.isHighestPriority(this)) {
              //         this.renderingState = RenderingStates.PAUSED;
              //         this.resume = () => {
              //             this.renderingState = RenderingStates.RUNNING;
              //             cont();
              //         };
              //         return;
              //     }
              //     cont();
              // };
              // const { width, height } = viewport;
              // const canvas = document.createElement("canvas");
              // canvas.setAttribute("role", "presentation");
              // // Keep the canvas hidden until the first draw callback, or until drawing
              // // is complete when `!this.renderingQueue`, to prevent black flickering.
              // canvas.hidden = true;
              // const hasHCM = !!(pageColors?.background && pageColors?.foreground);
              // let showCanvas = isLastShow => {
              //     // In HCM, a final filter is applied on the canvas which means that
              //     // before it's applied we've normal colors. Consequently, to avoid to have
              //     // a final flash we just display it once all the drawing is done.
              //     if (!hasHCM || isLastShow) {
              //         canvas.hidden = false;
              //         showCanvas = null; // Only invoke the function once.
              //     }
              // };
              // canvasWrapper.append(canvas);
              // this.canvas = canvas;
              // const ctx = canvas.getContext("2d", {
              //     alpha: false,
              //     willReadFrequently: !this.#enableHWA,
              // });
              // const ctx = canvas.getContext("2d");
              // const outputScale = (this.outputScale = new OutputScale());
              // if (
              //     (typeof PDFJSDev === "undefined" || PDFJSDev.test("GENERIC")) &&
              //     this.maxCanvasPixels === 0
              // ) {
              //     const invScale = 1 / this.scale;
              //     // Use a scale that makes the canvas have the originally intended size
              //     // of the page.
              //     outputScale.sx *= invScale;
              //     outputScale.sy *= invScale;
              //     this.#hasRestrictedScaling = true;
              // } else if (this.maxCanvasPixels > 0) {
              //     const pixelsInViewport = width * height;
              //     const maxScale = Math.sqrt(this.maxCanvasPixels / pixelsInViewport);
              //     if (outputScale.sx > maxScale || outputScale.sy > maxScale) {
              //         outputScale.sx = maxScale;
              //         outputScale.sy = maxScale;
              //         this.#hasRestrictedScaling = true;
              //     } else {
              //         this.#hasRestrictedScaling = false;
              //     }
              // }
              // const sfx = approximateFraction(outputScale.sx);
              // const sfy = approximateFraction(outputScale.sy);
              // canvas.width = floorToDivide(width * outputScale.sx, sfx[0]);
              // canvas.height = floorToDivide(height * outputScale.sy, sfy[0]);
              // const { style } = canvas;
              // style.width = floorToDivide(width, sfx[1]) + "px";
              // style.height = floorToDivide(height, sfy[1]) + "px";
              // Add the viewport so it's known what it was originally drawn with.
              __classPrivateFieldGet(this, _Page_viewportMap, "f").set(canvas, viewport);
              // // Rendering area
              // const transform = outputScale.scaled
              //     ? [outputScale.sx, 0, 0, outputScale.sy, 0, 0]
              //     : null;
              const renderContext = {
                  canvasContext: canvasContext,
                  // transform,
                  viewport,
                  annotationMode: __classPrivateFieldGet(this, _Page_annotationMode, "f"),
                  // optionalContentConfigPromise: this._optionalContentConfigPromise,
                  annotationCanvasMap: this._annotationCanvasMap,
                  // pageColors,
                  isEditing: __classPrivateFieldGet(this, _Page_isEditing, "f")
              };
              // pdfPage.render(renderContext)
              const renderTask = (this.renderTask = pdfPage.render(renderContext));
              // renderTask.onContinue = renderContinueCallback;
              const resultPromise = renderTask.promise.then(() => __awaiter(this, void 0, void 0, function* () {
                  var _a;
                  // showCanvas?.(true);
                  yield __classPrivateFieldGet(this, _Page_instances, "m", _Page_finishRenderTask).call(this, renderTask);
                  // todo: awaiting this breaks text nodes positioning after zoom
                  // if "includeMarkedContent": true is set in TextLayerBuilder
                  yield __classPrivateFieldGet(this, _Page_instances, "m", _Page_renderTextLayer).call(this);
                  // this.#renderTextLayer();
                  if (this.annotationLayer) {
                      yield __classPrivateFieldGet(this, _Page_instances, "m", _Page_renderAnnotationLayer).call(this);
                  }
                  const { annotationEditorUIManager } = __classPrivateFieldGet(this, _Page_layerProperties, "f");
                  if (!annotationEditorUIManager) {
                      return;
                  }
                  this.drawLayer || (this.drawLayer = new DrawLayerBuilder({
                      pageIndex: this.id
                  }));
                  yield __classPrivateFieldGet(this, _Page_instances, "m", _Page_renderDrawLayer).call(this);
                  this.drawLayer.setParent(canvasWrapper);
                  if (!this.annotationEditorLayer) {
                      this.annotationEditorLayer = new AnnotationEditorLayerBuilder({
                          uiManager: annotationEditorUIManager,
                          pdfPage,
                          // l10n,
                          accessibilityManager: this._accessibilityManager,
                          annotationLayer: (_a = this.annotationLayer) === null || _a === void 0 ? void 0 : _a.annotationLayer,
                          textLayer: this.textLayer,
                          drawLayer: this.drawLayer.getDrawLayer(),
                          onAppend: annotationEditorLayerDiv => {
                              __classPrivateFieldGet(this, _Page_instances, "m", _Page_addLayer).call(this, annotationEditorLayerDiv, "annotationEditorLayer");
                          }
                      });
                  }
                  // todo: this is not awaited in pdf.js
                  __classPrivateFieldGet(this, _Page_instances, "m", _Page_renderAnnotationEditorLayer).call(this);
                  // await this.#renderAnnotationEditorLayer();
              }), error => {
                  // When zooming with a `drawingDelay` set, avoid temporarily showing
                  // a black canvas if rendering was cancelled before the `onContinue`-
                  // callback had been invoked at least once.
                  // if (!(error instanceof RenderingCancelledException)) {
                  //     showCanvas?.(true);
                  // }
                  // return this.#finishRenderTask(renderTask, error);
                  if (!error) {
                      /* no-empty */
                  }
              });
              if (pdfPage.isPureXfa) {
                  // if (!this.xfaLayer) {
                  //     const { annotationStorage, linkService } = this.#layerProperties;
                  //     this.xfaLayer = new XfaLayerBuilder({
                  //         pdfPage,
                  //         annotationStorage,
                  //         linkService,
                  //     });
                  // }
                  // this.#renderXfaLayer();
              }
              div.setAttribute("data-loaded", true);
              this.eventBus.dispatch("pagerender", {
                  source: this,
                  pageNumber: this.id
              });
              return resultPromise;
          });
      }
  }
  _Page_annotationMode = new WeakMap(), _Page_isEditing = new WeakMap(), _Page_layerProperties = new WeakMap(), _Page_previousRotation = new WeakMap(), _Page_renderingState = new WeakMap(), _Page_textLayerMode = new WeakMap(), _Page_viewportMap = new WeakMap(), _Page_layers = new WeakMap(), _Page_instances = new WeakSet(), _Page_addLayer = function _Page_addLayer(div, name) {
      const pos = LAYERS_ORDER.get(name);
      const oldDiv = __classPrivateFieldGet(this, _Page_layers, "f")[pos];
      __classPrivateFieldGet(this, _Page_layers, "f")[pos] = div;
      if (oldDiv) {
          oldDiv.replaceWith(div);
          return;
      }
      for (let i = pos - 1; i >= 0; i--) {
          const layer = __classPrivateFieldGet(this, _Page_layers, "f")[i];
          if (layer) {
              layer.after(div);
              return;
          }
      }
      this.div.prepend(div);
  }, _Page_setDimensions = function _Page_setDimensions() {
      const { viewport } = this;
      if (this.pdfPage) {
          if (__classPrivateFieldGet(this, _Page_previousRotation, "f") === viewport.rotation) {
              return;
          }
          __classPrivateFieldSet(this, _Page_previousRotation, viewport.rotation, "f");
      }
      if (!this.div || !viewport) {
          return;
      }
      kendo_pdfjs_loader_js.setLayerDimensions(this.div, viewport, 
      /* mustFlip = */ true, 
      /* mustRotate = */ false);
  }, _Page_dispatchLayerRendered = function _Page_dispatchLayerRendered(name, error) {
      this.eventBus.dispatch(name, {
          source: this,
          pageNumber: this.id,
          error
      });
  }, _Page_renderAnnotationLayer = function _Page_renderAnnotationLayer() {
      return __awaiter(this, void 0, void 0, function* () {
          let error = null;
          try {
              yield this.annotationLayer.render(this.viewport, "display");
          }
          catch (ex) {
              // eslint-disable-next-line no-console
              console.error(`#renderAnnotationLayer: "${ex}".`);
              error = ex;
          }
          finally {
              __classPrivateFieldGet(this, _Page_instances, "m", _Page_dispatchLayerRendered).call(this, "annotationlayerrendered", error);
          }
      });
  }, _Page_renderAnnotationEditorLayer = function _Page_renderAnnotationEditorLayer() {
      return __awaiter(this, void 0, void 0, function* () {
          let error = null;
          try {
              // await this.annotationEditorLayer.render(this.viewport, "display");
              yield this.annotationEditorLayer.render(this.viewport);
          }
          catch (ex) {
              // console.error(`#renderAnnotationEditorLayer: "${ex}".`);
              error = ex;
          }
          finally {
              __classPrivateFieldGet(this, _Page_instances, "m", _Page_dispatchLayerRendered).call(this, "annotationeditorlayerrendered", error);
          }
      });
  }, _Page_renderDrawLayer = function _Page_renderDrawLayer() {
      return __awaiter(this, void 0, void 0, function* () {
          try {
              yield this.drawLayer.render("display");
          }
          catch (ex) {
              // console.error(`#renderDrawLayer: "${ex}".`);
          }
      });
  }, _Page_renderTextLayer = function _Page_renderTextLayer() {
      return __awaiter(this, void 0, void 0, function* () {
          if (!this.textLayer) {
              return;
          }
          let error = null;
          try {
              yield this.textLayer.render(this.viewport);
          }
          catch (ex) {
              if (ex instanceof kendo_pdfjs_loader_js.AbortException) {
                  return;
              }
              // console.error(`#renderTextLayer: "${ex}".`);
              error = ex;
          }
          __classPrivateFieldGet(this, _Page_instances, "m", _Page_dispatchLayerRendered).call(this, "textlayerrendered", error);
          // this.#renderStructTreeLayer();
      });
  }, _Page_finishRenderTask = function _Page_finishRenderTask(renderTask) {
      return __awaiter(this, void 0, void 0, function* () {
          // The renderTask may have been replaced by a new one, so only remove
          // the reference to the renderTask if it matches the one that is
          // triggering this callback.
          if (renderTask === this.renderTask) {
              this.renderTask = null;
          }
          //     if (error instanceof RenderingCancelledException) {
          //         this.#renderError = null;
          //         return;
          //     }
          //     this.#renderError = error;
          //     this.renderingState = RenderingStates.FINISHED;
          this._resetZoomLayer(/* removeFromDOM = */ true);
          //     // Ensure that the thumbnails won't become partially (or fully) blank,
          //     // for documents that contain interactive form elements.
          //     this.#useThumbnailCanvas.regularAnnotations = !renderTask.separateAnnots;
          this.eventBus.dispatch("pagerendered", {
              source: this,
              pageNumber: this.id,
              cssTransform: false,
              timestamp: performance.now(),
              // error: this.#renderError,
              error: "page render error"
          });
          //     if (error) {
          //         throw error;
          //     }
      });
  };

  /* eslint-disable no-console */
  /* Copyright 2015 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  var _a, _PDFLinkService_isValidExplicitDest;
  const DEFAULT_LINK_REL = "noopener noreferrer nofollow";
  const LinkTarget = {
      NONE: 0, // Default value.
      SELF: 1,
      BLANK: 2,
      PARENT: 3,
      TOP: 4
  };
  /**
   * @typedef {Object} PDFLinkServiceOptions
   * @property {EventBus} eventBus - The application event bus.
   * @property {number} [externalLinkTarget] - Specifies the `target` attribute
   *   for external links. Must use one of the values from {LinkTarget}.
   *   Defaults to using no target.
   * @property {string} [externalLinkRel] - Specifies the `rel` attribute for
   *   external links. Defaults to stripping the referrer.
   * @property {boolean} [ignoreDestinationZoom] - Ignores the zoom argument,
   *   thus preserving the current zoom level in the viewer, when navigating
   *   to internal destinations. The default value is `false`.
   */
  /**
   * Performs navigation functions inside PDF, such as opening specified page,
   * or destination.
   * @implements {IPDFLinkService}
   */
  class PDFLinkService {
      /**
       * @param {PDFLinkServiceOptions} options
       */
      constructor({ eventBus = null, externalLinkTarget = null, externalLinkRel = null, ignoreDestinationZoom = false } = {}) {
          // todo: props
          this.eventBus = null;
          this.externalLinkTarget = null;
          this.externalLinkRel = null;
          this._ignoreDestinationZoom = null;
          this.baseUrl = null;
          this.pdfDocument = null;
          this.pdfViewer = null;
          this.pdfHistory = null;
          // todo: props
          this.externalLinkEnabled = true;
          this.eventBus = eventBus;
          this.externalLinkTarget = externalLinkTarget;
          this.externalLinkRel = externalLinkRel;
          this._ignoreDestinationZoom = ignoreDestinationZoom;
          this.baseUrl = null;
          this.pdfDocument = null;
          this.pdfViewer = null;
          this.pdfHistory = null;
      }
      setDocument(pdfDocument, baseUrl = null) {
          this.baseUrl = baseUrl;
          this.pdfDocument = pdfDocument;
      }
      setViewer(pdfViewer) {
          this.pdfViewer = pdfViewer;
      }
      setHistory(pdfHistory) {
          this.pdfHistory = pdfHistory;
      }
      /**
       * @type {number}
       */
      get pagesCount() {
          return this.pdfDocument ? this.pdfDocument.numPages : 0;
      }
      /**
       * @type {number}
       */
      get page() {
          return this.pdfDocument ? this.pdfViewer.currentPageNumber : 1;
      }
      /**
       * @param {number} value
       */
      set page(value) {
          if (this.pdfDocument) {
              this.pdfViewer.currentPageNumber = value;
          }
      }
      /**
       * @type {number}
       */
      get rotation() {
          return this.pdfDocument ? this.pdfViewer.pagesRotation : 0;
      }
      /**
       * @param {number} value
       */
      set rotation(value) {
          if (this.pdfDocument) {
              this.pdfViewer.pagesRotation = value;
          }
      }
      /**
       * @type {boolean}
       */
      get isInPresentationMode() {
          return this.pdfDocument ? this.pdfViewer.isInPresentationMode : false;
      }
      /**
       * This method will, when available, also update the browser history.
       *
       * @param {string|Array} dest - The named, or explicit, PDF destination.
       */
      goToDestination(dest) {
          return __awaiter(this, void 0, void 0, function* () {
              if (!this.pdfDocument) {
                  return;
              }
              let namedDest, explicitDest, pageNumber;
              if (typeof dest === "string") {
                  namedDest = dest;
                  explicitDest = yield this.pdfDocument.getDestination(dest);
              }
              else {
                  namedDest = null;
                  explicitDest = yield dest;
              }
              if (!Array.isArray(explicitDest)) {
                  // console.error(
                  //     `goToDestination: "${explicitDest}" is not a valid destination array, for dest="${dest}".`
                  // );
                  return;
              }
              // Dest array looks like that: <page-ref> </XYZ|/FitXXX> <args..>
              const [destRef] = explicitDest;
              if (destRef && typeof destRef === "object") {
                  pageNumber = this.pdfDocument.cachedPageNumber(destRef);
                  if (!pageNumber) {
                      // Fetch the page reference if it's not yet available. This could
                      // only occur during loading, before all pages have been resolved.
                      try {
                          pageNumber = (yield this.pdfDocument.getPageIndex(destRef)) + 1;
                      }
                      catch (_b) {
                          console.error(`goToDestination: "${destRef}" is not a valid page reference, for dest="${dest}".`);
                          return;
                      }
                  }
              }
              else if (Number.isInteger(destRef)) {
                  pageNumber = destRef + 1;
              }
              if (!pageNumber || pageNumber < 1 || pageNumber > this.pagesCount) {
                  console.error(`goToDestination: "${pageNumber}" is not a valid page number, for dest="${dest}".`);
                  return;
              }
              if (this.pdfHistory) {
                  // Update the browser history before scrolling the new destination into
                  // view, to be able to accurately capture the current document position.
                  this.pdfHistory.pushCurrentPosition();
                  this.pdfHistory.push({ namedDest, explicitDest, pageNumber });
              }
              this.pdfViewer.scrollPageIntoView({
                  pageNumber,
                  destArray: explicitDest,
                  ignoreDestinationZoom: this._ignoreDestinationZoom
              });
          });
      }
      /**
       * This method will, when available, also update the browser history.
       *
       * @param {number|string} val - The page number, or page label.
       */
      goToPage(val) {
          if (!this.pdfDocument) {
              return;
          }
          const pageNumber = (typeof val === "string" && this.pdfViewer.pageLabelToPageNumber(val)) ||
              val | 0;
          if (!(Number.isInteger(pageNumber) &&
              pageNumber > 0 &&
              pageNumber <= this.pagesCount)) {
              console.error(`PDFLinkService.goToPage: "${val}" is not a valid page.`);
              return;
          }
          if (this.pdfHistory) {
              // Update the browser history before scrolling the new page into view,
              // to be able to accurately capture the current document position.
              this.pdfHistory.pushCurrentPosition();
              this.pdfHistory.pushPage(pageNumber);
          }
          this.pdfViewer.scrollPageIntoView({ pageNumber });
      }
      /**
       * Adds various attributes (href, title, target, rel) to hyperlinks.
       * @param {HTMLAnchorElement} link
       * @param {string} url
       * @param {boolean} [newWindow]
       */
      addLinkAttributes(link, url, newWindow = false) {
          if (!url || typeof url !== "string") {
              throw new Error('A valid "url" parameter must provided.');
          }
          const target = newWindow ? LinkTarget.BLANK : this.externalLinkTarget, rel = this.externalLinkRel;
          if (this.externalLinkEnabled) {
              link.href = link.title = url;
          }
          else {
              link.href = "";
              link.title = `Disabled: ${url}`;
              link.onclick = () => false;
          }
          let targetStr = ""; // LinkTarget.NONE
          switch (target) {
              case LinkTarget.NONE:
                  break;
              case LinkTarget.SELF:
                  targetStr = "_self";
                  break;
              case LinkTarget.BLANK:
                  targetStr = "_blank";
                  break;
              case LinkTarget.PARENT:
                  targetStr = "_parent";
                  break;
              case LinkTarget.TOP:
                  targetStr = "_top";
                  break;
              default: break;
          }
          link.target = targetStr;
          link.rel = typeof rel === "string" ? rel : DEFAULT_LINK_REL;
      }
      /**
       * @param {string|Array} dest - The PDF destination object.
       * @returns {string} The hyperlink to the PDF object.
       */
      getDestinationHash(dest) {
          if (typeof dest === "string") {
              if (dest.length > 0) {
                  return this.getAnchorUrl("#" + escape(dest));
              }
          }
          else if (Array.isArray(dest)) {
              const str = JSON.stringify(dest);
              if (str.length > 0) {
                  return this.getAnchorUrl("#" + escape(str));
              }
          }
          return this.getAnchorUrl("");
      }
      /**
       * Prefix the full url on anchor links to make sure that links are resolved
       * relative to the current URL instead of the one defined in <base href>.
       * @param {string} anchor - The anchor hash, including the #.
       * @returns {string} The hyperlink to the PDF object.
       */
      getAnchorUrl(anchor) {
          return this.baseUrl ? this.baseUrl + anchor : anchor;
      }
      /**
       * @param {string} hash
       */
      setHash(hash) {
          if (!this.pdfDocument) {
              return;
          }
          let pageNumber, dest;
          if (hash.includes("=")) {
              const params = parseQueryString(hash);
              if (params.has("search")) {
                  const query = params.get("search").replaceAll('"', ""), phrase = params.get("phrase") === "true";
                  this.eventBus.dispatch("findfromurlhash", {
                      source: this,
                      query: phrase ? query : query.match(/\S+/g)
                  });
              }
              // borrowing syntax from "Parameters for Opening PDF Files"
              if (params.has("page")) {
                  pageNumber = params.get("page") | 0 || 1;
              }
              if (params.has("zoom")) {
                  // Build the destination array.
                  const zoomArgs = params.get("zoom").split(","); // scale,left,top
                  const zoomArg = zoomArgs[0];
                  const zoomArgNumber = parseFloat(zoomArg);
                  if (!zoomArg.includes("Fit")) {
                      // If the zoomArg is a number, it has to get divided by 100. If it's
                      // a string, it should stay as it is.
                      dest = [
                          null,
                          { name: "XYZ" },
                          zoomArgs.length > 1 ? zoomArgs[1] | 0 : null,
                          zoomArgs.length > 2 ? zoomArgs[2] | 0 : null,
                          zoomArgNumber ? zoomArgNumber / 100 : zoomArg
                      ];
                  }
                  else if (zoomArg === "Fit" || zoomArg === "FitB") {
                      dest = [null, { name: zoomArg }];
                  }
                  else if (zoomArg === "FitH" ||
                      zoomArg === "FitBH" ||
                      zoomArg === "FitV" ||
                      zoomArg === "FitBV") {
                      dest = [
                          null,
                          { name: zoomArg },
                          zoomArgs.length > 1 ? zoomArgs[1] | 0 : null
                      ];
                  }
                  else if (zoomArg === "FitR") {
                      if (zoomArgs.length !== 5) {
                          console.error('PDFLinkService.setHash: Not enough parameters for "FitR".');
                      }
                      else {
                          dest = [
                              null,
                              { name: zoomArg },
                              zoomArgs[1] | 0,
                              zoomArgs[2] | 0,
                              zoomArgs[3] | 0,
                              zoomArgs[4] | 0
                          ];
                      }
                  }
                  else {
                      console.error(`PDFLinkService.setHash: "${zoomArg}" is not a valid zoom value.`);
                  }
              }
              if (dest) {
                  this.pdfViewer.scrollPageIntoView({
                      pageNumber: pageNumber || this.page,
                      destArray: dest,
                      allowNegativeOffset: true
                  });
              }
              else if (pageNumber) {
                  this.page = pageNumber; // simple page
              }
              if (params.has("pagemode")) {
                  this.eventBus.dispatch("pagemode", {
                      source: this,
                      mode: params.get("pagemode")
                  });
              }
              // Ensure that this parameter is *always* handled last, in order to
              // guarantee that it won't be overridden (e.g. by the "page" parameter).
              if (params.has("nameddest")) {
                  this.goToDestination(params.get("nameddest"));
              }
              // if (typeof PDFJSDev === "undefined" || !PDFJSDev.test("MOZCENTRAL")) {
              return;
              // }
              // // Support opening of PDF attachments in the Firefox PDF Viewer,
              // // which uses a couple of non-standard hash parameters; refer to
              // // `DownloadManager.openOrDownloadData` in the firefoxcom.js file.
              // if (!params.has("filename") || !params.has("filedest")) {
              //     return;
              // }
              // hash = params.get("filedest");
          }
          // Named (or explicit) destination.
          dest = unescape(hash);
          try {
              dest = JSON.parse(dest);
              if (!Array.isArray(dest)) {
                  // Avoid incorrectly rejecting a valid named destination, such as
                  // e.g. "4.3" or "true", because `JSON.parse` converted its type.
                  dest = dest.toString();
              }
          }
          catch (e) {
              if (!e) {
                  return;
              }
          }
          if (typeof dest === "string" || __classPrivateFieldGet(_a, _a, "m", _PDFLinkService_isValidExplicitDest).call(_a, dest)) {
              this.goToDestination(dest);
          }
          // console.error(
          //     `PDFLinkService.setHash: "${unescape(hash)}" is not a valid destination.`
          // );
      }
      /**
       * @param {string} action
       */
      executeNamedAction(action) {
          var _b, _c;
          if (!this.pdfDocument) {
              return;
          }
          // See PDF reference, table 8.45 - Named action
          switch (action) {
              case "GoBack":
                  (_b = this.pdfHistory) === null || _b === void 0 ? void 0 : _b.back();
                  break;
              case "GoForward":
                  (_c = this.pdfHistory) === null || _c === void 0 ? void 0 : _c.forward();
                  break;
              case "NextPage":
                  this.pdfViewer.nextPage();
                  break;
              case "PrevPage":
                  this.pdfViewer.previousPage();
                  break;
              case "LastPage":
                  this.page = this.pagesCount;
                  break;
              case "FirstPage":
                  this.page = 1;
                  break;
              default:
                  break; // No action according to spec
          }
          this.eventBus.dispatch("namedaction", {
              source: this,
              action
          });
      }
      /**
       * @param {Object} action
       */
      executeSetOCGState(action) {
          return __awaiter(this, void 0, void 0, function* () {
              if (!this.pdfDocument) {
                  return;
              }
              const pdfDocument = this.pdfDocument, optionalContentConfig = yield this.pdfViewer.optionalContentConfigPromise;
              if (pdfDocument !== this.pdfDocument) {
                  return; // The document was closed while the optional content resolved.
              }
              optionalContentConfig.setOCGState(action);
              this.pdfViewer.optionalContentConfigPromise = Promise.resolve(optionalContentConfig);
          });
      }
  }
  _a = PDFLinkService, _PDFLinkService_isValidExplicitDest = function _PDFLinkService_isValidExplicitDest(dest) {
      if (!Array.isArray(dest) || dest.length < 2) {
          return false;
      }
      const [page, zoom, ...args] = dest;
      if (!(typeof page === "object" &&
          Number.isInteger(page === null || page === void 0 ? void 0 : page.num) &&
          Number.isInteger(page === null || page === void 0 ? void 0 : page.gen)) &&
          !Number.isInteger(page)) {
          return false;
      }
      if (!(typeof zoom === "object" && typeof (zoom === null || zoom === void 0 ? void 0 : zoom.name) === "string")) {
          return false;
      }
      const argsLen = args.length;
      let allowNull = true;
      switch (zoom.name) {
          case "XYZ":
              if (argsLen < 2 || argsLen > 3) {
                  return false;
              }
              break;
          case "Fit":
          case "FitB":
              return argsLen === 0;
          case "FitH":
          case "FitBH":
          case "FitV":
          case "FitBV":
              if (argsLen > 1) {
                  return false;
              }
              break;
          case "FitR":
              if (argsLen !== 4) {
                  return false;
              }
              allowNull = false;
              break;
          default:
              return false;
      }
      for (const arg of args) {
          if (!(typeof arg === "number" || (allowNull && arg === null))) {
              return false;
          }
      }
      return true;
  };

  exports.P = void 0;
  (function (PdfViewerInteractionMode) {
      PdfViewerInteractionMode[PdfViewerInteractionMode["TextSelection"] = 0] = "TextSelection";
      PdfViewerInteractionMode[PdfViewerInteractionMode["Pan"] = 1] = "Pan";
  })(exports.P || (exports.P = {}));

  var _PdfViewer_instances, _PdfViewer_annotationEditorMode, _PdfViewer_switchAnnotationEditorModeTimeoutId, _PdfViewer_annotationMode, _PdfViewer_eventAbortController, _PdfViewer_onPageRenderedCallback, _PdfViewer_switchToEditAnnotationMode, _PdfViewer_scrollIntoView;
  const PDF_JS = "pdfjs";
  const ERROR = "error";
  const ZOOM_START = "zoomStart";
  const ZOOM_END = "zoomEnd";
  const PAGE_RENDERED = "pageRendered";
  const PAGES_LOAD = "pagesLoad";
  const PRINT_END = "printEnd";
  const SCROLL = "scroll";
  const DOWNLOAD = "download";
  const ANNOTATION_EDITOR_TOOLBAR_SHOW = "annotationEditorToolBarShow";
  const ANNOTATION_EDITOR_TOOLBAR_HIDE = "annotationEditorToolBarHide";
  const DEFAULT_ZOOM_LEVEL = 1.25;
  const FRAMES_PER_SECOND = 1000 / 60;
  class PdfViewer extends Component {
      constructor(element, options) {
          super(element, options);
          _PdfViewer_instances.add(this);
          this.options = {
              pdfServiceType: PDF_JS,
              // this is a flag used mainly in tests as CSSStyleSheet.replaceSync
              // fails with jsdom
              // a better solution is not to load a stylesheet in setHiddenCanvasStyles
              // but rather create a class like "k-hidden-canvas-element"
              // and override the rendering from pdf.js
              pdfjsSetHiddenCanvasStyles: true,
              fileData: [],
              page: 1,
              fileDescriptor: null,
              downloadFileName: "Document",
              minZoom: 0.5,
              maxZoom: 4,
              zoomRate: 0.25,
              zoomLevel: DEFAULT_ZOOM_LEVEL,
              zoomBeforePrint: false,
              zoomLevelForPrint: 3,
              renderForms: false,
              searchMatchScrollLeftOffset: 0,
              // add some default offset, so that the found match
              // does not appear on the top edge of the page when navigated to
              searchMatchScrollTopOffset: -64,
              // what percentage of the page should be scrolled,
              // so that the page is considered to be changed to the next one
              pageChangeScrollThreshold: 0.85,
              // values higher than 200ms can result in browser zoom
              pageWheelThrottleDelay: 200,
              // ported from pdf.js
              printResolution: 100,
              // the render scale that is used for controlling the render quality
              renderScale: 3,
              loadOnDemand: false,
              loadOnDemandPageSize: 2,
              messages: {
                  freeTextEditorPlaceholder: "Start typing",
                  errorMessages: {
                      parseError: "PDF file fails to process.",
                      notFound: "File is not found.",
                      popupBlocked: "Popup is blocked."
                  }
              },
              annotations: {
                  highlight: {
                      color: "#ffff00"
                  }
              },
              elementSelectors: {
                  pageSelector: "k-page:not(.k-blank-page)",
                  anyPageSelector: "k-page",
                  pagesContainerClass: "k-pdf-viewer-pages",
                  pageCanvasWrapper: "k-canvas-wrapper",
                  documentContainerClass: "k-pdf-viewer-canvas",
                  textLayerClass: "k-text-layer",
                  searchHighlightClass: "k-search-highlight",
                  searchHighlightMarkClass: "k-search-highlight-mark",
                  charClass: "k-text-char",
                  textElementSelector: "span[role='presentation']",
                  renderedPageSelector: "k-page[data-page-number]",
                  enabledTextSelectionClass: "k-enable-text-select",
                  enabledPanningClass: "k-enable-panning"
              },
              events: {
                  [PAGE_RENDERED]: noop,
                  [PAGES_LOAD]: noop,
                  [PRINT_END]: noop,
                  [ZOOM_START]: noop,
                  [ZOOM_END]: noop,
                  [ERROR]: noop,
                  [SCROLL]: noop,
                  [ANNOTATION_EDITOR_TOOLBAR_SHOW]: noop,
                  [ANNOTATION_EDITOR_TOOLBAR_HIDE]: noop
              }
          };
          // todo: props
          // isPageEditing = null;
          this.interactionMode = exports.P.TextSelection;
          this.printContainer = null;
          // todo: props ported from pdf.js
          this._scrollMode = ScrollMode.PAGE;
          this.isInPresentationMode = false;
          this._currentPageNumber = 1;
          this.linkService = null;
          this.annotationStorage = null;
          this._annotationStorageModified = false;
          this._hasAnnotationEditors = false;
          _PdfViewer_annotationEditorMode.set(this, kendo_pdfjs_loader_js.AnnotationEditorType.NONE);
          this.annotationEditorUIManager = null;
          _PdfViewer_switchAnnotationEditorModeTimeoutId.set(this, null);
          // #buffer = null;
          // #altTextManager = null;
          // #annotationEditorHighlightColors = null;
          // #annotationEditorMode = AnnotationEditorType.NONE;
          // #annotationEditorUIManager = null;
          _PdfViewer_annotationMode.set(this, AnnotationMode.ENABLE);
          // #containerTopLeft = null;
          // #enableHWA = false;
          // #enableHighlightFloatingButton = false;
          // #enablePermissions = false;
          // #enableUpdatedAddImage = false;
          // #enableNewAltTextWhenAddingImage = false;
          _PdfViewer_eventAbortController.set(this, null);
          // #mlManager = null;
          _PdfViewer_onPageRenderedCallback.set(this, null);
          // #switchAnnotationEditorModeTimeoutId = null;
          // #getAllTextInProgress = false;
          // #hiddenCopyElement = null;
          // #interruptCopyCondition = false;
          // #previousContainerHeight = 0;
          // #resizeObserver = new ResizeObserver(this.#resizeObserverCallback.bind(this));
          // #scrollModePageState = null;
          // #scaleTimeoutId = null;
          // #textLayerMode = TextLayerMode.ENABLE;
          // todo: props
          this.state = {};
          this.pdfDocument = null;
          this.pages = [];
          this.triggerError = (e) => {
              this.trigger(ERROR, {
                  error: e
              });
          };
          this.triggerPrintEnd = (e) => {
              this.trigger(PRINT_END, e);
          };
          this.onPagesLoad = (args) => {
              this.state.pdfDocument = args.pdfDoc;
              this.state.pdfPages = args.pdfPages;
              this.clearSearch();
              this.initSearchService();
              this.enableDocumentScrollEventsTracking();
              this.triggerPagesLoad(args);
          };
          this.onDocumentScrollerScroll = (e) => {
              const currentPageIndex = this.getCurrentPageIndex();
              const pages = this.pages;
              const page = pages[currentPageIndex];
              const nextPage = pages[currentPageIndex + 1];
              const previousPage = pages[currentPageIndex - 1];
              if (page && page.isBlank()) {
                  this.drawPageAsync({ pageIndex: currentPageIndex });
              }
              if (nextPage && nextPage.isBlank()) {
                  this.drawPageAsync({ pageIndex: currentPageIndex + 1 });
              }
              if (previousPage && previousPage.isBlank()) {
                  this.drawPageAsync({ pageIndex: currentPageIndex - 1 });
              }
              this.tryTriggerScroll(e);
          };
          // this is mainly used by blazor to track the page number
          // as this can only be obtained by JS
          this.tryTriggerScroll = (e) => {
              let isPageChanged = false;
              const pageNumber = this.getCurrentPageIndex() + 1;
              if (pageNumber !== this.state.activePageNumber && (pageNumber >= 1 && pageNumber <= this.state.pdfDocument.numPages)) {
                  isPageChanged = true;
                  this.state.activePageNumber = pageNumber;
              }
              if (this.shouldPreventScroll) {
                  this.shouldPreventScroll = false;
              }
              else {
                  this.trigger(SCROLL, {
                      scrollLeft: e.scrollLeft,
                      scrollTop: e.scrollTop,
                      pageNumber: this.state.activePageNumber,
                      isPageChanged: isPageChanged
                  });
              }
          };
          this.printDocumentAsync = () => {
              this.initPrintContainer();
              const pagePrintPromises = this.getPagesPrintContentAsync(this.printContainer);
              const printPromise = createPromise();
              Promise.all(pagePrintPromises)
                  .then(() => {
                  // print the document during next render task
                  setTimeout(() => {
                      this.openPrintDialog();
                      // @ts-expect-error TS()
                      printPromise.resolve();
                  }, FRAMES_PER_SECOND);
              });
              return printPromise;
          };
          this.onDocumentWheel = (e) => {
              if (!e.ctrlKey && !e.metaKey) {
                  return;
              }
              e.preventDefault();
              e.stopPropagation();
              const wheelDelta = mousewheelDelta(e);
              const zoomModifier = wheelDelta < 0 ? 1 : -1;
              const zoomLevel = this.state.zoomLevel + (zoomModifier * this.options.zoomRate);
              this.triggerZoomStart({
                  zoomLevel: zoomLevel
              });
              this.zoom({
                  zoomLevel: zoomLevel
              });
              this.triggerZoomEnd({
                  zoomLevel: zoomLevel
              });
          };
          this.extendOptions(options);
          this.throwIfInvalidOptions();
          this.wrapper = this.element;
          this.initEventBus();
          __classPrivateFieldSet(this, _PdfViewer_eventAbortController, new AbortController(), "f");
          if (this.options.renderForms)
              __classPrivateFieldSet(this, _PdfViewer_annotationMode, AnnotationMode.ENABLE_FORMS, "f");
          this.resetState();
          this.bindEvents();
          this.initLinkService();
          this.initDocumentContainer();
          this.loadFile(this.options.fileDescriptor || {
              data: this.options.fileData,
              page: this.options.page
          });
      }
      destroy() {
          this.destroyEventBus();
          this.unbindEvents();
          this.clearDocument();
          this.destroySearchService();
          this.destroyAnnotationEditorUIManager();
          this.destroyDocumentScroller();
      }
      throwIfInvalidOptions() {
          if (this.options.minZoom > this.options.maxZoom) {
              throw new Error("The min zoom should be greater than max zoom");
          }
      }
      set annotationEditorParams({ type, value }) {
          if (!this.annotationEditorUIManager) {
              return;
          }
          this.annotationEditorUIManager.updateParams(type, value);
      }
      get annotationEditorMode() {
          return this.annotationEditorUIManager
              ? __classPrivateFieldGet(this, _PdfViewer_annotationEditorMode, "f")
              : kendo_pdfjs_loader_js.AnnotationEditorType.DISABLE;
      }
      set annotationEditorMode({ mode, editId = null, isFromKeyboard = false }) {
          // todo: set isFromKeyboard intentionally to allow editor creation
          // set annotationEditorMode({ mode, editId = null, isFromKeyboard = true }) {
          if (!this.annotationEditorUIManager) {
              // throw new Error(`The AnnotationEditor is not enabled.`);
          }
          if (__classPrivateFieldGet(this, _PdfViewer_annotationEditorMode, "f") === mode) {
              return; // The AnnotationEditor mode didn't change.
          }
          if (!this.isValidAnnotationEditorMode(mode)) {
              // throw new Error(`Invalid AnnotationEditor mode: ${mode}`);
              return;
          }
          if (!this.pdfDocument) {
              return;
          }
          if (mode === kendo_pdfjs_loader_js.AnnotationEditorType.STAMP) {
              // this.#mlManager?.loadModel("altText");
          }
          const { eventBus } = this;
          const updater = () => {
              this.cleanupSwitchAnnotationEditorMode();
              __classPrivateFieldSet(this, _PdfViewer_annotationEditorMode, mode, "f");
              this.annotationEditorUIManager.updateMode(mode, editId, isFromKeyboard);
              eventBus.dispatch("annotationeditormodechanged", {
                  source: this,
                  mode
              });
          };
          // // todo: fix
          // const isEditingPage = (this.pages || []).some(x => x.isEditing);
          if (mode === kendo_pdfjs_loader_js.AnnotationEditorType.NONE || __classPrivateFieldGet(this, _PdfViewer_annotationEditorMode, "f") === kendo_pdfjs_loader_js.AnnotationEditorType.NONE) {
              const isEditing = mode !== kendo_pdfjs_loader_js.AnnotationEditorType.NONE;
              if (!isEditing) {
                  this.pdfDocument.annotationStorage.resetModifiedIds();
              }
              for (const pageView of this.pages) {
                  pageView.toggleEditingMode(isEditing);
              }
              // We must call #switchToEditAnnotationMode unconditionally to ensure that
              // page is rendered if it's useful or not.
              const idsToRefresh = __classPrivateFieldGet(this, _PdfViewer_instances, "m", _PdfViewer_switchToEditAnnotationMode).call(this);
              if (isEditing && idsToRefresh) {
                  // We're editing so we must switch to editing mode when the rendering is
                  // done.
                  this.cleanupSwitchAnnotationEditorMode();
                  __classPrivateFieldSet(this, _PdfViewer_onPageRenderedCallback, ({ pageNumber }) => {
                      idsToRefresh.delete(pageNumber);
                      if (idsToRefresh.size === 0) {
                          __classPrivateFieldSet(this, _PdfViewer_switchAnnotationEditorModeTimeoutId, setTimeout(updater, 0), "f");
                      }
                  }, "f");
                  const { signal } = __classPrivateFieldGet(this, _PdfViewer_eventAbortController, "f");
                  eventBus._on("pagerendered", __classPrivateFieldGet(this, _PdfViewer_onPageRenderedCallback, "f"), { signal });
              }
          }
          updater();
      }
      getAnnotationMode() {
          return __classPrivateFieldGet(this, _PdfViewer_annotationMode, "f");
      }
      getPrintUnits() {
          return this.options.printResolution / kendo_pdfjs_loader_js.PixelsPerInch.PDF;
      }
      extendOptions(options) {
          this.options = deepExtend(this.options, options);
      }
      setOptions(options) {
          this.options = options;
      }
      bindEvents() {
          this.bindPagesWheel();
      }
      bindPagesWheel() {
          const documentContainer = this.getDocumentContainer();
          if (!documentContainer) {
              return;
          }
          if (this.options.pageWheelThrottleDelay > 0) {
              // @ts-expect-error TS(2339): Property 'throttledPagesWheel' does not exist on t... Remove this comment to see the full error message
              this.throttledPagesWheel = throttle(this.onDocumentWheel, this.options.pageWheelThrottleDelay);
          }
          else {
              // @ts-expect-error TS(2339): Property 'throttledPagesWheel' does not exist on t... Remove this comment to see the full error message
              this.throttledPagesWheel = this.onDocumentWheel;
          }
          // @ts-expect-error TS(2339): Property 'throttledPagesWheel' does not exist on t... Remove this comment to see the full error message
          documentContainer.addEventListener("wheel", this.throttledPagesWheel);
      }
      unbindEvents() {
          this.unbindPagesWheel();
      }
      unbindPagesWheel() {
          const documentContainer = this.getDocumentContainer();
          if (!documentContainer) {
              return;
          }
          // @ts-expect-error TS(2339): Property 'throttledPagesWheel' does not exist on t... Remove this comment to see the full error message
          if (this.throttledPagesWheel && this.throttledPagesWheel.cancel) {
              // @ts-expect-error TS(2339): Property 'throttledPagesWheel' does not exist on t... Remove this comment to see the full error message
              this.throttledPagesWheel.cancel();
          }
          // @ts-expect-error TS(2339): Property 'throttledPagesWheel' does not exist on t... Remove this comment to see the full error message
          documentContainer.removeEventListener("wheel", this.throttledPagesWheel);
      }
      setState(newState) {
          this.state = deepExtend(this.state || {}, newState);
      }
      resetState() {
          this.setState({
              activePageNumber: 1,
              visiblePagesCount: 1,
              pagePromises: [],
              downloadFilePromise: null,
              pdfDocument: null,
              zoomLevel: this.options.zoomLevel,
              zoomLevelType: this.options.zoomLevelType,
              zoomLevelBeforePrint: null
          });
      }
      initEventBus() {
          this.eventBus = new EventBus();
      }
      destroyEventBus() { }
      initLinkService() {
          var _a;
          this.linkService = new PDFLinkService({
              eventBus: this.eventBus,
              externalLinkTarget: LinkTarget.BLANK,
              externalLinkRel: "noopener noreferrer nofollow",
              ignoreDestinationZoom: false
          });
          (_a = this.linkService) === null || _a === void 0 ? void 0 : _a.setViewer(this);
      }
      initAnnotationEditorUIManager() {
          this.annotationEditorUIManager = new AnnotationEditorUIManager({
              container: this.getDocumentContainer(),
              // todo: pdf.js expects a dom element and not a component
              viewer: this.element,
              pdfViewer: this,
              pdfDocument: this.state.pdfDocument,
              eventBus: this.eventBus
          });
          this.setAnnotationEditorUIManagerScale();
      }
      setAnnotationEditorUIManagerScale() {
          var _a;
          // this is required when loading a new document
          // so that annotation editors have correct positions during dragging
          (_a = this.annotationEditorUIManager) === null || _a === void 0 ? void 0 : _a.onScaleChanging({
              scale: this.options.zoomLevel
          });
      }
      destroyAnnotationEditorUIManager() {
          var _a;
          (_a = this.annotationEditorUIManager) === null || _a === void 0 ? void 0 : _a.destroy();
          this.annotationEditorUIManager = null;
      }
      bindEventBusAnnotationsEvents() {
          const eventBus = this.eventBus = this.eventBus || new EventBus();
          eventBus._on("switchannotationeditorparams", (evt) => {
              this.annotationEditorParams = evt;
          }
          // { signal }
          );
          eventBus._on("switchannotationeditormode", evt => {
              // todo: inline the call to this.annotationEditorMode = evt;
              // this.annotationEditorMode = evt;
              this.annotationEditorUIManager.updateParams(evt.type, evt.value);
              const { mode, editId, isFromKeyboard } = evt;
              this.annotationEditorUIManager.annotationEditorMode = evt;
              this.annotationEditorUIManager.updateMode(mode, editId, isFromKeyboard);
              eventBus.dispatch("annotationeditormodechanged", {
                  source: this,
                  mode
              });
          }
          // { signal }
          );
          eventBus._on("kendoAnnotationEditorToolBarShow", (evt) => {
              var _a;
              if (!evt) {
                  return;
              }
              const annotationEditorMode = this.annotationEditorUIManager.getMode();
              if (annotationEditorMode === kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT ||
                  annotationEditorMode === kendo_pdfjs_loader_js.AnnotationEditorType.FREETEXT) {
                  if (annotationEditorMode === kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT) {
                      this.addHighlightAnnotation();
                  }
                  this.triggerAnnotationEditorToolBarShow(Object.assign(Object.assign({}, evt), { annotationEditorMode: annotationEditorMode === kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT ? "highlight" : "freeText", anchor: evt.anchor || ((_a = this.annotationEditorUIManager.firstSelectedEditor) === null || _a === void 0 ? void 0 : _a.div) }));
              }
          }
          // { signal }
          );
          eventBus._on("kendoAnnotationEditorToolBarHide", (evt) => {
              if (!evt) {
                  return;
              }
              const annotationEditorMode = this.annotationEditorUIManager.getMode();
              if (annotationEditorMode === kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT ||
                  annotationEditorMode === kendo_pdfjs_loader_js.AnnotationEditorType.FREETEXT) {
                  this.triggerAnnotationEditorToolBarHide(Object.assign(Object.assign({}, evt), { annotationEditorMode: annotationEditorMode === kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT ? "highlight" : "freeText" }));
              }
          }
          // { signal }
          );
          eventBus._on("showannotationeditorui", (evt) => {
              switch (evt.mode) {
                  case kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT:
                      // editorHighlightButton.click();
                      eventBus.dispatch("switchannotationeditormode", {
                          source: this,
                          mode: kendo_pdfjs_loader_js.AnnotationEditorType.HIGHLIGHT,
                          // {},...eventDetails,
                          // evt.detail is the number of clicks.
                          // isFromKeyboard: evt.detail === 0,
                          isFromKeyboard: false
                      });
                      break;
                  default: break;
              }
          }
          // { signal }
          );
      }
      unbindEventBusAnnotationsEvents() {
          // this.eventBus.off();
      }
      loadFile(args) {
          const fileData = args.data;
          const loadFileOptions = {
              data: null,
              url: "",
              arrayBuffer: null,
              typedArray: null
          };
          if (fileData && (fileData.buffer instanceof ArrayBuffer || fileData instanceof ArrayBuffer)) {
              loadFileOptions.arrayBuffer = fileData.buffer || fileData;
          }
          else if (isString(fileData) && fileData !== "") {
              loadFileOptions.data = fileData;
              loadFileOptions.url = null;
          }
          else if (isString(args.url) && args.url !== "") {
              loadFileOptions.data = null;
              loadFileOptions.url = args.url;
          }
          else if (args.typedArray) {
              loadFileOptions.typedArray = args.typedArray;
          }
          if (args.data || args.url || args.arrayBuffer || args.typedArray) {
              const readOptions = Object.assign({ dom: this.getPagesContainer(), zoom: this.options.zoomLevel }, loadFileOptions);
              this.disableDocumentScrollEventsTracking();
              this.clearDocument();
              this.initEventBus();
              __classPrivateFieldSet(this, _PdfViewer_eventAbortController, new AbortController(), "f");
              this.bindEvents();
              this.initLinkService();
              this.initDocumentContainer();
              this.loadDocument(readOptions);
              this.setScaleFactor(this.options.zoomLevel);
          }
      }
      loadDocument(options) {
          const params = this.getDocumentParameters(options);
          const { zoom } = options;
          this.clearDocumentState();
          kendo_pdfjs_loader_js.getDocument(params)
              .promise.then((pdfDoc) => {
              var _a;
              (_a = this.linkService) === null || _a === void 0 ? void 0 : _a.setDocument(pdfDoc);
              this.initDocumentAnnotationStorage(pdfDoc);
              this.initAnnotationEditorUIManager();
              this.bindEventBusAnnotationsEvents();
              const pagesPromises = [];
              for (let i = 1; i <= pdfDoc.numPages; i++) {
                  pagesPromises.push(pdfDoc.getPage(i));
              }
              return { pagesPromises: pagesPromises, pdfDoc };
          })
              .then(({ pagesPromises: pagesPromises, pdfDoc }) => {
              this.state.pagesPromises = pagesPromises;
              this.destroyPageComponents();
              return this.drawPagesFromPromisesAsync(pagesPromises)
                  .then((pdfPages) => {
                  this.setHiddenCanvasStyles();
                  this.onPagesLoad({ pdfPages, pdfDoc, zoom });
              })
                  .catch((e) => {
                  this.triggerError(e);
              });
          })
              .catch((e) => {
              this.triggerError(e);
          })
              .finally(() => {
              var _a;
              (_a = this.linkService) === null || _a === void 0 ? void 0 : _a.setDocument(this.pdfDocument);
          });
      }
      initDocumentAnnotationStorage(pdfDocument) {
          this.state.pdfDocument = pdfDocument;
          this.pdfDocument = pdfDocument;
          this.annotationStorage = new AnnotationStorage();
          // todo: intentionally override the default value
          // as it relies on checks like "instanceof <something>"
          // but the classes from pdf.js are not exported
          // and thus they are migrated, see https://github.com/mozilla/pdf.js/issues/18656
          // Object.defineProperty(Object.getPrototypeOf(this.pdfDocument), 'annotationStorage', {
          //     get: () => {
          //         if (this.state.isPrintingInProgress) {
          //             return this.annotationStorage?.print;
          //         } else {
          //             return this.annotationStorage;
          //         }
          //     },
          //     set: (value) => {
          //         this.annotationStorage = value;
          //     },
          //     // this is required
          //     configurable: true
          // });
          Object.defineProperty(Object.getPrototypeOf(this.pdfDocument._transport), 'annotationStorage', {
              get: () => {
                  var _a;
                  if (this.state.isPrintingInProgress) {
                      return (_a = this.annotationStorage) === null || _a === void 0 ? void 0 : _a.print;
                  }
                  else {
                      return this.annotationStorage;
                  }
              },
              set: (value) => {
                  this.annotationStorage = value;
              },
              // this is required
              configurable: true
          });
          this._initializeAnnotationStorageCallbacks(pdfDocument);
      }
      _initializeAnnotationStorageCallbacks(pdfDocument) {
          if (pdfDocument !== this.pdfDocument) {
              return;
          }
          const { annotationStorage } = pdfDocument;
          annotationStorage.onSetModified = () => {
              // window.addEventListener("beforeunload", beforeUnload);
              // if (typeof PDFJSDev === "undefined" || PDFJSDev.test("GENERIC")) {
              this._annotationStorageModified = true;
              // }
          };
          annotationStorage.onResetModified = () => {
              // window.removeEventListener("beforeunload", beforeUnload);
              // if (typeof PDFJSDev === "undefined" || PDFJSDev.test("GENERIC")) {
              delete this._annotationStorageModified;
              // }
          };
          annotationStorage.onAnnotationEditor = typeStr => {
              this._hasAnnotationEditors = !!typeStr;
              // this.setTitle();
          };
      }
      drawPagesFromPromisesAsync(pagesPromises) {
          return Promise.all(pagesPromises)
              .then((pdfPages) => __awaiter(this, void 0, void 0, function* () {
              const pages = yield Promise.all(this.drawPagesAsync(pdfPages));
              this.appendPages(pages);
              return pdfPages;
          }));
      }
      drawPagesAsync(pdfPages) {
          pdfPages = pdfPages || this.state.pdfPages;
          const hasPages = (this.pages || []).length > 0;
          if (!hasPages) {
              this.initPageComponents(pdfPages);
          }
          else {
              for (let i = 0; i < this.pages.length; i++) {
                  const pageViewport = this.pages[i].getViewport({
                      scale: this.state.zoomLevel
                  });
                  // todo: adjust page viewport manually
                  // otherwise, loading a document with links to the document
                  // will not scroll to the specific page on click
                  // pdf.js handles this in a more complex way
                  // that will require porting more code
                  this.pages[i].viewport = pageViewport;
              }
          }
          const pageRenderPromises = [];
          pdfPages.map((pdfPage, pageIndex) => __awaiter(this, void 0, void 0, function* () {
              const page = this.pages[pageIndex];
              if (this.options.loadOnDemand &&
                  pageIndex >= this.options.loadOnDemandPageSize &&
                  !page.element) {
                  const blankPageElements = this.createBlankPageElements({ pdfPage, zoom: this.state.zoomLevel });
                  if (page && !page.element) {
                      page.element = blankPageElements.pageElement;
                      page.setBlank(true);
                  }
                  const pageRenderPromise = createPromise();
                  pageRenderPromises.push(pageRenderPromise);
                  pageRenderPromise.then((renderedPage) => {
                      return renderedPage;
                  });
                  pageRenderPromise.resolve(page.element);
              }
              else if (this.options.loadOnDemand && page.isBlank()) {
                  // keep blank pages on reload
                  const pageRenderPromise = createPromise();
                  pageRenderPromises.push(pageRenderPromise);
                  pageRenderPromise.then((renderedPage) => {
                      return renderedPage;
                  });
                  pageRenderPromise.resolve(page.element);
              }
              else {
                  const pageRenderPromise = this.drawPageAsync({ pageIndex });
                  pageRenderPromises.push(pageRenderPromise);
                  pageRenderPromise.then((renderedPage) => {
                      return renderedPage;
                  });
              }
          }));
          return pageRenderPromises;
      }
      createBlankPageElements({ pdfPage, zoom }) {
          const pageElements = this.createPageElements({ pdfPage, zoom });
          pageElements.canvasWrapper.appendChild(pageElements.canvas);
          pageElements.pageElement.appendChild(pageElements.canvasWrapper);
          return pageElements;
      }
      getDocumentParameters(options) {
          let params = {
              verbosity: 0,
              isEvalSupported: true
          };
          if (typeof options.data === 'string' && options.data !== "") {
              params.data = parsePdfFromBase64String(options.data);
          }
          else if (typeof options.url === 'string' && options.url !== "") {
              params.url = options.url;
          }
          else if (options.arrayBuffer instanceof ArrayBuffer) {
              params = options.arrayBuffer;
          }
          else if (options.typedArray) {
              params = options.typedArray;
          }
          return params;
      }
      appendPages(pages) {
          pages.forEach(page => this.appendPage(page));
      }
      appendPage(page, pageIndex = null) {
          const pagesContainer = this.getPagesContainer();
          if (hasValue(pageIndex)) {
              pagesContainer === null || pagesContainer === void 0 ? void 0 : pagesContainer.insertBefore(page, pagesContainer.children[pageIndex]);
          }
          else {
              pagesContainer === null || pagesContainer === void 0 ? void 0 : pagesContainer.appendChild(page);
          }
      }
      drawPageAsync({ pageIndex = 0 }) {
          var _a;
          const index = clamp(pageIndex, 0, Math.max(0, this.state.pdfDocument.numPages - 1));
          return (_a = this.pages[index]) === null || _a === void 0 ? void 0 : _a.draw().then(() => {
              this.triggerPageRendered({ page: this.pages[index] });
              return this.pages[index].element;
          });
      }
      createPageElements({ pdfPage = null, zoom = 1, printUnits = null }) {
          if (zoom <= 0) {
              return;
          }
          let scaleNum = scale(this.options.renderScale);
          if (printUnits) {
              scaleNum = zoom || scaleNum;
          }
          // changing the viewport dimensions here requires changes in
          // page.getPrintContentAsync for the printing dimensions
          const viewport = pdfPage === null || pdfPage === void 0 ? void 0 : pdfPage.getViewport({ scale: scaleNum });
          const { adjustedWidth, adjustedHeight, adjustRatio } = adjustCanvasSize(viewport.width, viewport.height);
          const styles = {
              // "round" is supported in all browsers since May 2024
              // https://developer.mozilla.org/en-US/docs/Web/CSS/round#browser_compatibility
              // width: `round(var(--scale-factor) * ${pageWidth}px, 1px)`,
              // height: `round(var(--scale-factor) * ${pageHeight}px, 1px)`
              width: `round(var(--scale-factor) * ${viewport.width / scaleNum}px, 1px)`,
              height: `round(var(--scale-factor) * ${viewport.height / scaleNum}px, 1px)`
          };
          const pageElement = createElement("div", "k-page", styles);
          const canvas = createElement("canvas", '', {
              width: "100%",
              height: "100%"
          });
          canvas.height = adjustedHeight;
          canvas.width = adjustedWidth;
          if (printUnits) {
              canvas.width = Math.floor(canvas.width * (printUnits || 1));
              canvas.height = Math.floor(canvas.height * (printUnits || 1));
          }
          const canvasContext = canvas.getContext("2d");
          const canvasWrapper = convertToHtml(`
            <div class="${this.options.elementSelectors.pageCanvasWrapper}"></div>
        `);
          const adjustedScale = adjustRatio * scaleNum;
          viewport.width = adjustedWidth;
          viewport.height = adjustedHeight;
          viewport.scale = adjustedScale;
          return {
              canvasContext,
              canvasWrapper,
              canvas,
              viewport,
              scaleNum,
              pageElement,
              styles
          };
      }
      triggerPageRendered(e) {
          this.trigger(PAGE_RENDERED, e);
      }
      triggerPagesLoad(e) {
          this.trigger(PAGES_LOAD, e);
      }
      triggerZoomStart(e) {
          this.trigger(ZOOM_START, e);
      }
      triggerZoomEnd(e) {
          this.trigger(ZOOM_END, e);
      }
      triggerDownload(e) {
          return this.trigger(DOWNLOAD, e);
      }
      triggerAnnotationEditorToolBarShow(e) {
          this.trigger(ANNOTATION_EDITOR_TOOLBAR_SHOW, e);
      }
      triggerAnnotationEditorToolBarHide(e) {
          this.trigger(ANNOTATION_EDITOR_TOOLBAR_HIDE, e);
      }
      clearDocument() {
          this.destroyEventBus();
          this.unbindEvents();
          this.destroySearchService();
          this.destroyAnnotationEditorUIManager();
          this.clearDocumentState();
      }
      clearDocumentState() {
          var _a;
          this.clearPagesState();
          this.state.pdfDocument = null;
          this.state.pdfPages = [];
          (_a = this.linkService) === null || _a === void 0 ? void 0 : _a.setDocument(null);
      }
      clearPagesState() {
          this.pages.forEach(x => x.destroy());
          this.clearPagesElements();
          this.pages = [];
      }
      initPageComponents(pdfPages) {
          // const scale = this.currentScale;
          // const currentScale = scale();
          const currentScale = this.options.zoomLevel;
          const viewport = pdfPages[0].getViewport({
              scale: currentScale * kendo_pdfjs_loader_js.PixelsPerInch.PDF_TO_CSS_UNITS
          });
          for (let pageNum = 1; pageNum <= pdfPages.length; pageNum++) {
              const pageIndex = pageNum - 1;
              const pageView = new Page(null, {
                  pdfViewer: this,
                  container: this.element,
                  eventBus: this.eventBus,
                  id: pageNum,
                  scale: currentScale,
                  viewport: viewport,
                  defaultViewport: viewport,
                  // optionalContentConfigPromise,
                  // renderingQueue: this.renderingQueue,
                  textLayerMode: TextLayerMode.ENABLE,
                  annotationMode: this.getAnnotationMode(),
                  // imageResourcesPath: this.imageResourcesPath,
                  // maxCanvasPixels: this.maxCanvasPixels,
                  // pageColors,
                  // l10n: this.l10n,
                  layerProperties: this._layerProperties
                  // enableHWA: this.#enableHWA,
              });
              this.pages.push(pageView);
              this.pages[pageIndex].setPdfPage(pdfPages[pageIndex]);
          }
      }
      destroyPageComponents() {
          this.pages.forEach(x => x.destroy());
          this.pages = [];
      }
      clearPagesElements() {
          const documentContainer = this.getDocumentContainer();
          const pagesContainer = this.getPagesContainer();
          if (!documentContainer || !pagesContainer || !this.hasDocument()) {
              return;
          }
          const pages = this.getPagesElements();
          pages.forEach(page => {
              // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
              pagesContainer.removeChild(page);
          });
      }
      initDocumentContainer() {
          if (this.documentContainer) {
              return;
          }
          this.documentContainer = this.getDocumentContainer();
          this.initDocumentScroller(this.documentContainer);
      }
      initDocumentScroller(element) {
          if (this.documentScroller || !element) {
              return;
          }
          this.documentScroller = this.createDocumentScroller(element, {
              filter: toClassSelector$1(this.options.elementSelectors.pageSelector),
              events: {
                  [SCROLL]: this.onDocumentScrollerScroll
              }
          });
      }
      createDocumentScroller(element, options) {
          return new Scroller(element, options);
      }
      destroyDocumentScroller() {
          if (!this.documentScroller) {
              return;
          }
          this.documentScroller.destroy();
          this.documentScroller = null;
      }
      enableDocumentScrollEventsTracking() {
          var _a;
          (_a = this.documentScroller) === null || _a === void 0 ? void 0 : _a.enableScrollEventsTracking();
      }
      disableDocumentScrollEventsTracking() {
          var _a;
          (_a = this.documentScroller) === null || _a === void 0 ? void 0 : _a.disableScrollEventsTracking();
      }
      getCurrentPageIndex() {
          return currentPage(this.element) || 0;
      }
      downloadFile({ fileName, saveOptions = {} }) {
          this.downloadDocument({
              options: {
                  pdf: this.state.pdfDocument
              },
              fileName: fileName || this.options.downloadFileName,
              saveOptions: saveOptions
          });
      }
      downloadDocument({ options, fileName = "Document", saveOptions = {} }) {
          if (options.pdf) {
              let exportMethod = options.pdf.getData.bind(options.pdf);
              let serializedAnnotationStorage = {};
              let originalAnnotationStorage = {};
              if (options.pdf.annotationStorage.size > 0) {
                  exportMethod = options.pdf.saveDocument.bind(options.pdf);
                  // saveDocument() has checks that test "editor instanceof AnnotationEditor", but they fail
                  // because AnnotationEditor from "pdfjs-dist/legacy/build/pdf.mjs" is not exported
                  // thus replace instances of editors with their serialized version
                  // and then revert
                  serializedAnnotationStorage = {};
                  originalAnnotationStorage = options.pdf.annotationStorage.getAll();
                  // With the form filling functionality enabled, values could be coming as pure JSON objects,
                  // thus the additional assertion.
                  Object.keys(originalAnnotationStorage).forEach((key) => {
                      var _a;
                      if (typeof ((_a = originalAnnotationStorage[key]) === null || _a === void 0 ? void 0 : _a.toJSON) === "function") {
                          serializedAnnotationStorage[key] = originalAnnotationStorage[key].toJSON();
                      }
                      else {
                          serializedAnnotationStorage[key] = originalAnnotationStorage[key];
                      }
                  });
                  Object.keys(originalAnnotationStorage).forEach((key) => {
                      options.pdf.annotationStorage.remove(key);
                  });
                  Object.keys(serializedAnnotationStorage).forEach((key) => {
                      options.pdf.annotationStorage.setValue(key, serializedAnnotationStorage[key]);
                  });
              }
              exportMethod()
                  .then((data) => {
                  return new Blob([data], { type: 'application/pdf' });
              })
                  .then((blob) => {
                  if (!this.triggerDownload({ blob, fileName, saveOptions })) {
                      this.saveFile(blob, fileName, saveOptions);
                  }
              })
                  .catch((e) => {
                  this.triggerError(e);
              })
                  .finally(() => {
                  var _a;
                  if (((_a = options.pdf) === null || _a === void 0 ? void 0 : _a.annotationStorage.size) <= 0) {
                      return;
                  }
                  const currentAnnotationStorage = options.pdf.annotationStorage.getAll();
                  Object.keys(currentAnnotationStorage).forEach((key) => {
                      options.pdf.annotationStorage.remove(key);
                  });
                  Object.keys(originalAnnotationStorage).forEach((key) => {
                      options.pdf.annotationStorage.setValue(key, originalAnnotationStorage[key]);
                  });
              });
          }
      }
      saveFile(blob, fileName, saveOptions) {
          try {
              kendo_fileSaver_cmn_chunk_js.s(blob, fileName, saveOptions);
          }
          catch (_a) {
              return false;
          }
          return true;
      }
      hasDocument() {
          return hasValue(this.state.pdfDocument);
      }
      zoom(args) {
          args.zoomLevel = this.calculateZoomLevel({
              zoomLevel: args.zoomLevel,
              zoomLevelType: args.zoomLevelType,
              currentZoom: this.options.zoomLevel
          });
          this.options.zoomLevel = args.zoomLevel;
          this.state.zoomLevel = args.zoomLevel;
          this.eventBus.dispatch("scalechanging", {
              source: this,
              scale: this.options.zoomLevel
          });
          this.reloadFile(this.state.pdfDocument);
      }
      calculateZoomLevel({ zoomLevel, zoomLevelType, currentZoom }) {
          const documentContainer = this.getDocumentContainer();
          const page = documentContainer.querySelector(toClassSelector$1(this.options.elementSelectors.anyPageSelector));
          let calculatedZoomLevel = clamp(zoomLevel || DEFAULT_ZOOM_LEVEL, this.options.minZoom, this.options.maxZoom);
          if (!hasValue(page)) {
              return calculatedZoomLevel;
          }
          const pageSize = { width: page.offsetWidth, height: page.offsetHeight };
          if (zoomLevelType === "ActualWidth" || zoomLevelType === "actualWidth") {
              calculatedZoomLevel = 1;
          }
          else if (zoomLevelType === "FitToWidth" || zoomLevelType === "fitToWidth") {
              calculatedZoomLevel = documentContainer.offsetWidth / (pageSize.width / currentZoom);
          }
          else if (zoomLevelType === "FitToPage" || zoomLevelType === "fitToPage") {
              calculatedZoomLevel = documentContainer.offsetHeight / (pageSize.height / currentZoom);
          }
          return calculatedZoomLevel;
      }
      reloadFile(pdfDoc) {
          const pagesPromises = [];
          for (let i = 1; i <= pdfDoc.numPages; i++) {
              pagesPromises.push(pdfDoc.getPage(i));
          }
          this.disableDocumentScrollEventsTracking();
          this.drawPagesFromPromisesAsync(pagesPromises)
              .then((pdfPages) => {
              this.setHiddenCanvasStyles();
              this.onPagesLoad({ pdfPages, pdfDoc });
          })
              .catch((e) => {
              this.triggerError(e);
          });
          this.setScaleFactor(this.state.zoomLevel);
      }
      setHiddenCanvasStyles() {
          if (!this.options.pdfjsSetHiddenCanvasStyles) {
              return;
          }
          // required after pdf.js 4.x version
          const sheet = new CSSStyleSheet();
          sheet.replaceSync(`.hiddenCanvasElement {
            position: absolute;
            top: 0;
            left: 0;
            width: 0;
            height: 0;
            display: none;
        }`);
          this.getPagesContainer().ownerDocument.adoptedStyleSheets = [sheet];
      }
      printFile() {
          if (!this.hasDocument()) {
              return;
          }
          this.setState({
              isPrintingInProgress: true
          });
          if (this.options.zoomBeforePrint) {
              // such option existed in the Kendo jQuery version internally
              this.cacheZoomLevelBeforePrint();
              this.loadDocumentForPrintAsync({
                  zoomLevel: this.options.zoomLevelBeforePrint,
                  force: true
              })
                  .then(() => {
                  this.printDocumentAsync()
                      .then(() => {
                      this.trigger(PRINT_END);
                  });
              })
                  .catch(this.triggerError)
                  .finally(() => {
                  this.setState({
                      isPrintingInProgress: false
                  });
                  this.restoreZoomLevelBeforePrint();
              });
          }
          else {
              this.loadDocumentForPrintAsync({
                  zoomLevel: this.state.zoomLevel,
                  force: true
              })
                  .then(() => {
                  this.printDocumentAsync()
                      .then(() => {
                      this.trigger(PRINT_END);
                  });
              })
                  .catch(this.triggerError)
                  .finally(() => {
                  this.setState({
                      isPrintingInProgress: false
                  });
              });
          }
      }
      loadDocumentForPrintAsync({ zoomLevel = DEFAULT_ZOOM_LEVEL, force = false }) {
          const pages = this.pages;
          const pageLoadPromises = [];
          const loadPromise = createPromise();
          for (let i = 0; i < pages.length; i++) {
              const pageLoadPromise = pages[i].loadForPrintAsync({
                  zoomLevel: zoomLevel,
                  force: force
              });
              pageLoadPromises.push(pageLoadPromise);
          }
          Promise.all(pageLoadPromises)
              .then(() => {
              // @ts-expect-error TS()
              loadPromise.resolve();
          });
          return loadPromise;
      }
      getPagesPrintContentAsync(printContainer) {
          const pages = this.pages;
          const pagePrintPromises = [];
          for (let i = 0; i < pages.length; i++) {
              const pagePrintPromise = pages[i].getPrintContentAsync();
              pagePrintPromise.then((pagePrintContent) => {
                  const pageWrapper = convertToHtml(`<div></div>`);
                  pageWrapper.appendChild(pagePrintContent);
                  printContainer.appendChild(pageWrapper);
              });
              pagePrintPromises.push(pagePrintPromise);
          }
          return pagePrintPromises;
      }
      initPrintContainer() {
          this.printContainer = convertToHtml(`<div></div>`);
      }
      openPrintDialog() {
          const pages = this.pages;
          const width = pages[0].rawWidth * this.getPrintUnits();
          const height = pages[0].rawHeight * this.getPrintUnits();
          const printDialog = window.open('', '', 'innerWidth=' + width + ',innerHeight=' + height + 'location=no,titlebar=no,toolbar=no');
          if (!printDialog || !printDialog.document) {
              this.triggerError({
                  message: this.options.messages.errorMessages.popupBlocked
              });
              return;
          }
          printDialog.document.body.style.margin = '0';
          printDialog.document.body.appendChild(this.printContainer);
          const afterPrintHandler = () => {
              printDialog.removeEventListener("afterprint", afterPrintHandler);
              printDialog.close();
          };
          printDialog.addEventListener("afterprint", afterPrintHandler);
          printDialog.focus();
          printDialog.print();
          // setTimeout(() => {
          // printDialog.print();
          // done();
          // });
      }
      cacheZoomLevelBeforePrint() {
          this.setState({
              zoomLevelBeforePrint: this.state.zoomLevel
          });
      }
      restoreZoomLevelBeforePrint() {
          if (this.state.zoomLevelBeforePrint === this.state.zoomLevel) {
              return;
          }
          this.zoom({
              zoomLevel: this.state.zoomLevelBeforePrint,
              zoomLevelType: this.state.zoomLevelType,
              currentZoom: this.state.zoomLevel
          });
      }
      searchText(options = { text: "", matchCase: false }) {
          var _a;
          this.initSearchService();
          const matches = (_a = this.searchService) === null || _a === void 0 ? void 0 : _a.search(options);
          return matches;
      }
      clearSearch() {
          this.destroySearchService();
      }
      initSearchService() {
          const textLayers = Array.from(this.wrapper.querySelectorAll(toClassSelector$1(this.options.elementSelectors.textLayerClass)) || []);
          if (this.searchService) {
              // refresh text nodes as text layers have changed
              if (textLayers.every((x, i) => x === this.searchService.options.textContainers[i])) {
                  return;
              }
              else {
                  this.destroySearchService();
              }
          }
          this.searchService = new SearchService({
              textContainers: textLayers,
              highlightClass: this.options.elementSelectors.searchHighlightClass,
              highlightMarkClass: this.options.elementSelectors.searchHighlightMarkClass,
              charClass: this.options.elementSelectors.charClass
          });
      }
      destroySearchService() {
          if (!this.searchService) {
              return;
          }
          this.searchService.destroy();
          this.searchService = null;
      }
      goToNextSearchMatch() {
          if (!this.searchService) {
              return;
          }
          this.searchService.markNextMatch();
          const matchElement = this.searchService.getActiveMatchElement();
          this.scrollToSearchMatch(matchElement);
      }
      goToPreviousSearchMatch() {
          if (!this.searchService) {
              return;
          }
          this.searchService.markPreviousMatch();
          const matchElement = this.searchService.getActiveMatchElement();
          this.scrollToSearchMatch(matchElement);
      }
      getPagesContainer() {
          return this.element.querySelector(toClassSelector$1(this.options.elementSelectors.pagesContainerClass));
      }
      getDocumentContainer() {
          return this.wrapper.querySelector(toClassSelector$1(this.options.elementSelectors.documentContainerClass));
      }
      getPagesElements() {
          const documentContainer = this.getDocumentContainer();
          if (!documentContainer) {
              return [];
          }
          return toArray(documentContainer.querySelectorAll(toClassSelector$1(this.options.elementSelectors.pageSelector)));
      }
      scrollToSearchMatch(matchElement) {
          if (!matchElement) {
              return;
          }
          const closestCharElement = matchElement.closest('.k-text-char');
          const closestTextElement = closestCharElement
              ? closestCharElement.closest('span[role="presentation"]')
              : null;
          if (!closestTextElement) {
              return;
          }
          const closestPageElement = closestTextElement.closest('.k-page');
          if (!closestPageElement) {
              return;
          }
          const scrollLeft = closestPageElement.offsetLeft +
              -1 * this.documentScroller.element.offsetLeft +
              closestTextElement.offsetLeft +
              this.options.searchMatchScrollLeftOffset;
          const scrollTop = closestPageElement.offsetTop +
              -1 * this.documentScroller.element.offsetTop +
              closestTextElement.offsetTop +
              this.options.searchMatchScrollTopOffset;
          this.documentScroller.scrollTo(scrollLeft, scrollTop, { trackScrollEvent: false });
      }
      resetInteractionMode() {
          this.setInteractionMode({
              mode: exports.P.TextSelection
          });
      }
      setInteractionMode(args) {
          this.interactionMode = args.mode;
          if (this.interactionMode === exports.P.TextSelection) {
              this.disableScrollerEventsTracking();
              addClass(this.options.elementSelectors.enabledTextSelectionClass, this.documentScroller.element);
              removeClass(this.options.elementSelectors.enabledPanningClass, this.documentScroller.element);
          }
          else if (this.interactionMode === exports.P.Pan) {
              this.enableScrollerEventsTracking();
              removeClass(this.options.elementSelectors.enabledTextSelectionClass, this.documentScroller.element);
              addClass(this.options.elementSelectors.enabledPanningClass, this.documentScroller.element);
          }
      }
      enableScrollerEventsTracking() {
          if (!this.documentScroller) {
              return;
          }
          this.documentScroller.enablePanEventsTracking();
      }
      disableScrollerEventsTracking() {
          if (!this.documentScroller) {
              return;
          }
          this.documentScroller.disablePanEventsTracking();
      }
      setScaleFactor(scaleFactor) {
          this.element.style.setProperty('--scale-factor', String(scaleFactor * kendo_pdfjs_loader_js.PixelsPerInch.PDF_TO_CSS_UNITS));
      }
      activatePageNumber(pageNumber) {
          const page = this.getPageByNumber(pageNumber);
          if (!page) {
              return;
          }
          const pageIndex = pageNumber - 1;
          if (this.state.activePageNumber === pageNumber) {
              return;
          }
          this.state.activePageNumber = pageNumber;
          if (page.isBlank()) {
              this.drawPageAsync({ pageIndex: pageIndex })
                  .then(() => {
                  this.scrollToPage({
                      pageNumber
                  });
              });
          }
          else {
              this.scrollToPage({
                  pageNumber
              });
          }
      }
      scrollToPage({ pageNumber }) {
          const { left, top } = this.getPageNumberScrollOffset(pageNumber);
          this.scrollDocument({
              left: left,
              top: top
          });
      }
      scrollDocument({ left, top }) {
          var _a;
          (_a = this.documentScroller) === null || _a === void 0 ? void 0 : _a.scrollTo(left, top, {
              // as we are manually scrolling to the page
              // we want to ignore the scroller's element scroll event
              // to avoid double handling of the scrolling
              trackScrollEvent: false
          });
      }
      getPageNumberScrollOffset(pageNumber) {
          const page = this.getPageByNumber(pageNumber);
          if (!page) {
              return {
                  left: 0,
                  top: 0
              };
          }
          // pages might have different sizes
          // although pdf.js does not fully support this
          const previousPages = this.pages.slice(0, Math.max(0, pageNumber - 1));
          const previousPagesScrollOffset = previousPages
              .map(x => {
              const pageScrollOffset = this.getPageScrollOffset(x);
              return pageScrollOffset;
          })
              .reduce((sum, pageScrollOffset) => sum + pageScrollOffset, 0);
          return {
              left: 0,
              top: previousPagesScrollOffset
          };
      }
      getPageScrollOffset(page) {
          var _a;
          const pageHeight = ((_a = page === null || page === void 0 ? void 0 : page.element) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) || 0;
          const computedStyles = getComputedStyle(page.element);
          const pageMarginTop = parseFloat(computedStyles.marginTop) || 0;
          return pageHeight + pageMarginTop;
      }
      getPageByNumber(pageNumber) {
          const page = this.pages && this.pages[pageNumber - 1];
          return page;
      }
      addHighlightAnnotation() {
          var _a;
          (_a = this.annotationEditorUIManager) === null || _a === void 0 ? void 0 : _a.highlightSelection();
      }
      setHighlightColor(color) {
          this.executeAnnotationCommand({
              commandType: kendo_pdfjs_loader_js.AnnotationEditorParamsType.HIGHLIGHT_COLOR,
              commandValue: color
          });
      }
      deleteAnnotation() {
          var _a;
          (_a = this.annotationEditorUIManager) === null || _a === void 0 ? void 0 : _a.delete();
      }
      resetAnnotationEditorMode() {
          this.setAnnotationEditorMode({
              mode: kendo_pdfjs_loader_js.AnnotationEditorType.NONE,
              editId: null,
              isFromKeyboard: false
          });
      }
      setAnnotationEditorMode(modeDescriptor) {
          this.annotationEditorMode = modeDescriptor;
      }
      setFreeTextColor(color) {
          this.executeAnnotationCommand({
              commandType: kendo_pdfjs_loader_js.AnnotationEditorParamsType.FREETEXT_COLOR,
              commandValue: color
          });
      }
      setFreeTextFontSize(fontSize) {
          this.executeAnnotationCommand({
              commandType: kendo_pdfjs_loader_js.AnnotationEditorParamsType.FREETEXT_SIZE,
              commandValue: parseFloat(fontSize)
          });
      }
      executeAnnotationCommand({ commandType, commandValue }) {
          this.eventBus.dispatch("switchannotationeditorparams", {
              source: this,
              type: commandType,
              value: commandValue
          });
      }
      // todo: ported from pdf.js
      isValidAnnotationEditorMode(mode) {
          return Object.values(kendo_pdfjs_loader_js.AnnotationEditorType).includes(mode) && mode !== kendo_pdfjs_loader_js.AnnotationEditorType.DISABLE;
      }
      cleanupSwitchAnnotationEditorMode() {
          if (__classPrivateFieldGet(this, _PdfViewer_onPageRenderedCallback, "f")) {
              this.eventBus._off("pagerendered", __classPrivateFieldGet(this, _PdfViewer_onPageRenderedCallback, "f"));
              __classPrivateFieldSet(this, _PdfViewer_onPageRenderedCallback, null, "f");
          }
          if (__classPrivateFieldGet(this, _PdfViewer_switchAnnotationEditorModeTimeoutId, "f") !== null) {
              clearTimeout(__classPrivateFieldGet(this, _PdfViewer_switchAnnotationEditorModeTimeoutId, "f"));
              __classPrivateFieldSet(this, _PdfViewer_switchAnnotationEditorModeTimeoutId, null, "f");
          }
      }
      _getVisiblePages() {
          // const views =
          //     this._scrollMode === ScrollMode.PAGE
          //         ? this.#scrollModePageState.pages
          //         : this._pages,
          //     horizontal = this._scrollMode === ScrollMode.HORIZONTAL,
          //     rtl = horizontal && this._isContainerRtl;
          // return getVisibleElements({
          //     scrollEl: this.container,
          //     views,
          //     sortByVisibility: true,
          //     horizontal,
          //     rtl,
          // });
          return this.pages;
      }
      get _layerProperties() {
          const self = this;
          return kendo_pdfjs_loader_js.shadow(this, "_layerProperties", {
              get annotationEditorUIManager() {
                  return self.annotationEditorUIManager;
              },
              get annotationStorage() {
                  var _a;
                  return (_a = self.pdfDocument) === null || _a === void 0 ? void 0 : _a.annotationStorage;
              },
              // get downloadManager() {
              //     return self.downloadManager;
              // },
              // get enableScripting() {
              //     return !!self._scriptingManager;
              // },
              // get fieldObjectsPromise() {
              //     return self.pdfDocument?.getFieldObjects();
              // },
              // get findController() {
              //     return self.findController;
              // },
              // get hasJSActionsPromise() {
              //     return self.pdfDocument?.hasJSActions();
              // },
              get linkService() {
                  return self.linkService;
              }
          });
      }
      /**
       * Scrolls page into view.
       * @param {ScrollPageIntoViewParameters} params
       */
      scrollPageIntoView({ pageNumber, destArray = null, allowNegativeOffset = false, ignoreDestinationZoom = false }) {
          if (!this.pdfDocument) {
              return;
          }
          const pageView = Number.isInteger(pageNumber) && this.pages[pageNumber - 1];
          if (!pageView) {
              // console.error(
              //     `scrollPageIntoView: "${pageNumber}" is not a valid pageNumber parameter.`
              // );
              return;
          }
          if (this.isInPresentationMode || !destArray) {
              this._setCurrentPageNumber(pageNumber, /* resetCurrentPageView = */ true);
              return;
          }
          let x = 0, y = 0;
          const width = 0, height = 0;
          // widthScale,
          // heightScale;
          const changeOrientation = pageView.rotation % 180 !== 0;
          // const pageWidth =
          //     (changeOrientation ? pageView.height : pageView.width) /
          //     pageView.scale /
          //     PixelsPerInch.PDF_TO_CSS_UNITS;
          const pageHeight = (changeOrientation ? pageView.rawWidth : pageView.rawHeight) /
              pageView.scale /
              kendo_pdfjs_loader_js.PixelsPerInch.PDF_TO_CSS_UNITS;
          // let scale: any = 0;
          switch (destArray[1].name) {
              case "XYZ":
                  x = destArray[2];
                  y = destArray[3];
                  // scale = destArray[4];
                  // If x and/or y coordinates are not supplied, default to
                  // _top_ left of the page (not the obvious bottom left,
                  // since aligning the bottom of the intended page with the
                  // top of the window is rarely helpful).
                  x = x !== null ? x : 0;
                  y = y !== null ? y : pageHeight;
                  break;
              // case "Fit":
              // case "FitB":
              //     scale = "page-fit";
              //     break;
              // case "FitH":
              // case "FitBH":
              //     y = destArray[2];
              //     scale = "page-width";
              //     // According to the PDF spec, section 12.3.2.2, a `null` value in the
              //     // parameter should maintain the position relative to the new page.
              //     if (y === null && this._location) {
              //         x = this._location.left;
              //         y = this._location.top;
              //     } else if (typeof y !== "number" || y < 0) {
              //         // The "top" value isn't optional, according to the spec, however some
              //         // bad PDF generators will pretend that it is (fixes bug 1663390).
              //         y = pageHeight;
              //     }
              //     break;
              // case "FitV":
              // case "FitBV":
              //     x = destArray[2];
              //     width = pageWidth;
              //     height = pageHeight;
              //     scale = "page-height";
              //     break;
              // case "FitR":
              //     x = destArray[2];
              //     y = destArray[3];
              //     width = destArray[4] - x;
              //     height = destArray[5] - y;
              //     let hPadding = SCROLLBAR_PADDING,
              //         vPadding = VERTICAL_PADDING;
              //     if (
              //         (typeof PDFJSDev === "undefined" || PDFJSDev.test("GENERIC")) &&
              //         this.removePageBorders
              //     ) {
              //         hPadding = vPadding = 0;
              //     }
              //     widthScale =
              //         (this.container.clientWidth - hPadding) /
              //         width /
              //         PixelsPerInch.PDF_TO_CSS_UNITS;
              //     heightScale =
              //         (this.container.clientHeight - vPadding) /
              //         height /
              //         PixelsPerInch.PDF_TO_CSS_UNITS;
              //     scale = Math.min(Math.abs(widthScale), Math.abs(heightScale));
              //     break;
              default:
                  // console.error(
                  //     `scrollPageIntoView: "${destArray[1].name}" is not a valid destination type.`
                  // );
                  return;
          }
          if (!ignoreDestinationZoom) {
              // if (scale && scale !== this.options.zoomLevel) {
              // }
              // if (scale && scale !== this._currentScale) {
              // this.currentScaleValue = scale;
              // } else if (this._currentScale === UNKNOWN_SCALE) {
              // this.currentScaleValue = DEFAULT_SCALE_VALUE;
              // }
          }
          // if (scale === "page-fit" && !destArray[4]) {
          //     this.#scrollIntoView(pageView);
          //     return;
          // }
          const boundingRect = [
              pageView.viewport.convertToViewportPoint(x, y),
              pageView.viewport.convertToViewportPoint(x + width, y + height)
          ];
          let left = Math.min(boundingRect[0][0], boundingRect[1][0]);
          let top = Math.min(boundingRect[0][1], boundingRect[1][1]);
          if (!allowNegativeOffset) {
              // Some bad PDF generators will create destinations with e.g. top values
              // that exceeds the page height. Ensure that offsets are not negative,
              // to prevent a previous page from becoming visible (fixes bug 874482).
              left = Math.max(left, 0);
              top = Math.max(top, 0);
          }
          // left *= scale || this.state.zoomLevel;
          // top *= scale || this.state.zoomLevel;
          __classPrivateFieldGet(this, _PdfViewer_instances, "m", _PdfViewer_scrollIntoView).call(this, pageView, /* pageSpot = */ { left, top });
      }
      /**
       * @returns {boolean} Whether the pageNumber is valid (within bounds).
       * @private
       */
      _setCurrentPageNumber(val, resetCurrentPageView = false) {
          if (this._currentPageNumber === val) {
              if (resetCurrentPageView) {
                  // this.#resetCurrentPageView();
              }
              return true;
          }
          // if (!(0 < val && val <= this.pagesCount)) {
          if (!(0 < val && val <= this.state.pdfDocument.numPages)) {
              return false;
          }
          const previous = this._currentPageNumber;
          this._currentPageNumber = val;
          this.eventBus.dispatch("pagechanging", {
              source: this,
              pageNumber: val,
              // pageLabel: this._pageLabels?.[val - 1] ?? null,
              previous
          });
          // if (resetCurrentPageView) {
          //     this.#resetCurrentPageView();
          // }
          return true;
      }
  }
  _PdfViewer_annotationEditorMode = new WeakMap(), _PdfViewer_switchAnnotationEditorModeTimeoutId = new WeakMap(), _PdfViewer_annotationMode = new WeakMap(), _PdfViewer_eventAbortController = new WeakMap(), _PdfViewer_onPageRenderedCallback = new WeakMap(), _PdfViewer_instances = new WeakSet(), _PdfViewer_switchToEditAnnotationMode = function _PdfViewer_switchToEditAnnotationMode() {
      // const visible = this._getVisiblePages();
      // const visible = this._getVisiblePages();
      const pagesToRefresh = [];
      // const { ids, views } = visible;
      // for (const page of views) {
      const ids = new Set();
      this.pages.forEach(x => {
          ids.add(x.id);
      });
      for (const page of this.pages) {
          // const { view } = page;
          const view = page;
          if (!view.hasEditableAnnotations()) {
              ids.delete(view.id);
              continue;
          }
          pagesToRefresh.push(page);
      }
      if (pagesToRefresh.length === 0) {
          return null;
      }
      // this.renderingQueue.renderHighestPriority({
      //     first: pagesToRefresh[0],
      //     last: pagesToRefresh.at(-1),
      //     views: pagesToRefresh,
      //     ids,
      // });
      // todo: render pages instead of using renderingQueue
      // as this will require porting more code
      this.drawPagesAsync(this.state.pdfPages);
      return ids;
  }, _PdfViewer_scrollIntoView = function _PdfViewer_scrollIntoView(pageView, pageSpot = null) {
      const { div, id } = pageView;
      // Ensure that `this._currentPageNumber` is correct, when `#scrollIntoView`
      // is called directly (and not from `#resetCurrentPageView`).
      if (this._currentPageNumber !== id) {
          this._setCurrentPageNumber(id);
      }
      // if (this._scrollMode === ScrollMode.PAGE) {
      //     this.#ensurePageViewVisible();
      //     // Ensure that rendering always occurs, to avoid showing a blank page,
      //     // even if the current position doesn't change when the page is scrolled.
      //     this.update();
      // }
      if (!pageSpot && !this.isInPresentationMode) {
          const left = div.offsetLeft + div.clientLeft, right = left + div.clientWidth;
          // const { scrollLeft, clientWidth } = this.container;
          const { scrollLeft, clientWidth } = this.element;
          if (this._scrollMode === ScrollMode.HORIZONTAL ||
              left < scrollLeft ||
              right > scrollLeft + clientWidth) {
              pageSpot = { left: 0, top: 0 };
          }
      }
      scrollIntoView(div, pageSpot);
      // // Ensure that the correct *initial* document position is set, when any
      // // OpenParameters are used, for documents with non-default Scroll/Spread
      // // modes (fixes issue 15695). This is necessary since the scroll-handler
      // // invokes the `update`-method asynchronously, and `this._location` could
      // // thus be wrong when the initial zooming occurs in the default viewer.
      // if (!this._currentScaleValue && this._location) {
      //     this._location = null;
      // }
  };

  exports.D = DEFAULT_ZOOM_LEVEL$2;
  exports.S = Scroller;
  exports.__meta__ = __meta__;
  exports.a = PdfViewer;
  exports.c = currentPage;
  exports.s = scrollToPage;

}));
